const HotelintentData = {
    "amaravati": {
        "name": "Amaravati",
        "description": "Best hotels in Amaravati—comfortable stays near the Amaravati Stupa, Krishna River, and key roads. Enjoy convenient dining, clean rooms, modest event spaces, and easy access to Vijayawada and Guntur.",
        "sectionOne": "Amaravati, the heritage-rich capital region of Andhra Pradesh, sits along the Krishna River and is known for the ancient Amaravati Stupa, serene ghats, and emerging civic infrastructure. The area connects efficiently to Vijayawada and Guntur, offering practical access to rail, road, and airport links. Hotels here focus on clean, comfortable rooms, dependable Wi‑Fi, small conference facilities, and easy transit to temples, museums, and riverside attractions—ideal for pilgrimages, business visits, and short family getaways.",
        "sectionTwo": {
            "text": "Amaravati offers a selection of practical hotels and nearby premium options for travelers visiting the capital region. Here are handpicked stays that balance location, amenities, and value for both business and leisure trips.",
            "hotels": [
                {
                    "name": "AVR Aditya Convention",
                    "address": "Near Amaravati Temple Road, Amaravathi, Guntur District, Andhra Pradesh 522020",
                    "website": "#",
                    "averageCost": {
                        "stay": 4500,
                        "dining": { "min": 600, "max": 1500 }
                    },
                    "facilities": [
                        "Clean, functional rooms near the temple area",
                        "In-house dining with regional and Indian cuisine",
                        "Convention and banquet spaces for events",
                        "Parking, travel assistance, and Wi‑Fi"
                    ],
                    "brief": "A convenient convention-style property close to religious sites, suitable for family functions and pilgrimage stays.",
                    "highlights": [
                        "Proximity to Amaravati Temple and local markets",
                        "Banquet halls for social and community events",
                        "Simple, value-focused amenities",
                        "Supportive on-site staff services"
                    ]
                },
                {
                    "name": "Hotel Sindura Residency",
                    "address": "Main Road, Amaravathi, Guntur District, Andhra Pradesh 522020",
                    "website": "#",
                    "averageCost": {
                        "stay": 3200,
                        "dining": { "min": 400, "max": 1200 }
                    },
                    "facilities": [
                        "Neat, budget-friendly rooms",
                        "Basic multi-cuisine restaurant",
                        "Front desk and concierge assistance",
                        "Wi‑Fi and on-site parking"
                    ],
                    "brief": "A practical choice for short stays with straightforward comfort and easy access to local transport.",
                    "highlights": [
                        "Budget value near core town points",
                        "Efficient check-in/check-out",
                        "Family rooms available (select)",
                        "Close to shops and eateries"
                    ]
                },
                {
                    "name": "S.R.R Residency",
                    "address": "Temple Road Junction, Amaravathi, Andhra Pradesh 522020",
                    "website": "#",
                    "averageCost": {
                        "stay": 2800,
                        "dining": { "min": 300, "max": 900 }
                    },
                    "facilities": [
                        "Basic rooms with essential amenities",
                        "Room service (limited hours)",
                        "Assistance with local transfers",
                        "Wi‑Fi in common areas"
                    ],
                    "brief": "A budget lodging option for pilgrims and solo travelers seeking essential comforts close to town landmarks.",
                    "highlights": [
                        "Walking distance to temple road",
                        "Value pricing for short-stop itineraries",
                        "Local transit and rickshaw access",
                        "Simple, no-frills setup"
                    ]
                },
                {
                    "name": "Haritha Berm Park (AP Tourism)",
                    "address": "Berm Park, Near Prakasam Barrage, Vijayawada, Andhra Pradesh 520004",
                    "website": "#",
                    "averageCost": {
                        "stay": 5200,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Riverside rooms near Krishna riverfront",
                        "On-site restaurant with vegetarian options",
                        "Parking and tour assistance",
                        "Event lawns (property-specific)"
                    ],
                    "brief": "A scenic, tourism-run stay by the riverside—popular for families visiting nearby Amaravati and Vijayawada attractions.",
                    "highlights": [
                        "River views and evening walks",
                        "Easy access to Prakasam Barrage",
                        "Good base for regional sightseeing",
                        "Family-friendly setting"
                    ]
                },
                {
                    "name": "Novotel Vijayawada Varun",
                    "address": "MG Road, Vijayawada, Andhra Pradesh 520010",
                    "website": "#",
                    "averageCost": {
                        "stay": 8500,
                        "dining": { "min": 1200, "max": 2500 }
                    },
                    "facilities": [
                        "Modern rooms and suites with city views",
                        "All-day dining, café, and bar",
                        "Rooftop pool, gym, and spa",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A premium city hotel in Vijayawada offering contemporary comforts and full-service facilities within reach of Amaravati.",
                    "highlights": [
                        "Strong MICE and event capabilities",
                        "Wellness and rooftop leisure spaces",
                        "Convenient for airport and rail links",
                        "Reliable brand standards"
                    ]
                },
                {
                    "name": "Welcomhotel by ITC Hotels, Guntur",
                    "address": "Opp. Nagarjuna University Road, Guntur, Andhra Pradesh 522510",
                    "website": "#",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1400, "max": 2800 }
                    },
                    "facilities": [
                        "Well-appointed rooms with modern amenities",
                        "Signature restaurants with regional specialties",
                        "Fitness center and spa services",
                        "Conference halls and boardrooms"
                    ],
                    "brief": "A premium option in nearby Guntur with polished rooms, quality dining, and dependable business facilities.",
                    "highlights": [
                        "Business-friendly location",
                        "Curated local cuisine experiences",
                        "Efficient service and event support",
                        "Comfortable for longer stays"
                    ]
                }
            ]
        }
    },

    "itanagar": {
        "name": "Itanagar",
        "description": "Best hotels in Itanagar—comfortable stays near Ganga Market, Gompa Road, and administrative zones. Expect convenient dining, clean rooms, basic event spaces, and access to key city sights.",
        "sectionOne": "Itanagar, the capital of Arunachal Pradesh, blends hill-city charm with cultural landmarks like the Jawaharlal Nehru State Museum and the Buddhist Gompa. Well-connected to Naharlagun and regional transport hubs, the city offers practical hotels focused on clean rooms, courteous service, reliable Wi‑Fi, and on-site dining. Visitors come for government work, regional business, and local exploration. Whether for short work trips or family visits, Itanagar’s stays emphasize convenience, safety, and proximity to markets and offices.",
        "sectionTwo": {
            "text": "Itanagar features a mix of budget, midscale, and a few premium options suitable for business and leisure travelers. Below are handpicked stays that balance location, amenities, and value.",
            "hotels": [
                {
                    "name": "Cygnett Inn Trendz",
                    "address": "Chandranagar, Itanagar, Arunachal Pradesh 791111",
                    "website": "https://www.cygnetthotels.com/",
                    "averageCost": {
                        "stay": 8500,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Modern rooms with essential amenities",
                        "Multi-cuisine restaurant and in-room dining",
                        "Conference room and business services",
                        "Wi‑Fi, parking, and travel assistance"
                    ]
                },
                {
                    "name": "Waii International Hotel",
                    "address": "Near Jawaharlal Nehru State Museum, Gompa Road, Itanagar, Arunachal Pradesh 791111",
                    "website": "https://waiiinternationalhotel.business.site/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Spacious rooms with city or hill views",
                        "Restaurant serving regional and Indian cuisine",
                        "Event-friendly banquet and meeting facilities",
                        "Parking and concierge assistance"
                    ]
                },
                {
                    "name": "Hotel Pybss",
                    "address": "D-Sector, Near Civil Secretariat, Itanagar, Arunachal Pradesh 791111",
                    "website": "https://pybsshotel.com/",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 700, "max": 1800 }
                    },
                    "facilities": [
                        "Comfortable rooms with practical amenities",
                        "On-site restaurant with local favorites",
                        "Front desk, housekeeping, and room service",
                        "Wi‑Fi and limited parking"
                    ]
                },
                {
                    "name": "Hotel Blue Pine",
                    "address": "Ganga Market, Itanagar, Arunachal Pradesh 791111",
                    "website": "http://www.hotelbluepine.in/",
                    "averageCost": {
                        "stay": 4500,
                        "dining": { "min": 500, "max": 1500 }
                    },
                    "facilities": [
                        "Neat rooms with essential comforts",
                        "In-house dining with vegetarian options",
                        "Front desk, tour assistance, and Wi‑Fi",
                        "Easy access to bus and taxi stands"
                    ]
                },
                {
                    "name": "Hotel SC Grand",
                    "address": "Zero Point Tinali, Itanagar, Arunachal Pradesh 791111",
                    "website": "#",
                    "averageCost": {
                        "stay": 5000,
                        "dining": { "min": 600, "max": 1600 }
                    },
                    "facilities": [
                        "Comfortable rooms with basic amenities",
                        "On-site restaurant and room service",
                        "Assistance with local transit and taxis",
                        "Wi‑Fi and limited parking"
                    ]
                },
                {
                    "name": "Hotel Kameng",
                    "address": "Near Ganga Market, Itanagar, Arunachal Pradesh 791111",
                    "website": "#",
                    "averageCost": {
                        "stay": 3800,
                        "dining": { "min": 500, "max": 1400 }
                    },
                    "facilities": [
                        "Budget rooms with essential utilities",
                        "In-house dining (limited hours)",
                        "Front desk and housekeeping support",
                        "Wi‑Fi in common areas"
                    ]
                }
            ]
        }
    },

    "dispur": {
        "name": "Dispur",
        "description": "Best hotels in Dispur—comfortable stays near Ganeshguri, GS Road, and Assam Secretariat. Enjoy convenient dining, clean rooms, basic event spaces, and easy access to Guwahati attractions.",
        "sectionOne": "Dispur, the capital area within Guwahati, is known for the Assam Secretariat, bustling markets like Ganeshguri, and quick links to GS Road and key business districts. The neighborhood offers practical hotels that focus on clean rooms, courteous service, reliable Wi‑Fi, and on-site dining. With ready access to city attractions—zoos, temples, and riverfront spots—plus medical and administrative hubs, Dispur suits short business trips, medical visits, and family stays.",
        "sectionTwo": {
            "text": "Dispur features a mix of budget and midscale hotels with convenient access to markets, transit, and administrative zones. Below are handpicked stays that balance location, amenities, and value.",
            "hotels": [
                {
                    "name": "Vivanta Guwahati",
                    "address": "Nikita Complex, GS Road, Khanapara, Guwahati, Assam 781022",
                    "website": "https://www.vivantahotels.com/en-in/vivanta-guwahati/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1400, "max": 2800 }
                    },
                    "facilities": [
                        "Well-appointed rooms and suites",
                        "Signature restaurants and bar",
                        "Outdoor pool, spa, and fitness center",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A premium option near Dispur with strong dining, wellness, and event capabilities for business and leisure travelers.",
                    "highlights": [
                        "Quick access to Khanapara and GS Road",
                        "Multiple venue sizes for MICE and socials",
                        "Reliable service for longer stays",
                        "Convenient for administrative visits"
                    ]
                },
                {
                    "name": "Novotel Guwahati GS Road",
                    "address": "GS Road, Downtown, Guwahati, Assam 781022",
                    "website": "https://all.accor.com/hotel/B8Z1/index.en.shtml",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 1200, "max": 2500 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining, café, and bar",
                        "Rooftop pool, fitness center, and spa",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A modern, full-service hotel on GS Road with robust dining and wellness, within easy reach of Dispur’s administrative zones.",
                    "highlights": [
                        "Convenient for GS Road and Ganeshguri",
                        "Strong event and conference capabilities",
                        "Rooftop leisure and wellness facilities",
                        "Brand reliability for business travel"
                    ]
                },
                {
                    "name": "Hotel Gateway Grandeur",
                    "address": "GS Road, Christian Basti, Guwahati, Assam 781005",
                    "website": "https://www.gatewaygrandeur.com/",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Modern rooms with city views",
                        "All-day dining and a coffee lounge",
                        "Banquet and meeting spaces",
                        "Wi‑Fi, parking, and travel assistance"
                    ],
                    "brief": "A contemporary city hotel offering polished rooms, reliable dining, and event-friendly spaces close to Dispur.",
                    "highlights": [
                        "Easy access to GS Road and business hubs",
                        "Central location for shopping and dining",
                        "Event halls for corporate and social functions",
                        "Suitable for business and family stays"
                    ]
                },
                {
                    "name": "The Guwahati Address by Centre Point",
                    "address": "Zoo Road, Guwahati, Assam 781021",
                    "website": "https://www.theguwahatiaddress.com/",
                    "averageCost": {
                        "stay": 7800,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Stylish rooms with modern finishes",
                        "Restaurant, café, and bar",
                        "Event spaces and business services",
                        "Wi‑Fi, concierge, and parking"
                    ],
                    "brief": "A boutique-style property a short drive from Dispur, offering chic rooms and versatile dining and event options.",
                    "highlights": [
                        "Close to Zoo Road and city landmarks",
                        "Chic ambience and curated menus",
                        "Flexible meeting and event setups",
                        "Good for business and leisure"
                    ]
                },
                {
                    "name": "Hotel Pragati Manor",
                    "address": "GS Road, Christian Basti, Guwahati, Assam 781005",
                    "website": "https://pragatimanor.com/",
                    "averageCost": {
                        "stay": 5200,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential amenities",
                        "Multi-cuisine restaurant and room service",
                        "Conference room and event support",
                        "Wi‑Fi and on-site parking"
                    ],
                    "brief": "A practical hotel near Dispur with straightforward comforts, dining, and small meeting facilities.",
                    "highlights": [
                        "Central GS Road location",
                        "Value-friendly rates",
                        "Convenient for shopping and clinics",
                        "Suitable for short work trips"
                    ]
                },
                {
                    "name": "Hotel Palacio",
                    "address": "GS Road, Christian Basti, Guwahati, Assam 781005",
                    "website": "https://hotelpalacio.in/",
                    "averageCost": {
                        "stay": 6500,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Modern rooms with essential comforts",
                        "Restaurant and coffee lounge",
                        "Banquet and meeting facilities",
                        "Wi‑Fi, parking, and travel assistance"
                    ],
                    "brief": "A well-located, contemporary hotel offering clean rooms, dependable dining, and event-friendly spaces close to Dispur.",
                    "highlights": [
                        "Proximity to Dispur administrative areas",
                        "Event-friendly halls and services",
                        "Shopping and dining nearby",
                        "Good for business and family stays"
                    ]
                }
            ]
        }
    },

    "patna": {
        "name": "Patna",
        "description": "Best hotels in Patna—well-located stays near Gandhi Maidan, Fraser Road, and the airport. Enjoy reliable dining, clean rooms, event spaces, and easy access to business and heritage sites.",
        "sectionOne": "Patna, the capital of Bihar, blends historic landmarks with growing business districts. Travelers explore Gandhi Maidan, Golghar, Patna Museum, and riverfront ghats, while benefitting from improved air, rail, and road connectivity. The city’s hotels focus on clean rooms, consistent service, dependable Wi‑Fi, and event facilities for conferences and social functions. From centrally located business hotels to premium addresses with pools and spa services, Patna offers practical options for corporate trips, family visits, and city sightseeing.",
        "sectionTwo": {
            "text": "Patna offers a mix of premium and midscale hotels across central districts and transit-linked neighborhoods. Below are handpicked stays known for balanced locations, amenities, and value for business and leisure travelers.",
            "hotels": [
                {
                    "name": "Taj City Centre, Patna",
                    "address": "South Gandhi Maidan, Patna, Bihar 800001",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-city-centre-patna/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Acclaimed specialty dining and lounge",
                        "Outdoor pool, spa, and fitness center",
                        "Ballrooms and boardrooms for events"
                    ],
                    "brief": "A premium city-center hotel overlooking Gandhi Maidan, combining refined rooms, destination dining, and strong event capabilities.",
                    "highlights": [
                        "Central location near business and shopping",
                        "Wellness facilities with pool and spa",
                        "Multiple venue sizes for meetings and weddings",
                        "Trusted luxury brand service standards"
                    ]
                },
                {
                    "name": "Hotel Patliputra Continental",
                    "address": "BMP-8, Patliputra Industrial Area, Patna, Bihar 800013",
                    "website": "https://www.hotelpatliputracontinental.com/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1500, "max": 3500 }
                    },
                    "facilities": [
                        "Spacious rooms with modern amenities",
                        "All-day dining, bar, and bakery",
                        "Rooftop pool, gym, and spa services",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A popular premium hotel with full-service dining, wellness, and comprehensive banquet spaces for business and social events.",
                    "highlights": [
                        "Convenient access to airport and industrial area",
                        "Large-capacity event floors",
                        "Family-friendly leisure facilities",
                        "Reliable service for longer stays"
                    ]
                },
                {
                    "name": "Lemon Tree Premier, Patna",
                    "address": "Exhibition Road, Patna, Bihar 800001",
                    "website": "https://www.lemontreehotels.com/lemon-tree-premier/patna/hotel-patna",
                    "averageCost": {
                        "stay": 10000,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "Citrus Café (all-day dining) and bar",
                        "Rooftop pool and fitness center",
                        "Meeting rooms and banquet facilities"
                    ],
                    "brief": "A centrally located upscale hotel with dependable dining, rooftop leisure, and meeting spaces for corporate and family stays.",
                    "highlights": [
                        "Proximity to business districts and transit",
                        "Consistent breakfast and room service options",
                        "Compact but versatile event venues",
                        "Good value for short and extended stays"
                    ]
                },
                {
                    "name": "Hotel Maurya",
                    "address": "South Gandhi Maidan, Patna, Bihar 800001",
                    "website": "https://www.mauryahotels.com/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "Multi-cuisine restaurants and bakery",
                        "Outdoor pool and fitness center",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A long-standing city hotel near Gandhi Maidan with multiple dining options, pool access, and extensive event facilities.",
                    "highlights": [
                        "Central address with city views",
                        "Diverse F&B outlets for different occasions",
                        "Popular for social functions and conferences",
                        "Easy access to markets and offices"
                    ]
                },
                {
                    "name": "Hotel The Panache",
                    "address": "West of Ram Gulam Chowk, South Gandhi Maidan, Patna, Bihar 800001",
                    "website": "https://www.thepanachepatna.com/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Well-kept rooms with city views",
                        "Restaurant and café lounge",
                        "Event halls with AV support",
                        "Wi‑Fi, parking, and concierge"
                    ],
                    "brief": "A centrally placed, full-service hotel with clean rooms, reliable dining, and practical event spaces near Gandhi Maidan.",
                    "highlights": [
                        "Walkable reach to commercial zones",
                        "Value-friendly business amenities",
                        "Efficient for small and mid-size events",
                        "Good pick for family trips"
                    ]
                },
                {
                    "name": "Hotel Chanakya",
                    "address": "Beer Chand Patel Path, Patna, Bihar 800001",
                    "website": "https://www.hotelchanakya.in/",
                    "averageCost": {
                        "stay": 7500,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential amenities",
                        "Multi-cuisine dining and bar",
                        "Conference rooms and banquet spaces",
                        "Wi‑Fi, parking, and travel desk"
                    ],
                    "brief": "A well-known business hotel with consistent dining and meeting facilities, suitable for corporate travelers and families.",
                    "highlights": [
                        "Close to administrative and business areas",
                        "Multiple venue options for events",
                        "Streamlined check-in and services",
                        "Balanced pricing for longer stays"
                    ]
                }
            ]
        }
    },

    "raipur": {
        "name": "Raipur",
        "description": "Best hotels in Raipur—well‑located stays near GE Road, VIP Road, and the airport. Enjoy reliable dining, clean rooms, event spaces, and easy access to corporate hubs and city sights.",
        "sectionOne": "Raipur, the capital of Chhattisgarh, blends growing corporate zones with lakeside leisure and convenient transit. Travelers explore Marine Drive (Telibandha), Nandan Van Zoo & Safari, and local markets, while benefitting from strong air, rail, and road connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, conference and banquet facilities, and multiple dining options. From premium business hotels with spas and pools to value midscale properties, Raipur offers practical choices for corporate trips, family visits, and conferences.",
        "sectionTwo": {
            "text": "Raipur offers premium and midscale hotels across business corridors and transit-linked neighborhoods. Below are handpicked stays known for balanced locations, amenities, and value for business and leisure travelers.",
            "hotels": [
                {
                    "name": "Courtyard by Marriott Raipur",
                    "address": "NH-6 Labhandi, Raipur, Chhattisgarh 492001",
                    "website": "https://www.marriott.com/en-us/hotels/rprcy-courtyard-raipur/overview/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1500, "max": 3500 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining, bar, and bakery",
                        "Outdoor pool, spa, and fitness center",
                        "Large ballrooms and meeting rooms"
                    ],
                    "brief": "A premium, conference-friendly hotel with robust dining and wellness—ideal for business events and comfortable family stays.",
                    "highlights": [
                        "Quick access to industrial corridors",
                        "High-capacity banquets and breakout rooms",
                        "Consistent brand service standards",
                        "Good for extended corporate stays"
                    ]
                },
                {
                    "name": "Hyatt Raipur",
                    "address": "Magneto The Mall, GE Road, Raipur, Chhattisgarh 492001",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-raipur/rprhy",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1500, "max": 3200 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "Restaurant, lounge, and in-room dining",
                        "Fitness center",
                        "Meeting rooms and event support"
                    ],
                    "brief": "A business-forward hotel attached to a major mall, offering convenience, smart rooms, and dependable meeting facilities.",
                    "highlights": [
                        "Direct mall access for dining and shopping",
                        "Efficient for quick work trips",
                        "Central GE Road connectivity",
                        "Brand reliability for business travelers"
                    ]
                },
                {
                    "name": "Singhania Sarovar Portico, Raipur",
                    "address": "Near AIIMS Hospital, GE Road, Tatibandh, Raipur, Chhattisgarh 492099",
                    "website": "https://www.sarovarhotels.com/singhania-sarovar-portico-raipur/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Well-appointed rooms and suites",
                        "Multi-cuisine restaurant and lounge bar",
                        "Spa and fitness center",
                        "Banquet hall and meeting room"
                    ],
                    "brief": "A polished, value-forward business hotel with strong F&B and practical event spaces near key medical and education hubs.",
                    "highlights": [
                        "Proximity to AIIMS and industrial areas",
                        "Good banquet capacity for socials and MICE",
                        "Comfortable for multi-night stays",
                        "Easy access to rail and city attractions"
                    ]
                },
                {
                    "name": "Sayaji Raipur",
                    "address": "GE Road, Near Magneto The Mall, Raipur, Chhattisgarh 492001",
                    "website": "https://www.sayajihotels.com/hotel/sayaji-raipur/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple dining outlets and bar",
                        "Outdoor pool and fitness facilities",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A popular full-service hotel with diverse dining and sizable event spaces, suitable for weddings, conferences, and family trips.",
                    "highlights": [
                        "Central GE Road location",
                        "Large event floors and catering",
                        "Family-friendly leisure facilities",
                        "Convenient for shopping and dining"
                    ]
                },
                {
                    "name": "Hotel Babylon International",
                    "address": "VIP Road, Rajiv Gandhi Marg, Raipur, Chhattisgarh 492006",
                    "website": "https://hotelbabyloninternational.com/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2600 }
                    },
                    "facilities": [
                        "Comfortable rooms with classic decor",
                        "Multi-cuisine restaurants and bar",
                        "Pool and fitness center",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A long-standing city favorite near the airport route, offering reliable service, multiple dining options, and versatile banquets.",
                    "highlights": [
                        "Airport-friendly VIP Road access",
                        "Popular for social functions and conferences",
                        "Balanced leisure and business amenities",
                        "Trusted city landmark property"
                    ]
                },
                {
                    "name": "Hotel Vennington Court",
                    "address": "VIP Road, Raipur, Chhattisgarh 492006",
                    "website": "https://www.venningtoncourt.com/",
                    "averageCost": {
                        "stay": 6500,
                        "dining": { "min": 800, "max": 1800 }
                    },
                    "facilities": [
                        "Modern rooms with essential comforts",
                        "Restaurant and café lounge",
                        "Meeting room and banquet hall",
                        "Wi‑Fi, parking, and concierge"
                    ],
                    "brief": "A contemporary midscale stay on VIP Road with straightforward dining and event spaces for quick business and family trips.",
                    "highlights": [
                        "Convenient airport connectivity",
                        "Value-friendly business amenities",
                        "Efficient check-in and services",
                        "Good pick for short stays"
                    ]
                }
            ]
        }
    },

    "panaji": {
        "name": "Panaji",
        "description": "Best hotels in Panaji—beachfront and riverside stays near Miramar, Dona Paula, and Mandovi River. Enjoy award-winning dining, clean rooms, pools, spas, casinos, and event-ready venues.",
        "sectionOne": "Panaji (Panjim), the capital of Goa, blends riverfront charm, Latin quarters, and beach access. Travelers explore Miramar Beach, Dona Paula, Fontainhas, and the Mandovi riverfront casinos, supported by strong air, rail, and road connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, destination dining, pools, spas, and versatile banquet spaces. From luxury resorts with sea views to boutique heritage stays in the old quarter, Panaji offers practical options for business trips, family holidays, and weddings.",
        "sectionTwo": {
            "text": "Panaji features premium beachfront resorts, river-view business hotels, and stylish boutique stays. Below are handpicked properties known for prime locations, strong amenities, and reliable service.",
            "hotels": [
                {
                    "name": "Taj Cidade de Goa Horizon, Goa",
                    "address": "Vainguinim Beach, Dona Paula, Panaji, Goa 403004",
                    "website": "https://www.seleqtionshotels.com/hotels/cidade-de-goa-horizon-goa",
                    "averageCost": {
                        "stay": 23000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Beachfront rooms and suites with sea views",
                        "Multiple specialty restaurants and bars",
                        "Infinity pool, spa, and fitness center",
                        "Convention center, ballrooms, and meeting rooms"
                    ],
                    "brief": "A luxurious beachfront resort with panoramic sea views, destination dining, and expansive event spaces—ideal for weddings and conferences.",
                    "highlights": [
                        "Direct beach access at Vainguinim",
                        "Renowned Goan and global cuisine",
                        "Resort-scale wellness and recreation",
                        "Large-capacity banquets and breakouts"
                    ]
                },
                {
                    "name": "Vivanta Goa, Panaji",
                    "address": "DB Bandodkar Road, Panaji, Goa 403001",
                    "website": "https://www.vivantahotels.com/en-in/vivanta-goa-panaji/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Contemporary rooms with city/river glimpses",
                        "Signature restaurants, patisserie, and bar",
                        "Rooftop pool, spa, and 24/7 fitness",
                        "Boardrooms and mid-size banquet venues"
                    ],
                    "brief": "A polished city hotel near the Mandovi riverfront, offering refined rooms, strong F&B, and rooftop leisure for business and family stays.",
                    "highlights": [
                        "Quick reach to casinos and CBD",
                        "Rooftop pool with city views",
                        "Consistent service and brand standards",
                        "Efficient for meetings and socials"
                    ]
                },
                {
                    "name": "Goa Marriott Resort & Spa",
                    "address": "Miramar Beach, Panaji, Goa 403001",
                    "website": "https://www.marriott.com/en-us/hotels/goimc-goa-marriott-resort-and-spa/overview/",
                    "averageCost": {
                        "stay": 24000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Riverside/sea-facing rooms and suites",
                        "Multiple restaurants and lounge bar",
                        "Outdoor pool, Quan Spa, and fitness center",
                        "Ballrooms, lawns, and meeting rooms"
                    ],
                    "brief": "A riverfront luxury resort at Miramar with upscale dining, spa-driven wellness, and versatile indoor-outdoor event spaces.",
                    "highlights": [
                        "Mandovi river and sunset views",
                        "Popular for weddings and corporate offsites",
                        "Family-friendly leisure facilities",
                        "Proximity to beaches and casinos"
                    ]
                },
                {
                    "name": "DoubleTree by Hilton Goa – Panaji",
                    "address": "Kadamba Plateau, Panaji, Goa 403006",
                    "website": "https://www.hilton.com/en/hotels/goipcdi-doubletree-goa-panaji/",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1600, "max": 4000 }
                    },
                    "facilities": [
                        "Modern rooms with river/green views",
                        "All-day dining, bar, and bakery",
                        "Outdoor pool, spa treatments, and gym",
                        "Banquet spaces and meeting rooms"
                    ],
                    "brief": "A contemporary riverside escape with scenic views, strong dining, and event-friendly spaces—good for balanced business-leisure stays.",
                    "highlights": [
                        "Views over Mandovi backwaters",
                        "Resort-like pool and wellness",
                        "Good access to Panaji and Old Goa",
                        "Reliable brand standards"
                    ]
                },
                {
                    "name": "Fortune Miramar, Goa",
                    "address": "Miramar, Panaji, Goa 403001",
                    "website": "https://www.itchotels.com/in/en/fortune-miramar-goa",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Well-appointed rooms near the beach",
                        "Multi-cuisine restaurant and café",
                        "Fitness center",
                        "Meeting room and banquet hall"
                    ],
                    "brief": "A smart city-beach hotel steps from Miramar, offering practical rooms, dependable dining, and compact event facilities.",
                    "highlights": [
                        "Walkable to Miramar Beach",
                        "Efficient for short corporate trips",
                        "Consistent breakfast and room service",
                        "Value-friendly in a prime area"
                    ]
                },
                {
                    "name": "The Crown Goa",
                    "address": "Bairo Alto Dos Pilotos, Jose Falcao Road, Panaji, Goa 403001",
                    "website": "https://www.thecrowngoa.com/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "City-view rooms and suites",
                        "Restaurant, bar, and café",
                        "Outdoor pool and fitness room",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A centrally located hotel on a hill above the Mandovi, with city views, straightforward leisure, and versatile event spaces.",
                    "highlights": [
                        "Close to casinos and Latin Quarter",
                        "Good city access for shopping/dining",
                        "Event-friendly with multiple halls",
                        "Practical for families and business"
                    ]
                },
                {
                    "name": "Varanda do Mar",
                    "address": "Miramar Beach, Panaji, Goa 403001",
                    "website": "https://www.varandadomar.com/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Spacious rooms near the waterfront",
                        "Restaurant and rooftop lounge (property-specific)",
                        "Event/banquet room (select categories)",
                        "Wi‑Fi, parking, and concierge"
                    ],
                    "brief": "A comfortable beachside hotel near Miramar offering relaxed rooms, simple dining, and event options for small gatherings.",
                    "highlights": [
                        "Miramar promenade proximity",
                        "Easy access to beaches and CBD",
                        "Good value for family stays",
                        "Quick reach to casinos and river cruises"
                    ]
                }
            ]
        }
    },

    "gandhinagar": {
        "name": "Gandhinagar",
        "description": "Best hotels in Gandhinagar—business and leisure stays near Sector 11, Gift City, and the Railway/Bus terminals. Enjoy reliable dining, clean rooms, event spaces, and quick access to Ahmedabad.",
        "sectionOne": "Gandhinagar, the planned capital of Gujarat, is known for its clean sectors, administrative hubs, and green spaces like Indroda Nature Park. With Gift City, Mahatma Mandir Convention Centre, and easy access to Ahmedabad International Airport, the city attracts business travelers, delegates, and families. Hotels here focus on clean rooms, dependable Wi‑Fi, meeting and banquet venues, and convenient on-site dining. Whether attending conferences, visiting government offices, or exploring nearby sights, Gandhinagar’s hotels offer practical comfort and connectivity.",
        "sectionTwo": {
            "text": "Gandhinagar offers a mix of premium and midscale hotels across central sectors and the Gift City/Ahmedabad corridor. Below are handpicked stays known for location, amenities, and value for business and leisure trips.",
            "hotels": [
                {
                    "name": "The Leela Gandhinagar",
                    "address": "Above Gandhinagar Railway Station, Sector 14, Gandhinagar, Gujarat 382010",
                    "website": "https://www.theleela.com/the-leela-gandhinagar",
                    "averageCost": {
                        "stay": 19000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Luxurious rooms and suites with city views",
                        "Multiple restaurants, bar, and lounge",
                        "Outdoor pool, spa, and fitness center",
                        "Grand ballrooms and boardrooms connected to Mahatma Mandir"
                    ],
                    "brief": "A premium city landmark set above the railway station, offering luxury rooms, destination dining, and large-scale event facilities.",
                    "highlights": [
                        "Sky bridge access to Mahatma Mandir/Convention Centre",
                        "Seamless rail/road connectivity",
                        "Club lounge privileges (select categories)",
                        "Ideal for conferences and weddings"
                    ]
                },
                {
                    "name": "Fortune Inn Haveli, Gandhinagar",
                    "address": "Plot No. 235, Sector 11, Gandhinagar, Gujarat 382011",
                    "website": "https://www.itchotels.com/in/en/fortune-inn-haveli-gandhinagar",
                    "averageCost": {
                        "stay": 8500,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Comfortable rooms with modern amenities",
                        "All-day dining and coffee lounge",
                        "Fitness center and sauna (property-specific)",
                        "Meeting rooms and banquet spaces"
                    ],
                    "brief": "A centrally located hotel in Sector 11 with dependable rooms, dining, and compact event facilities for business travelers.",
                    "highlights": [
                        "Close to Secretariat and administrative zones",
                        "Value-friendly business amenities",
                        "Easy access to sector markets",
                        "Suitable for short and extended stays"
                    ]
                },
                {
                    "name": "Prominent Corporate Residency",
                    "address": "PDPU Road, Raysan, Gandhinagar, Gujarat 382421",
                    "website": "https://prominenthotels.in/",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Spacious rooms and serviced-style units",
                        "Restaurant and café lounge",
                        "Fitness room",
                        "Banquet and meeting facilities"
                    ],
                    "brief": "A business-friendly hotel near academic and corporate clusters, balancing roomy accommodation with practical event spaces.",
                    "highlights": [
                        "Convenient for PDPU, Raysan, and Gift City approach",
                        "Good parking and road connectivity",
                        "Family-friendly layouts (select rooms)",
                        "Efficient check-in and service"
                    ]
                },
                {
                    "name": "The Fern Residency, Gandhinagar",
                    "address": "Sector 7, Gandhinagar, Gujarat 382007",
                    "website": "https://www.fernhotels.com/",
                    "averageCost": {
                        "stay": 6500,
                        "dining": { "min": 800, "max": 1800 }
                    },
                    "facilities": [
                        "Modern rooms with eco-sensitive features",
                        "Multi-cuisine restaurant",
                        "Fitness center",
                        "Meeting room and small banquet hall"
                    ],
                    "brief": "An eco-aware, midscale option with clean rooms and reliable dining, suited to quick business trips and family visits.",
                    "highlights": [
                        "Sector-side convenience for government offices",
                        "Green practices and efficient operations",
                        "Breakfast and room service consistency",
                        "Value pricing for longer stays"
                    ]
                },
                {
                    "name": "Cambay Sapphire, Gandhinagar",
                    "address": "Sector 25, Gandhinagar, Gujarat 382025",
                    "website": "https://www.cambayhotels.com/",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 700, "max": 1700 }
                    },
                    "facilities": [
                        "Neat rooms with essential amenities",
                        "Restaurant and coffee shop",
                        "Fitness room and spa (property-specific)",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A practical, event-friendly hotel with straightforward rooms, dining, and banquet options for social functions and corporate meets.",
                    "highlights": [
                        "Convenient sector access and parking",
                        "Multiple hall configurations",
                        "Suitable for training programs",
                        "Balanced value and location"
                    ]
                },
                {
                    "name": "Siara Styles Amba Suites",
                    "address": "Near Gift City, Gandhinagar, Gujarat 382355",
                    "website": "https://siarahotels.com/",
                    "averageCost": {
                        "stay": 6200,
                        "dining": { "min": 800, "max": 1900 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "In-house restaurant and café",
                        "Fitness corner",
                        "Meeting room (property-specific)"
                    ],
                    "brief": "A modern, value-forward stay near Gift City with clean rooms and simple event facilities for quick corporate trips.",
                    "highlights": [
                        "Gift City approach and highway connectivity",
                        "Newer-build rooms and utilities",
                        "Efficient for weekday business stays",
                        "Good value around corporate hubs"
                    ]
                },
                {
                    "name": "Belvedere Golf & Country Club (Club Stay Option)",
                    "address": "Shantigram Township, Near S.G. Highway, Gandhinagar–Ahmedabad Corridor 382421",
                    "website": "https://www.belvederegolfandcountryclub.com/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Club-style rooms and suites",
                        "Restaurants, café, and lounge",
                        "Golf access, sports courts, pool, and gym",
                        "Banquet lawns and event venues"
                    ],
                    "brief": "A club-and-resort style option along the corridor with extensive sports and event facilities—suitable for retreats and family weekends.",
                    "highlights": [
                        "Quick drive to Gift City and Ahmedabad",
                        "Expansive leisure and sports amenities",
                        "Indoor–outdoor venues for large gatherings",
                        "Family-friendly stay configurations"
                    ]
                }
            ]
        }
    },

    "chandigarh": {
        "name": "Chandigarh",
        "description": "Best hotels in Chandigarh—premium and midscale stays near Sector 17, Elante, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Chandigarh, India’s first planned city, blends modernist design, green boulevards, and business districts. Visitors explore Sukhna Lake, Rock Garden, Sector 17 Plaza, and Elante Mall, while benefiting from strong air, rail, and road connectivity. City hotels focus on clean rooms, reliable Wi‑Fi, multiple dining outlets, and banquet facilities for conferences and weddings. From luxury brands with spas and pools to value-forward business hotels near commercial hubs, Chandigarh offers practical choices for corporate trips, family holidays, and social events.",
        "sectionTwo": {
            "text": "Chandigarh features luxury, premium, and midscale hotels across central sectors and the Elante/Industrial Area corridor. Below are handpicked stays known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "JW Marriott Hotel Chandigarh",
                    "address": "Sector 35B, Dakshin Marg, Chandigarh 160035",
                    "website": "https://www.marriott.com/en-us/hotels/ixcjw-jw-marriott-hotel-chandigarh/overview/",
                    "averageCost": {
                        "stay": 23000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Spacious rooms and suites with city views",
                        "Multiple restaurants, lounge, and bakery",
                        "Rooftop pool, spa, and fitness center",
                        "Grand ballroom and conference rooms"
                    ],
                    "brief": "A luxury city hotel with destination dining, rooftop leisure, and expansive event spaces—ideal for weddings, conferences, and upscale getaways.",
                    "highlights": [
                        "Central Sector 35 location",
                        "High-capacity banquets and breakout rooms",
                        "Consistent five-star service standards",
                        "Convenient for airport and rail links"
                    ]
                },
                {
                    "name": "Hyatt Regency Chandigarh",
                    "address": "178 Industrial & Business Park, Phase I, Chandigarh 160002",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-regency-chandigarh/ixcra",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining and specialty restaurants",
                        "Outdoor pool, spa, and fitness center",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A premium hotel connected to Elante Mall precinct, offering strong dining, wellness, and event capabilities for business and family stays.",
                    "highlights": [
                        "Direct access to Elante shopping and dining",
                        "Event-friendly floors with modern AV",
                        "Family-friendly leisure facilities",
                        "Quick approach from highway and city center"
                    ]
                },
                {
                    "name": "Taj Chandigarh",
                    "address": "Block No. 9, Sector 17A, Chandigarh 160017",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-chandigarh/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 2000, "max": 4800 }
                    },
                    "facilities": [
                        "Elegant rooms in the main business district",
                        "Specialty restaurants and bar",
                        "Outdoor pool and fitness center",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A classic address in Sector 17 with refined rooms, acclaimed dining, and efficient event spaces—great for corporate and social occasions.",
                    "highlights": [
                        "Walkable to Sector 17 Plaza",
                        "Trusted brand service and cuisine",
                        "Balanced for business and leisure",
                        "Convenient for shopping and offices"
                    ]
                },
                {
                    "name": "Hyatt Centric Sector 17 Chandigarh",
                    "address": "Sector 17E, Chandigarh 160017",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-centric-sector-17-chandigarh/ixcct",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1800, "max": 4200 }
                    },
                    "facilities": [
                        "Stylish, centrally located rooms",
                        "Restaurant, café, and bar",
                        "Fitness center",
                        "Meeting rooms for small events"
                    ],
                    "brief": "A design-forward city hotel in the heart of Sector 17, ideal for quick business trips and stylish weekend breaks.",
                    "highlights": [
                        "Steps from shops and eateries",
                        "Contemporary interiors and amenities",
                        "Efficient for compact meetings",
                        "Easy access to key landmarks"
                    ]
                },
                {
                    "name": "The LaLiT Chandigarh",
                    "address": "IT Park, DLF Commercial Complex, Chandigarh 160101",
                    "website": "https://www.thelalit.com/the-lalit-chandigarh/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple dining outlets and bar",
                        "Spa, salon, pool, and fitness center",
                        "Large banquets and convention-style spaces"
                    ],
                    "brief": "A five-star hotel at IT Park with generous rooms, full-service wellness, and sizeable banquets—popular for conferences and weddings.",
                    "highlights": [
                        "IT Park proximity for corporate stays",
                        "Extensive indoor event capacity",
                        "Wellness-led amenities",
                        "Good highway and airport access"
                    ]
                },
                {
                    "name": "Novotel Chandigarh Tribune Chowk",
                    "address": "Plot 181/45, Industrial Area Phase I, Tribune Chowk, Chandigarh 160002",
                    "website": "https://all.accor.com/hotel/B9M2/index.en.shtml",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All-day dining and bar",
                        "Fitness center",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A contemporary, business-friendly stay near Tribune Chowk with reliable dining and practical event spaces.",
                    "highlights": [
                        "Quick reach to Elante and business parks",
                        "Consistent breakfast and room service",
                        "Value-forward event options",
                        "Good choice for short corporate trips"
                    ]
                },
                {
                    "name": "Hotel Mountview",
                    "address": "Sector 10, Chandigarh 160011",
                    "website": "https://www.hospitality.citcochandigarh.com/hotel-mountview/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms with garden views (select)",
                        "Multi-cuisine restaurant and café",
                        "Outdoor pool and fitness center",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A city landmark with green surroundings, offering relaxed rooms, classic dining, and indoor-outdoor venues for socials and meetings.",
                    "highlights": [
                        "Leafy Sector 10 setting",
                        "Event lawns for gatherings",
                        "Convenient for leisure sightseeing",
                        "Balanced pricing and amenities"
                    ]
                }
            ]
        }
    },

    "shimla": {
        "name": "Shimla",
        "description": "Best hotels in Shimla—mountain-view stays near Mall Road, Jakhu, and Kufri. Enjoy cozy rooms, scenic dining, heated pools/spas (select), and versatile event spaces for weddings and retreats.",
        "sectionOne": "Shimla, the queen of hills, blends colonial-era charm with pine forests, mountain vistas, and a lively Mall Road. Travelers explore The Ridge, Christ Church, Jakhu Temple, and nearby Kufri/Mashobra, supported by rail/road connectivity via Kalka–Shimla line and highways. City hotels focus on warm hospitality, clean rooms, reliable Wi‑Fi, on-site dining, and indoor leisure for cool weather. From iconic heritage addresses with heated pools to chic boutique retreats and value midscale stays, Shimla suits family holidays, honeymoons, and corporate offsites.",
        "sectionTwo": {
            "text": "Shimla features heritage icons, premium resorts, and midscale city hotels across Mall Road, Chaura Maidan, and Kufri/Mashobra. Below are handpicked stays known for great views, dependable service, and strong amenities.",
            "hotels": [
                {
                    "name": "The Oberoi Cecil, Shimla",
                    "address": "Chaura Maidan, Shimla, Himachal Pradesh 171004",
                    "website": "https://www.oberoihotels.com/hotels-in-shimla-cecil/",
                    "averageCost": {
                        "stay": 28000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Heritage rooms with mountain/city views",
                        "Fine dining restaurants and lounge bar",
                        "Heated indoor pool, spa, and fitness centre",
                        "Ballroom and boardroom for intimate events"
                    ],
                    "brief": "A heritage grand hotel with classic wood interiors, refined dining, and a heated pool—perfect for elegant hill holidays and small celebrations.",
                    "highlights": [
                        "Historic charm near key landmarks",
                        "Wellness-led downtime in cool weather",
                        "Personalised service and concierge",
                        "Romantic and family-friendly ambience"
                    ]
                },
                {
                    "name": "Wildflower Hall, An Oberoi Resort, Shimla",
                    "address": "Chharabra, Mashobra, Shimla, Himachal Pradesh 171012",
                    "website": "https://www.oberoihotels.com/hotels-in-shimla-wildflower-hall/",
                    "averageCost": {
                        "stay": 42000,
                        "dining": { "min": 3000, "max": 7000 }
                    },
                    "facilities": [
                        "Luxury rooms with panoramic Himalayan views",
                        "Signature restaurants and alfresco seating",
                        "Heated indoor/outdoor pools and spa",
                        "Nature trails and curated outdoor experiences"
                    ],
                    "brief": "A luxury mountain retreat surrounded by cedar forests, offering serene views, immersive wellness, and memorable dining experiences.",
                    "highlights": [
                        "Iconic Himalayan vantage points",
                        "Couple-friendly private dining",
                        "Guided treks and nature walks",
                        "High-touch hospitality for special occasions"
                    ]
                },
                {
                    "name": "Taj Theog Resort & Spa, Shimla",
                    "address": "Theog, Shimla, Himachal Pradesh 171201",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-theog-resort-spa-shimla/",
                    "averageCost": {
                        "stay": 26000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Contemporary rooms with valley views",
                        "Multiple dining venues and bar",
                        "Indoor heated pool, spa, and fitness centre",
                        "Ballroom and meeting rooms"
                    ],
                    "brief": "A modern luxury resort amid orchards and valleys—pairing heated-pool wellness with destination dining and event-friendly venues.",
                    "highlights": [
                        "Expansive mountain panoramas",
                        "Wellness therapies and cosy lounges",
                        "Wedding and offsite-ready spaces",
                        "Ideal for honeymoons and family breaks"
                    ]
                },
                {
                    "name": "Welcomhotel by ITC Hotels, Shimla",
                    "address": "Village Poshwan, Shimla, Himachal Pradesh 171012",
                    "website": "https://www.itchotels.com/in/en/destinations/hotels-in-shimla",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 1600, "max": 4000 }
                    },
                    "facilities": [
                        "Rooms with mountain and forest views",
                        "All-day dining and bar",
                        "Fitness centre and recreation (property-specific)",
                        "Banquet/meeting facilities"
                    ],
                    "brief": "A hillside premium stay with scenic rooms, warm service, and practical event spaces—good for balanced leisure and business trips.",
                    "highlights": [
                        "Calm setting away from crowds",
                        "Comfort-forward rooms and service",
                        "Event support for small gatherings",
                        "Good access to Mashobra/Chharabra belt"
                    ]
                },
                {
                    "name": "Radisson Hotel Shimla",
                    "address": "Lower Bharari Road, Longwood, Shimla, Himachal Pradesh 171001",
                    "website": "https://www.radissonhotels.com/en-us/hotels/radisson-shimla",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Rooms and suites with valley views",
                        "All-day dining and lounge bar",
                        "Spa services and fitness room",
                        "Banquet hall and meeting rooms"
                    ],
                    "brief": "A reliable city hotel with scenic rooms, spa downtime, and event spaces—close enough to Mall Road yet away from heavy footfall.",
                    "highlights": [
                        "Convenient access to central sights",
                        "Good breakfast and in-room dining",
                        "Value-friendly premium positioning",
                        "Suitable for families and work trips"
                    ]
                },
                {
                    "name": "Hotel Marina, Shimla",
                    "address": "Mall Road, Shimla, Himachal Pradesh 171001",
                    "website": "https://www.marinashimla.com/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Modern rooms on/near Mall Road",
                        "Restaurant, café, and bar",
                        "Spa and fitness room",
                        "Small banquet/meeting space"
                    ],
                    "brief": "A boutique-style address on Mall Road with stylish rooms, convenient dining, and compact event facilities for city-focused stays.",
                    "highlights": [
                        "Walk-to shopping and eateries",
                        "Easy access to The Ridge/Christ Church",
                        "Good for quick weekend breaks",
                        "Comfort at a central location"
                    ]
                },
                {
                    "name": "The Orchid Shimla",
                    "address": "Sanjauli, Shimla, Himachal Pradesh 171006",
                    "website": "https://www.orchidhotel.com/the-orchid-shimla/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Mountain-view rooms and suites",
                        "Restaurant and rooftop seating (property-specific)",
                        "Indoor activities corner (select) and fitness room",
                        "Banquet/meeting room"
                    ],
                    "brief": "A modern, value-forward hotel with scenic rooms and easy access to city highlights—popular for families and small events.",
                    "highlights": [
                        "Rooftop/terrace views (select)",
                        "Family-friendly layouts and dining",
                        "Easy taxi access to Mall Road",
                        "Balanced price-to-amenities"
                    ]
                }
            ]
        }
    },

    "ranchi": {
        "name": "Ranchi",
        "description": "Best hotels in Ranchi—well-located stays near Main Road, Hinoo, and the airport. Enjoy reliable dining, clean rooms, event spaces, and easy access to business hubs and city sights.",
        "sectionOne": "Ranchi, the capital of Jharkhand, blends expanding business districts with lakes, waterfalls, and sports venues. Travelers visit Kanke Dam, Rock Garden, Nakshatra Van, and the Morabadi grounds while benefiting from strong rail and air connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, multi-cuisine dining, and flexible banquet halls for conferences and social events. From premium brands with pools and spas to centrally located midscale stays, Ranchi offers practical choices for corporate trips, family travel, and weekend breaks.",
        "sectionTwo": {
            "text": "Ranchi features premium and midscale hotels across Main Road, Hinoo, and airport corridors. Below are handpicked stays known for balanced locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Courtyard by Marriott Ranchi",
                    "address": "Station Road, near Kishoreganj Chowk, Ranchi, Jharkhand 834001",
                    "website": "https://www.marriott.com/",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining, lounge bar, and bakery",
                        "Outdoor pool, spa, and fitness center",
                        "Grand ballroom and meeting rooms"
                    ],
                    "brief": "A premium, event-ready city hotel with robust dining and wellness—ideal for conferences, weddings, and comfortable family stays.",
                    "highlights": [
                        "Central connectivity to business and shopping",
                        "High-capacity banquets and breakout spaces",
                        "Reliable brand standards and service",
                        "Convenient access to rail and city sights"
                    ]
                },
                {
                    "name": "Radisson Blu Hotel Ranchi",
                    "address": "Main Road, Kadru Diversion, Ranchi, Jharkhand 834001",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1500, "max": 3500 }
                    },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple dining outlets and bar",
                        "Outdoor pool and fitness center",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A centrally located premium hotel popular for business trips and social events, with strong dining and leisure facilities.",
                    "highlights": [
                        "Prime Main Road access",
                        "Versatile event and meeting venues",
                        "Consistent breakfast and room service",
                        "Good for short and extended stays"
                    ]
                },
                {
                    "name": "Ramada by Wyndham Ranchi",
                    "address": "Airport Road, Hinoo, Ranchi, Jharkhand 834002",
                    "website": "https://www.wyndhamhotels.com/ramada",
                    "averageCost": {
                        "stay": 10500,
                        "dining": { "min": 1300, "max": 3200 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All-day dining and lounge bar",
                        "Fitness center (property-specific)",
                        "Banquet and conference spaces"
                    ],
                    "brief": "An airport-corridor hotel with practical rooms, dependable dining, and event-friendly halls for business and family travel.",
                    "highlights": [
                        "Quick access to airport and industrial zones",
                        "Efficient check-in/out for short trips",
                        "Multiple room categories",
                        "Balanced pricing for longer stays"
                    ]
                },
                {
                    "name": "Le Lac Sarovar Portico, Ranchi",
                    "address": "Line Tank Road, Ranchi, Jharkhand 834001",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms with city/lake proximity",
                        "Multi-cuisine restaurant and bar",
                        "Fitness room",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A dependable city hotel with convenient dining and compact event spaces—good for work trips and family visits.",
                    "highlights": [
                        "Central location near markets and offices",
                        "Popular breakfast and in-room dining",
                        "Value-forward event options",
                        "Easy access to lakeside walks"
                    ]
                },
                {
                    "name": "Capitol Hill",
                    "address": "Mahatma Gandhi Main Road, Ranchi, Jharkhand 834001",
                    "website": "https://www.hotelcapitolhill.com/",
                    "averageCost": {
                        "stay": 8500,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Neat rooms with essential amenities",
                        "Restaurant, café, and bar",
                        "Fitness room",
                        "Banquet and conference facilities"
                    ],
                    "brief": "A centrally placed business hotel with reliable rooms, varied dining, and meeting spaces—suited to quick corporate visits.",
                    "highlights": [
                        "Walkable to shopping and eateries",
                        "Efficient front-desk services",
                        "Good value in the city center",
                        "Suitable for short stays and meetings"
                    ]
                },
                {
                    "name": "Chanakya BNR Hotel Ranchi",
                    "address": "Station Road, Ranchi, Jharkhand 834001",
                    "website": "https://www.chanakyabnrhotels.com/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Classic rooms with heritage touches",
                        "Multi-cuisine restaurant and café",
                        "Event hall (property-specific)",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A heritage-style city hotel offering comfortable rooms and straightforward dining in a convenient, transit-friendly location.",
                    "highlights": [
                        "Close to railway connectivity",
                        "Calm ambience and classic interiors",
                        "Practical for families and solo travelers",
                        "Good base for city sightseeing"
                    ]
                }
            ]
        }
    },

    "bengaluru": {
        "name": "Bengaluru",
        "description": "Best hotels in Bengaluru—premium and midscale stays near MG Road, Outer Ring Road, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Bengaluru, India’s tech capital, blends vibrant business districts with gardens, nightlife, and top dining. Travelers explore Cubbon Park, Lalbagh, UB City, and heritage hotspots, supported by strong air, rail, and metro connectivity. City hotels emphasize clean rooms, reliable Wi‑Fi, multiple restaurants and bars, pools/spas (select), and banquet facilities for conferences and weddings. From five-star icons to smart business hotels near tech parks, Bengaluru offers practical options for corporate trips, family getaways, and extended stays.",
        "sectionTwo": {
            "text": "Bengaluru features luxury landmarks, premium business hotels, and stylish boutique stays across MG Road, CBD, Whitefield, and Outer Ring Road. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The Oberoi, Bengaluru",
                    "address": "37-39, MG Road, Bengaluru, Karnataka 560001",
                    "website": "https://www.oberoihotels.com/hotels-in-bengaluru/",
                    "averageCost": {
                        "stay": 28000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Garden-facing rooms and suites with balconies",
                        "Award‑winning restaurants and bar",
                        "Pool, spa, and fitness centre",
                        "Meeting rooms and intimate event spaces"
                    ],
                    "brief": "A lush MG Road sanctuary with acclaimed dining, tranquil gardens, and boutique‑style luxury—ideal for business and city breaks.",
                    "highlights": [
                        "Central CBD location near metro",
                        "Renowned hospitality and cuisine",
                        "Serene landscaped courtyards",
                        "Efficient venues for small events"
                    ]
                },
                {
                    "name": "The Leela Palace Bengaluru",
                    "address": "23, HAL Old Airport Road, Bengaluru, Karnataka 560008",
                    "website": "https://www.theleela.com/the-leela-palace-bengaluru",
                    "averageCost": {
                        "stay": 30000,
                        "dining": { "min": 3000, "max": 7000 }
                    },
                    "facilities": [
                        "Palatial rooms and suites with garden/city views",
                        "Multiple specialty restaurants and lounges",
                        "Outdoor pool, luxury spa, and fitness centre",
                        "Grand ballrooms and boardrooms"
                    ],
                    "brief": "A modern palace hotel offering grand interiors, destination dining, and large‑scale event spaces—perfect for weddings and C‑suite stays.",
                    "highlights": [
                        "Nine‑acre landscaped grounds",
                        "Club lounge privileges (select)",
                        "High‑touch concierge services",
                        "Convenient to Indiranagar/tech hubs"
                    ]
                },
                {
                    "name": "ITC Gardenia, a Luxury Collection Hotel, Bengaluru",
                    "address": "No.1, Residency Road, Bengaluru, Karnataka 560025",
                    "website": "https://www.itchotels.com/in/en/itcgardenia-bengaluru",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Elegant rooms and suites",
                        "Iconic Indian and global dining",
                        "Pool, Kaya Kalp spa, and fitness centre",
                        "Expansive banquets and meeting spaces"
                    ],
                    "brief": "A sustainability‑led luxury address in the heart of the city, loved for signature restaurants and polished event operations.",
                    "highlights": [
                        "LEED® Platinum eco credentials",
                        "Destination dining experiences",
                        "City‑centre convenience",
                        "Seasoned conference planning teams"
                    ]
                },
                {
                    "name": "The Ritz‑Carlton, Bangalore",
                    "address": "99, Residency Road, Bengaluru, Karnataka 560025",
                    "website": "https://www.ritzcarlton.com/en/hotels/india/bangalore",
                    "averageCost": {
                        "stay": 28000,
                        "dining": { "min": 2800, "max": 6500 }
                    },
                    "facilities": [
                        "Luxurious rooms with city views",
                        "Multiple restaurants, afternoon tea, rooftop bar",
                        "Spa, outdoor pool, and fitness studio",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "An art‑rich luxury hotel with standout spa, refined dining, and sophisticated venues for upscale events and stays.",
                    "highlights": [
                        "Residency Road CBD access",
                        "Curated culinary concepts",
                        "Signature spa therapies",
                        "High‑service guest experience"
                    ]
                },
                {
                    "name": "JW Marriott Hotel Bengaluru",
                    "address": "24/1, Vittal Mallya Road, Bengaluru, Karnataka 560001",
                    "website": "https://www.marriott.com/en-us/hotels/blrjw-jw-marriott-hotel-bengaluru/overview/",
                    "averageCost": {
                        "stay": 20000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Spacious rooms and suites overlooking Cubbon Park (select)",
                        "All‑day dining, specialty restaurants, bakery",
                        "Outdoor pool, spa, and gym",
                        "Large ballrooms and meeting rooms"
                    ],
                    "brief": "A central luxury hotel with robust dining, park‑adjacent views, and strong MICE capabilities—great for conferences and city vacations.",
                    "highlights": [
                        "Walkable to UB City and museums",
                        "Popular Sunday brunches",
                        "High‑capacity banquets",
                        "Corporate‑friendly location"
                    ]
                },
                {
                    "name": "Four Seasons Hotel Bengaluru at Embassy ONE",
                    "address": "8, Bellary Road, Ganganagar, Bengaluru, Karnataka 560024",
                    "website": "https://www.fourseasons.com/bengaluru/",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Signature restaurants and bar",
                        "Outdoor pool, spa, and fitness centre",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A chic luxury hotel in the Embassy ONE precinct with refined rooms, upscale dining, and polished event operations.",
                    "highlights": [
                        "Proximity to Hebbal/airport corridor",
                        "Lush pool gardens and bar scene",
                        "Attentive, detail‑oriented service",
                        "Efficient business amenities"
                    ]
                },
                {
                    "name": "Shangri‑La Bengaluru",
                    "address": "No. 56‑6B, Palace Road, Bengaluru, Karnataka 560001",
                    "website": "https://www.shangri-la.com/bengaluru/shangrila/",
                    "averageCost": {
                        "stay": 19000,
                        "dining": { "min": 1800, "max": 5000 }
                    },
                    "facilities": [
                        "Rooms and suites with skyline views",
                        "Multiple restaurants and bars",
                        "CHI, The Spa, pool, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A skyline‑view luxury stay with diverse dining, serene spa, and flexible venues—ideal for both leisure and executive travel.",
                    "highlights": [
                        "Palace Road and CBD connectivity",
                        "Panoramic city vistas",
                        "Recognized F&B variety",
                        "Conference‑ready floors"
                    ]
                },
                {
                    "name": "Sheraton Grand Bengaluru Whitefield Hotel & Convention Center",
                    "address": "Prestige Shantiniketan, Whitefield, Bengaluru, Karnataka 560066",
                    "website": "https://www.marriott.com/en-us/hotels/blrgs-sheraton-grand-bengaluru-whitefield-hotel-and-convention-center/overview/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1600, "max": 4200 }
                    },
                    "facilities": [
                        "Modern rooms in the tech corridor",
                        "All‑day dining and specialty outlets",
                        "Pool, spa, and fitness centre",
                        "Convention centre and ballrooms"
                    ],
                    "brief": "A convention‑scale hotel in Whitefield with big‑ticket event capacity, smart rooms, and convenient access to tech parks.",
                    "highlights": [
                        "Ideal for large conferences",
                        "Close to corporate campuses",
                        "Efficient meeting logistics",
                        "Good long‑stay comfort"
                    ]
                },
                {
                    "name": "Aloft Bengaluru Outer Ring Road",
                    "address": "Cessna Business Park, Kadubeesanahalli, Bengaluru, Karnataka 560103",
                    "website": "https://www.marriott.com/en-us/hotels/blrlo-aloft-bengaluru-outer-ring-road/overview/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Smart, tech‑friendly rooms",
                        "All‑day dining and grab‑and‑go",
                        "Rooftop/Outdoor pool and fitness",
                        "Meeting rooms"
                    ],
                    "brief": "A youthful business hotel on ORR with efficient rooms, casual dining, and practical meeting spaces—great for weekday work trips.",
                    "highlights": [
                        "Adjacent to major tech parks",
                        "Fast check‑in and F&B convenience",
                        "Reliable connectivity and Wi‑Fi",
                        "Value‑forward for corporate travelers"
                    ]
                },
                {
                    "name": "The Zuri Whitefield, Bengaluru",
                    "address": "ITPL Road, Whitefield, Bengaluru, Karnataka 560066",
                    "website": "https://www.thezurihotels.com/bengaluru/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1200, "max": 3200 }
                    },
                    "facilities": [
                        "Contemporary rooms near IT parks",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness centre",
                        "Banquet and meeting facilities"
                    ],
                    "brief": "A dependable Whitefield hotel with robust dining, wellness, and event spaces—well‑suited to tech‑park itineraries.",
                    "highlights": [
                        "Easy reach to ITPL/EPIP Zone",
                        "Popular buffet and in‑room dining",
                        "Balanced price‑to‑amenities",
                        "Good for short and extended stays"
                    ]
                }
            ]
        }
    },

    "thiruvananthapuram": {
        "name": "Thiruvananthapuram",
        "description": "Best hotels in Thiruvananthapuram—premium and midscale stays near MG Road, Kovalam, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Thiruvananthapuram (Trivandrum), Kerala’s capital, blends coastal scenery, heritage landmarks, and thriving business districts. Visitors explore Padmanabhaswamy Temple, Napier Museum, Shanghumugham Beach, and nearby Kovalam, supported by strong air, rail, and road connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, multiple dining outlets, and flexible banquet facilities for conferences and weddings. From five‑star addresses with pools and spas to centrally located business hotels, the city suits corporate trips, family holidays, pilgrimages, and medical travel.",
        "sectionTwo": {
            "text": "Thiruvananthapuram features luxury beach resorts, premium city hotels, and value business stays across MG Road, airport corridors, and Kovalam. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Hyatt Regency Trivandrum",
                    "address": "CV Raman Pillai Road, Near Kerala Government Secretariat, Thiruvananthapuram, Kerala 695014",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-regency-trivandrum/trvrt",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites in city center",
                        "All‑day dining, specialty restaurant, and bar",
                        "Outdoor pool, spa, and fitness center",
                        "Ballrooms and meeting rooms with modern AV"
                    ],
                    "brief": "A polished city‑centre hotel with refined rooms, strong dining, and event‑ready venues—ideal for business and leisure stays.",
                    "highlights": [
                        "Proximity to Secretariat and MG Road",
                        "High‑capacity banquets and breakouts",
                        "Reliable brand standards and service",
                        "Convenient for museums and markets"
                    ]
                },
                {
                    "name": "Vivanta Thiruvananthapuram",
                    "address": "C V Raman Pillai Road, Thycaud, Thiruvananthapuram, Kerala 695014",
                    "website": "https://www.vivantahotels.com/en-in/vivanta-thiruvananthapuram/",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "Signature restaurants and lounge bar",
                        "Rooftop pool, spa services, and gym",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A premium city hotel with rooftop leisure and signature dining, suited to corporate travelers and family weekends.",
                    "highlights": [
                        "Central access to offices and sights",
                        "Rooftop pool with city views",
                        "Efficient meeting and event setups",
                        "Consistent breakfast and room service"
                    ]
                },
                {
                    "name": "O by Tamara, Trivandrum",
                    "address": "Bypass Road, Near Aakkulam Bridge, Thiruvananthapuram, Kerala 695029",
                    "website": "https://www.tamarahotels.com/o-by-tamara-trivandrum/",
                    "averageCost": {
                        "stay": 13000,
                        "dining": { "min": 1600, "max": 4200 }
                    },
                    "facilities": [
                        "Well‑appointed rooms and suites",
                        "Multiple dining outlets and bar",
                        "Pool, spa, and fitness center",
                        "Large banquets and meeting rooms"
                    ],
                    "brief": "A stylish premium hotel on the bypass with robust dining, wellness, and large event capacity for weddings and conferences.",
                    "highlights": [
                        "Good connectivity to airport and Technopark",
                        "High‑capacity banquet floors",
                        "Family‑friendly leisure facilities",
                        "Reliable long‑stay comfort"
                    ]
                },
                {
                    "name": "Hilton Garden Inn Trivandrum",
                    "address": "Punnen Road, Statue, Palayam, Thiruvananthapuram, Kerala 695039",
                    "website": "https://www.hilton.com/en/hotels/trvgigi-hilton-garden-inn-trivandrum/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1400, "max": 3200 }
                    },
                    "facilities": [
                        "Comfortable rooms near MG Road",
                        "All‑day dining and bar",
                        "Outdoor pool and fitness center",
                        "Meeting rooms and business services"
                    ],
                    "brief": "A dependable city‑center stay with practical rooms, consistent dining, and compact meeting facilities close to shopping and offices.",
                    "highlights": [
                        "Walkable to markets and restaurants",
                        "Efficient check‑in and services",
                        "Good for short corporate trips",
                        "Brand reliability for business travel"
                    ]
                },
                {
                    "name": "Uday Suites – Airport Hotel",
                    "address": "Watts Lane, Shangumugham, Thiruvananthapuram, Kerala 695007",
                    "website": "https://www.udaysuites.in/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Spacious rooms in a garden setting",
                        "Restaurant and café",
                        "Outdoor pool and fitness room",
                        "Event hall (property‑specific)"
                    ],
                    "brief": "A resort‑like airport‑side hotel near the beach with relaxed rooms, a landscaped pool, and convenient dining for families and transit stays.",
                    "highlights": [
                        "Quick airport access",
                        "Beach proximity at Shangumugham",
                        "Family‑friendly ambience",
                        "Value‑forward leisure facilities"
                    ]
                },
                {
                    "name": "Taj Green Cove Resort & Spa, Kovalam",
                    "address": "G. V. Raja Vattappara Road, Kovalam, Kerala 695527",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-green-cove-resort-and-spa-kovalam/",
                    "averageCost": {
                        "stay": 26000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Luxury rooms and villas with sea/lagoon views",
                        "Specialty restaurants and bars",
                        "J Wellness Circle spa, pool, and fitness",
                        "Lawns and halls for events"
                    ],
                    "brief": "A luxury coastal resort near Trivandrum offering scenic stays, destination dining, and wellness—ideal for honeymoons and upscale retreats.",
                    "highlights": [
                        "Clifftop and lagoon vistas",
                        "Curated spa and yoga experiences",
                        "Indoor‑outdoor event venues",
                        "Easy access to Kovalam beaches"
                    ]
                },
                {
                    "name": "Classic Sarovar Portico, Trivandrum",
                    "address": "Manjalikulam Road, Thampanoor, Thiruvananthapuram, Kerala 695001",
                    "website": "https://www.sarovarhotels.com/classic-sarovar-portico-trivandrum/",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Comfortable rooms near station and bus stand",
                        "Multi‑cuisine restaurant and café",
                        "Rooftop pool (property‑specific) and gym",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A centrally located hotel with practical rooms, easy transit access, and versatile event spaces—good for families and work trips.",
                    "highlights": [
                        "Transit‑friendly Thampanoor location",
                        "Popular breakfast options",
                        "Value pricing in the city center",
                        "Balanced amenities for short stays"
                    ]
                }
            ]
        }
    },

    "bhopal": {
        "name": "Bhopal",
        "description": "Best hotels in Bhopal—well-located stays near MP Nagar, New Market, and the lakefront. Enjoy reliable dining, clean rooms, event spaces, and easy access to business hubs and heritage sights.",
        "sectionOne": "Bhopal, the capital of Madhya Pradesh, blends serene lakes, heritage architecture, and growing business districts. Travelers explore Upper Lake, VIP Road, Shaukat Mahal, Van Vihar National Park, and tribal/archaeological museums while benefiting from strong rail, air, and highway connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, multi-cuisine dining, and flexible banquet halls for conferences and social events. From premium brands with pools and spas to centrally located midscale stays, Bhopal suits corporate trips, family travel, and weekend breaks.",
        "sectionTwo": {
            "text": "Bhopal offers premium and midscale hotels across MP Nagar, the lakefront, and airport corridors. Below are handpicked stays known for balanced locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Lakefront Bhopal",
                    "address": "VIP Road, Near Upper Lake, Bhopal, Madhya Pradesh 462002",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-lakefront-bhopal/",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Luxury rooms and suites with lake or city views",
                        "Multiple specialty restaurants and bar",
                        "Outdoor pool, J Wellness Circle spa, and gym",
                        "Grand ballroom, lawns, and meeting rooms"
                    ],
                    "brief": "A contemporary luxury hotel overlooking the lake, known for destination dining, wellness, and event-ready venues.",
                    "highlights": [
                        "Scenic VIP Road address",
                        "Indoor–outdoor event flexibility",
                        "Family-friendly leisure amenities",
                        "Convenient for lakeside attractions"
                    ]
                },
                {
                    "name": "Radisson Bhopal",
                    "address": "C10, DDN Square, Hoshangabad Road, Bhopal, Madhya Pradesh 462026",
                    "website": "https://www.radissonhotels.com/en-us/hotels/radisson-bhopal",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1500, "max": 3500 }
                    },
                    "facilities": [
                        "Modern rooms and suites",
                        "All-day dining, specialty restaurant, and lounge bar",
                        "Rooftop pool (select), gym, and spa services",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A premium business hotel on Hoshangabad Road with strong dining, leisure, and versatile event spaces.",
                    "highlights": [
                        "Quick access to corporate clusters",
                        "Reliable breakfast and room service",
                        "Multiple venue sizes for MICE",
                        "Good pick for short and extended stays"
                    ]
                },
                {
                    "name": "Courtyard by Marriott Bhopal",
                    "address": "DB City Mall, Arera Hills, Bhopal, Madhya Pradesh 462011",
                    "website": "https://www.marriott.com/en-us/hotels/bhocy-courtyard-bhopal/overview/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms with ergonomic workspaces",
                        "All-day dining, bakery, and bar",
                        "Outdoor pool, spa, and fitness center",
                        "Grand ballroom and meeting rooms"
                    ],
                    "brief": "A mall-connected premium hotel with robust dining, wellness, and event capabilities—ideal for conferences and family city breaks.",
                    "highlights": [
                        "Direct access to DB City Mall",
                        "High-capacity banquets and breakouts",
                        "Central location for business and shopping",
                        "Consistent brand standards"
                    ]
                },
                {
                    "name": "Jehan Numa Palace Hotel",
                    "address": "157, Shamla Hills, Bhopal, Madhya Pradesh 462013",
                    "website": "https://www.jehannuma.com/jehan-numa-palace/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 2000, "max": 4800 }
                    },
                    "facilities": [
                        "Heritage-style rooms and suites amid gardens",
                        "Multiple restaurants and classic bar",
                        "Outdoor pool and fitness room",
                        "Banquet lawns and indoor venues"
                    ],
                    "brief": "A heritage address with colonial charm, lush lawns, and refined dining—popular for elegant getaways and social events.",
                    "highlights": [
                        "Shamla Hills greenery and calm",
                        "Indoor–outdoor event settings",
                        "Signature regional cuisine",
                        "Easy reach to museums and lakefront"
                    ]
                },
                {
                    "name": "Hotel Courtyard by Anise (Formerly Hotel Amer Palace)",
                    "address": "Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462011",
                    "website": "https://www.hotelamerpalace.com/",
                    "averageCost": {
                        "stay": 7500,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Neat rooms in the business district",
                        "Restaurant, café, and bakery",
                        "Fitness room",
                        "Banquet and conference facilities"
                    ],
                    "brief": "A centrally placed business hotel in MP Nagar offering practical rooms, varied dining, and meeting spaces.",
                    "highlights": [
                        "Walkable to markets and offices",
                        "Efficient front-desk services",
                        "Value-friendly corporate amenities",
                        "Suitable for short stays and meetings"
                    ]
                },
                {
                    "name": "Enrise by Sayaji Bhopal",
                    "address": "Hoshangabad Road, Bhopal, Madhya Pradesh 462026",
                    "website": "https://www.sayajihotels.com/hotel/enrise-by-sayaji-bhopal/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Well-kept rooms with modern amenities",
                        "Multi-cuisine restaurant and lounge",
                        "Fitness corner (property-specific)",
                        "Banquet hall and meeting room"
                    ],
                    "brief": "A value-forward, business-friendly stay on a key corridor with clean rooms and practical event options.",
                    "highlights": [
                        "Good roadway connectivity",
                        "Popular buffet and in-room dining",
                        "Compact, efficient venues",
                        "Balanced price-to-amenities"
                    ]
                }
            ]
        }
    },

    "mumbai": {
        "name": "Mumbai",
        "description": "Best hotels in Mumbai—iconic sea-facing and business‑district stays near Marine Drive, BKC, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Mumbai, India’s financial and entertainment capital, blends seafront promenades with high-energy business hubs and historic landmarks. Travelers explore Marine Drive, Gateway of India, Kala Ghoda, and Bandra’s dining and nightlife, supported by strong air, suburban rail, and Metro connectivity. City hotels focus on polished rooms, dependable Wi‑Fi, destination dining, and extensive banquet floors for conferences and weddings. From legendary waterfront icons to BKC’s contemporary luxury and airport‑corridor business stays, Mumbai fits corporate trips, family getaways, and long stays.",
        "sectionTwo": {
            "text": "Mumbai features legendary waterfront hotels, premium business properties in BKC and Lower Parel, and stylish stays across Bandra–Juhu–Andheri. Below are handpicked hotels known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The Taj Mahal Palace, Mumbai",
                    "address": "Apollo Bunder, Colaba, Mumbai, Maharashtra 400001",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-mahal-palace-mumbai/",
                    "averageCost": {
                        "stay": 40000,
                        "dining": { "min": 3500, "max": 8000 }
                    },
                    "facilities": [
                        "Iconic sea-facing rooms and heritage suites",
                        "Multiple award‑winning restaurants and bars",
                        "Outdoor pool, J Wellness Circle spa, and gym",
                        "Grand ballrooms, salons, and meeting rooms"
                    ],
                    "brief": "A legendary waterfront address opposite the Gateway of India, renowned for heritage luxury, destination dining, and marquee events.",
                    "highlights": [
                        "Unrivalled Colaba location and sea views",
                        "Signature Indian and global cuisine",
                        "Palace‑wing butler service (select)",
                        "Preferred venue for high‑profile events"
                    ]
                },
                {
                    "name": "The Oberoi, Mumbai",
                    "address": "Nariman Point, Mumbai, Maharashtra 400021",
                    "website": "https://www.oberoihotels.com/hotels-in-mumbai-the-oberoi/",
                    "averageCost": {
                        "stay": 32000,
                        "dining": { "min": 3000, "max": 7000 }
                    },
                    "facilities": [
                        "Contemporary sea-view rooms and suites",
                        "Fine dining restaurants, bar, and patisserie",
                        "Outdoor pool, spa, and fitness centre",
                        "Meeting rooms and elegant event spaces"
                    ],
                    "brief": "A modern luxury icon on Marine Drive with panoramic vistas, refined dining, and discreet, high-touch service.",
                    "highlights": [
                        "Marine Drive promenade frontage",
                        "Quiet, minimalist luxury aesthetic",
                        "Acclaimed service and security standards",
                        "Ideal for executives and city breaks"
                    ]
                },
                {
                    "name": "Trident, Nariman Point",
                    "address": "Nariman Point, Mumbai, Maharashtra 400021",
                    "website": "https://www.tridenthotels.com/hotels-in-mumbai-nariman-point/",
                    "averageCost": {
                        "stay": 20000,
                        "dining": { "min": 2200, "max": 5000 }
                    },
                    "facilities": [
                        "Sea-view rooms along the Queen’s Necklace",
                        "Multi‑cuisine restaurants and lounge",
                        "Outdoor pool and fitness centre",
                        "Banquets and meeting facilities"
                    ],
                    "brief": "A sea-facing business‑leisure favorite on Marine Drive, offering dependable rooms, dining, and event spaces.",
                    "highlights": [
                        "Classic Marine Drive skyline views",
                        "Central access to South Mumbai",
                        "Strong breakfast and room service",
                        "Great value in a prime locale"
                    ]
                },
                {
                    "name": "The St. Regis Mumbai",
                    "address": "462, Senapati Bapat Marg, Lower Parel, Mumbai, Maharashtra 400013",
                    "website": "https://www.marriott.com/en-us/hotels/bomst-the-st-regis-mumbai/overview/",
                    "averageCost": {
                        "stay": 26000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "City‑view rooms and suites in a lifestyle district",
                        "Multiple restaurants, bars, and high‑tea lounge",
                        "Pool, Iridium Spa, and fitness centre",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A luxury lifestyle hotel attached to a high‑end mall complex, known for vibrant dining and large event capacity in Lower Parel.",
                    "highlights": [
                        "Direct link to Palladium/High Street Phoenix",
                        "Skyline bars and social venues",
                        "Popular for weddings and launches",
                        "Central to business and nightlife"
                    ]
                },
                {
                    "name": "Sofitel Mumbai BKC",
                    "address": "C 57, Bandra Kurla Complex, Mumbai, Maharashtra 400051",
                    "website": "https://all.accor.com/hotel/6451/index.en.shtml",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Elegant rooms in the financial district",
                        "French‑Indian dining concepts and bar",
                        "Outdoor pool, spa, and gym",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "A polished business‑district hotel in BKC with upscale dining, spa‑led downtime, and efficient meeting floors.",
                    "highlights": [
                        "Walkable to BKC corporate offices",
                        "Club lounge privileges (select)",
                        "Event‑ready with modern AV",
                        "Good airport/expressway access"
                    ]
                },
                {
                    "name": "Trident, Bandra Kurla",
                    "address": "C-56, G Block, Bandra Kurla Complex, Mumbai, Maharashtra 400051",
                    "website": "https://www.tridenthotels.com/hotels-in-mumbai-bandra-kurla/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Contemporary rooms in BKC",
                        "All‑day dining, specialty outlets, and bar",
                        "Outdoor pool and fitness centre",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A business‑first hotel in BKC with reliable rooms, strong F&B, and versatile venues for meetings and socials.",
                    "highlights": [
                        "Prime BKC address for corporate travel",
                        "Efficient check‑in and services",
                        "Consistent breakfast and room dining",
                        "Value‑forward in the financial hub"
                    ]
                },
                {
                    "name": "JW Marriott Mumbai Juhu",
                    "address": "Juhu Tara Road, Juhu, Mumbai, Maharashtra 400049",
                    "website": "https://www.marriott.com/en-us/hotels/bomjw-jw-marriott-mumbai-juhu/overview/",
                    "averageCost": {
                        "stay": 24000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Beachfront rooms and suites (select sea view)",
                        "Multiple restaurants, bakery, and bars",
                        "Outdoor pools, spa, and fitness centre",
                        "Ballrooms and event lawns"
                    ],
                    "brief": "A flagship beachfront hotel in Juhu with destination dining, resort‑style pools, and large indoor‑outdoor event spaces.",
                    "highlights": [
                        "Direct beach access and sunsets",
                        "Celebrity‑favoured dining venues",
                        "Family‑friendly leisure amenities",
                        "Convenient to Bandra/airport"
                    ]
                },
                {
                    "name": "Taj Santacruz, Mumbai",
                    "address": "Chhatrapati Shivaji Maharaj International Airport, Santacruz (E), Mumbai, Maharashtra 400099",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-santacruz-mumbai/",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Spacious, sound‑insulated rooms near terminals",
                        "Signature specialty restaurants and bar",
                        "Outdoor pool, spa, and gym",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A luxury airport‑side hotel with grand rooms, refined dining, and quiet comfort—ideal for flyers and quick corporate trips.",
                    "highlights": [
                        "Terminal‑area convenience",
                        "Club lounge and butler (select)",
                        "Efficient for layovers and meetings",
                        "Reliable luxury service standards"
                    ]
                },
                {
                    "name": "The Leela Mumbai",
                    "address": "Sahar, Andheri (E), Mumbai, Maharashtra 400059",
                    "website": "https://www.theleela.com/the-leela-mumbai",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Garden‑view rooms and suites near the airport",
                        "Multiple restaurants, bar, and patisserie",
                        "Pool, spa, and fitness centre",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A lush, resort‑style luxury hotel near the international airport, balancing tranquil gardens with business‑ready amenities.",
                    "highlights": [
                        "Green oasis amid Andheri’s bustle",
                        "Club floors and airport convenience",
                        "Known for polished F&B programs",
                        "Preferred for business/leisure mix"
                    ]
                },
                {
                    "name": "ITC Maratha, a Luxury Collection Hotel, Mumbai",
                    "address": "Sahar, Andheri (E), Mumbai, Maharashtra 400099",
                    "website": "https://www.itchotels.com/in/en/itcmaratha-mumbai",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2200, "max": 5200 }
                    },
                    "facilities": [
                        "Elegant rooms and suites with classic design",
                        "Celebrated Indian fine‑dining and global outlets",
                        "Kaya Kalp spa, pool, and fitness",
                        "Expansive banquets and boardrooms"
                    ],
                    "brief": "A heritage‑inspired luxury hotel with iconic Indian dining, comprehensive wellness, and strong event capabilities near the airport.",
                    "highlights": [
                        "Responsible Luxury sustainability focus",
                        "Signature restaurants and patisserie",
                        "Airport/Andheri business access",
                        "Seasoned conference planning"
                    ]
                }
            ]
        }
    },


    "imphal": {
        "name": "Imphal",
        "description": "Best hotels in Imphal—well-located stays near Thangal Bazar, North AOC, and the airport. Enjoy reliable dining, clean rooms, basic event spaces, and quick access to Kangla Fort and Ema Keithel.",
        "sectionOne": "Imphal, the capital of Manipur, blends heritage sites, lively bazaars, and scenic hills. Visitors explore Kangla Fort, Ema Keithel (women’s market), War Cemetery, and Loktak Lake day trips, supported by growing air and road connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, on-site dining, and compact banquet halls suitable for meetings and social functions. From central business-friendly stays to boutique properties, Imphal suits government work trips, family visits, and cultural getaways.",
        "sectionTwo": {
            "text": "Imphal features a mix of midscale and boutique hotels across central markets and airport corridors. Below are handpicked stays known for location, practical amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Hotel Imphal by Classic",
                    "address": "North AOC, Imphal, Manipur 795001",
                    "website": "https://www.hotelimphal.com",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Comfortable rooms with city access",
                        "Multi-cuisine restaurant and café",
                        "Event lawn and banquet hall",
                        "Wi‑Fi, parking, and travel assistance"
                    ],
                    "brief": "A centrally located city hotel with green lawns, reliable dining, and event-friendly spaces near key landmarks.",
                    "highlights": [
                        "Quick reach to Kangla Fort and markets",
                        "Spacious grounds for socials",
                        "Consistent city-center convenience",
                        "Good for families and work trips"
                    ]
                },
                {
                    "name": "Classic Grande, a member of Radisson Individuals",
                    "address": "Chingmeirong, Imphal, Manipur 795001",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1400, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms and suites",
                        "All-day dining and lounge",
                        "Pool (property-specific) and fitness",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A polished, full-service hotel offering contemporary rooms, dependable dining, and versatile venues for events.",
                    "highlights": [
                        "Business-friendly location and access",
                        "Event-ready floors with AV support",
                        "Brand-backed service consistency",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "Sangai Continental (The Boutique Hotel)",
                    "address": "Thangal Bazar, Imphal, Manipur 795001",
                    "website": "https://www.sangaicontinental.com/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Boutique rooms with essential amenities",
                        "On-site restaurant and room service",
                        "Fitness corner (property-specific)",
                        "Wi‑Fi and limited parking"
                    ],
                    "brief": "A boutique-style stay in a central market area, offering convenient dining and practical comforts for short trips.",
                    "highlights": [
                        "Steps to shops and eateries",
                        "Easy access to local transport",
                        "Value-forward city base",
                        "Suitable for solo and family stays"
                    ]
                },
                {
                    "name": "The Classic Hotel",
                    "address": "North AOC, Imphal, Manipur 795001",
                    "website": "https://theclassichotel.in/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Well-kept rooms in a central precinct",
                        "Restaurant, café, and in-room dining",
                        "Banquet/meeting facilities",
                        "Wi‑Fi, parking, concierge"
                    ],
                    "brief": "A centrally placed hotel with tidy rooms, steady dining, and meeting spaces—good for business delegates and families.",
                    "highlights": [
                        "Proximity to administrative hubs",
                        "Popular breakfast options",
                        "Efficient for short work trips",
                        "Balanced amenities and pricing"
                    ]
                },
                {
                    "name": "Hotel Yaiphaba",
                    "address": "Thangal Bazar, Imphal, Manipur 795001",
                    "website": "https://www.hotelyaiphaba.com/",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 700, "max": 1800 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential utilities",
                        "In-house dining and room service",
                        "Front desk and travel assistance",
                        "Wi‑Fi and limited parking"
                    ],
                    "brief": "A practical, centrally located hotel offering straightforward rooms and dining near the main market.",
                    "highlights": [
                        "Walkable access to Ema Keithel area",
                        "Budget-friendly for longer stays",
                        "Transit and shopping convenience",
                        "Simple, no-fuss experience"
                    ]
                },
                {
                    "name": "Aurora Boutique Hotel Imphal",
                    "address": "Thangmeiband, Imphal, Manipur 795001",
                    "website": "https://auroraboutiquehotel.com/",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Stylish boutique rooms",
                        "On-site café/restaurant",
                        "Concierge assistance",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A chic boutique option with modern rooms and an intimate ambience—suited to couples and weekenders.",
                    "highlights": [
                        "Short drive to central landmarks",
                        "Curated interiors and cozy vibe",
                        "Good pick for short leisure stays",
                        "Convenient for local sightseeing"
                    ]
                }
            ]
        }
    },

    "shillong": {
        "name": "Shillong",
        "description": "Best hotels in Shillong—hill‑city stays near Police Bazar, Golf Links, and Umiam Lake access. Enjoy scenic rooms, reliable dining, cozy lounges, and event spaces for weddings and retreats.",
        "sectionOne": "Shillong, Meghalaya’s capital, blends pine-clad hills, waterfalls, and lively markets with colonial-era charm. Travelers explore Umiam Lake, Elephant Falls, Shillong Peak, Ward’s Lake, Don Bosco Museum, and the café-lined streets around Police Bazar. City hotels focus on clean, view-forward rooms, dependable Wi‑Fi, on-site dining with local and global cuisine, and indoor leisure for cool weather. From boutique hideaways to premium resorts near lakes and viewpoints, Shillong suits family holidays, honeymoons, and small corporate retreats.",
        "sectionTwo": {
            "text": "Shillong features boutique city hotels, serene lake-view stays, and premium resorts across Police Bazar, Golf Links, and the Umiam corridor. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Courtyard by Marriott Shillong",
                    "address": "Thana Road, Police Bazar, Shillong, Meghalaya 793001",
                    "website": "https://www.marriott.com/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 2200, "max": 5200 }
                    },
                    "facilities": [
                        "Contemporary rooms with hill/city views",
                        "All-day dining, bakery, and bar",
                        "Heated pool (select), spa, and fitness center",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A premium city-center hotel near Police Bazar with polished rooms, strong dining, and event-ready spaces.",
                    "highlights": [
                        "Walkable to markets and cafés",
                        "Reliable breakfast and room service",
                        "Good for weddings and conferences",
                        "Brand standards and service consistency"
                    ]
                },
                {
                    "name": "Ri Kynjai – Serenity by the Lake",
                    "address": "Umiam Lake, Ri Bhoi District, Meghalaya 793103",
                    "website": "https://www.rikynjai.com/",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Lake-view cottages and rooms",
                        "Regional and global dining with local produce",
                        "Spa, yoga lawn, and nature trails",
                        "Event lawn and intimate halls"
                    ],
                    "brief": "A serene lakeside retreat with panoramic views, wellness, and destination dining—ideal for honeymoons and quiet getaways.",
                    "highlights": [
                        "Iconic Umiam Lake vistas",
                        "Curated Khasi cuisine experiences",
                        "Indoor–outdoor event flexibility",
                        "Calm ambience for restorative stays"
                    ]
                },
                {
                    "name": "The Heritage Club – Tripura Castle",
                    "address": "Cleve Colony, Shillong, Meghalaya 793003",
                    "website": "https://www.tripura-castle.com/",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1500, "max": 3800 }
                    },
                    "facilities": [
                        "Heritage rooms with vintage accents",
                        "Multi-cuisine restaurant and bar",
                        "Garden sit-outs and bonfire zones",
                        "Small banquet/meeting spaces"
                    ],
                    "brief": "A heritage-style hill residence with characterful rooms, cozy dining, and green courtyards for relaxed evenings.",
                    "highlights": [
                        "Old-world charm and views",
                        "Quiet location close to city spots",
                        "Great for couples and families",
                        "Boutique event suitability"
                    ]
                },
                {
                    "name": "Vivanta Meghalaya, Shillong",
                    "address": "Police Bazar, Shillong, Meghalaya 793001",
                    "website": "https://www.vivantahotels.com/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Modern rooms in the city hub",
                        "Signature restaurants and lounge",
                        "Fitness center",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A contemporary city hotel with reliable dining and compact event spaces, steps from shopping and cafés.",
                    "highlights": [
                        "Prime Police Bazar access",
                        "Efficient for business trips",
                        "Popular breakfast and bakery",
                        "Consistent service standards"
                    ]
                },
                {
                    "name": "Polo Orchid Resort, Cherrapunji (Convenient from Shillong)",
                    "address": "Nongthymmai, Sohra (Cherrapunji), Meghalaya 793108",
                    "website": "https://www.palacesonwheels.com/polo-orchid-resort/",
                    "averageCost": {
                        "stay": 21000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Cliff-side cottages and suites",
                        "Restaurant with valley views",
                        "Infinity pool (select) and lawns",
                        "Event deck (property-specific)"
                    ],
                    "brief": "A dramatic valley-view resort in Sohra, popular for scenic stays and photo-friendly venues within driving distance of Shillong.",
                    "highlights": [
                        "Proximity to waterfalls and caves",
                        "Couple- and family-friendly layouts",
                        "Sunset-view dining",
                        "Memorable setting for small events"
                    ]
                },
                {
                    "name": "Cafe Shillong Bed & Breakfast",
                    "address": "Lachumiere, Shillong, Meghalaya 793001",
                    "website": "https://www.cafeshillongbnb.com/",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Cozy rooms with warm décor",
                        "On-site café and room service",
                        "Travel assistance",
                        "Wi‑Fi and limited parking"
                    ],
                    "brief": "A beloved boutique B&B with a lively café culture—ideal for casual city breaks and café-hopping itineraries.",
                    "highlights": [
                        "Close to popular eateries and sights",
                        "Friendly, homely ambience",
                        "Good value in central Shillong",
                        "Perfect for weekenders"
                    ]
                },
                {
                    "name": "Hotel Polo Towers Shillong",
                    "address": "Oakland Road, Shillong, Meghalaya 793001",
                    "website": "https://www.pohotels.in/polo-towers-shillong/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Comfortable rooms near city attractions",
                        "Multi-cuisine restaurant and lounge",
                        "Banquet/meeting facilities",
                        "Wi‑Fi, concierge, and parking"
                    ],
                    "brief": "A centrally located city hotel with steady dining and practical event spaces—suited to business and family stays.",
                    "highlights": [
                        "Convenient for Ward’s Lake and markets",
                        "Event-friendly halls",
                        "Reliable service and breakfast",
                        "Balanced price-to-amenities"
                    ]
                }
            ]
        }
    },


    "aizawl": {
        "name": "Aizawl",
        "description": "Best hotels in Aizawl—well-located stays near Zarkawt, Chaltlang, and key market areas. Expect clean rooms, convenient dining, basic event spaces, and quick access to viewpoints and museums.",
        "sectionOne": "Aizawl, the hilltop capital of Mizoram, is known for its panoramic vistas, church-spired skyline, and vibrant markets. Travelers explore Durtlang viewpoints, Solomon’s Temple, State Museum, and nearby village trails. City stays focus on tidy rooms, courteous service, dependable Wi‑Fi, and in-house dining, with compact halls for meetings and social events. From centrally located business-friendly hotels to simple boutique options, Aizawl suits government trips, family visits, and culture-led itineraries.",
        "sectionTwo": {
            "text": "Aizawl features a mix of midscale city hotels, government lodges, and boutique stays across Zarkawt, Chaltlang, and central market zones. Below are handpicked properties known for location, practical amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Hotel Regency",
                    "address": "B-49, Mac Donald Hill, Zarkawt, Aizawl, Mizoram 796007",
                    "website": "http://regencyaizawl.com/",
                    "averageCost": {
                        "stay": 8500,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential amenities",
                        "Multi-cuisine restaurant and room service",
                        "Banquet/meeting hall (property-specific)",
                        "Wi‑Fi, parking, and travel assistance"
                    ],
                    "brief": "A centrally placed city hotel in Zarkawt with reliable rooms, steady dining, and compact event facilities.",
                    "highlights": [
                        "Proximity to markets and offices",
                        "Consistent breakfast options",
                        "Good for short business stays",
                        "Helpful front-desk support"
                    ]
                },
                {
                    "name": "David’s Hotel Clover",
                    "address": "Zarkawt, Aizawl, Mizoram 796007",
                    "website": "#",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Neat rooms with practical comforts",
                        "On-site restaurant and café",
                        "Front desk assistance",
                        "Wi‑Fi and limited parking"
                    ],
                    "brief": "A value-forward hotel in a lively area, suitable for quick trips with straightforward dining and essentials.",
                    "highlights": [
                        "Walkable to shops and eateries",
                        "Budget-friendly categories",
                        "Simple check-in/check-out",
                        "Convenient for solo and family stays"
                    ]
                },
                {
                    "name": "The Grand Hotel, Aizawl",
                    "address": "Central Aizawl, Mizoram 796001",
                    "website": "#",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Comfortable rooms with city access",
                        "In-house dining and room service",
                        "Meeting space (property-specific)",
                        "Wi‑Fi and concierge"
                    ],
                    "brief": "A central city stay with tidy rooms and convenient dining—good for transit and business visits.",
                    "highlights": [
                        "Easy access to transport and markets",
                        "Balanced price-to-amenities",
                        "Reliable housekeeping",
                        "Suitable for short stays"
                    ]
                },
                {
                    "name": "Chaltlang Tourist Lodge (Mizoram Tourism)",
                    "address": "M.G. Road, Chaltlang, Aizawl, Mizoram 796012",
                    "website": "https://tourism.mizoram.gov.in/",
                    "averageCost": {
                        "stay": 5000,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Basic rooms with city views (select)",
                        "On-site restaurant (timed service)",
                        "Parking and tour assistance",
                        "Event lawn/hall (property-specific)"
                    ],
                    "brief": "A government-run lodge with simple rooms, scenic perch, and straightforward dining—popular with budget travelers and families.",
                    "highlights": [
                        "Viewpoints within short drives",
                        "Value pricing in a central area",
                        "Calm setting above the city bustle",
                        "Good base for local sightseeing"
                    ]
                },
                {
                    "name": "Emerald Hotel",
                    "address": "Aizawl, Mizoram 796001",
                    "website": "#",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1200, "max": 2500 }
                    },
                    "facilities": [
                        "Well-appointed rooms (select with views)",
                        "Restaurant and lounge",
                        "Fitness corner (property-specific)",
                        "Wi‑Fi, parking, concierge"
                    ],
                    "brief": "A newer, premium-leaning option offering comfortable rooms and dependable dining in central Aizawl.",
                    "highlights": [
                        "Convenient reach to key landmarks",
                        "Contemporary interiors",
                        "Reliable service standards",
                        "Family-friendly stay formats"
                    ]
                },
                {
                    "name": "Hotel Delano",
                    "address": "Aizawl, Mizoram 796001",
                    "website": "#",
                    "averageCost": {
                        "stay": 6500,
                        "dining": { "min": 900, "max": 2000 }
                    },
                    "facilities": [
                        "Clean rooms with essential utilities",
                        "On-site dining and room service",
                        "Front desk and housekeeping",
                        "Wi‑Fi and limited parking"
                    ],
                    "brief": "A practical choice for budget- to mid-range travelers seeking tidy rooms and simple dining near central areas.",
                    "highlights": [
                        "Good value for money",
                        "Suitable for short and multi-night stays",
                        "Access to nearby cafés",
                        "Straightforward, no-fuss experience"
                    ]
                }
            ]
        }
    },



    "kohima": {
        "name": "Kohima",
        "description": "Best hotels in Kohima—well-located stays near PR Hill, Midland, and Kisama access. Expect clean rooms, convenient dining, basic event spaces, and quick reach to the War Cemetery and markets.",
        "sectionOne": "Kohima, the capital of Nagaland, blends hill-town scenery, World War II heritage, and vibrant Naga culture. Travelers visit the Kohima War Cemetery, Kisama Heritage Village (Hornbill Festival venue), Catholic Cathedral, and local craft markets. City hotels focus on tidy rooms, courteous service, reliable Wi‑Fi, and on-site dining, with compact halls for meetings and social functions. From centrally placed business-friendly stays to boutique options and homestays, Kohima suits cultural trips, family visits, and festival travel.",
        "sectionTwo": {
            "text": "Kohima features a mix of midscale city hotels, boutique stays, and festival-friendly bases around the town center and Kisama corridor. Below are handpicked properties known for location, practical amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Niraamaya Retreats Aradura, Kohima",
                    "address": "Aradura Hill, Kohima, Nagaland 797001",
                    "website": "https://www.niraamaya.in/",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Well-appointed rooms with hill views",
                        "Signature restaurant and lounge",
                        "Wellness services (property-specific)",
                        "Banquet/meeting venue"
                    ],
                    "brief": "A premium hill retreat with serene rooms, refined dining, and compact event space—suited to relaxed getaways and small gatherings.",
                    "highlights": [
                        "Quiet hilltop setting near key sights",
                        "Comfort-forward rooms and service",
                        "Balanced for leisure and business",
                        "Good base during Hornbill Festival"
                    ]
                },
                {
                    "name": "Hotel Vivor",
                    "address": "PR Hill, Kohima, Nagaland 797001",
                    "website": "https://hotelvivor.in/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "Multi-cuisine restaurant and café",
                        "Banquet hall and meeting room",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A centrally located hotel with practical rooms, dependable dining, and event-friendly halls for business and family stays.",
                    "highlights": [
                        "Proximity to markets and offices",
                        "Value-forward corporate amenities",
                        "Efficient check-in and service",
                        "Popular choice for festivals"
                    ]
                },
                {
                    "name": "de Oriental Grand",
                    "address": "Midland, Kohima, Nagaland 797001",
                    "website": "https://www.deorientalgrand.com/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Neat rooms with essential comforts",
                        "Restaurant and bar",
                        "Event/banquet facilities",
                        "Travel desk and Wi‑Fi"
                    ],
                    "brief": "A popular city hotel offering tidy rooms, consistent dining, and practical banquets—good for work trips and festival visits.",
                    "highlights": [
                        "Convenient Midland location",
                        "Straightforward, reliable service",
                        "Event-friendly spaces",
                        "Suitable for short and longer stays"
                    ]
                },
                {
                    "name": "La Colline Resort",
                    "address": "Kisama (near Hornbill venue), Kohima, Nagaland 797005",
                    "website": "https://www.lacollineresort.com/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Hill-view rooms and cottages",
                        "Restaurant with local and Indian cuisine",
                        "Event lawn (property-specific)",
                        "Parking and concierge"
                    ],
                    "brief": "A hilltop resort close to Kisama, offering scenic rooms, simple dining, and flexible outdoor space—ideal during Hornbill Festival.",
                    "highlights": [
                        "Easy access to heritage village",
                        "Sunset views and quiet ambience",
                        "Family-friendly layouts",
                        "Good for photo-friendly events"
                    ]
                },
                {
                    "name": "Morung Lodge",
                    "address": "Near Old Ministers’ Hill, Kohima, Nagaland 797001",
                    "website": "https://morunglodge.com/",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 800, "max": 2000 }
                    },
                    "facilities": [
                        "Cozy rooms with homely ambience",
                        "On-site café (property-specific)",
                        "Common lounge and terrace",
                        "Wi‑Fi and travel assistance"
                    ],
                    "brief": "A boutique lodge with warm interiors and a friendly vibe—great for couples, small groups, and long-weekend breaks.",
                    "highlights": [
                        "Characterful design and views",
                        "Close to cafés and local markets",
                        "Relaxed, community feel",
                        "Good base for city sightseeing"
                    ]
                },
                {
                    "name": "Hotel Eastgate",
                    "address": "PR Hill Junction, Kohima, Nagaland 797001",
                    "website": "https://www.hoteleastgatekohima.com/",
                    "averageCost": {
                        "stay": 6500,
                        "dining": { "min": 800, "max": 1800 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential amenities",
                        "Restaurant and room service",
                        "Small banquet/meeting space",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A practical, centrally placed hotel with clean rooms, convenient dining, and compact event facilities for quick work trips.",
                    "highlights": [
                        "Walkable access to shops and sights",
                        "Budget-friendly categories",
                        "Efficient for short stays",
                        "Simple, no-fuss experience"
                    ]
                },
                {
                    "name": "Hotel Japfu",
                    "address": "PR Hill, Kohima, Nagaland 797001",
                    "website": "https://www.nagalandtourism.com/",
                    "averageCost": {
                        "stay": 5500,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Basic rooms with city access",
                        "In-house dining (timed service)",
                        "Event hall (property-specific)",
                        "Wi‑Fi in common areas"
                    ],
                    "brief": "A longstanding city hotel offering essential comforts and simple dining—popular with budget and government travelers.",
                    "highlights": [
                        "Central reach and local transit",
                        "Good value for multi-night visits",
                        "Suitable for family and group travel",
                        "Handy for festival season stays"
                    ]
                }
            ]
        }
    },


    "bhubaneswar": {
        "name": "Bhubaneswar",
        "description": "Best hotels in Bhubaneswar—well-located stays near Jaydev Vihar, KIIT/Patia, and the airport. Enjoy reliable dining, clean rooms, pools/spas (select), and versatile event spaces near temples and business hubs.",
        "sectionOne": "Bhubaneswar, the ‘Temple City’ of India, blends ancient Kalinga architecture with growing IT corridors and educational institutions. Travelers explore Lingaraj Temple, Udayagiri–Khandagiri Caves, Ekamra Kshetra Heritage walks, and museums, while benefiting from strong air, rail, and highway connectivity. City hotels focus on clean rooms, dependable Wi‑Fi, multi-cuisine dining, and banquet halls for conferences and weddings. From five-star brands to centrally located midscale stays, Bhubaneswar suits corporate trips, pilgrimages, and family holidays.",
        "sectionTwo": {
            "text": "Bhubaneswar features luxury and premium city hotels as well as value business stays across Jaydev Vihar, KIIT/Patia, and airport corridors. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Mayfair Lagoon",
                    "address": "8-B, Jaydev Vihar, Bhubaneswar, Odisha 751013",
                    "website": "https://www.mayfairhotels.com/mayfair-lagoon-bhubaneswar/",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Resort-style rooms and suites around lagoons",
                        "Multiple specialty restaurants and bar",
                        "Outdoor pool, spa, salon, and gym",
                        "Large banquets, lawns, and meeting rooms"
                    ],
                    "brief": "A luxury resort-hotel with lush landscaping, destination dining, and expansive event spaces—ideal for weddings and premium getaways.",
                    "highlights": [
                        "Central Jaydev Vihar location",
                        "Indoor–outdoor event flexibility",
                        "Family-friendly leisure amenities",
                        "High-touch hospitality standards"
                    ]
                },
                {
                    "name": "Trident Bhubaneswar",
                    "address": "CB-1, Nayapalli, Bhubaneswar, Odisha 751013",
                    "website": "https://www.tridenthotels.com/hotels-in-bhubaneswar/",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 4800 }
                    },
                    "facilities": [
                        "Garden-view rooms with minimalist elegance",
                        "All-day dining and specialty restaurant",
                        "Outdoor pool, fitness centre, and lawns",
                        "Banquet and boardroom facilities"
                    ],
                    "brief": "A serene garden hotel with refined service, polished rooms, and dependable dining—great for business and calm city breaks.",
                    "highlights": [
                        "Quiet green setting near city hubs",
                        "Consistent breakfast and room service",
                        "Efficient, boutique-style events",
                        "Known for attentive hospitality"
                    ]
                },
                {
                    "name": "Welcomhotel by ITC Hotels, Bhubaneswar",
                    "address": "DN Regalia Mall, Patrapada, Bhubaneswar, Odisha 751019",
                    "website": "https://www.itchotels.com/in/en/welcomhotel-bhubaneswar",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Signature Indian and global dining",
                        "Pool, spa services, and fitness centre",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A modern premium hotel with strong dining credentials and flexible venues—suited to business travelers and family events.",
                    "highlights": [
                        "Easy highway and city access",
                        "Event-friendly floors with AV",
                        "Responsible service ethos",
                        "Good value for upscale stays"
                    ]
                },
                {
                    "name": "Fortune Park Sishmo, Bhubaneswar",
                    "address": "5-B, Surya Nagar, Bhubaneswar, Odisha 751007",
                    "website": "https://www.itchotels.com/in/en/fortune-park-sishmo-bhubaneswar",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms in a central precinct",
                        "Multi-cuisine restaurant and bar",
                        "Rooftop pool (property-specific) and gym",
                        "Banquet hall and meeting rooms"
                    ],
                    "brief": "A centrally located hotel with tidy rooms, reliable dining, and compact event spaces—good for business trips and family visits.",
                    "highlights": [
                        "Proximity to markets and offices",
                        "Popular breakfast options",
                        "Value-forward event setups",
                        "Efficient front-desk and services"
                    ]
                },
                {
                    "name": "Ginger Bhubaneswar",
                    "address": "Opposite Nalco Headquarters, Jaydev Vihar, Bhubaneswar, Odisha 751013",
                    "website": "https://www.gingerhotels.com/hotels/ginger-bhubaneswar",
                    "averageCost": {
                        "stay": 6000,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Smart rooms with essential amenities",
                        "Café and in-room dining (timed)",
                        "Fitness corner",
                        "Meeting room (property-specific)"
                    ],
                    "brief": "A value business hotel offering clean, efficient rooms in a prime location—ideal for short corporate stays.",
                    "highlights": [
                        "Central Jaydev Vihar convenience",
                        "Budget-friendly categories",
                        "Fast check-in/out",
                        "Practical for solo and team travel"
                    ]
                },
                {
                    "name": "Hotel Swosti Premium",
                    "address": "P-1, Jaydev Vihar, Bhubaneswar, Odisha 751013",
                    "website": "https://www.swostihotels.com/swosti-premium-bhubaneswar/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Spacious rooms with classic décor",
                        "Multiple restaurants and bar",
                        "Pool and fitness centre",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A well-known city hotel with multiple dining outlets, pool access, and versatile banquets—popular for social functions and conferences.",
                    "highlights": [
                        "Jaydev Vihar business access",
                        "Catering depth for large events",
                        "Comfortable for longer stays",
                        "Good reach to temples and museums"
                    ]
                }
            ]
        }
    },


    "chandigarh": {
        "name": "Chandigarh",
        "description": "Best hotels in Chandigarh—premium and midscale stays near Sector 17, Elante, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Chandigarh, India’s first planned city, blends modernist design, green boulevards, and business districts. Visitors explore Sukhna Lake, Rock Garden, Sector 17 Plaza, and Elante Mall, while benefiting from strong air, rail, and road connectivity. City hotels focus on clean rooms, reliable Wi‑Fi, multiple dining outlets, and banquet facilities for conferences and weddings. From luxury brands with spas and pools to value-forward business hotels near commercial hubs, Chandigarh offers practical choices for corporate trips, family holidays, and social events.",
        "sectionTwo": {
            "text": "Chandigarh features luxury, premium, and midscale hotels across central sectors and the Elante/Industrial Area corridor. Below are handpicked stays known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "JW Marriott Hotel Chandigarh",
                    "address": "Sector 35B, Dakshin Marg, Chandigarh 160035",
                    "website": "https://www.marriott.com/en-us/hotels/ixcjw-jw-marriott-hotel-chandigarh/overview/",
                    "averageCost": {
                        "stay": 23000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Spacious rooms and suites with city views",
                        "Multiple restaurants, lounge, and bakery",
                        "Rooftop pool, spa, and fitness center",
                        "Grand ballroom and conference rooms"
                    ],
                    "brief": "A luxury city hotel with destination dining, rooftop leisure, and expansive event spaces—ideal for weddings, conferences, and upscale getaways.",
                    "highlights": [
                        "Central Sector 35 location",
                        "High-capacity banquets and breakout rooms",
                        "Consistent five-star service standards",
                        "Convenient for airport and rail links"
                    ]
                },
                {
                    "name": "Hyatt Regency Chandigarh",
                    "address": "178 Industrial & Business Park, Phase I, Chandigarh 160002",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-regency-chandigarh/ixcra",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining and specialty restaurants",
                        "Outdoor pool, spa, and fitness center",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A premium hotel connected to the Elante Mall precinct, offering strong dining, wellness, and event capabilities for business and family stays.",
                    "highlights": [
                        "Direct access to Elante shopping and dining",
                        "Event-friendly floors with modern AV",
                        "Family-friendly leisure facilities",
                        "Quick approach from highway and city center"
                    ]
                },
                {
                    "name": "Taj Chandigarh",
                    "address": "Block No. 9, Sector 17A, Chandigarh 160017",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-chandigarh/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 2000, "max": 4800 }
                    },
                    "facilities": [
                        "Elegant rooms in the main business district",
                        "Specialty restaurants and bar",
                        "Outdoor pool and fitness center",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A classic address in Sector 17 with refined rooms, acclaimed dining, and efficient event spaces—great for corporate and social occasions.",
                    "highlights": [
                        "Walkable to Sector 17 Plaza",
                        "Trusted brand service and cuisine",
                        "Balanced for business and leisure",
                        "Convenient for shopping and offices"
                    ]
                },
                {
                    "name": "Hyatt Centric Sector 17 Chandigarh",
                    "address": "Sector 17E, Chandigarh 160017",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-centric-sector-17-chandigarh/ixcct",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1800, "max": 4200 }
                    },
                    "facilities": [
                        "Stylish, centrally located rooms",
                        "Restaurant, café, and bar",
                        "Fitness center",
                        "Meeting rooms for small events"
                    ],
                    "brief": "A design-forward city hotel in the heart of Sector 17, ideal for quick business trips and stylish weekend breaks.",
                    "highlights": [
                        "Steps from shops and eateries",
                        "Contemporary interiors and amenities",
                        "Efficient for compact meetings",
                        "Easy access to key landmarks"
                    ]
                },
                {
                    "name": "The LaLiT Chandigarh",
                    "address": "IT Park, DLF Commercial Complex, Chandigarh 160101",
                    "website": "https://www.thelalit.com/the-lalit-chandigarh/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple dining outlets and bar",
                        "Spa, salon, pool, and fitness center",
                        "Large banquets and convention-style spaces"
                    ],
                    "brief": "A five-star hotel at IT Park with generous rooms, full-service wellness, and sizeable banquets—popular for conferences and weddings.",
                    "highlights": [
                        "IT Park proximity for corporate stays",
                        "Extensive indoor event capacity",
                        "Wellness-led amenities",
                        "Good highway and airport access"
                    ]
                },
                {
                    "name": "Novotel Chandigarh Tribune Chowk",
                    "address": "Plot 181/45, Industrial Area Phase I, Tribune Chowk, Chandigarh 160002",
                    "website": "https://all.accor.com/hotel/B9M2/index.en.shtml",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All-day dining and bar",
                        "Fitness center",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A contemporary, business-friendly stay near Tribune Chowk with reliable dining and practical event spaces.",
                    "highlights": [
                        "Quick reach to Elante and business parks",
                        "Consistent breakfast and room service",
                        "Value-forward event options",
                        "Good choice for short corporate trips"
                    ]
                },
                {
                    "name": "Hotel Mountview",
                    "address": "Sector 10, Chandigarh 160011",
                    "website": "https://www.hospitality.citcochandigarh.com/hotel-mountview/",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2500 }
                    },
                    "facilities": [
                        "Comfortable rooms with garden views (select)",
                        "Multi-cuisine restaurant and café",
                        "Outdoor pool and fitness center",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A city landmark with green surroundings, offering relaxed rooms, classic dining, and indoor-outdoor venues for socials and meetings.",
                    "highlights": [
                        "Leafy Sector 10 setting",
                        "Event lawns for gatherings",
                        "Convenient for leisure sightseeing",
                        "Balanced pricing and amenities"
                    ]
                }
            ]
        }
    },


    "jaipur": {
        "name": "Jaipur",
        "description": "Best hotels in Jaipur—heritage palaces and premium city stays near Pink City, MI Road, and Mansarovar. Enjoy award‑winning dining, royal suites, pools, spas, and grand event venues.",
        "sectionOne": "Jaipur, the Pink City, blends royal palaces, vibrant bazaars, and UNESCO‑listed forts with a thriving modern hospitality scene. Travelers explore Hawa Mahal, City Palace, Amer Fort, Jantar Mantar, and Johari/Bapu Bazaars, supported by strong air, rail, and road connectivity. City hotels range from palace‑style heritage icons to contemporary five‑stars with destination dining, tranquil spas, and expansive banquets for weddings and conferences—ideal for luxury vacations, family trips, and curated cultural escapes.",
        "sectionTwo": {
            "text": "Jaipur features opulent heritage hotels, premium urban resorts, and reliable business properties across Pink City, Amer, and Tonk/MI Road corridors. Below are handpicked stays known for prime locations, standout amenities, and polished service.",
            "hotels": [
                {
                    "name": "Rambagh Palace, Jaipur",
                    "address": "Bhawani Singh Road, Jaipur, Rajasthan 302005",
                    "website": "https://www.tajhotels.com/en-in/taj/rambagh-palace-jaipur/",
                    "averageCost": {
                        "stay": 65000,
                        "dining": { "min": 3500, "max": 9000 }
                    },
                    "facilities": [
                        "Royal suites and heritage rooms",
                        "Iconic specialty restaurants and bars",
                        "Palace gardens, spa, and pool",
                        "Grand lawns, ballrooms, and butler service"
                    ],
                    "brief": "A former royal residence offering immersive palace luxury, destination dining, and spectacular venues for signature celebrations.",
                    "highlights": [
                        "Regal experiences and heritage walks",
                        "Signature afternoon tea settings",
                        "Marquee wedding backdrops",
                        "High‑touch concierge and butlers"
                    ]
                },
                {
                    "name": "The Oberoi Rajvilas, Jaipur",
                    "address": "Goner Road, Jaipur, Rajasthan 302031",
                    "website": "https://www.oberoihotels.com/hotels-in-jaipur-rajvilas/",
                    "averageCost": {
                        "stay": 52000,
                        "dining": { "min": 3000, "max": 8000 }
                    },
                    "facilities": [
                        "Luxury rooms, tents, and villas",
                        "Fine dining and curated private meals",
                        "Spa, yoga pavilion, and pool",
                        "Expansive lawns and intimate event spaces"
                    ],
                    "brief": "A serene luxury resort with ornate architecture, immersive wellness, and refined dining in a lush, temple‑dotted estate.",
                    "highlights": [
                        "Temple aarti and cultural evenings",
                        "Couple‑friendly private dining",
                        "Nature‑rich, quiet setting",
                        "Personalized, discreet service"
                    ]
                },
                {
                    "name": "Fairmont Jaipur",
                    "address": "Riico Kukas, Jaipur, Rajasthan 302028",
                    "website": "https://www.fairmont.com/jaipur/",
                    "averageCost": {
                        "stay": 26000,
                        "dining": { "min": 2200, "max": 6000 }
                    },
                    "facilities": [
                        "Mughal‑Rajputana inspired rooms",
                        "Multiple restaurants and bars",
                        "Pool, spa, and fitness center",
                        "Ballrooms and courtyards for big weddings"
                    ],
                    "brief": "A grand, palace‑style hotel in Kukas designed for lavish weddings and conventions, with dramatic venues and rich culinary programs.",
                    "highlights": [
                        "Ornate courtyards and arches",
                        "High‑capacity banquet venues",
                        "Close to Amer/Jaigarh circuits",
                        "Photogenic ceremony settings"
                    ]
                },
                {
                    "name": "ITC Rajputana, a Luxury Collection Hotel",
                    "address": "Palace Road, Gopalbari, Jaipur, Rajasthan 302006",
                    "website": "https://www.itchotels.com/in/en/itcrajputana-jaipur",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5200 }
                    },
                    "facilities": [
                        "Elegant rooms with Rajasthani motifs",
                        "Celebrated Indian and global restaurants",
                        "Kaya Kalp spa, pool, and gym",
                        "Large conference and banquet floors"
                    ],
                    "brief": "A city‑center luxury hotel known for iconic Indian dining, wellness, and seasoned event operations near rail and shopping zones.",
                    "highlights": [
                        "Responsible Luxury credentials",
                        "Signature fine‑dining experiences",
                        "Event‑friendly layouts",
                        "Central access to MI Road/C‑Scheme"
                    ]
                },
                {
                    "name": "Jai Mahal Palace, Jaipur",
                    "address": "Jacob Road, Civil Lines, Jaipur, Rajasthan 302006",
                    "website": "https://www.tajhotels.com/en-in/taj/jai-mahal-palace-jaipur/",
                    "averageCost": {
                        "stay": 30000,
                        "dining": { "min": 2500, "max": 6500 }
                    },
                    "facilities": [
                        "Palace rooms amid 18‑acre gardens",
                        "Signature restaurants and bar",
                        "Pool, spa services, and fitness",
                        "Lawns and halls for social events"
                    ],
                    "brief": "A romantic palace hotel with lush lawns, refined rooms, and classic dining—popular for weddings and family retreats.",
                    "highlights": [
                        "Expansive heritage gardens",
                        "Kid‑friendly leisure",
                        "Indoor–outdoor event flexibility",
                        "Convenient Civil Lines location"
                    ]
                },
                {
                    "name": "Taj Amer, Jaipur",
                    "address": "Kunda, Amer, Jaipur, Rajasthan 302028",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-amer-jaipur/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Contemporary rooms near Amer Fort circuit",
                        "All‑day dining and lounge bar",
                        "Pool and fitness center",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A modern premium hotel at the Amer approach, pairing smart rooms with dependable dining and practical event spaces.",
                    "highlights": [
                        "Quick access to Amer/Jaigarh/Nahargarh",
                        "Efficient for sightseeing itineraries",
                        "Event‑ready with modern AV",
                        "Good for families and groups"
                    ]
                },
                {
                    "name": "Radisson Blu Jaipur",
                    "address": "Tonk Road, Near Airport, Jaipur, Rajasthan 302018",
                    "website": "https://www.radissonhotels.com/en-us/hotels/radisson-blu-jaipur",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All‑day dining, rooftop bar (select), and lounge",
                        "Rooftop pool and fitness center",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A business‑friendly hotel on Tonk Road with easy airport access, strong dining, and versatile venues for meetings and socials.",
                    "highlights": [
                        "Airport/tonk corridor convenience",
                        "Popular breakfast and room service",
                        "Value‑forward for corporate trips",
                        "Reliable brand standards"
                    ]
                },
                {
                    "name": "Hilton Jaipur",
                    "address": "Hawa Sadak, Geejgarh House, Jaipur, Rajasthan 302006",
                    "website": "https://www.hilton.com/en/hotels/jaijphi-hilton-jaipur/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1800, "max": 4200 }
                    },
                    "facilities": [
                        "Contemporary rooms with city views",
                        "Multiple restaurants and bar",
                        "Rooftop pool, spa, and gym",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A polished city hotel near MI Road/C‑Scheme with upscale dining, rooftop leisure, and event‑ready spaces.",
                    "highlights": [
                        "Central access to shopping and offices",
                        "Rooftop city views",
                        "Efficient conference planning",
                        "Good for business and families"
                    ]
                }
            ]
        }
    },


    "gangtok": {
        "name": "Gangtok",
        "description": "Best hotels in Gangtok—hill-city stays near MG Marg, Tadong, and Rumtek access. Enjoy scenic rooms, reliable dining, cozy lounges, and event spaces for weddings and retreats.",
        "sectionOne": "Gangtok, Sikkim’s capital, blends Himalayan vistas, monasteries, and a vibrant café culture along MG Marg. Travellers explore Rumtek Monastery, Tashi View Point, Hanuman Tok, Enchey Monastery, and nearby day trips to Tsomgo Lake and Nathula (permit-dependent). City hotels focus on warm hospitality, clean rooms, dependable Wi‑Fi, and on-site dining—many with valley or Kanchenjunga views. From boutique hideaways to premium resorts, Gangtok suits family vacations, honeymoons, and small corporate retreats.",
        "sectionTwo": {
            "text": "Gangtok features boutique city hotels, view-forward retreats, and premium resorts across MG Marg, Tadong, and Rumtek approaches. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Tashi Delek, Gangtok (formerly Denzong Regency area reference)",
                    "address": "Cherry Banks, Gangtok, Sikkim 737101",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": {
                        "stay": 24000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Mountain/valley-view rooms and suites",
                        "Multiple restaurants and bar",
                        "Spa services and fitness room",
                        "Banquet hall and meeting rooms"
                    ],
                    "brief": "A premium, view-led hotel offering refined rooms, strong dining, and event-ready spaces near central Gangtok.",
                    "highlights": [
                        "Quick access to MG Marg",
                        "Kanchenjunga-view categories (select)",
                        "Good for weddings and conferences",
                        "Consistent brand standards"
                    ]
                },
                {
                    "name": "Mayfair Spa Resort & Casino, Gangtok",
                    "address": "Ranipool, Gangtok, Sikkim 737135",
                    "website": "https://www.mayfairhotels.com/",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Resort-style rooms, villas, and suites",
                        "Multiple restaurants, bar, and bakery",
                        "Spa, pool (seasonal/select), and fitness",
                        "Large banquets and lawns"
                    ],
                    "brief": "A destination resort on the city’s outskirts with expansive grounds, wellness, and sizeable indoor‑outdoor venues.",
                    "highlights": [
                        "Resort ambience amid greenery",
                        "Event-friendly lawns and halls",
                        "Family‑friendly leisure setup",
                        "Convenient city approach road"
                    ]
                },
                {
                    "name": "The Elgin Nor-Khill, Gangtok",
                    "address": "Paljor Stadium Road, Gangtok, Sikkim 737101",
                    "website": "https://www.elginhotels.com/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1800, "max": 4200 }
                    },
                    "facilities": [
                        "Heritage rooms with vintage décor",
                        "Restaurant, lounge, and high-tea service",
                        "Garden sit-outs",
                        "Small banquet/meeting room"
                    ],
                    "brief": "A heritage hotel with colonial-era charm, curated dining, and cosy lounges—great for romantic and family stays.",
                    "highlights": [
                        "Walkable reach to central sights",
                        "Classic interiors and ambience",
                        "Intimate event suitability",
                        "Warm, personalised service"
                    ]
                },
                {
                    "name": "Denzong Regency, Gangtok",
                    "address": "Cherry Banks, Gangtok, Sikkim 737101",
                    "website": "https://www.denzongregency.com/",
                    "averageCost": {
                        "stay": 15000,
                        "dining": { "min": 1600, "max": 3800 }
                    },
                    "facilities": [
                        "Spacious, view-facing rooms and suites",
                        "Multi-cuisine restaurant and bar",
                        "Decks/terraces (property-specific)",
                        "Banquet and meeting facilities"
                    ],
                    "brief": "A premium city hotel with panoramic views, dependable dining, and practical event spaces near MG Marg.",
                    "highlights": [
                        "Kanchenjunga/valley views (select)",
                        "Central-yet-tranquil setting",
                        "Good for families and groups",
                        "Efficient event support"
                    ]
                },
                {
                    "name": "Sterling Gangtok Orange Village",
                    "address": "Ronsey Road, Singtam – Dentam Road, Gangtok, Sikkim 737101",
                    "website": "https://www.sterlingholidays.com/",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Rooms and cottages with greenery views",
                        "Restaurant and café",
                        "Activity zone (select) and fitness corner",
                        "Banquet/meeting room"
                    ],
                    "brief": "A relaxed resort setting with family-friendly rooms, casual dining, and simple event facilities.",
                    "highlights": [
                        "Green, quiet surrounds",
                        "Kid-friendly spaces (select)",
                        "Good value for longer stays",
                        "Easy taxi access to attractions"
                    ]
                },
                {
                    "name": "Summit Golden Crescent Resort & Spa",
                    "address": "Near Sichey, Gangtok, Sikkim 737101",
                    "website": "https://www.summithotels.in/",
                    "averageCost": {
                        "stay": 9500,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Comfortable rooms with hill views",
                        "Restaurant and lounge",
                        "Spa services (property-specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A value-forward resort-hotel with cosy rooms, spa services, and basic event spaces close to central areas.",
                    "highlights": [
                        "Short drive to MG Marg",
                        "Popular breakfast options",
                        "Suitable for families and groups",
                        "Balanced price-to-amenities"
                    ]
                },
                {
                    "name": "Lemon Tree Hotel, Gangtok",
                    "address": "Deorali, Nam Nang Road, Gangtok, Sikkim 737102",
                    "website": "https://www.lemontreehotels.com/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Modern rooms with essential comforts",
                        "All-day dining and bar",
                        "Fitness room",
                        "Meeting room (property-specific)"
                    ],
                    "brief": "A dependable, centrally connected stay with clean rooms, steady dining, and compact business facilities.",
                    "highlights": [
                        "Deorali ropeway/MG Marg access",
                        "Consistent service standards",
                        "Good for short corporate trips",
                        "Family-friendly categories"
                    ]
                }
            ]
        }
    },


    "chennai": {
        "name": "Chennai",
        "description": "Best hotels in Chennai—sea-facing icons and business-district stays near Marina, Nungambakkam, OMR, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Chennai, Tamil Nadu’s capital, blends Bay of Bengal seafronts, heritage landmarks, and thriving IT and corporate corridors. Travellers explore Marina Beach, Kapaleeshwarar Temple, Santhome Basilica, Fort St. George, and buzzing food districts, supported by strong air, rail, and Metro links. City hotels emphasize polished rooms, reliable Wi‑Fi, destination dining, and expansive banquet floors for conferences and weddings. From legendary waterfront luxury to OMR tech‑corridor business stays and airport‑area conveniences, Chennai suits corporate trips, family getaways, medical travel, and extended stays.",
        "sectionTwo": {
            "text": "Chennai features luxury waterfront addresses, premium CBD hotels, and smart business stays across Nungambakkam, Guindy, OMR, and the airport corridor. Below are handpicked properties known for prime locations, strong amenities, and consistent service.",
            "hotels": [
                {
                    "name": "ITC Grand Chola, a Luxury Collection Hotel, Chennai",
                    "address": "No. 63, Mount Road, Guindy, Chennai, Tamil Nadu 600032",
                    "website": "https://www.itchotels.com/in/en/itcgrandchola-chennai",
                    "averageCost": {
                        "stay": 26000,
                        "dining": { "min": 2500, "max": 6000 }
                    },
                    "facilities": [
                        "Palatial rooms, suites, and serviced residences",
                        "Multiple award‑winning restaurants and bars",
                        "Three outdoor pools, Kaya Kalp spa, and fitness",
                        "Grand ballrooms and convention spaces"
                    ],
                    "brief": "A monumental city landmark with signature Indian dining, spa‑led wellness, and large‑scale event capabilities.",
                    "highlights": [
                        "LEED® Platinum sustainability",
                        "Butler service in select suites",
                        "Close to Guindy/velachery business hubs",
                        "Ideal for conferences and weddings"
                    ]
                },
                {
                    "name": "The Leela Palace Chennai",
                    "address": "Adyar Seaface, MRC Nagar, Chennai, Tamil Nadu 600028",
                    "website": "https://www.theleela.com/the-leela-palace-chennai",
                    "averageCost": {
                        "stay": 28000,
                        "dining": { "min": 3000, "max": 7000 }
                    },
                    "facilities": [
                        "Sea‑facing rooms and opulent suites",
                        "Destination restaurants and chic bars",
                        "Outdoor pool, spa, and fitness centre",
                        "Ballrooms and waterfront lawns"
                    ],
                    "brief": "A seaside modern‑palace hotel offering panoramic views, refined dining, and elegant indoor‑outdoor venues.",
                    "highlights": [
                        "Views over the Bay of Bengal/Adyar estuary",
                        "Curated fine‑dining experiences",
                        "Resort‑style pool terrace",
                        "Premium address near Marina"
                    ]
                },
                {
                    "name": "Taj Coromandel, Chennai",
                    "address": "37, Mahatma Gandhi Road, Nungambakkam, Chennai, Tamil Nadu 600034",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-coromandel-chennai/",
                    "averageCost": {
                        "stay": 20000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Elegant rooms and suites in CBD",
                        "Iconic specialty restaurants and lounge",
                        "Outdoor pool, J Wellness spa, and gym",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "A classic luxury address in Nungambakkam known for celebrated dining and sophisticated event service.",
                    "highlights": [
                        "Central business/shopping access",
                        "Signature Indian and global cuisine",
                        "High‑touch hospitality",
                        "Corporate‑friendly venues"
                    ]
                },
                {
                    "name": "Park Hyatt Chennai",
                    "address": "39, Velachery Main Road, Guindy, Chennai, Tamil Nadu 600032",
                    "website": "https://www.hyatt.com/en-US/hotel/india/park-hyatt-chennai/maapc",
                    "averageCost": {
                        "stay": 19000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Design‑forward rooms with city/forest views",
                        "Fine dining, lounge, and bakery",
                        "Rooftop infinity pool, spa, and fitness",
                        "Stylish meeting and event spaces"
                    ],
                    "brief": "A contemporary luxury hotel with serene rooftop pool and refined dining—ideal for upscale business and leisure stays.",
                    "highlights": [
                        "Views over Guindy greens (select)",
                        "Tranquil urban‑retreat ambience",
                        "Close to business corridors",
                        "Boutique‑style events"
                    ]
                },
                {
                    "name": "Trident, Chennai",
                    "address": "1/24, G.S.T. Road, Chennai, Tamil Nadu 600027",
                    "website": "https://www.tridenthotels.com/hotels-in-chennai/",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1500, "max": 3500 }
                    },
                    "facilities": [
                        "Garden‑view rooms near the airport",
                        "All‑day dining and bar",
                        "Outdoor pool, spa, and fitness",
                        "Meeting rooms and lawns"
                    ],
                    "brief": "A calm, airport‑proximate hotel with polished rooms, dependable dining, and compact event spaces.",
                    "highlights": [
                        "Quick terminal access",
                        "Resort‑like gardens",
                        "Efficient for short stays",
                        "Value‑friendly premium option"
                    ]
                },
                {
                    "name": "Grand Chennai by GRT Hotels",
                    "address": "120, Sir Thyagaraya Road, T. Nagar, Chennai, Tamil Nadu 600017",
                    "website": "https://www.grthotels.com/grand-chennai-by-grt",
                    "averageCost": {
                        "stay": 11000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms in the shopping district",
                        "Multiple restaurants and bar",
                        "Indoor pool, spa, and gym",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A popular city hotel with strong dining and leisure in the heart of T. Nagar—great for business and family trips.",
                    "highlights": [
                        "Walkable to Pondy Bazaar",
                        "Reliable breakfast and service",
                        "Event‑friendly floors",
                        "Good for short and extended stays"
                    ]
                },
                {
                    "name": "The Raintree, St. Mary’s Road",
                    "address": "120, St. Mary’s Road, Alwarpet, Chennai, Tamil Nadu 600018",
                    "website": "https://raintreehotels.com/st-marys-road/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Contemporary rooms near Mylapore/Alwarpet",
                        "All‑day dining and rooftop bar",
                        "Rooftop pool and fitness room",
                        "Meeting rooms and banquet hall"
                    ],
                    "brief": "A stylish city‑centre hotel with rooftop leisure and consistent F&B—ideal for quick corporate trips and weekenders.",
                    "highlights": [
                        "Easy reach to cultural landmarks",
                        "Rooftop city views",
                        "Efficient event setups",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Sheraton Grand Chennai Resort & Spa (Mahabalipuram Corridor)",
                    "address": "East Coast Road, Kovalam, Tiruvallur District, Chennai, Tamil Nadu 603112",
                    "website": "https://www.marriott.com/en-us/hotels/maasi-sheraton-grand-chennai-resort-and-spa/overview/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 1800, "max": 4200 }
                    },
                    "facilities": [
                        "Beachfront rooms and villas (select)",
                        "Multiple restaurants and bars",
                        "Resort‑style pool, spa, and activities",
                        "Indoor‑outdoor event spaces"
                    ],
                    "brief": "A coastal resort on ECR with family‑friendly leisure, beach access, and scenic venues for weddings and retreats.",
                    "highlights": [
                        "Proximity to Mahabalipuram",
                        "Sunrise beach walks",
                        "Large lawns and ballrooms",
                        "Good weekend getaway choice"
                    ]
                },
                {
                    "name": "Holiday Inn Chennai OMR IT Expressway",
                    "address": "110, Rajiv Gandhi Salai, Thiruvanmiyur, Chennai, Tamil Nadu 600041",
                    "website": "https://www.ihg.com/holidayinn/hotels/us/en/chennai/maach/hoteldetail",
                    "averageCost": {
                        "stay": 9000,
                        "dining": { "min": 1000, "max": 2400 }
                    },
                    "facilities": [
                        "Smart rooms in the IT corridor",
                        "All‑day dining and lounge bar",
                        "Rooftop/Outdoor pool and fitness",
                        "Meeting rooms"
                    ],
                    "brief": "A business‑forward hotel on OMR with efficient rooms, casual dining, and practical meeting spaces.",
                    "highlights": [
                        "Convenient to tech parks",
                        "Fast check‑in and services",
                        "Good value for weekday stays",
                        "Reliable brand standards"
                    ]
                }
            ]
        }
    },


    "hyderabad": {
        "name": "Hyderabad",
        "description": "Best hotels in Hyderabad—heritage icons and premium business stays near Banjara Hills, Hitec City, and the airport. Enjoy award‑winning dining, clean rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Hyderabad, the City of Pearls, blends Nizam-era heritage with thriving IT and business corridors. Travellers explore Charminar, Golconda Fort, Chowmahalla Palace, Hussain Sagar, and the food trails of the old city and Jubilee/Banjara Hills. The city’s hotels emphasize polished rooms, reliable Wi‑Fi, destination dining, and expansive banquet floors for conferences and weddings. From luxury palaces to Hitec City business hotels and airport‑corridor conveniences, Hyderabad suits corporate trips, family getaways, and long stays.",
        "sectionTwo": {
            "text": "Hyderabad features palace hotels, luxury urban properties, and business‑first stays across Banjara/Jubilee Hills, Hitec City, Gachibowli, and the airport corridor. Below are handpicked properties known for prime locations, strong amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Falaknuma Palace, Hyderabad",
                    "address": "Engine Bowli, Falaknuma, Hyderabad, Telangana 500053",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-falaknuma-palace-hyderabad/",
                    "averageCost": {
                        "stay": 65000,
                        "dining": { "min": 3500, "max": 9000 }
                    },
                    "facilities": [
                        "Royal suites and heritage rooms in a hill‑top palace",
                        "Signature fine dining and heritage high‑tea",
                        "J Wellness Circle spa and curated experiences",
                        "Lawns, ballrooms, and palace tours"
                    ],
                    "brief": "A Nizam-era palace hotel with grand architecture, immersive dining, and unforgettable venues for marquee celebrations.",
                    "highlights": [
                        "Panoramic city vistas from the palace",
                        "Horse‑drawn carriage arrivals (select)",
                        "Curated heritage walks",
                        "Bucket‑list wedding destination"
                    ]
                },
                {
                    "name": "ITC Kohenur, a Luxury Collection Hotel, Hyderabad",
                    "address": "Knowledge City, Madhapur, Hyderabad, Telangana 500081",
                    "website": "https://www.itchotels.com/in/en/itckohenur-hyderabad",
                    "averageCost": {
                        "stay": 22000,
                        "dining": { "min": 2200, "max": 5500 }
                    },
                    "facilities": [
                        "Elegant rooms and suites in Hitec City",
                        "Celebrated Indian and global restaurants",
                        "Kaya Kalp spa, pool, and fitness centre",
                        "Large banquets and meeting spaces"
                    ],
                    "brief": "A sustainability‑led luxury hotel in the tech hub with iconic dining and seasoned event capabilities.",
                    "highlights": [
                        "Responsible Luxury credentials",
                        "Proximity to business parks",
                        "Destination dining experiences",
                        "Conference‑ready floors"
                    ]
                },
                {
                    "name": "Park Hyatt Hyderabad",
                    "address": "Road No. 2, Banjara Hills, Hyderabad, Telangana 500034",
                    "website": "https://www.hyatt.com/en-US/hotel/india/park-hyatt-hyderabad/hydph",
                    "averageCost": {
                        "stay": 20000,
                        "dining": { "min": 2200, "max": 5200 }
                    },
                    "facilities": [
                        "Design‑forward rooms and serviced apartments",
                        "Fine dining, lounge, and patisserie",
                        "Spa, indoor pool (select), and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A chic luxury hotel in Banjara Hills with refined dining, wellness, and polished venues for upscale events.",
                    "highlights": [
                        "Central access to Banjara/Jubilee Hills",
                        "Sophisticated, contemporary design",
                        "Strong breakfast and bakery programs",
                        "Ideal for business and leisure"
                    ]
                },
                {
                    "name": "The Westin Hyderabad Mindspace",
                    "address": "Raheja IT Park, Hitec City, Hyderabad, Telangana 500081",
                    "website": "https://www.marriott.com/en-us/hotels/hydwi-the-westin-hyderabad-mindspace/overview/",
                    "averageCost": {
                        "stay": 17000,
                        "dining": { "min": 1800, "max": 4500 }
                    },
                    "facilities": [
                        "Wellness‑forward rooms with Heavenly Bed",
                        "Multiple dining venues and lounge",
                        "Pool, spa, and fitness studio",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A business‑friendly luxury hotel in Hitec City with wellness programming and versatile event spaces.",
                    "highlights": [
                        "Walkable to tech campuses (select)",
                        "Sleep and fitness‑centric amenities",
                        "Reliable for conferences",
                        "Good for extended corporate stays"
                    ]
                },
                {
                    "name": "Trident Hyderabad",
                    "address": "Survey No. 64, Hitec City, Hyderabad, Telangana 500081",
                    "website": "https://www.tridenthotels.com/hotels-in-hyderabad/",
                    "averageCost": {
                        "stay": 16000,
                        "dining": { "min": 1600, "max": 4200 }
                    },
                    "facilities": [
                        "Modern rooms with skyline views",
                        "All‑day dining, specialty restaurant, and bar",
                        "Pool and fitness centre",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A polished business hotel with clean lines, dependable dining, and event‑ready venues in the tech district.",
                    "highlights": [
                        "Efficient access within Hitec City",
                        "Consistent service standards",
                        "Value‑forward premium positioning",
                        "Good for short and long stays"
                    ]
                },
                {
                    "name": "Novotel Hyderabad Convention Centre",
                    "address": "Hitec City, Near HICC, Hyderabad, Telangana 500081",
                    "website": "https://all.accor.com/hotel/6182/index.en.shtml",
                    "averageCost": {
                        "stay": 14000,
                        "dining": { "min": 1400, "max": 3500 }
                    },
                    "facilities": [
                        "Rooms and suites adjoining convention centre",
                        "Multiple restaurants and bar",
                        "Pool, spa services, and fitness",
                        "Convention halls, lawns, and meeting rooms"
                    ],
                    "brief": "A large, event‑scale hotel connected to HICC, ideal for exhibitions, conventions, and corporate offsites.",
                    "highlights": [
                        "Direct access to convention venues",
                        "High‑capacity event logistics",
                        "Family‑friendly leisure",
                        "Efficient for business delegations"
                    ]
                },
                {
                    "name": "Taj Krishna, Hyderabad",
                    "address": "Road No. 1, Banjara Hills, Hyderabad, Telangana 500034",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-krishna-hyderabad/",
                    "averageCost": {
                        "stay": 18000,
                        "dining": { "min": 2000, "max": 5000 }
                    },
                    "facilities": [
                        "Classic rooms and suites with city views",
                        "Signature restaurants and lounge bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "A long‑standing luxury hotel with refined dining, central access, and seasoned event operations in Banjara Hills.",
                    "highlights": [
                        "Proximity to shopping and dining hubs",
                        "Trusted luxury brand service",
                        "Wedding and conference‑ready",
                        "Good for family city stays"
                    ]
                },
                {
                    "name": "Radisson Blu Plaza Hotel Hyderabad Banjara Hills",
                    "address": "Road No. 6, Banjara Hills, Hyderabad, Telangana 500034",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": {
                        "stay": 12000,
                        "dining": { "min": 1200, "max": 3000 }
                    },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All‑day dining and bar",
                        "Pool and fitness centre",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A business‑forward hotel in Banjara Hills with dependable rooms, dining, and versatile event venues.",
                    "highlights": [
                        "Central Banjara corridor",
                        "Consistent breakfast and room service",
                        "Value‑friendly for corporate trips",
                        "Suitable for short and extended stays"
                    ]
                },
                {
                    "name": "Holiday Inn Express & Suites Hyderabad Gachibowli",
                    "address": "IT Park, Gachibowli, Hyderabad, Telangana 500032",
                    "website": "https://www.ihg.com/holidayinnexpress/hotels/us/en/hyderabad/hydin/hoteldetail",
                    "averageCost": {
                        "stay": 8000,
                        "dining": { "min": 900, "max": 2200 }
                    },
                    "facilities": [
                        "Smart rooms and suites in IT corridor",
                        "Express café and grab‑and‑go",
                        "Fitness room",
                        "Meeting room (property‑specific)"
                    ],
                    "brief": "A practical, value‑driven stay for weekday business travellers in the Gachibowli‑Financial District.",
                    "highlights": [
                        "Walk/short drive to tech parks",
                        "Fast check‑in and services",
                        "Good value for long stays",
                        "Reliable essentials and Wi‑Fi"
                    ]
                }
            ]
        }
    },



    "agartala": {
        "name": "Agartala",
        "description": "Best hotels in Agartala—well-located stays near Akhaura Road, Palace Compound, and the airport. Expect clean rooms, convenient dining, basic event spaces, and quick access to Ujjayanta Palace and markets.",
        "sectionOne": "Agartala, Tripura’s capital, blends royal heritage with calm city vibes and improving connectivity. Travellers explore Ujjayanta Palace, Heritage Park, ISKCON, and Neermahal (day trip) while relying on straightforward hotel amenities—clean rooms, dependable Wi‑Fi, on‑site dining, and compact banquet spaces. From central business-friendly hotels to newer premium options, Agartala suits government work trips, family visits, and short leisure breaks.",
        "sectionTwo": {
            "text": "Agartala features a mix of premium city hotels, practical midscale options, and budget stays across the airport corridor, Akhaura Road, and Palace Compound. Below are handpicked properties with balanced location, amenities, and value.",
            "hotels": [
                {
                    "name": "Hotel Polo Towers, Agartala",
                    "address": "VIP Road, Near City Centre, Agartala, Tripura 799001",
                    "website": "https://www.hotelpolotowers.com/hotel-polo-towers-agartala/",
                    "averageCost": {
                        "stay": 7000,
                        "dining": { "min": 1200, "max": 2800 }
                    },
                    "facilities": [
                        "Modern rooms and suites",
                        "Multi-cuisine restaurant and bar",
                        "Outdoor pool (select) and fitness room",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A premium city hotel with polished rooms, lively dining, and event-friendly venues—good for business and family stays.",
                    "highlights": [
                        "Central access to shopping and offices",
                        "Reliable breakfast and room service",
                        "Event setups for socials and MICE",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "Ginger Agartala",
                    "address": "Khejur Bagan, Airport Road, Agartala, Tripura 799009",
                    "website": "https://www.gingerhotels.com/hotels/ginger-agartala",
                    "averageCost": {
                        "stay": 4500,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Smart rooms with essential amenities",
                        "In‑house café and in‑room dining (timed)",
                        "Fitness corner (property-specific)",
                        "Meeting room"
                    ],
                    "brief": "A practical, value-forward business hotel near the airport corridor, offering clean rooms and dependable service.",
                    "highlights": [
                        "Quick airport connectivity",
                        "Efficient check‑in/out",
                        "Good for weekday business trips",
                        "Balanced price-to-amenities"
                    ]
                },
                {
                    "name": "Hotel Noah Spire",
                    "address": "Palace Compound, Agartala, Tripura 799001",
                    "website": "#",
                    "averageCost": {
                        "stay": 5200,
                        "dining": { "min": 900, "max": 2000 }
                    },
                    "facilities": [
                        "Neat, contemporary rooms",
                        "Restaurant and room service",
                        "Front desk and travel assistance",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A modern city hotel with tidy rooms and straightforward dining close to Palace Compound and markets.",
                    "highlights": [
                        "Convenient for central sightseeing",
                        "Family-friendly categories",
                        "Consistent housekeeping",
                        "Suitable for short and multi-night stays"
                    ]
                },
                {
                    "name": "Hotel Sonar Tori",
                    "address": "Akhaura Road, Agartala, Tripura 799001",
                    "website": "#",
                    "averageCost": {
                        "stay": 5200,
                        "dining": { "min": 900, "max": 2000 }
                    },
                    "facilities": [
                        "Comfortable rooms with essential utilities",
                        "On‑site restaurant and café",
                        "Small banquet/meeting space",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A centrally located hotel with simple comforts, popular dining, and compact event options.",
                    "highlights": [
                        "Walkable to shops and eateries",
                        "Value pricing for families",
                        "Easy access to transport",
                        "Good choice for quick trips"
                    ]
                },
                {
                    "name": "Hotel Welcome Palace",
                    "address": "HGB Road, Palace Compound, Agartala, Tripura 799001",
                    "website": "#",
                    "averageCost": {
                        "stay": 3800,
                        "dining": { "min": 700, "max": 1600 }
                    },
                    "facilities": [
                        "Basic rooms with essential amenities",
                        "In‑house dining and room service",
                        "Front desk support",
                        "Wi‑Fi (property-specific)"
                    ],
                    "brief": "A budget-friendly central stay offering essential comforts and straightforward dining near city landmarks.",
                    "highlights": [
                        "Close to Ujjayanta Palace",
                        "Quick access to bazaars",
                        "Good for short stopovers",
                        "Simple, no‑frills experience"
                    ]
                },
                {
                    "name": "Starline Hotel",
                    "address": "City Centre Area, Agartala, Tripura 799001",
                    "website": "#",
                    "averageCost": {
                        "stay": 4200,
                        "dining": { "min": 800, "max": 1800 }
                    },
                    "facilities": [
                        "Clean rooms in a central location",
                        "Restaurant and breakfast service",
                        "Travel assistance",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A practical midscale option with tidy rooms and convenient dining, suitable for business and family stays.",
                    "highlights": [
                        "Central reach for errands and offices",
                        "Consistent service",
                        "Budget‑sensitive categories",
                        "Handy for transit travellers"
                    ]
                }
            ]
        }
    },


    "lucknow": {
        "name": "Lucknow",
        "description": "Best hotels in Lucknow—premium and midscale stays near Gomti Nagar, Hazratganj, and the airport. Enjoy award‑winning dining, clean rooms, pools/spas (select), and versatile event spaces.",
        "sectionOne": "Lucknow, the City of Nawabs, blends heritage architecture, kebab trails, and expanding business districts. Visitors explore Bara Imambara, Rumi Darwaza, British Residency, and Hazratganj markets while benefiting from strong air, rail, and expressway connectivity. City hotels focus on polished rooms, reliable Wi‑Fi, multiple dining options, and banquet facilities for conferences and weddings. From riverside and Gomti Nagar premium hotels to practical central stays, Lucknow suits corporate trips, family holidays, and culinary getaways.",
        "sectionTwo": {
            "text": "Lucknow features luxury and premium city hotels alongside value business stays across Gomti Nagar, Hazratganj/central, and airport corridors. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Mahal, Lucknow",
                    "address": "Vipin Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-mahal-lucknow/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Elegant rooms and suites with garden/pool views",
                        "Signature Awadhi and global dining",
                        "Pool, J Wellness spa, and fitness center",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "A classic luxury address in Gomti Nagar with refined rooms, acclaimed dining, and polished event operations.",
                    "highlights": [
                        "Proximity to riverfront and shopping",
                        "Renowned Awadhi cuisine experiences",
                        "Trusted luxury service standards",
                        "Efficient for meetings and weddings"
                    ]
                },
                {
                    "name": "Renaissance Lucknow Hotel",
                    "address": "Vipin Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Contemporary rooms with city/river glimpses",
                        "Multiple restaurants and rooftop bar",
                        "Rooftop pool and fitness studio",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A skyline‑view premium hotel in Gomti Nagar with vibrant dining and event‑ready spaces for business and socials.",
                    "highlights": [
                        "Rooftop leisure with city views",
                        "Walkable to malls and cafés (area dependent)",
                        "Strong breakfast and room service",
                        "Good for corporate and family stays"
                    ]
                },
                {
                    "name": "Hyatt Regency Lucknow",
                    "address": "Vibhuti Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All‑day dining, lounge, and bakery",
                        "Pool, spa services, and gym",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A business‑forward premium hotel offering dependable rooms, strong dining, and versatile venues in Gomti Nagar.",
                    "highlights": [
                        "Quick access to business clusters",
                        "Event‑friendly floors with modern AV",
                        "Consistent service and amenities",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "Novotel Lucknow Gomti Nagar",
                    "address": "Viraj Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
                    "website": "https://all.accor.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Stylish rooms in the business district",
                        "All‑day dining and bar",
                        "Rooftop pool and fitness center",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A contemporary hotel with rooftop leisure, reliable dining, and compact event spaces—ideal for weekday business trips.",
                    "highlights": [
                        "Convenient Gomti Nagar address",
                        "Popular breakfast options",
                        "Efficient check‑in and services",
                        "Value‑forward for corporate stays"
                    ]
                },
                {
                    "name": "The Piccadily Lucknow",
                    "address": "Kanpur Road, Near Airport, Lucknow, Uttar Pradesh 226005",
                    "website": "https://www.piccadilyhotels.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Comfortable rooms near the airport corridor",
                        "Multi‑cuisine restaurants and bar",
                        "Pool and fitness center",
                        "Banquet halls and conference rooms"
                    ],
                    "brief": "A long‑trusted city hotel close to the airport route with steady dining and versatile event facilities.",
                    "highlights": [
                        "Airport and highway connectivity",
                        "Event‑friendly layouts",
                        "Balanced price‑to‑amenities",
                        "Good for transit and family stays"
                    ]
                },
                {
                    "name": "La Place Sarovar Portico, Lucknow",
                    "address": "Hazratganj, Lucknow, Uttar Pradesh 226001",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Central rooms with business conveniences",
                        "Restaurant, café, and bar",
                        "Meeting room and banquet hall",
                        "Wi‑Fi, parking, concierge"
                    ],
                    "brief": "A centrally located hotel in Hazratganj offering tidy rooms, convenient dining, and compact event spaces.",
                    "highlights": [
                        "Walkable to markets and eateries",
                        "Reliable breakfast and service",
                        "Good for short corporate trips",
                        "Practical for city sightseeing"
                    ]
                },
                {
                    "name": "Clarks Avadh",
                    "address": "MG Marg, Hazratganj, Lucknow, Uttar Pradesh 226001",
                    "website": "https://www.clarkshotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "City/river‑view rooms and suites (select)",
                        "Multiple dining options and bar",
                        "Pool and fitness room",
                        "Banquets and lawns"
                    ],
                    "brief": "A city landmark with classic hospitality, views, and indoor‑outdoor venues for weddings and conferences.",
                    "highlights": [
                        "Central Hazratganj access",
                        "Event lawns and ballrooms",
                        "Family‑friendly leisure facilities",
                        "Steady service and housekeeping"
                    ]
                },
                {
                    "name": "Fairfield by Marriott Lucknow",
                    "address": "Vibhuti Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Smart rooms with essential comforts",
                        "All‑day dining and grab‑and‑go",
                        "Fitness center",
                        "Meeting room"
                    ],
                    "brief": "A reliable, value‑forward business hotel in Gomti Nagar with clean rooms and practical amenities.",
                    "highlights": [
                        "Close to offices and cafés",
                        "Quick check‑in/out for work trips",
                        "Consistent breakfast options",
                        "Good for short weekday stays"
                    ]
                }
            ]
        }
    },


    "dehradun": {
        "name": "Dehradun",
        "description": "Best hotels in Dehradun—hill‑city stays near Rajpur Road, Jakhan–Mussoorie Road, and the airport corridor. Expect scenic rooms, reliable dining, cozy lounges, and event spaces for offsites and family functions.",
        "sectionOne": "Dehradun, the gateway to Mussoorie and the Doon Valley, blends green avenues and cafés with quick access to hills, caves, and rivers. Travellers explore Robber’s Cave (Gucchupani), Tapkeshwar Temple, Forest Research Institute, Malsi Deer Park, and nearby Mussoorie/Kempty Falls day trips. City hotels focus on clean, view‑forward rooms, dependable Wi‑Fi, on‑site dining, and compact to mid‑size banquets—ideal for family holidays, weekend breaks, and corporate meets.",
        "sectionTwo": {
            "text": "Dehradun features boutique city hotels, premium hillside resorts, and practical midscale stays across Rajpur Road, Jakhan/IT Park, and the airport/Haridwar Road approach. Below are handpicked stays known for location, amenities, and value.",
            "hotels": [
                {
                    "name": "Hyatt Regency Dehradun Resort & Spa",
                    "address": "Mussoorie Road (Malsi/Jakhan belt), Dehradun, Uttarakhand 248001",
                    "website": "#",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 5000 } },
                    "facilities": [
                        "Mountain‑view rooms and suites",
                        "Multiple restaurants, bar, and high‑tea",
                        "Rooftop/terrace pool (property‑specific), spa, and gym",
                        "Ballrooms, lawns, and meeting rooms"
                    ],
                    "brief": "A premium hillside resort with scenic vistas, strong dining, and versatile event spaces—great for retreats and weddings.",
                    "highlights": [
                        "Quick access to Mussoorie road",
                        "Family‑friendly leisure and kids’ activities",
                        "High‑capacity banquets and breakouts",
                        "Good pick for weekend escapes"
                    ]
                },
                {
                    "name": "Hyatt Centric Rajpur Road Dehradun",
                    "address": "Rajpur Road, near Pacific Mall, Dehradun, Uttarakhand 248001",
                    "website": "#",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Contemporary rooms near cafés and shopping",
                        "All‑day dining, lounge, and rooftop (select)",
                        "Fitness center",
                        "Meeting rooms"
                    ],
                    "brief": "A polished city‑hub hotel with vibrant dining and compact event spaces for quick business and family trips.",
                    "highlights": [
                        "Walkable to Rajpur Road hotspots",
                        "Efficient check‑in/out",
                        "Consistent breakfast and service",
                        "Ideal for short stays"
                    ]
                },
                {
                    "name": "LP Vilas by LP Hotels",
                    "address": "Chakrata Road, Dehradun, Uttarakhand 248007",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Spacious rooms with city views",
                        "Multi‑cuisine restaurant and bakery",
                        "Fitness room",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A popular city hotel offering roomy stays, steady dining, and indoor‑outdoor venues for socials and meetings.",
                    "highlights": [
                        "Good event and wedding capacity",
                        "Comfortable for multi‑night stays",
                        "Easy access to central areas",
                        "Value‑forward amenities"
                    ]
                },
                {
                    "name": "Effotel by Sayaji Dehradun",
                    "address": "Haridwar Bypass/Doonga Gaon Road approach, Dehradun 248001",
                    "website": "#",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Modern rooms with essential comforts",
                        "Restaurant and lounge",
                        "Activity/games corner (select)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A tidy, value‑led stay with practical dining and compact event facilities—good for families and quick work trips.",
                    "highlights": [
                        "Convenient city approach",
                        "Popular buffet breakfast",
                        "Budget‑friendly categories",
                        "Efficient services"
                    ]
                },
                {
                    "name": "Regenta by Royal Orchid Dehradun",
                    "address": "Sahastradhara/Doonga Gaon Road belt, Dehradun 248001",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Comfortable rooms with hill/city glimpses",
                        "All‑day dining and rooftop (property‑specific)",
                        "Pool (select) and fitness",
                        "Event hall"
                    ],
                    "brief": "A scenic, mid‑premium option with rooftop vibes and compact banquets—suited to families and small celebrations.",
                    "highlights": [
                        "Easy drive to Sahastradhara",
                        "City views from rooftop (select)",
                        "Good value for weekenders",
                        "Balanced F&B and service"
                    ]
                },
                {
                    "name": "Sarovar Portico Dehradun",
                    "address": "Haridwar Road/ISBT approach, Dehradun 248001",
                    "website": "#",
                    "averageCost": { "stay": 8000, "dining": { "min": 900, "max": 2000 } },
                    "facilities": [
                        "Neat rooms with essential amenities",
                        "Multi‑cuisine restaurant and café",
                        "Meeting room",
                        "Wi‑Fi, parking, concierge"
                    ],
                    "brief": "A dependable midscale hotel near the transit corridor—practical for business travel and family stopovers.",
                    "highlights": [
                        "Transit‑friendly location",
                        "Consistent breakfast and housekeeping",
                        "Quick check‑in/out",
                        "Good value in city limits"
                    ]
                },
                {
                    "name": "Shaheen Bagh – A Luxury Boutique Resort & Spa",
                    "address": "Jamniwala, Gular Ghati, Dehradun 248141",
                    "website": "#",
                    "averageCost": { "stay": 20000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Estate‑style rooms amid greenery",
                        "Curated dining and high‑tea",
                        "Spa services and pool",
                        "Lawns and intimate event spaces"
                    ],
                    "brief": "A boutique garden estate offering tranquil stays, curated dining, and serene lawns—great for couples and small gatherings.",
                    "highlights": [
                        "Green, quiet surroundings",
                        "Photo‑friendly gardens",
                        "Personalised service",
                        "Calm weekend retreat feel"
                    ]
                },
                {
                    "name": "Hotel Aketa Rajpur Road",
                    "address": "113/1, Rajpur Road, Dehradun 248001",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Comfortable rooms in a prime area",
                        "Restaurant and room service",
                        "Fitness/sauna (property‑specific)",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A long‑trusted address on Rajpur Road with tidy rooms, simple dining, and practical event facilities.",
                    "highlights": [
                        "Central stretch for cafés and shopping",
                        "Reliable staff and services",
                        "Good for short stays",
                        "Balanced pricing"
                    ]
                }
            ]
        }
    },


    "kolkata": {
        "name": "Kolkata",
        "description": "Best hotels in Kolkata—heritage icons and premium city stays near Park Street, New Town/Rajarhat, and the riverfront. Enjoy award‑winning dining, elegant rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Kolkata, the City of Joy, blends colonial‑era architecture, arts and literature, and a thriving culinary scene. Travellers explore Victoria Memorial, Park Street, Dakshineswar/Belur Math, Prinsep Ghat, and New Town’s modern hubs, supported by strong air, rail, and Metro connectivity. City hotels emphasize polished rooms, reliable Wi‑Fi, destination dining, and expansive banquet floors for conferences and weddings. From legendary Park Street and Maidan‑adjacent icons to New Town convention‑scale properties and airport‑corridor business stays, Kolkata suits corporate trips, family holidays, events, and long stays.",
        "sectionTwo": {
            "text": "Kolkata features luxury heritage addresses, premium business hotels, and smart new‑town stays across Park Street–Maidan, EM Bypass, and New Town. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The Oberoi Grand, Kolkata",
                    "address": "15, Jawaharlal Nehru Road, Esplanade, Kolkata, West Bengal 700013",
                    "website": "https://www.oberoihotels.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Heritage rooms and suites around a central pool",
                        "Fine dining restaurants, bar, and patisserie",
                        "Outdoor pool, spa, and fitness centre",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A colonial‑era landmark near Park Street/Esplanade with refined rooms, destination dining, and polished event spaces.",
                    "highlights": [
                        "Classic ‘Grand Dame’ ambience",
                        "Steps to Park Street and New Market",
                        "Renowned service standards",
                        "Great for business and city breaks"
                    ]
                },
                {
                    "name": "ITC Royal Bengal, a Luxury Collection Hotel, Kolkata",
                    "address": "JBS Haldane Avenue, EM Bypass, Kolkata, West Bengal 700105",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Grand rooms and suites, club floors",
                        "Signature Indian and global restaurants",
                        "Kaya Kalp spa, pool, and fitness",
                        "Expansive banquets and convention spaces"
                    ],
                    "brief": "A convention‑scale luxury hotel on EM Bypass with iconic dining and large event capacity for conferences and weddings.",
                    "highlights": [
                        "‘Responsible Luxury’ credentials",
                        "Direct link to adjacent ITC Sonar (select shared ecosystem)",
                        "Strong MICE capabilities",
                        "Convenient EM Bypass connectivity"
                    ]
                },
                {
                    "name": "JW Marriott Hotel Kolkata",
                    "address": "4A, JBS Haldane Avenue, EM Bypass, Kolkata, West Bengal 700105",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Multiple restaurants, bakery, and bar",
                        "Outdoor pool, spa, and fitness studio",
                        "Large ballrooms and meeting rooms"
                    ],
                    "brief": "A luxury address on EM Bypass known for vibrant dining, lavish brunches, and robust event operations.",
                    "highlights": [
                        "Quick reach to New Town and Park Street",
                        "Family‑friendly leisure facilities",
                        "Event‑ready with modern AV",
                        "Consistent five‑star service"
                    ]
                },
                {
                    "name": "Taj Bengal, Kolkata",
                    "address": "34B, Belvedere Road, Alipore, Kolkata, West Bengal 700027",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Elegant rooms and suites near the Maidan/Alipore",
                        "Signature restaurants and lounge bar",
                        "Pool, spa, and fitness centre",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A classic luxury hotel with refined rooms, celebrated dining, and serene city‑green proximity.",
                    "highlights": [
                        "Alipore/Maidan cultural access",
                        "Trusted luxury brand hospitality",
                        "Balanced for business and leisure",
                        "Popular for social events"
                    ]
                },
                {
                    "name": "The LaLiT Great Eastern Kolkata",
                    "address": "1,2,3 Old Court House Street, Dalhousie, Kolkata, West Bengal 700069",
                    "website": "https://www.thelalit.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Heritage‑modern rooms and suites",
                        "Multiple dining outlets and bar",
                        "Outdoor pool, spa, and fitness",
                        "Banquet halls and event spaces"
                    ],
                    "brief": "A restored heritage gem near the central business district with distinctive charm and versatile venues.",
                    "highlights": [
                        "Historic character and ambience",
                        "Easy reach to BBD Bag and riverfront",
                        "Good for business delegations",
                        "Memorable dining backdrops"
                    ]
                },
                {
                    "name": "Novotel Kolkata Hotel & Residences",
                    "address": "CF 11, Action Area 1C, New Town, Rajarhat, Kolkata, West Bengal 700156",
                    "website": "https://all.accor.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Rooms, suites, and serviced residences",
                        "All‑day dining, rooftop/bar (property‑specific)",
                        "Pool, spa, and fitness centre",
                        "Convention halls and meeting rooms"
                    ],
                    "brief": "A New Town hotel‑residence hybrid ideal for longer stays, families, and convention‑scale events.",
                    "highlights": [
                        "Airport and New Town connectivity",
                        "Flexible room/apartment categories",
                        "Strong MICE footprint",
                        "Value for extended stays"
                    ]
                },
                {
                    "name": "Holiday Inn Kolkata Airport",
                    "address": "Biswa Bangla Sarani, Rajarhat, Kolkata, West Bengal 700136",
                    "website": "https://www.ihg.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Modern, sound‑insulated rooms",
                        "All‑day dining and lounge",
                        "Rooftop/Outdoor pool (select) and gym",
                        "Meeting rooms"
                    ],
                    "brief": "A convenient airport‑side hotel with practical rooms, steady dining, and compact event facilities.",
                    "highlights": [
                        "Quick terminal access",
                        "Efficient for short business trips",
                        "Reliable breakfast options",
                        "Good value near the airport"
                    ]
                },
                {
                    "name": "The Park Kolkata",
                    "address": "17, Park Street, Kolkata, West Bengal 700016",
                    "website": "https://www.theparkhotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "City‑view rooms in a nightlife/dining hub",
                        "Multiple restaurants, lounge, and club",
                        "Pool and fitness room",
                        "Event and meeting spaces"
                    ],
                    "brief": "A lifestyle hotel on Park Street with buzzy dining and nightlife, suitable for social events and city breaks.",
                    "highlights": [
                        "Prime Park Street location",
                        "Vibrant F&B and nightlife",
                        "Easy access to shopping and cafés",
                        "Great for weekenders"
                    ]
                }
            ]
        }
    },

    "delhi": {
        "name": "Delhi",
        "description": "Best hotels in Delhi—heritage icons and premium business stays near Lutyens’, Connaught Place, Aerocity, and Gurugram corridor. Enjoy award‑winning dining, elegant rooms, pools, spas, and versatile event spaces.",
        "sectionOne": "Delhi, India’s capital, blends Mughal heritage and Lutyens’ boulevards with modern business hubs and vibrant markets. Travellers explore India Gate, Red Fort, Qutub Minar, Humayun’s Tomb, Connaught Place, and Aerocity dining—backed by extensive Metro, air, and rail connectivity. City hotels emphasize polished rooms, dependable Wi‑Fi, destination dining, and large banquets for conferences and weddings. From legendary colonial‑era grand hotels to Aerocity convention‑scale properties and leafy Chanakyapuri luxury, Delhi suits corporate trips, family holidays, and long stays.",
        "sectionTwo": {
            "text": "Delhi features palace‑style icons, luxury urban properties, and business‑first stays across Central Delhi, Aerocity, Chanakyapuri, and Gurugram’s approach. Below are handpicked properties known for prime locations, standout amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The Imperial New Delhi",
                    "address": "Janpath, Connaught Place, New Delhi, Delhi 110001",
                    "website": "https://www.theimperialindia.com/",
                    "averageCost": { "stay": 30000, "dining": { "min": 3000, "max": 7500 } },
                    "facilities": [
                        "Heritage rooms and suites with colonial art",
                        "Award‑winning restaurants, bar, and patisserie",
                        "Courtyard pool, spa, and fitness centre",
                        "Ballrooms and salons for events"
                    ],
                    "brief": "A grand colonial‑era landmark near Connaught Place offering refined luxury, destination dining, and elegant venues.",
                    "highlights": [
                        "Iconic heritage ambience",
                        "Central access to CP and museums",
                        "High‑touch concierge and service",
                        "Preferred for upscale events"
                    ]
                },
                {
                    "name": "The Oberoi, New Delhi",
                    "address": "Dr. Zakir Hussain Marg, New Delhi, Delhi 110003",
                    "website": "https://www.oberoihotels.com/hotels-in-new-delhi-the-oberoi/",
                    "averageCost": { "stay": 32000, "dining": { "min": 3000, "max": 7000 } },
                    "facilities": [
                        "Modern rooms with views of Humayun’s Tomb/Delhi Golf Club",
                        "Fine dining, rooftop bar, and patisserie",
                        "Indoor and outdoor pools, spa, and gym",
                        "Meeting rooms and elegant event spaces"
                    ],
                    "brief": "A contemporary luxury icon with panoramic vistas, acclaimed dining, and discreet, high‑touch service.",
                    "highlights": [
                        "Leafy Lutyens’ setting",
                        "Panoramic monument/golf views (select)",
                        "Impeccable service and security",
                        "Ideal for executives and city breaks"
                    ]
                },
                {
                    "name": "Taj Palace, New Delhi",
                    "address": "Sardar Patel Marg, Diplomatic Enclave, New Delhi, Delhi 110021",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-palace-new-delhi/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "City‑view rooms and suites",
                        "Multiple specialty restaurants and bars",
                        "Outdoor pool, J Wellness Circle spa, and gym",
                        "Grand ballrooms and boardrooms"
                    ],
                    "brief": "A diplomatic‑enclave luxury favorite with celebrated dining and seasoned event operations amid green surroundings.",
                    "highlights": [
                        "Chanakyapuri/Lutyens’ connectivity",
                        "Renowned Indian and global cuisine",
                        "Conference‑ready venues",
                        "Trusted luxury brand standards"
                    ]
                },
                {
                    "name": "ITC Maurya, a Luxury Collection Hotel",
                    "address": "Diplomatic Enclave, Sardar Patel Marg, New Delhi, Delhi 110021",
                    "website": "https://www.itchotels.com/in/en/itcmaurya-new-delhi",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Elegant rooms and suites",
                        "Iconic Indian fine‑dining and global outlets",
                        "Kaya Kalp spa, pool, and fitness",
                        "Expansive banquets and meeting rooms"
                    ],
                    "brief": "A heritage‑inspired luxury hotel with legendary Indian dining and strong MICE capabilities in the diplomatic district.",
                    "highlights": [
                        "‘Responsible Luxury’ ethos",
                        "Destination restaurants (select)",
                        "Seasoned conference planning",
                        "Green, quiet surroundings"
                    ]
                },
                {
                    "name": "The Leela Palace New Delhi",
                    "address": "Africa Avenue, Chanakyapuri, New Delhi, Delhi 110023",
                    "website": "https://www.theleela.com/the-leela-palace-new-delhi",
                    "averageCost": { "stay": 30000, "dining": { "min": 3000, "max": 7000 } },
                    "facilities": [
                        "Palatial rooms and suites with city views",
                        "Multiple specialty restaurants and lounges",
                        "Rooftop pool, spa, and fitness centre",
                        "Ballrooms and boardrooms"
                    ],
                    "brief": "A modern‑palace address in Chanakyapuri with opulent rooms, rooftop leisure, and elegant venues.",
                    "highlights": [
                        "Rooftop pool with skyline views",
                        "Curated fine‑dining experiences",
                        "Embassy/diplomatic access",
                        "High‑touch concierge services"
                    ]
                },
                {
                    "name": "Andaz Delhi – Aerocity",
                    "address": "Aerocity, Indira Gandhi International Airport, New Delhi, Delhi 110037",
                    "website": "https://www.hyatt.com/en-US/hotel/india/andaz-delhi/newaz",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Design‑forward rooms and suites",
                        "Multiple restaurants and bars",
                        "Outdoor pool, spa, and fitness",
                        "Ballrooms and meeting spaces"
                    ],
                    "brief": "A lifestyle‑led luxury hotel in Aerocity with vibrant dining and event‑ready venues for modern business and socials.",
                    "highlights": [
                        "Terminal/Metro connectivity",
                        "Creative F&B concepts",
                        "Convention‑friendly footprint",
                        "Great for short corporate stays"
                    ]
                },
                {
                    "name": "JW Marriott Hotel New Delhi Aerocity",
                    "address": "Asset Area 4, Hospitality District, Aerocity, New Delhi, Delhi 110037",
                    "website": "https://www.marriott.com/en-us/hotels/delap-jw-marriott-hotel-new-delhi-aerocity/overview/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All‑day dining, specialty restaurants, bakery",
                        "Outdoor pool, spa, and fitness studio",
                        "Large ballrooms and meeting rooms"
                    ],
                    "brief": "A luxury Aerocity hub with robust dining, lavish brunches, and strong event operations near the airport.",
                    "highlights": [
                        "Quick terminal access",
                        "High‑capacity banquets",
                        "Family‑friendly leisure",
                        "Reliable five‑star service"
                    ]
                },
                {
                    "name": "The Lodhi",
                    "address": "Lodhi Road, New Delhi, Delhi 110003",
                    "website": "https://www.thelodhi.com/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2500, "max": 6500 } },
                    "facilities": [
                        "Spacious rooms and suites, some with private plunge pools",
                        "Signature restaurants, patisserie, and bar",
                        "Spa, pool, and fitness centre",
                        "Event and meeting spaces"
                    ],
                    "brief": "An art‑forward luxury hotel offering serene rooms, destination dining, and refined wellness in central Delhi.",
                    "highlights": [
                        "Near Lodhi Gardens and monuments",
                        "Private‑pool suites (select)",
                        "Sophisticated urban retreat",
                        "Ideal for special occasions"
                    ]
                },
                {
                    "name": "Shangri‑La Eros New Delhi",
                    "address": "19 Ashoka Road, Connaught Place, New Delhi, Delhi 110001",
                    "website": "https://www.shangri-la.com/newdelhi/shangrila/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 5000 } },
                    "facilities": [
                        "Rooms and suites with city views",
                        "Multiple restaurants and bars",
                        "Spa, pool, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A skyline‑view luxury stay with diverse dining, serene spa, and flexible venues near Connaught Place.",
                    "highlights": [
                        "Walkable to CP and India Gate axis",
                        "Panoramic city vistas",
                        "Recognized F&B variety",
                        "Conference‑ready floors"
                    ]
                },
                {
                    "name": "Holiday Inn New Delhi International Airport (Aerocity)",
                    "address": "Asset Area 12, Aerocity, New Delhi, Delhi 110037",
                    "website": "https://www.ihg.com/holidayinn/hotels/us/en/new-delhi/delap/hoteldetail",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Sound‑insulated, modern rooms",
                        "All‑day dining and lounge bar",
                        "Outdoor pool and fitness",
                        "Meeting rooms"
                    ],
                    "brief": "A convenient airport‑side hotel with practical rooms, steady dining, and compact event facilities.",
                    "highlights": [
                        "Terminal and Metro proximity",
                        "Efficient for short stays",
                        "Popular breakfast options",
                        "Good value in Aerocity"
                    ]
                }
            ]
        }
    },



    "agra": {
        "name": "Agra",
        "description": "Best hotels in Agra—heritage and premium stays near Taj East Gate, Fatehabad Road, and the city center. Enjoy Taj‑view rooms (select), award‑winning dining, pools, spas, and versatile event spaces.",
        "sectionOne": "Agra, home to the Taj Mahal, Agra Fort, and Fatehpur Sikri, blends Mughal grandeur with a modern hospitality scene. Travellers base themselves near Taj East Gate and Fatehabad Road for quick monument access, reliable Wi‑Fi, destination dining, and banquet floors for weddings and conferences. From exclusive Taj‑view icons to resort‑style escapes and dependable business hotels, Agra suits family trips, romantic getaways, and event-focused stays.",
        "sectionTwo": {
            "text": "Agra features luxury Taj‑view landmarks, resort hotels with gardens and spas, and practical city stays along Fatehabad Road and the Cantonment/Civil Lines side. Below are curated options known for location, amenities, and service.",
            "hotels": [
                {
                    "name": "The Oberoi Amarvilas, Agra",
                    "address": "Taj East Gate Road, Agra, Uttar Pradesh 282001",
                    "website": "https://www.oberoihotels.com/hotels-in-agra-amarvilas-resort/",
                    "averageCost": { "stay": 45000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "All rooms and suites with Taj Mahal views",
                        "Fine dining, bar, and terrace venues",
                        "Pool, spa, and fitness centre",
                        "Private dining with Taj backdrop"
                    ],
                    "brief": "Agra’s definitive luxury hotel with uninterrupted Taj Mahal views, refined dining, and bespoke experiences.",
                    "highlights": [
                        "Approx. 600 m from Taj entrance (golf cart access)",
                        "Iconic sunrise/sunset vistas",
                        "High‑touch butler‑style service",
                        "Perfect for honeymoons and milestones"
                    ]
                },
                {
                    "name": "ITC Mughal, a Luxury Collection Resort & Spa, Agra",
                    "address": "Tajganj, Fatehabad Road, Agra, Uttar Pradesh 282001",
                    "website": "https://www.marriott.com/en-us/hotels/agrlc-itc-mughal-a-luxury-collection-resort-and-spa-agra/overview/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1800, "max": 5200 } },
                    "facilities": [
                        "Mughal‑inspired rooms and suites",
                        "Multiple restaurants and bar",
                        "Expansive gardens, pool, and spa",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A sprawling resort tribute to Mughal aesthetics with lush grounds, celebrated dining, and event capacity.",
                    "highlights": [
                        "Resort ambience near the Taj circuit",
                        "Signature Indian dining",
                        "Family‑friendly leisure",
                        "Strong MICE capabilities"
                    ]
                },
                {
                    "name": "Jaypee Palace Hotel & Convention Centre",
                    "address": "Fatehabad Road, Agra, Uttar Pradesh 282004",
                    "website": "https://www.jaypeehotels.com/hotels-in-agra/jaypee-palace-hotel",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 4200 } },
                    "facilities": [
                        "Palace‑style rooms and suites",
                        "Multiple restaurants, café, and bar",
                        "Pool, spa, and fitness",
                        "Convention centre, lawns, and banquets"
                    ],
                    "brief": "A palace‑style convention hotel with large venues, varied dining, and resort‑like leisure for big weddings and conferences.",
                    "highlights": [
                        "Event‑scale infrastructure",
                        "Family and group friendly",
                        "Easy access to Fatehabad Road",
                        "Balanced business‑leisure mix"
                    ]
                },
                {
                    "name": "Trident, Agra",
                    "address": "Fatehabad Road, Agra, Uttar Pradesh 282001",
                    "website": "https://www.tridenthotels.com/hotels-in-agra/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Garden‑facing rooms and suites",
                        "All‑day dining and bar",
                        "Pool and fitness room",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A serene, family‑friendly hotel offering polished rooms, gardens, and consistent service close to the Taj approach.",
                    "highlights": [
                        "Calm resort vibe within city reach",
                        "Reliable breakfast and service",
                        "Good value for premium segment",
                        "Ideal for families and short breaks"
                    ]
                },
                {
                    "name": "Courtyard by Marriott Agra",
                    "address": "Taj Nagari Phase 2, Fatehabad Road, Agra, Uttar Pradesh 282001",
                    "website": "https://www.marriott.com/en-us/hotels/agrcy-courtyard-agra/overview/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A modern, event‑ready hotel with robust dining and leisure facilities just off Fatehabad Road.",
                    "highlights": [
                        "Convenient Taj‑side location",
                        "Popular buffets and brunches",
                        "Versatile venues for socials",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "DoubleTree by Hilton Hotel Agra",
                    "address": "B/H – 1&2, Taj Nagri Phase II, Agra, Uttar Pradesh 282001",
                    "website": "https://www.hilton.com/en/hotels/agrhitw-doubletree-agra/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1400, "max": 3000 } },
                    "facilities": [
                        "Modern rooms (select with Taj glimpses)",
                        "All‑day dining, lounge, and bar",
                        "Pool and fitness centre",
                        "Banquet and meeting spaces"
                    ],
                    "brief": "A business‑leisure hotel near Fatehabad Road with contemporary rooms, steady dining, and practical event spaces.",
                    "highlights": [
                        "Easy access to Taj/Agra Fort circuit",
                        "Consistent brand standards",
                        "Good for families and work trips",
                        "Value‑forward premium pick"
                    ]
                },
                {
                    "name": "Tajview, Agra – IHCL SeleQtions",
                    "address": "Fatehabad Road, Agra, Uttar Pradesh 282001",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Rooms and suites (select with Taj view)",
                        "Restaurant, café, and bar",
                        "Pool and fitness room",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A classic Agra stay offering select Taj‑view categories, comfortable rooms, and reliable dining.",
                    "highlights": [
                        "Taj‑facing categories (select)",
                        "Central Fatehabad Road access",
                        "Event‑friendly layouts",
                        "Good for families and groups"
                    ]
                }
            ]
        }
    },



    "udaipur": {
        "name": "Udaipur",
        "description": "Best hotels in Udaipur—lakefront palaces and premium city resorts near Lake Pichola, Fateh Sagar, and the airport corridor. Enjoy award‑winning dining, royal suites, pools, spas, and grand event venues.",
        "sectionOne": "Udaipur, the City of Lakes, blends palaces, ghats, and Aravalli vistas with a refined hospitality scene. Travellers explore City Palace, Jag Mandir, Jagdish Temple, Saheliyon‑ki‑Bari, and sunset boat rides on Pichola/Fateh Sagar. City hotels span legendary lake palaces, heritage‑modern resorts, and dependable premium stays with destination dining, serene spas, and expansive banquets—ideal for honeymoons, family trips, and wedding celebrations.",
        "sectionTwo": {
            "text": "Udaipur features iconic lake palaces, luxury resorts with gardens and courtyards, and polished city hotels along Pichola, Fateh Sagar, and NH/Airport approaches. Below are handpicked properties known for location, amenities, and service.",
            "hotels": [
                {
                    "name": "The Oberoi Udaivilas, Udaipur",
                    "address": "Haridas Ji Ki Magri, Malla Talai, Udaipur, Rajasthan 313001",
                    "website": "https://www.oberoihotels.com/hotels-in-udaipur-udaivilas-resort/",
                    "averageCost": { "stay": 50000, "dining": { "min": 3000, "max": 8000 } },
                    "facilities": [
                        "Luxury rooms and suites (select with semi‑private pool)",
                        "Fine dining restaurants and bar",
                        "Pools, spa, and fitness centre",
                        "Lawns and elegant event spaces"
                    ],
                    "brief": "A lakeside luxury resort with Mughal‑Mewari architecture, serene courtyards, and curated dining—perfect for romantic and family retreats.",
                    "highlights": [
                        "Boat‑arrivals ambience (area dependent)",
                        "Lake and palace views (select)",
                        "Signature spa and sunset promenades",
                        "High‑touch hospitality"
                    ]
                },
                {
                    "name": "Taj Lake Palace, Udaipur",
                    "address": "Pichola Lake, Udaipur, Rajasthan 313001",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-lake-palace-udaipur/",
                    "averageCost": { "stay": 60000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "Heritage lake‑island palace suites and rooms",
                        "Signature restaurants and bars",
                        "Pool, spa, and butler‑led services",
                        "Intimate event and dining venues"
                    ],
                    "brief": "An ethereal island‑palace hotel on Lake Pichola offering cinematic views, royal‑style service, and unforgettable dining.",
                    "highlights": [
                        "Only‑by‑boat access from the jetty",
                        "Iconic views of City Palace and Aravallis",
                        "Butler service in select categories",
                        "Bucket‑list celebrations"
                    ]
                },
                {
                    "name": "The Leela Palace Udaipur",
                    "address": "Lake Pichola, Pichola, Udaipur, Rajasthan 313001",
                    "website": "https://www.theleela.com/the-leela-palace-udaipur",
                    "averageCost": { "stay": 38000, "dining": { "min": 2500, "max": 7000 } },
                    "facilities": [
                        "Lake‑facing rooms and suites",
                        "Destination restaurants and bars",
                        "Pool, spa, and fitness",
                        "Ballrooms, lawns, and courtyards"
                    ],
                    "brief": "A contemporary palace on Pichola with grand interiors, refined dining, and elegant indoor‑outdoor venues for weddings and events.",
                    "highlights": [
                        "Sunset views across the lake",
                        "Boat arrival experience (property‑managed)",
                        "Curated culinary programs",
                        "Large wedding capacity"
                    ]
                },
                {
                    "name": "Raffles Udaipur",
                    "address": "Island 1, Near Udai Sagar Lake, Udaipur, Rajasthan 313001",
                    "website": "https://www.raffles.com/udaipur/",
                    "averageCost": { "stay": 35000, "dining": { "min": 2500, "max": 6500 } },
                    "facilities": [
                        "Island resort rooms and suites (select with pools)",
                        "Signature restaurants, Writers Bar, Long Bar",
                        "Spa, pool, and fitness studio",
                        "Event lawns and ballrooms"
                    ],
                    "brief": "A private‑island luxury resort on Udai Sagar blending classic Raffles touches with Rajasthan’s lake‑country romance.",
                    "highlights": [
                        "Boat transit to an exclusive island",
                        "Expansive spa and wellness",
                        "Iconic bars and high‑tea culture",
                        "Photo‑ready wedding backdrops"
                    ]
                },
                {
                    "name": "Trident, Udaipur",
                    "address": "Haridas Ji Ki Magri, Malla Talai, Udaipur, Rajasthan 313001",
                    "website": "https://www.tridenthotels.com/hotels-in-udaipur/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Garden‑facing rooms and suites",
                        "All‑day dining and bar",
                        "Pool and kids’ activities (select)",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A serene, family‑friendly premium hotel with lush gardens, consistent dining, and easy access to lake attractions.",
                    "highlights": [
                        "Calm resort vibe in city limits",
                        "Reliable service and breakfast",
                        "Great value for premium stays",
                        "Ideal for families and short breaks"
                    ]
                },
                {
                    "name": "Radisson Blu Udaipur Palace Resort & Spa",
                    "address": "Near Fateh Sagar Lake, Ambamata, Udaipur, Rajasthan 313001",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and lawns"
                    ],
                    "brief": "A popular resort‑style hotel near Fateh Sagar with sizable event spaces, family‑friendly leisure, and steady dining.",
                    "highlights": [
                        "Convenient lake‑belt location",
                        "Large banquet capacity",
                        "Good for weddings and socials",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "Taj Fateh Prakash Palace",
                    "address": "The City Palace Complex, Udaipur, Rajasthan 313001",
                    "website": "https://www.tajhotels.com/en-in/seleqtions/taj-fateh-prakash-palace-udaipur/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2200, "max": 6000 } },
                    "facilities": [
                        "Palace rooms and suites with lake views (select)",
                        "Signature dining and bar",
                        "Courtyards and heritage galleries",
                        "Event halls and terraces"
                    ],
                    "brief": "A heritage palace within the City Palace complex offering vintage charm, lake views, and evocative event settings.",
                    "highlights": [
                        "City Palace access and ambience",
                        "Sunset‑facing terraces (select)",
                        "Iconic photo spots",
                        "Immersive cultural feel"
                    ]
                },
                {
                    "name": "Fateh Garh by Fateh Collection",
                    "address": "Sisarma, Udaipur, Rajasthan 313001",
                    "website": "https://www.fatehcollection.com/fatehgarh/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Hilltop heritage‑style rooms",
                        "Restaurant, bar, and terraces",
                        "Pool and wellness services",
                        "Event decks and lawns"
                    ],
                    "brief": "A hill‑perched heritage‑modern retreat with sweeping city and lake views, relaxed dining, and scenic venues.",
                    "highlights": [
                        "Panoramic viewpoints",
                        "Romantic, quiet ambience",
                        "Great for intimate weddings",
                        "Photo‑friendly architecture"
                    ]
                }
            ]
        }
    },




    "goa": {
        "name": "Goa",
        "description": "Best hotels in Goa—luxury beach resorts and premium city stays across North (Candolim–Calangute–Vagator–Anjuna) and South (Cavelossim–Benaulim–Majorda–Arossim). Enjoy award‑winning dining, sea‑view rooms, pools, spas, and grand event venues.",
        "sectionOne": "Goa blends Arabian Sea beaches, Portuguese heritage, and a thriving dining and nightlife scene. Travellers split time between North Goa’s lively stretches (Fort Aguada, Candolim, Calangute, Baga, Vagator–Anjuna) and South Goa’s quieter sands (Majorda, Arossim, Benaulim, Varca, Cavelossim, Palolem). Resorts emphasize polished rooms, dependable Wi‑Fi, destination dining, beach clubs, and expansive banquets for weddings and offsites. From iconic beachfront palaces to chic hillside retreats and riverside escapes, Goa fits luxury vacations, family holidays, and celebration travel.",
        "sectionTwo": {
            "text": "Goa features marquee beachfront resorts in South, heritage and lifestyle stays in North, and river/lake‑side retreats near Panaji/Old Goa. Below are handpicked properties known for prime locations, standout amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The St. Regis Goa Resort (formerly The Leela Goa)",
                    "address": "Cavelossim, Salcete, South Goa 403731",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 42000, "dining": { "min": 3000, "max": 8000 } },
                    "facilities": [
                        "Lagoon‑side and sea‑facing rooms/villas (select with pools)",
                        "Multiple specialty restaurants, lounges, and beach club",
                        "Golf putting, spa, large pools, and activities",
                        "Expansive lawns and ballrooms"
                    ],
                    "brief": "A flagship luxury beach resort with sprawling lagoons, private‑feel beaches, and grand venues—ideal for honeymoons and destination weddings.",
                    "highlights": [
                        "Direct beach access with sunsets",
                        "Signature butler/service in select categories",
                        "Family‑friendly leisure and kids’ programs",
                        "High‑capacity indoor–outdoor events"
                    ]
                },
                {
                    "name": "Taj Exotica Resort & Spa, Goa",
                    "address": "Calwaddo, Benaulim Beach, South Goa 403716",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 30000, "dining": { "min": 2800, "max": 6500 } },
                    "facilities": [
                        "Mediterranean‑style rooms, suites, and villas",
                        "Destination restaurants and bars",
                        "Beachfront lawns, pools, and J Wellness Spa",
                        "Banquet halls and sprawling gardens"
                    ],
                    "brief": "A South Goa classic with tranquil lawns, extensive dining, and beach‑edge celebrations—great for families and milestone events.",
                    "highlights": [
                        "Sunset‑facing beachfront",
                        "Kid‑friendly and activity‑rich",
                        "Polished event operations",
                        "Relaxed resort ambience"
                    ]
                },
                {
                    "name": "ITC Grand Goa, a Luxury Collection Resort & Spa",
                    "address": "Arossim Beach, Cansaulim, South Goa 403712",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Indo‑Portuguese village‑style rooms/suites",
                        "Signature Indian and coastal dining",
                        "Large free‑form pool, spa, and fitness",
                        "Event lawns, beach access, and halls"
                    ],
                    "brief": "A beachside luxury village with lush lagoons, celebrated cuisine, and event‑scale infrastructure close to Dabolim airport.",
                    "highlights": [
                        "Resort scale with direct beach reach",
                        "Responsible Luxury ethos",
                        "Great for weekend luxury escapes",
                        "Versatile indoor–outdoor venues"
                    ]
                },
                {
                    "name": "Taj Fort Aguada Resort & Spa, Goa",
                    "address": "Sinquerim, Candolim, North Goa 403515",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Clifftop/sea‑view rooms and cottages",
                        "Multiple restaurants and bars",
                        "Pool, spa, and fitness",
                        "Banquets and cliffside lawns"
                    ],
                    "brief": "An iconic North Goa resort by the historic Fort Aguada, pairing sweeping views with classic hospitality.",
                    "highlights": [
                        "Clifftop panoramas of the Arabian Sea",
                        "Easy access to Candolim–Calangute circuit",
                        "Sister‑property synergies with Taj Holiday Village",
                        "Photogenic wedding settings"
                    ]
                },
                {
                    "name": "W Goa",
                    "address": "Vagator Beach, North Goa 403509",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Design‑forward rooms, suites, and villas",
                        "Lifestyle restaurants, Woobar, and poolside venues",
                        "Spa, gym, and beach access",
                        "Event lawns and party‑ready spaces"
                    ],
                    "brief": "A bold, lifestyle‑led beachfront resort with buzzy dining and nightlife near Vagator and Anjuna.",
                    "highlights": [
                        "Party‑friendly vibe and DJ‑led venues",
                        "Great for adult getaways",
                        "Clifftop/beach access aesthetics",
                        "Instagram‑ready design"
                    ]
                },
                {
                    "name": "Alila Diwa Goa (Hyatt)",
                    "address": "Majorda, South Goa 403713",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Balinese‑inspired rooms with paddy views",
                        "Multiple restaurants and bar",
                        "Infinity pool, spa, and fitness",
                        "Event lawns and halls"
                    ],
                    "brief": "A serene, design‑driven resort overlooking paddy fields, popular for honeymoons and quiet luxury stays.",
                    "highlights": [
                        "Tranquil paddy vistas",
                        "Club‑level perks (select room plans)",
                        "Refined, romantic ambience",
                        "Quick drive to Majorda beach"
                    ]
                },
                {
                    "name": "The LaLiT Golf & Spa Resort Goa",
                    "address": "Rajbaga Beach, Canacona, South Goa 403702",
                    "website": "https://www.thelalit.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Sprawling suites and villas",
                        "Multiple dining outlets and bar",
                        "18‑hole golf course, pool, and spa",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A vast, all‑in‑one South Goa resort near Palolem, with golf, direct beach access, and big‑format event capacity.",
                    "highlights": [
                        "Quiet, scenic southern coastline",
                        "Family and group‑friendly",
                        "Resort‑scale activities",
                        "Great for destination weddings"
                    ]
                },
                {
                    "name": "Grand Hyatt Goa",
                    "address": "Bambolim Bay, Near Panaji, North Goa 403206",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2000, "max": 5000 } },
                    "facilities": [
                        "Bay‑facing rooms and suites",
                        "Multiple restaurants and bars",
                        "Large pool, spa, and fitness",
                        "Convention‑scale halls and lawns"
                    ],
                    "brief": "A bayfront luxury resort near Panaji with convention‑ready spaces and family‑friendly leisure.",
                    "highlights": [
                        "Calm bay setting vs surf beaches",
                        "Efficient access to Panaji/Old Goa",
                        "Strong MICE footprint",
                        "Versatile for business and leisure"
                    ]
                },
                {
                    "name": "Novotel Goa Resort & Spa / Novotel Goa Candolim",
                    "address": "Candolim–Calangute belt, North Goa 403515",
                    "website": "https://all.accor.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Modern rooms and family‑friendly layouts",
                        "All‑day dining and bars",
                        "Resort pools and spa",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "Popular North Goa resorts combining proximity to beaches with reliable dining and amenities for families and groups.",
                    "highlights": [
                        "Shuttle/walkable access to beaches (area dependent)",
                        "Consistent breakfast and service",
                        "Good value in the action belt",
                        "Suited to short and extended stays"
                    ]
                },
                {
                    "name": "Planet Hollywood Beach Resort Goa",
                    "address": "Utorda Beach, South Goa 403713",
                    "website": "https://www.planethollywoodgoa.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Contemporary rooms and villas",
                        "Restaurants, lounge, and beach shack access",
                        "Pool, spa, and fitness",
                        "Event lawns and halls"
                    ],
                    "brief": "A stylish beachfront resort on a quieter South Goa strand, balancing glitzy style with family‑friendly facilities.",
                    "highlights": [
                        "Easy beach access and sunsets",
                        "Near popular shacks and cafés",
                        "Event‑ready grounds",
                        "Solid value for South Goa"
                    ]
                }
            ]
        }
    },



    "amritsar": {
        "name": "Amritsar",
        "description": "Best hotels in Amritsar—premium and midscale stays near the Golden Temple, Ranjit Avenue, and the airport corridor. Enjoy award‑winning dining, clean rooms, pools/spas (select), and versatile event spaces.",
        "sectionOne": "Amritsar, home to the Harmandir Sahib (Golden Temple), blends deep spiritual heritage with vibrant bazaars and culinary trails. Travellers explore the Golden Temple, Jallianwala Bagh, Partition Museum, Gobindgarh Fort, and the Wagah–Attari border ceremony, supported by strong air, rail, and road links. City hotels focus on polished rooms, reliable Wi‑Fi, destination dining, and banquet venues for weddings and conferences. From temple‑area boutique stays to Ranjit Avenue premium hotels and airport‑side conveniences, Amritsar suits pilgrimages, family trips, and events.",
        "sectionTwo": {
            "text": "Amritsar features luxury and premium city hotels alongside value business stays around the Golden Temple, Ranjit Avenue, and airport corridors. Below are handpicked properties known for prime locations, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Swarna, Amritsar",
                    "address": "Plot No. C-3, Opp. Basant Avenue, Ranjit Avenue, Amritsar, Punjab 143001",
                    "website": "https://www.tajhotels.com/en-in/taj/taj-swarna-amritsar/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness centre",
                        "Grand ballroom and meeting rooms"
                    ],
                    "brief": "A polished luxury hotel in Ranjit Avenue with refined rooms, strong dining, and event‑ready venues.",
                    "highlights": [
                        "Easy access to markets and cafés",
                        "Reliable breakfast and room service",
                        "Strong MICE capabilities",
                        "Good for family and corporate stays"
                    ]
                },
                {
                    "name": "Hyatt Regency Amritsar",
                    "address": "MBM Farms, GT Road, Amritsar, Punjab 143001",
                    "website": "https://www.hyatt.com/en-US/hotel/india/hyatt-regency-amritsar/ixrar",
                    "averageCost": { "stay": 15000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Modern rooms and suites",
                        "All‑day dining, specialty restaurant, and lounge",
                        "Outdoor pool, spa, and fitness",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A premium city hotel with robust dining, leisure, and versatile events—well placed for shopping and temple visits.",
                    "highlights": [
                        "Shuttle/drive access to Golden Temple",
                        "Family‑friendly leisure facilities",
                        "Event‑friendly floors with AV",
                        "Consistent brand standards"
                    ]
                },
                {
                    "name": "Welcomhotel by ITC Hotels, Raja Sansi",
                    "address": "C-Block, Ranjit Avenue (Airport Side), Amritsar, Punjab 143001",
                    "website": "https://www.itchotels.com/in/en/welcomhotelamritsar",
                    "averageCost": { "stay": 14000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Heritage‑inspired rooms in a haveli setting",
                        "Signature Indian and global dining",
                        "Pool, spa services, and fitness",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A characterful premium hotel with a heritage vibe, strong dining, and indoor‑outdoor event spaces near the airport approach.",
                    "highlights": [
                        "Quick airport connectivity",
                        "LEED‑focused design credentials",
                        "Great for weddings and socials",
                        "Calm ambience with city access"
                    ]
                },
                {
                    "name": "Ramada by Wyndham Amritsar",
                    "address": "Hall Bazaar, Near Golden Temple, Amritsar, Punjab 143006",
                    "website": "https://www.wyndhamhotels.com/ramada",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Comfortable rooms near heritage core",
                        "Restaurant, café, and in‑room dining",
                        "Rooftop/indoor pool (property‑specific) and gym",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A centrally located hotel close to the temple area with steady dining and practical event spaces.",
                    "highlights": [
                        "Walk/short drive to Golden Temple",
                        "Popular breakfast options",
                        "Practical for families and seniors",
                        "Good value in the old‑city belt"
                    ]
                },
                {
                    "name": "Fairfield by Marriott Amritsar",
                    "address": "Albert Road, Amritsar, Punjab 143001",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Smart rooms with essential comforts",
                        "All‑day dining and lobby lounge",
                        "Fitness room",
                        "Meeting room"
                    ],
                    "brief": "A value‑forward, business‑friendly stay with clean rooms and dependable service near railway/market access.",
                    "highlights": [
                        "Transit‑friendly connectivity",
                        "Efficient check‑in/out",
                        "Consistent breakfast and Wi‑Fi",
                        "Good for short weekday trips"
                    ]
                },
                {
                    "name": "Radisson Blu Hotel Amritsar",
                    "address": "Ajnala Road, Amritsar, Punjab 143001",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Spacious rooms near the airport road",
                        "All‑day dining and lounge bar",
                        "Outdoor pool and fitness centre",
                        "Banquet halls and lawns"
                    ],
                    "brief": "An airport‑corridor hotel balancing leisure and events—convenient for business trips and family stays.",
                    "highlights": [
                        "Quick drive to terminals",
                        "Event‑ready grounds",
                        "Reliable breakfast and service",
                        "Value‑friendly for longer stays"
                    ]
                },
                {
                    "name": "Golden Sarovar Portico, Amritsar",
                    "address": "Maqbool Road, Near Ranjit Avenue, Amritsar, Punjab 143001",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 8000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Neat rooms with business comforts",
                        "Restaurant and café",
                        "Fitness corner (property‑specific)",
                        "Banquet/meeting space"
                    ],
                    "brief": "A practical, mid‑premium city hotel with steady dining and compact event facilities near Ranjit Avenue.",
                    "highlights": [
                        "Convenient shopping/market access",
                        "Good housekeeping consistency",
                        "Efficient for short stays",
                        "Balanced price‑to‑amenities"
                    ]
                }
            ]
        }
    },





    "manali": {
        "name": "Manali",
        "description": "Best hotels in Manali—mountain‑view resorts and boutique stays near Old Manali, Prini–Naggar Road, and the Mall Road approach. Enjoy cozy rooms, scenic dining, heated pools/spas (select), and event spaces for weddings and offsites.",
        "sectionOne": "Manali, a Himalayan favorite, blends deodar forests, riverside trails, and snow‑view peaks with a lively café scene. Travellers explore Hadimba Temple, Old Manali cafés, Vashisht hot springs, Solang Valley, Atal Tunnel/Rohtang side trips, and Naggar Castle. Hotels focus on warm hospitality, clean rooms with balconies/views, dependable Wi‑Fi, all‑day dining, and indoor leisure for cool weather—ideal for honeymoons, family holidays, and corporate retreats.",
        "sectionTwo": {
            "text": "Manali features premium hillside resorts, river‑facing retreats, and boutique hotels across Prini–Naggar Road, Old Manali, and the Mall Road approach. Below are handpicked stays known for views, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Baragarh Resort & Spa, Manali – IHCL SeleQtions",
                    "address": "Village Ghordour, PO Larankelo, Manali, Himachal Pradesh 175104",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Mountain‑view rooms and suites",
                        "Signature restaurant and bar",
                        "Spa, pool (seasonal/select), and fitness",
                        "Banquet lawn and meeting room"
                    ],
                    "brief": "A refined hillside resort with panoramic views, wellness focus, and elegant dining—great for romantic and family stays.",
                    "highlights": [
                        "Expansive valley vistas",
                        "Curated Himachali cuisine",
                        "Calm, resort‑style ambience",
                        "Event‑friendly lawns"
                    ]
                },
                {
                    "name": "ManuAllaya – The Resort Spa in the Himalayas",
                    "address": "Sunny Side, Chadiyari, Manali, Himachal Pradesh 175131",
                    "website": "https://www.manuallaya.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 4200 } },
                    "facilities": [
                        "Rooms and cottages with mountain views",
                        "Multiple dining outlets and bar",
                        "Spa, heated pool (select), and gym",
                        "Banquet hall and meeting rooms"
                    ],
                    "brief": "A full‑service resort with wellness, indoor leisure, and scenic rooms—ideal for families and longer vacations.",
                    "highlights": [
                        "Indoor leisure for cold months",
                        "Popular buffets and bakery",
                        "Close to town yet tranquil",
                        "Good for social events"
                    ]
                },
                {
                    "name": "The Himalayan, Manali",
                    "address": "Hadimba Temple Road, Manali, Himachal Pradesh 175131",
                    "website": "https://www.thehimalayan.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Castle‑style rooms and cottages",
                        "Restaurant and lounge",
                        "Heated pool (seasonal/select) and fitness",
                        "Boutique event spaces"
                    ],
                    "brief": "A striking, castle‑inspired boutique resort with mountain vistas, stylish rooms, and photogenic common spaces.",
                    "highlights": [
                        "Unique architecture and ambience",
                        "Great for couples and photoshoots",
                        "Close to Hadimba Temple",
                        "Intimate events and gatherings"
                    ]
                },
                {
                    "name": "The Orchid Hotel Manali",
                    "address": "Shuru, Kullu–Naggar–Manali Road, Manali, Himachal Pradesh 175143",
                    "website": "https://www.orchidhotel.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Modern rooms with balconies (select)",
                        "Restaurant and rooftop (property‑specific)",
                        "Spa services and fitness room",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A contemporary, value‑forward hotel with scenic rooms, practical dining, and compact event facilities near Prini–Shuru.",
                    "highlights": [
                        "Quick access to Naggar Road",
                        "Family‑friendly layouts",
                        "Consistent breakfast service",
                        "Good price‑to‑amenities"
                    ]
                },
                {
                    "name": "Tiaraa Hotels & Resorts, Manali",
                    "address": "Left Bank, Naggar Road, Prini, Manali, Himachal Pradesh 175143",
                    "website": "https://www.tiaaraa.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Spacious rooms with mountain views",
                        "All‑day dining and lounge",
                        "Spa services (property‑specific)",
                        "Banquet and meeting room"
                    ],
                    "brief": "A premium‑leaning resort in the Prini belt offering roomy accommodation, steady dining, and simple event options.",
                    "highlights": [
                        "Left Bank scenery and access",
                        "Comfortable for longer stays",
                        "Balanced leisure and work setup",
                        "Value‑friendly premium pick"
                    ]
                },
                {
                    "name": "Club Mahindra White Meadows, Manali",
                    "address": "Prini, Naggar Road, Manali, Himachal Pradesh 175131",
                    "website": "https://www.clubmahindra.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Resort‑style rooms and family suites",
                        "Restaurant and café",
                        "Activity zone and spa (select)",
                        "Event hall (property‑specific)"
                    ],
                    "brief": "A family‑friendly resort with activities, scenic rooms, and reliable dining—a good base for sightseeing and downtime.",
                    "highlights": [
                        "Kid‑friendly amenities",
                        "Tour assistance for Solang/Atal Tunnel",
                        "Consistent housekeeping",
                        "Good for multi‑night holidays"
                    ]
                },
                {
                    "name": "Span Resort & Spa",
                    "address": "Kullu–Manali Highway, Katrain, Himachal Pradesh 175129",
                    "website": "https://www.spanresorts.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Riverside cottages and rooms",
                        "Restaurants and bar",
                        "Spa, pool (seasonal), and activities",
                        "Banquet lawn and event room"
                    ],
                    "brief": "A riverside retreat set in nature with relaxing rooms, outdoor spaces, and family‑friendly leisure.",
                    "highlights": [
                        "Beas river proximity",
                        "Green lawns and pathways",
                        "Quiet, restorative vibe",
                        "Good for small celebrations"
                    ]
                },
                {
                    "name": "The Anantmaya Resort",
                    "address": "Naggar Road, Shuru, Manali, Himachal Pradesh 175143",
                    "website": "https://www.theanantmaya.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Mountain‑facing rooms and cottages",
                        "Restaurant and lounge",
                        "Spa services (property‑specific)",
                        "Event room"
                    ],
                    "brief": "A well‑kept hillside resort with scenic rooms, warm service, and reliable dining near the Naggar approach.",
                    "highlights": [
                        "Good access to attractions",
                        "Popular breakfast options",
                        "Value for families and groups",
                        "Pleasant landscaped grounds"
                    ]
                }
            ]
        }
    },




    "leh-ladakh": {
        "name": "Leh–Ladakh",
        "description": "Best stays in Leh–Ladakh—premium city hotels in Leh, boutique heritage retreats, and scenic resorts along the Indus and Nubra approaches. Expect heated rooms, oxygen support (select), hearty dining, and cozy lounges.",
        "sectionOne": "Leh–Ladakh pairs high‑altitude desert vistas, monasteries, and starry skies with a compact hospitality scene centered in Leh town. Travellers explore Shanti Stupa, Leh Palace, Thiksey/Hemis monasteries, Sangam (Indus–Zanskar), Khardung La to Nubra, and Pangong/ Tso Moriri (permits, weather permitting). Hotels prioritize acclimatization comfort—heated rooms, electric blankets, oxygen support (select), all‑day dining with local and global options, and reliable transport assistance—ideal for couples, families, bikers, and small tour groups.",
        "sectionTwo": {
            "text": "Leh offers polished city hotels and design‑forward boutiques; broader Ladakh features heritage palaces and nature‑led retreats. Below are handpicked options known for altitude‑friendly comfort, service, and location.",
            "hotels": [
                {
                    "name": "The Grand Dragon Ladakh",
                    "address": "Old Road Sheynam, Leh, Ladakh 194101",
                    "website": "https://www.thegranddragonladakh.com",
                    "averageCost": { "stay": 22000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Heated, altitude‑ready rooms and suites",
                        "All‑day dining, bakery, and tea lounge",
                        "Oxygen support (on request) and clinic tie‑ups",
                        "Banquet/meeting halls and travel desk"
                    ],
                    "brief": "Leh’s flagship luxury hotel offering heated rooms, robust dining, and altitude‑aware service in a central yet quiet precinct.",
                    "highlights": [
                        "Reliable winter operations",
                        "Mountain‑view categories (select)",
                        "Consistent buffet breakfast",
                        "Good base for day‑trip circuits"
                    ]
                },
                {
                    "name": "The Abduz",
                    "address": "Fort Road, Leh, Ladakh 194101",
                    "website": "https://www.theadbuz.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Modern, centrally heated rooms",
                        "Restaurant and café lounge",
                        "Airport/permit assistance (on request)",
                        "Conference/banquet space"
                    ],
                    "brief": "A contemporary, city‑center hotel combining cozy heated rooms with dependable dining and practical trip support.",
                    "highlights": [
                        "Walk/short drive to market streets",
                        "Steady hot‑water and heating",
                        "Popular breakfast spreads",
                        "Good for families and groups"
                    ]
                },
                {
                    "name": "The Indus Valley",
                    "address": "Lower Tukcha Road, Leh, Ladakh 194101",
                    "website": "https://www.theindusvalley.in/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Centrally heated rooms with views (select)",
                        "All‑day dining and rooftop (seasonal)",
                        "Oxygen and doctor on call (on request)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A polished Leh hotel with heated rooms, scenic decks, and attentive service—suited to couples and small groups.",
                    "highlights": [
                        "Near market yet relatively quiet",
                        "Altitude‑aware hospitality",
                        "Rooftop stargazing vibes (clear nights)",
                        "Smooth check‑in and services"
                    ]
                },
                {
                    "name": "Chospa Hotel",
                    "address": "Fort Road, Leh, Ladakh 194101",
                    "website": "https://www.chospahotel.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1500, "max": 3500 } },
                    "facilities": [
                        "Design‑forward, centrally heated rooms",
                        "Restaurant and café",
                        "Travel/permit desk (on request)",
                        "Compact event space"
                    ],
                    "brief": "A stylish, boutique‑leaning hotel that blends Ladakhi aesthetics with modern comforts close to the main bazaar.",
                    "highlights": [
                        "Warm interiors and amenities",
                        "Good market access",
                        "Comfortable for acclimatization",
                        "Value‑friendly premium choice"
                    ]
                },
                {
                    "name": "Ladakh Residency",
                    "address": "Changspa, Leh, Ladakh 194101",
                    "website": "https://ladakhresidency.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Cozy, heated rooms (seasonal), balconies (select)",
                        "Multi‑cuisine restaurant",
                        "Tour assistance",
                        "Small banquet/meeting room"
                    ],
                    "brief": "A long‑time favorite in Changspa with comfortable rooms, friendly service, and easy sightseeing access.",
                    "highlights": [
                        "Walkable to cafés and shops",
                        "Mountain/city glimpses (select)",
                        "Reliable housekeeping",
                        "Good for repeat visitors"
                    ]
                },
                {
                    "name": "Dolkhar",
                    "address": "Skara, Leh, Ladakh 194101",
                    "website": "https://www.dolkhar.in/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Earthy, design‑led villas/rooms",
                        "Slow‑food, local‑produce restaurant",
                        "Experiences and wellness (property‑specific)",
                        "Concierge/travel help"
                    ],
                    "brief": "A conscious, boutique retreat celebrating Ladakhi craft and cuisine—ideal for slow, immersive stays.",
                    "highlights": [
                        "Sustainable design ethos",
                        "Local culinary experiences",
                        "Calm, intimate ambience",
                        "Great for couples"
                    ]
                },
                {
                    "name": "Stok Palace Heritage Hotel",
                    "address": "Stok Village, Leh, Ladakh 194101",
                    "website": "https://www.stokpalaceheritage.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Heritage palace rooms and suites",
                        "Courtyard dining and cultural evenings",
                        "Guided experiences (property‑specific)",
                        "Event terraces (intimate)"
                    ],
                    "brief": "A regal, heritage stay in the royal palace complex—memorable rooms, stories, and valley panoramas.",
                    "highlights": [
                        "Authentic palace ambience",
                        "Sunset terraces and views",
                        "Culture‑rich experiences",
                        "Destination‑style dining"
                    ]
                },
                {
                    "name": "Nimmu House (Glamping + Heritage)",
                    "address": "Nimmu Village, Indus Valley, Leh, Ladakh 194101",
                    "website": "https://www.nimmuhouse.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1500, "max": 3500 } },
                    "facilities": [
                        "Heritage rooms and luxury tents (seasonal)",
                        "Farm‑to‑table dining",
                        "Day trips and soft adventures",
                        "Courtyards and lounges"
                    ],
                    "brief": "A charming Indus‑valley homestead offering heritage rooms and seasonal glamping with farm‑fresh cuisine.",
                    "highlights": [
                        "Peaceful village setting",
                        "Great for families and friends",
                        "Authentic Ladakhi vibe",
                        "Ideal for slow travel"
                    ]
                }
            ]
        }
    },




    "rishikesh": {
        "name": "Rishikesh",
        "description": "Best stays in Rishikesh—riverside resorts and boutique retreats near Tapovan, Ram/Lakshman Jhula, and Shivpuri. Expect Ganga‑view rooms (select), yoga/ayurveda, scenic dining, and event spaces for retreats and weddings.",
        "sectionOne": "Rishikesh, the yoga capital on the Ganges, blends Himalayan foothill views with ashrams, temples, and adventure sports. Travellers explore Triveni Ghat, Ram/Lakshman Jhula, Beatles Ashram, and rafting in Shivpuri, supported by road/rail links and Dehradun’s airport. Hotels focus on serene rooms, dependable Wi‑Fi, wholesome dining, yoga/ayurveda programs, and compact to mid‑size banquets—ideal for wellness breaks, family trips, and corporate offsites.",
        "sectionTwo": {
            "text": "Rishikesh features luxury riverfront retreats, premium hillside resorts, and practical city hotels across Tapovan, Muni‑ki‑Reti, and Shivpuri. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Rishikesh Resort & Spa, Uttarakhand",
                    "address": "Byasi–Singthali, Rishikesh–Badrinath Road, Uttarakhand 249192",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 38000, "dining": { "min": 2800, "max": 7000 } },
                    "facilities": [
                        "River‑ and mountain‑view villas/rooms",
                        "Destination restaurants and bar",
                        "J Wellness Spa, yoga pavilion, and pool",
                        "Lawns and intimate event spaces"
                    ],
                    "brief": "A luxury, nature‑led retreat along the Ganges offering serene villas, curated dining, and signature wellness.",
                    "highlights": [
                        "Private river access (property‑managed zones)",
                        "Immersive yoga and spa programs",
                        "Romantic and family‑friendly layouts",
                        "Great for boutique weddings/retreats"
                    ]
                },
                {
                    "name": "Anand Kashi by the Ganges – IHCL SeleQtions",
                    "address": "Gular Dogi, Shivpuri, Rishikesh, Uttarakhand 249192",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Ganga‑facing rooms with balconies (select)",
                        "Restaurant, café, and bar",
                        "Spa, yoga/meditation spaces",
                        "Courtyards and small event decks"
                    ],
                    "brief": "A riverside boutique retreat with tranquil views, thoughtful dining, and restorative wellness.",
                    "highlights": [
                        "Direct river proximity",
                        "Slow‑travel ambience",
                        "Curated local experiences",
                        "Good for couples and families"
                    ]
                },
                {
                    "name": "The Westin Resort & Spa, Himalayas",
                    "address": "Khetu Wali Koti, Rishikesh, Uttarakhand 249201",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Hillside rooms and suites",
                        "Multiple restaurants and lounge",
                        "Heavenly Spa, pool, and fitness studio",
                        "Ballrooms, lawns, and meeting rooms"
                    ],
                    "brief": "A wellness‑forward premium resort pairing scenic rooms with spa‑led downtime and versatile event spaces.",
                    "highlights": [
                        "Retreat‑style setting",
                        "Sleep and fitness‑centric amenities",
                        "Event‑ready infrastructure",
                        "Good for offsites and families"
                    ]
                },
                {
                    "name": "Aloha On The Ganges by Leisure Hotels",
                    "address": "Tapovan, Near Lakshman Jhula, Rishikesh, Uttarakhand 249192",
                    "website": "https://www.leisurehotels.co.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Rooms and apartments (select Ganga view)",
                        "Restaurant, café, and room service",
                        "Pool (property‑specific), spa corner",
                        "Banquet/meeting room"
                    ],
                    "brief": "A popular river‑adjacent resort with family‑friendly units, scenic dining, and compact event options in Tapovan.",
                    "highlights": [
                        "Walkable to Jhulas/cafés",
                        "Good value for families",
                        "Reliable breakfast and housekeeping",
                        "Easy base for rafting/yoga"
                    ]
                },
                {
                    "name": "GANGA KINARE – A Riverside Boutique Resort",
                    "address": "Shivananda Nagar, Rishikesh, Uttarakhand 249192",
                    "website": "https://www.gangakinare.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Riverside rooms (select with balconies)",
                        "Vegetarian restaurant and café",
                        "Yoga/meditation hall",
                        "Small banquet/meeting space"
                    ],
                    "brief": "A beloved boutique resort along the Ganges with vegetarian dining, calm rooms, and a devotional ambience.",
                    "highlights": [
                        "Riverfront promenade setting",
                        "Wellness/yoga focus",
                        "Family‑friendly hospitality",
                        "Consistent service standards"
                    ]
                },
                {
                    "name": "Yog Niketan by Sanskriti",
                    "address": "Muni‑ki‑Reti, Rishikesh, Uttarakhand 249201",
                    "website": "https://www.sanskritiwellness.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Simple, clean rooms (select Ganga view)",
                        "Vegetarian satvik dining",
                        "Daily yoga/meditation sessions",
                        "Prayer/ceremony access (property‑led)"
                    ],
                    "brief": "An ashram‑adjacent, wellness‑centric stay offering satvik meals, yoga, and tranquil river views.",
                    "highlights": [
                        "Spiritual ambience and rituals",
                        "Great for wellness seekers",
                        "Walkable to ghats/ashrams",
                        "Value‑forward riverfront option"
                    ]
                },
                {
                    "name": "Holywater Hotel by Ganga Kinare",
                    "address": "Muni‑ki‑Reti belt, Rishikesh, Uttarakhand 249201",
                    "website": "https://www.gangakinare.com/holywater/",
                    "averageCost": { "stay": 9000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Modern rooms near the river",
                        "Restaurant and café",
                        "Yoga corner (property‑specific)",
                        "Meeting room"
                    ],
                    "brief": "A contemporary, value‑leaning partner hotel near the river promenade with clean rooms and easy access.",
                    "highlights": [
                        "Transit‑friendly location",
                        "Consistent breakfast",
                        "Good for short family trips",
                        "Reliable essentials and Wi‑Fi"
                    ]
                },
                {
                    "name": "Lamrin Boutique Cottages, Rishikesh",
                    "address": "Near Tapovan/Marine Drive belt, Rishikesh, Uttarakhand 249192",
                    "website": "https://lamrinhotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Cottage‑style rooms with balconies (select)",
                        "Café and in‑room dining",
                        "Yoga/meditation deck (seasonal)",
                        "Small event space"
                    ],
                    "brief": "A cosy boutique stay with cottage layouts, friendly service, and quick access to Tapovan cafés and activities.",
                    "highlights": [
                        "Quiet lanes yet central access",
                        "Great for couples and families",
                        "Good price‑to‑amenities",
                        "Helpful tour/rafting assistance"
                    ]
                }
            ]
        }
    },



    "haridwar": {
        "name": "Haridwar",
        "description": "Best stays in Haridwar—riverfront heritage retreats and practical city hotels near Har Ki Pauri, Ranipur/Bypass Road, and the highway–airport corridor. Expect Ganga‑view rooms (select), satvik dining, yoga spaces, and compact to mid‑size banquets.",
        "sectionOne": "Haridwar, a major pilgrimage city on the Ganges, blends sacred ghats and evening aarti with bustling bazaars and calm river stretches. Travellers center stays around Har Ki Pauri, Moti Bazar, and Shivalik Nagar/Ranipur Road for easy access to ghats and transit. Hotels emphasize serene rooms, dependable Wi‑Fi, vegetarian dining, and event spaces for satsangs and family functions—ideal for pilgrimages, wellness breaks, and quick city stopovers.",
        "sectionTwo": {
            "text": "Haridwar features heritage riverfront havelis, premium retreats on the Ganga belt, and value business hotels around Ranipur/Bypass. Below are handpicked options known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Pilibhit House, Haridwar – IHCL SeleQtions",
                    "address": "Near Har Ki Pauri (Muni‑ki‑Reti axis), Haridwar, Uttarakhand 249401",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Restored riverside haveli rooms (select Ganga view)",
                        "Satvik/vegetarian dining and café",
                        "Ghat access for aarti (property‑managed)",
                        "Courtyards and intimate event spaces"
                    ],
                    "brief": "A refined riverside haveli with curated dining, calm courtyards, and close connect to the evening aarti.",
                    "highlights": [
                        "Ganga‑facing categories (select)",
                        "Private ghat/aarti facilitation (property‑managed)",
                        "Boutique wedding/retreat suitability",
                        "High‑touch heritage hospitality"
                    ]
                },
                {
                    "name": "Ganga Lahari by Leisure Hotels",
                    "address": "Har Ki Pauri/Ram Ghat belt, Haridwar, Uttarakhand 249401",
                    "website": "https://www.leisurehotels.co.in/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Riverside heritage rooms (select balconies)",
                        "Vegetarian restaurant",
                        "Aarti seating coordination (property‑assisted)",
                        "Small meeting room"
                    ],
                    "brief": "A beloved riverfront stay with devotional ambience, vegetarian dining, and seamless aarti access.",
                    "highlights": [
                        "Steps to Har Ki Pauri ghats",
                        "Peaceful, heritage interiors",
                        "Great for family pilgrimages",
                        "Consistent service standards"
                    ]
                },
                {
                    "name": "Haveli Hari Ganga (Leisure Hotels)",
                    "address": "Kusha Ghat, Haridwar, Uttarakhand 249401",
                    "website": "https://www.leisurehotels.co.in/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Heritage haveli rooms (select Ganga view)",
                        "Vegetarian restaurant and chai terrace",
                        "Private ghat and spa services (property‑specific)",
                        "Prayer/meditation hall"
                    ],
                    "brief": "A storied haveli with private ghat access, satvik dining, and heritage‑rich spaces for contemplative stays.",
                    "highlights": [
                        "Direct Ganga steps (property‑managed)",
                        "Temple/aarti convenience",
                        "Wellness/meditation focus",
                        "Ideal for seniors and families"
                    ]
                },
                {
                    "name": "Hyatt Place Haridwar",
                    "address": "Ranipur/Bypass Road corridor, Haridwar, Uttarakhand 249407",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "All‑day dining and bakery",
                        "Fitness center",
                        "Meeting room"
                    ],
                    "brief": "A contemporary, transit‑friendly hotel offering clean rooms, steady dining, and quick highway access.",
                    "highlights": [
                        "Convenient for road travelers",
                        "Reliable breakfast and Wi‑Fi",
                        "Efficient check‑in/out",
                        "Good for short business/family stays"
                    ]
                },
                {
                    "name": "Amatra by the Ganges (near Haridwar belt)",
                    "address": "Shyampur Noamabad, Haridwar–Rishikesh corridor, Uttarakhand 249408",
                    "website": "https://www.amatrahotels.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Riverside rooms and villas (select)",
                        "Restaurant and lawns",
                        "Pool and spa (property‑specific)",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A river‑hugging resort with expansive lawns, family‑friendly leisure, and event‑ready infrastructure.",
                    "highlights": [
                        "Scenic Ganga‑side setting",
                        "Great for weddings and socials",
                        "Spacious grounds for kids",
                        "Balanced leisure and value"
                    ]
                },
                {
                    "name": "Lemon Tree Hotel, Haridwar",
                    "address": "SIDCUL/Ranipur Road approach, Haridwar, Uttarakhand 249403",
                    "website": "https://www.lemontreehotels.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Smart rooms with essentials",
                        "Café and room service",
                        "Fitness corner",
                        "Meeting room"
                    ],
                    "brief": "A value‑forward business hotel with tidy rooms and practical amenities near the industrial/transit belt.",
                    "highlights": [
                        "Good for quick work trips",
                        "Consistent housekeeping",
                        "Budget‑friendly categories",
                        "Easy highway connectivity"
                    ]
                },
                {
                    "name": "Devnadi – The Heritage Hotel",
                    "address": "Riverside ghat belt, Haridwar, Uttarakhand 249401",
                    "website": "https://www.devnadi.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Heritage rooms (select river view)",
                        "Vegetarian dining",
                        "Private ghat access (property‑managed)",
                        "Prayer/meeting room"
                    ],
                    "brief": "A heritage riverside retreat with devotional character, satvik meals, and intimate ghat access.",
                    "highlights": [
                        "Close to aarti zones",
                        "Calm, old‑world ambience",
                        "Family‑friendly service",
                        "Great for spiritual stays"
                    ]
                }
            ]
        }
    },



    "mysore": {
        "name": "Mysore",
        "description": "Best hotels in Mysore—heritage palaces and premium city stays near Mysore Palace, Chamundi foothills, and the ring road. Enjoy polished rooms, dependable dining, pools/spas (select), and versatile event spaces.",
        "sectionOne": "Mysore, the City of Palaces, blends royal architecture, leafy boulevards, and vibrant markets with calm, family‑friendly hospitality. Travellers explore Mysore Palace, Brindavan Gardens, Chamundi Hill, Devaraja Market, and the zoo, supported by strong rail and highway links from Bengaluru. City hotels focus on clean rooms, reliable Wi‑Fi, multi‑cuisine dining, and banquets for weddings and conferences. From heritage icons to contemporary five‑stars and value‑forward business hotels, Mysore suits family holidays, cultural getaways, and corporate meets.",
        "sectionTwo": {
            "text": "Mysore features heritage addresses, premium resorts, and centrally located business hotels across the Palace–Chamundi belt, KRS/Brindavan approach, and ring‑road corridors. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Radisson Blu Plaza Hotel Mysore",
                    "address": "MG Road, Near Mall of Mysore, Mysuru, Karnataka 570010",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Modern rooms and suites (select with palace/hill glimpses)",
                        "All‑day dining, specialty restaurant, and bar",
                        "Outdoor pool, spa services, and gym",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A polished city hotel by the Mall of Mysore with strong dining, leisure, and event‑ready spaces close to key sights.",
                    "highlights": [
                        "Quick access to Mysore Palace and zoo",
                        "Popular breakfast and Sunday brunch",
                        "High‑capacity banquets",
                        "Reliable brand standards"
                    ]
                },
                {
                    "name": "Grand Mercure Mysore – An Accor Brand",
                    "address": "Sayyaji Rao Road, Yadavagiri, Mysuru, Karnataka 570021",
                    "website": "https://all.accor.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Contemporary rooms in city centre",
                        "All‑day dining, rooftop/alfresco (property‑specific), and bar",
                        "Rooftop pool (select) and fitness",
                        "Banquet and meeting spaces"
                    ],
                    "brief": "A central, event‑friendly hotel with vibrant dining and comfortable rooms—good for business and family trips.",
                    "highlights": [
                        "Convenient for shopping and cafés",
                        "Efficient check‑in and services",
                        "Consistent housekeeping",
                        "Good value in the premium bracket"
                    ]
                },
                {
                    "name": "Fortune JP Palace, Mysore",
                    "address": "Abba Road, Near Puneeth Rajkumar Road, Mysuru, Karnataka 570007",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Spacious rooms with city views (select)",
                        "Multi‑cuisine restaurants and bar",
                        "Pool and fitness centre",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A dependable city hotel with multiple dining outlets, leisure facilities, and versatile banquets near central attractions.",
                    "highlights": [
                        "Close to Palace/CBD belt",
                        "Event‑friendly layouts",
                        "Good for longer stays",
                        "Value‑forward amenities"
                    ]
                },
                {
                    "name": "Lalitha Mahal Palace Hotel",
                    "address": "Lalitha Mahal Palace Road, Mysuru, Karnataka 570028",
                    "website": "https://www.karnatakahotels.co.in/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Heritage palace rooms and suites",
                        "Grand dining hall, bar, and tea lounges",
                        "Lawns and terraces (property‑specific)",
                        "Banquet and event spaces"
                    ],
                    "brief": "A heritage palace with vintage grandeur, scenic balconies, and royal‑style dining—ideal for cultural stays and photo‑friendly events.",
                    "highlights": [
                        "Historic architecture and ambience",
                        "Expansive lawns for socials",
                        "Unique heritage experience",
                        "Calm, green surroundings"
                    ]
                },
                {
                    "name": "Silent Shores Resort & Spa",
                    "address": "Hootagalli, Mysuru, Karnataka 570018",
                    "website": "https://www.silentshoresresort.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Lake‑side rooms and cottages",
                        "Restaurants and café",
                        "Large pool, spa, and activities",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A serene resort with water‑view rooms, a big pool, and family‑friendly leisure—popular for staycations and weddings.",
                    "highlights": [
                        "Resort ambience within city reach",
                        "Kid‑friendly amenities",
                        "Spacious grounds for events",
                        "Balanced leisure and value"
                    ]
                },
                {
                    "name": "Sandesh The Prince",
                    "address": "Nazarbad Main Road, Mysuru, Karnataka 570010",
                    "website": "https://www.sandeshtheprince.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Comfortable rooms near Palace belt",
                        "Multi‑cuisine restaurant and bar",
                        "Pool and fitness room",
                        "Banquet hall and meeting rooms"
                    ],
                    "brief": "A centrally located hotel with steady dining, leisure, and event facilities—good for families and quick business trips.",
                    "highlights": [
                        "Walk/short drive to key sights",
                        "Popular breakfast options",
                        "Efficient services",
                        "Good value downtown"
                    ]
                },
                {
                    "name": "Royal Orchid Metropole, Mysore",
                    "address": "J.L.B Road, Lakshmipuram, Mysuru, Karnataka 570005",
                    "website": "https://www.royalorchidhotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Heritage‑style rooms with verandas (select)",
                        "Courtyard restaurants and bar",
                        "Garden sit‑outs",
                        "Event/meeting spaces"
                    ],
                    "brief": "A characterful, heritage‑inspired hotel with leafy courtyards and cosy dining—ideal for relaxed city breaks.",
                    "highlights": [
                        "Old‑world charm in city centre",
                        "Intimate event suitability",
                        "Calm courtyards and greenery",
                        "Convenient sightseeing access"
                    ]
                },
                {
                    "name": "Southern Star Mysuru",
                    "address": "Vinobha Road, Mysuru, Karnataka 570005",
                    "website": "https://www.southernstarmysore.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Neat rooms in a central location",
                        "Restaurant, café, and bar",
                        "Pool and fitness room",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A dependable, centrally placed hotel with tidy rooms, steady dining, and practical banquets for socials and meetings.",
                    "highlights": [
                        "Close to markets and eateries",
                        "Consistent service",
                        "Good for short stays",
                        "Balanced price‑to‑amenities"
                    ]
                }
            ]
        }
    },




    "darjeeling": {
        "name": "Darjeeling",
        "description": "Best hotels in Darjeeling—heritage hill stays and premium resorts near Mall Road, Jalapahar, and Ghoom. Enjoy Kanchenjunga‑view rooms (select), cozy lounges, fireplaces, spas, and intimate event spaces.",
        "sectionOne": "Darjeeling, the Queen of the Hills, blends tea gardens, colonial‑era charm, and Himalayan panoramas. Travellers explore Tiger Hill sunrise, Batasia Loop, Darjeeling Himalayan Railway (Toy Train), Happy Valley Tea Estate, Himalayan Mountaineering Institute, and Chowrasta Mall. Hill hotels emphasize warm rooms, dependable Wi‑Fi, hearty dining, bonfire/lounge spaces, and compact banquets—ideal for family holidays, honeymoons, and serene retreats.",
        "sectionTwo": {
            "text": "Darjeeling features heritage icons, boutique hill resorts, and practical central stays across Mall Road/Chowrasta, Jalapahar, and Ghoom approaches. Below are handpicked properties known for views, ambience, and consistent service.",
            "hotels": [
                {
                    "name": "Mayfair Darjeeling",
                    "address": "The Mall, Opposite Governor House, Darjeeling, West Bengal 734101",
                    "website": "https://www.mayfairhotels.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Heritage‑style rooms and suites",
                        "Restaurants, tea lounge, and bar",
                        "Spa services and fitness corner",
                        "Banquet/meeting rooms and lawns"
                    ],
                    "brief": "A grand heritage‑style address near the Mall offering refined rooms, classic dining, and polished event service.",
                    "highlights": [
                        "Prime Mall Road access",
                        "Vintage ambience with modern comforts",
                        "Family‑friendly leisure",
                        "Good for weddings and socials"
                    ]
                },
                {
                    "name": "The Elgin, Darjeeling",
                    "address": "18, HD Lama Road, Darjeeling, West Bengal 734101",
                    "website": "https://www.elginhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2000, "max": 5200 } },
                    "facilities": [
                        "Colonial‑era rooms with fireplaces (select)",
                        "Restaurant, lounge, and high‑tea",
                        "Garden sit‑outs",
                        "Intimate banquet/meeting space"
                    ],
                    "brief": "A colonial gem with cozy salons, high‑tea ritual, and warm service—perfect for romantic and heritage stays.",
                    "highlights": [
                        "Walkable to Chowrasta",
                        "Old‑world interiors",
                        "Curated dining and teas",
                        "Boutique event suitability"
                    ]
                },
                {
                    "name": "Cedar Inn, Darjeeling",
                    "address": "Jalapahar Road, Below St. Paul’s School, Darjeeling, West Bengal 734102",
                    "website": "https://www.cedarinn.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Wood‑accented rooms (select Kanchenjunga view)",
                        "Restaurant, bar, and tea lounge",
                        "Spa therapies (property‑specific)",
                        "Small banquet hall"
                    ],
                    "brief": "A tranquil hillside retreat with sweeping views, classic wooden interiors, and serene lounge spaces.",
                    "highlights": [
                        "Panoramic Kanchenjunga vistas (select)",
                        "Quiet yet near town",
                        "Great for slow, scenic stays",
                        "Warm, attentive service"
                    ]
                },
                {
                    "name": "Windamere Hotel",
                    "address": "Observatory Hill, Darjeeling, West Bengal 734101",
                    "website": "https://www.windamerehotel.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Vintage cottages and heritage rooms",
                        "Dining room, tea lounges, and bar",
                        "Garden terraces",
                        "Salon/reading rooms"
                    ],
                    "brief": "An iconic heritage hotel on Observatory Hill with period furnishings, old‑world dining, and enchanting views.",
                    "highlights": [
                        "Historic setting near Chowrasta",
                        "Classic colonial charm",
                        "High‑tea and fireside lounges",
                        "Ideal for nostalgic getaways"
                    ]
                },
                {
                    "name": "Sinclairs Darjeeling",
                    "address": "18/1, Gandhi Road, Darjeeling, West Bengal 734101",
                    "website": "https://www.sinclairshotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Rooms and suites (select with views)",
                        "Restaurant and bar",
                        "Spa services (property‑specific)",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "A dependable hill hotel near the town centre with scenic rooms, steady dining, and compact event spaces.",
                    "highlights": [
                        "Convenient for sightseeing",
                        "Consistent breakfast and service",
                        "Value‑forward premium option",
                        "Good for families and groups"
                    ]
                },
                {
                    "name": "Summit Swiss Heritage Hotel & Spa",
                    "address": "15/A, Gandhi Road, Limbugaon, Darjeeling, West Bengal 734101",
                    "website": "https://www.summithotels.in/",
                    "averageCost": { "stay": 9500, "dining": { "min": 900, "max": 2400 } },
                    "facilities": [
                        "Heritage rooms and family suites",
                        "Restaurant and café",
                        "Spa (property‑specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A value‑friendly heritage property with cosy rooms, spa services, and easy access to Mall Road.",
                    "highlights": [
                        "Near Mall Road cafés and shops",
                        "Good family configurations",
                        "Popular breakfast options",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Taj Chia Kutir Resort & Spa, Darjeeling",
                    "address": "Panchayat Office Road, Kurseong (Darjeeling district), West Bengal 734203",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 32000, "dining": { "min": 2800, "max": 6500 } },
                    "facilities": [
                        "Tea‑estate‑view rooms and suites",
                        "Destination restaurants and bar",
                        "J Wellness Spa and pool (select/seasonal)",
                        "Event lawns and halls"
                    ],
                    "brief": "A tea‑estate luxury resort in the Darjeeling hills with refined rooms, destination dining, and signature wellness.",
                    "highlights": [
                        "Immersive plantation setting",
                        "Curated tea and dining experiences",
                        "Elegant event backdrops",
                        "Great for couples and retreats"
                    ]
                },
                {
                    "name": "Chamong Chiabari – Mountain Retreat",
                    "address": "Pokhriabong, Darjeeling, West Bengal 734216",
                    "website": "https://www.chamongchiabari.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Estate cottages with valley views",
                        "Restaurant and tea lounge",
                        "Experiences/treks (property‑led)",
                        "Intimate event decks"
                    ],
                    "brief": "A boutique tea‑estate retreat offering calm cottages, tea trails, and photo‑ready viewpoints.",
                    "highlights": [
                        "Quiet, nature‑rich ambience",
                        "Estate experiences and walks",
                        "Ideal for slow travel",
                        "Scenic sunrise/sunset spots"
                    ]
                }
            ]
        }
    },



    "kochi": {
        "name": "Kochi (Cochin)",
        "description": "Best hotels in Kochi—waterfront and business-district stays across Fort Kochi, Marine Drive, and Infopark/Kakkanad. Enjoy refined dining, clean rooms, pools/spas (select), and versatile event spaces.",
        "sectionOne": "Kochi blends colonial-era Fort Kochi, island-studded backwaters, and a modern business core. Travellers explore Chinese Fishing Nets, Jew Town/Synagogue, Mattancherry Palace, Marine Drive, and Cherai Beach, supported by air, rail, and Water Metro links. City hotels emphasize polished rooms, reliable Wi‑Fi, destination dining, and banquet floors for conferences and weddings—ideal for culture trips, family breaks, and business travel.",
        "sectionTwo": {
            "text": "Kochi features heritage boutiques in Fort Kochi, premium waterfront hotels on Marine Drive/Willingdon Island, and smart business stays in the Infopark corridor.",
            "hotels": [
                {
                    "name": "Taj Malabar Resort & Spa, Cochin",
                    "address": "Willingdon Island, Kochi, Kerala 682009",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Harbour-view rooms and suites",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness centre",
                        "Ballrooms and lawns"
                    ],
                    "brief": "A harbourfront classic with sunset views, destination dining, and elegant indoor–outdoor venues.",
                    "highlights": [
                        "Backwater/harbour vistas",
                        "Easy access to Fort Kochi by ferry/road",
                        "Family-friendly leisure",
                        "Seasoned event operations"
                    ]
                },
                {
                    "name": "Grand Hyatt Kochi Bolgatty",
                    "address": "Bolgatty Island, Kochi, Kerala 682504",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Backwater-facing rooms and suites",
                        "Signature restaurants, lounges",
                        "Pools, spa, and fitness",
                        "Convention centre and lawns"
                    ],
                    "brief": "A backwater landmark with expansive leisure and convention-scale venues overlooking Vembanad waters.",
                    "highlights": [
                        "Island setting and skyline views",
                        "Large MICE capability",
                        "Good for weddings and retreats",
                        "Convenient city connectivity"
                    ]
                },
                {
                    "name": "Fragrant Nature Kochi",
                    "address": "Near State Bank of India, Calvathy Rd, Fort Kochi, Kerala 682001",
                    "website": "https://www.fragrantnature.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Boutique rooms with heritage accents",
                        "Restaurant, rooftop lounge",
                        "Spa services",
                        "Small banquet/meeting spaces"
                    ],
                    "brief": "A chic Fort Kochi boutique with heritage styling, cosy dining, and walkable sightseeing access.",
                    "highlights": [
                        "Steps to Chinese Nets and cafés",
                        "Intimate event suitability",
                        "Great for couples",
                        "Curated local experiences"
                    ]
                },
                {
                    "name": "Forte Kochi",
                    "address": "1/373, Kochi - Fort Kochi Rd, Fort Kochi, Kerala 682001",
                    "website": "https://www.fortekochi.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Heritage-style rooms",
                        "Courtyard pool and restaurant",
                        "Concierge and tours",
                        "Small event room"
                    ],
                    "brief": "A restored heritage mansion around a leafy courtyard, perfect for slow, culture-led stays.",
                    "highlights": [
                        "Atmospheric heritage ambience",
                        "Walkable to sights",
                        "Relaxed courtyard pool",
                        "Boutique hospitality"
                    ]
                },
                {
                    "name": "Crowne Plaza Kochi",
                    "address": "NH-47 Bypass, Maradu, Kochi, Kerala 682304",
                    "website": "https://www.ihg.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Backwater-view rooms (select)",
                        "All-day dining and bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A business-leisure hotel on the bypass with solid dining and event spaces, convenient for city commutes.",
                    "highlights": [
                        "Good road connectivity",
                        "Family-friendly amenities",
                        "Value-forward premium pick",
                        "Consistent service"
                    ]
                }
            ]
        }
    },
    "alleppey": {
        "name": "Alappuzha (Alleppey)",
        "description": "Best stays in Alleppey—backwater resorts and houseboats along Vembanad Lake and Punnamada. Enjoy sunset cruises, Keralan dining, Ayurveda, and lawns for intimate events.",
        "sectionOne": "Alleppey is Kerala’s backwater heartland, known for palm-lined canals, houseboats, and beaches. Travellers enjoy shikara cruises, village walks, Marari Beach day trips, and sunset views over Vembanad. Resorts and boats emphasize airy rooms, local cuisine, Ayurveda, and boat jetty access—great for honeymoons, families, and wellness breaks.",
        "sectionTwo": {
            "text": "Alleppey offers resort stays on the lakefront and canal-side boutique properties, plus premium houseboats with private dining.",
            "hotels": [
                {
                    "name": "Lake Palace Resort",
                    "address": "Thiruvambadi PO, Alleppey, Kerala 688007",
                    "website": "https://lakepalaceresort.in/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Lake-view rooms and villas",
                        "Restaurants and bar",
                        "Pool, spa/Ayurveda, and activities",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A lakeside resort with classic Kerala architecture, serene lawns, and sunset-facing spaces.",
                    "highlights": [
                        "Private jetty/boat access",
                        "Great for family retreats",
                        "Event-friendly lawns",
                        "Backwater sunset views"
                    ]
                },
                {
                    "name": "Punnamada Resort",
                    "address": "Punnamada, Alappuzha, Kerala 688006",
                    "website": "https://www.punnamada.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Traditional villas along the lake",
                        "Restaurant and bar",
                        "Ayurveda centre and pool",
                        "Event lawn and meeting room"
                    ],
                    "brief": "An authentic lakefront resort with heritage villas, Ayurveda, and easy houseboat connectivity.",
                    "highlights": [
                        "On Punnamada backwaters",
                        "Ayurveda/wellness focus",
                        "Calm lawns and courtyards",
                        "Ideal for slow travel"
                    ]
                },
                {
                    "name": "Citrus Retreats Alleppey",
                    "address": "Punnamada, Alappuzha, Kerala 688006",
                    "website": "https://www.citrushotels.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Canal- and lake-facing rooms",
                        "Restaurant and café",
                        "Pool and activities",
                        "Banquet/meeting space"
                    ],
                    "brief": "A value-forward backwater hotel with bright rooms, scenic dining, and easy cruise arrangements.",
                    "highlights": [
                        "Boat/cruise desk",
                        "Family-friendly amenities",
                        "Good base for day trips",
                        "Balanced price-to-amenities"
                    ]
                },
                {
                    "name": "Premium Houseboat (Example Category)",
                    "address": "Punnamada Jetty, Alappuzha 688006",
                    "website": "#",
                    "averageCost": { "stay": 18000, "dining": { "min": 1500, "max": 3200 } },
                    "facilities": [
                        "Private ensuite cabins",
                        "Onboard kitchen and sundeck",
                        "Air-conditioning (timed, select)",
                        "Crew and guided routes"
                    ],
                    "brief": "A private houseboat for overnight backwater cruising with curated meals and sunset decks.",
                    "highlights": [
                        "Sunset and canal routes",
                        "Intimate, photo-friendly",
                        "Great for couples/families",
                        "Unique Alleppey experience"
                    ]
                }
            ]
        }
    },
    "munnar": {
        "name": "Munnar",
        "description": "Best stays in Munnar—tea-estate resorts and hillside boutiques around Chithirapuram, Pallivasal, and Pothamedu. Enjoy mountain views, plantation walks, fireplaces, spas, and cosy lounges.",
        "sectionOne": "Munnar offers rolling tea gardens, misty viewpoints, and wildlife sanctuaries. Travellers explore Top Station, Eravikulam National Park, Kolukkumalai (jeep), Attukad waterfalls, and tea museums. Hill hotels emphasize view-led rooms, hearty dining, and indoor leisure for cool weather—ideal for honeymoons, family trips, and wellness escapes.",
        "sectionTwo": {
            "text": "Munnar features premium hillside resorts with valley decks, plantation retreats, and boutique cottages set among tea slopes.",
            "hotels": [
                {
                    "name": "Fragrant Nature Munnar",
                    "address": "Bison Valley Road, Pothamedu, Munnar, Kerala 685612",
                    "website": "https://www.fragrantnature.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Valley-view rooms and suites",
                        "Restaurant and lounge",
                        "Spa and fitness",
                        "Banquet/meeting room"
                    ],
                    "brief": "A refined hillside resort with panoramic decks, warm service, and spa-led downtime.",
                    "highlights": [
                        "Sunrise/sunset viewpoints (select)",
                        "Great for couples",
                        "Good access to major sights",
                        "Cosy interiors for cool nights"
                    ]
                },
                {
                    "name": "Parakkat Nature Resort",
                    "address": "2nd Mile, Pallivasal, Munnar, Kerala 685565",
                    "website": "https://parakkatnature.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Rooms with tea-valley views",
                        "Restaurant and café",
                        "Activities/bonfire (seasonal)",
                        "Small event hall"
                    ],
                    "brief": "A popular valley-view resort with lively dining, decks, and activities suitable for families.",
                    "highlights": [
                        "Photo-friendly viewpoints",
                        "Family-friendly layouts",
                        "Balanced price-to-amenities",
                        "Helpful tour assistance"
                    ]
                },
                {
                    "name": "The Fog Munnar",
                    "address": "Eatty City Road, Chithirapuram P.O, Munnar, Kerala 685565",
                    "website": "https://www.thefogmunnar.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Cottages/rooms with valley vistas",
                        "Restaurant and lounge",
                        "Heated pool (select/seasonal) and spa",
                        "Banquet/meeting room"
                    ],
                    "brief": "A scenic resort with cloud-kissed decks, warm rooms, and restorative spa facilities.",
                    "highlights": [
                        "Misty valley ambience",
                        "Couple- and family-friendly",
                        "Good dining consistency",
                        "Quiet, relaxed setting"
                    ]
                },
                {
                    "name": "Amber Dale Luxury Hotel & Spa",
                    "address": "KSEB Tunnel Road, Pallivasal, Munnar, Kerala 685612",
                    "website": "https://amberdalehotels.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1300, "max": 3000 } },
                    "facilities": [
                        "View-facing rooms with balconies",
                        "Restaurant and café",
                        "Spa and activities",
                        "Event room"
                    ],
                    "brief": "A comfortable hillside hotel with balcony views, friendly service, and easy access to attractions.",
                    "highlights": [
                        "Great sunrise decks (select)",
                        "Value-forward premium option",
                        "Suitable for longer stays",
                        "Reliable housekeeping"
                    ]
                }
            ]
        }
    },
    "thiruvananthapuram": {
        "name": "Thiruvananthapuram (Trivandrum)",
        "description": "Best hotels in Thiruvananthapuram—premium and midscale stays near MG Road, Kovalam access, and the airport. Enjoy reliable dining, clean rooms, pools/spas (select), and event spaces.",
        "sectionOne": "Kerala’s capital blends coastal scenery, heritage landmarks, and civic hubs. Travellers explore Sree Padmanabhaswamy Temple, Napier Museum, Shanghumugham Beach, and nearby Kovalam, with strong air/rail/road links. Hotels focus on clean rooms, dependable Wi‑Fi, multi-cuisine dining, and banquet halls for conferences and weddings—ideal for corporate trips, family holidays, and pilgrimages.",
        "sectionTwo": {
            "text": "The city offers luxury beach resorts near Kovalam, premium hotels around Secretariat/MG Road, and value business stays near the airport corridor.",
            "hotels": [
                {
                    "name": "Hyatt Regency Trivandrum",
                    "address": "CV Raman Pillai Road, Near Secretariat, Thiruvananthapuram 695014",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 2000, "max": 5000 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All-day dining and bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A polished city-centre hotel with refined rooms, strong dining, and event-ready venues.",
                    "highlights": [
                        "Secretariat/MG Road access",
                        "Reliable brand standards",
                        "Good for events and conferences",
                        "Convenient for museums/markets"
                    ]
                },
                {
                    "name": "Vivanta Thiruvananthapuram",
                    "address": "C V Raman Pillai Road, Thycaud, Thiruvananthapuram 695014",
                    "website": "https://www.vivantahotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Modern rooms with ergonomic workspaces",
                        "Restaurants and lounge",
                        "Rooftop pool, spa services, and gym",
                        "Banquet halls and boardrooms"
                    ],
                    "brief": "A premium city hotel with rooftop leisure and signature dining, suited to business and family stays.",
                    "highlights": [
                        "Central access to offices/sights",
                        "Rooftop pool views",
                        "Efficient event setups",
                        "Consistent service"
                    ]
                },
                {
                    "name": "O by Tamara, Trivandrum",
                    "address": "Bypass Road, Near Aakkulam Bridge, Thiruvananthapuram 695029",
                    "website": "https://www.tamarahotels.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1600, "max": 4200 } },
                    "facilities": [
                        "Well-appointed rooms and suites",
                        "Multiple dining outlets and bar",
                        "Pool, spa, and fitness",
                        "Large banquets and meeting rooms"
                    ],
                    "brief": "A stylish premium hotel on the bypass with robust dining, wellness, and event capacity.",
                    "highlights": [
                        "Airport/Technopark connectivity",
                        "High-capacity banquets",
                        "Family-friendly leisure",
                        "Reliable for long stays"
                    ]
                },
                {
                    "name": "Taj Green Cove Resort & Spa, Kovalam",
                    "address": "GV Raja Vattappara Road, Kovalam 695527",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Luxury rooms/villas with sea/lagoon views",
                        "Specialty restaurants and bars",
                        "J Wellness Spa, pool, and fitness",
                        "Lawns and halls for events"
                    ],
                    "brief": "A luxury coastal resort near the city offering scenic stays, destination dining, and wellness.",
                    "highlights": [
                        "Clifftop/lagoon vistas",
                        "Spa/yoga experiences",
                        "Indoor–outdoor venues",
                        "Access to Kovalam beaches"
                    ]
                },
                {
                    "name": "Classic Sarovar Portico, Trivandrum",
                    "address": "Manjalikulam Road, Thampanoor, Thiruvananthapuram 695001",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Comfortable rooms near station/bus stand",
                        "Restaurant and café",
                        "Rooftop pool (select) and gym",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A central hotel with practical rooms, easy transit access, and versatile event spaces.",
                    "highlights": [
                        "Transit-friendly location",
                        "Value pricing",
                        "Popular breakfast options",
                        "Good for short stays"
                    ]
                }
            ]
        }
    },

    "khajuraho": {
        "name": "Khajuraho (Madhya Pradesh)",
        "description": "Best hotels in Khajuraho—heritage and premium stays near the Western Group of Temples, Jain group, and airport corridor. Enjoy clean rooms, reliable dining, gardens/pools (select), and event spaces for weddings and cultural events.",
        "sectionOne": "Khajuraho, a UNESCO World Heritage site, is famed for its exquisite Chandela‑era temples and intricate sculptures. Travellers explore the Western, Eastern (Jain), and Southern temple groups, the evening light‑and‑sound show, Raneh Falls day trips, and nearby Panna Tiger Reserve. Hotels focus on serene gardens, dependable Wi‑Fi, multi‑cuisine dining, and compact to mid‑size banquets—ideal for heritage trips, pilgrimages, family holidays, and small conferences.",
        "sectionTwo": {
            "text": "Khajuraho features premium garden resorts, classic city hotels, and value picks around the temple belt, airport road, and railway approach. Below are handpicked options known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "The Lalit Temple View Khajuraho",
                    "address": "Opp. Western Group of Temples, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.thelalit.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Temple‑view rooms and suites (select)",
                        "Signature restaurants and bar",
                        "Pool, spa services, and fitness",
                        "Lawns and banquet halls"
                    ],
                    "brief": "A landmark luxury stay with temple‑side location, refined dining, and elegant indoor‑outdoor venues.",
                    "highlights": [
                        "Walkable access to Western Temples",
                        "Popular breakfast and high‑tea",
                        "Event‑friendly lawns",
                        "Trusted luxury service"
                    ]
                },
                {
                    "name": "Radisson Jass Hotel Khajuraho",
                    "address": "By Pass Road, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Modern rooms with garden views",
                        "All‑day dining and bar",
                        "Outdoor pool and fitness corner",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A polished, garden‑style hotel with steady dining, poolside downtime, and practical event spaces.",
                    "highlights": [
                        "Quick drive to temple complexes",
                        "Family‑friendly leisure",
                        "Consistent breakfast service",
                        "Good for tours and groups"
                    ]
                },
                {
                    "name": "Ramada by Wyndham Khajuraho",
                    "address": "Airport Road, Sevagram, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.wyndhamhotels.com/ramada",
                    "averageCost": { "stay": 11000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "Restaurant, café, and bar",
                        "Pool and fitness room",
                        "Banquet hall and boardroom"
                    ],
                    "brief": "A dependable airport‑corridor hotel with tidy rooms, lively dining, and event‑ready facilities.",
                    "highlights": [
                        "Airport/temple belt convenience",
                        "Good value for families",
                        "Efficient check‑in/out",
                        "Popular for tour groups"
                    ]
                },
                {
                    "name": "Clarks Khajuraho",
                    "address": "Airport Road, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.clarkshotels.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Spacious rooms with garden/pool views",
                        "Multi‑cuisine restaurant and bar",
                        "Pool and lawns",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A classic city hotel with roomy stays, green spaces, and versatile banquets for socials and meetings.",
                    "highlights": [
                        "Easy reach to all temple groups",
                        "Family‑friendly greens",
                        "Reliable housekeeping",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Syna Heritage Hotel, Khajuraho",
                    "address": "Bypass Road, Sevagram, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.synahotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1300, "max": 3000 } },
                    "facilities": [
                        "Heritage‑style rooms and suites",
                        "Restaurant and lounge",
                        "Pool and gardens",
                        "Small banquet hall"
                    ],
                    "brief": "A boutique, heritage‑inspired stay with charming rooms, garden lawns, and calm ambience.",
                    "highlights": [
                        "Quiet, resort‑like feel",
                        "Good for couples and families",
                        "Photo‑friendly spaces",
                        "Comfortable for multi‑night stays"
                    ]
                },
                {
                    "name": "Hotel Isabel Palace",
                    "address": "Airport Road, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.hotelisabelpalace.com/",
                    "averageCost": { "stay": 6000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Neat rooms with balconies (select)",
                        "Rooftop/restaurant dining",
                        "Travel assistance",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A value‑forward hotel with spacious rooms, friendly service, and easy sightseeing access.",
                    "highlights": [
                        "Proximity to Western Temples",
                        "Good family configurations",
                        "Popular breakfast options",
                        "Budget‑friendly comfort"
                    ]
                },
                {
                    "name": "MPT Payal, Khajuraho (MP Tourism)",
                    "address": "Near Western Group of Temples, Khajuraho, Madhya Pradesh 471606",
                    "website": "https://www.mptourism.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Cottage/room categories in green campus",
                        "Restaurant and room service",
                        "Lawns and sit‑outs",
                        "Event hall (property‑specific)"
                    ],
                    "brief": "A government‑run property with large grounds, simple rooms, and straightforward dining close to the monuments.",
                    "highlights": [
                        "Green, spacious campus",
                        "Temple‑side convenience",
                        "Good parking and access",
                        "Value for families/groups"
                    ]
                }
            ]
        }
    },


    "orchha": {
        "name": "Orchha (Madhya Pradesh)",
        "description": "Best stays in Orchha—heritage havelis and riverside resorts near Orchha Fort, Ram Raja Temple, and Betwa River. Expect clean rooms, gardens/pools (select), reliable dining, and intimate event spaces.",
        "sectionOne": "Orchha, a Bundela-era heritage town on the Betwa River, is known for Orchha Fort, Jahangir Mahal, Chaturbhuj Temple, Ram Raja Temple, and cenotaphs (Chhatris). Travellers enjoy river sunsets, palace views, and nature walks. Local hotels emphasize leafy campuses, classic architecture, satvik and multi‑cuisine dining, and compact to mid‑size banquet lawns—ideal for heritage getaways, pilgrimages, family trips, and small weddings.",
        "sectionTwo": {
            "text": "Orchha offers riverfront resorts, fort‑area heritage hotels, and practical midscale stays around the main monument complex and the bypass/airport approach.",
            "hotels": [
                {
                    "name": "MPT Sheesh Mahal, Orchha",
                    "address": "Inside Orchha Fort, Orchha, Madhya Pradesh 472246",
                    "website": "https://mpstdc.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Heritage rooms within the fort complex",
                        "Restaurant and courtyard dining",
                        "Guided heritage experiences (property‑assisted)",
                        "Small banquet/meeting space"
                    ],
                    "brief": "A unique heritage hotel set inside the fort complex, offering historic ambience and unforgettable sunrise/sunset vistas.",
                    "highlights": [
                        "Walkable to Jahangir/Raja Mahals",
                        "Immersive fort‑side setting",
                        "Great photo spots",
                        "Ideal for culture‑led stays"
                    ]
                },
                {
                    "name": "Bundelkhand Riverside",
                    "address": "Kothi Ghat, Betwa River, Orchha, Madhya Pradesh 472246",
                    "website": "https://www.bundelkhandriverside.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Riverside rooms and suites (select balconies)",
                        "Restaurant, bar, and lawns",
                        "Pool and activities (property‑specific)",
                        "Banquet lawns and hall"
                    ],
                    "brief": "A colonial‑style riverside retreat with leafy grounds, spacious rooms, and serene Betwa views.",
                    "highlights": [
                        "Direct river proximity",
                        "Family‑friendly green spaces",
                        "Popular for small weddings",
                        "Calm, nature‑rich ambience"
                    ]
                },
                {
                    "name": "Orchha Palace and Convention Centre",
                    "address": "Orchha Bypass Road, Orchha, Madhya Pradesh 472246",
                    "website": "https://www.orchhapalace.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Multiple dining outlets",
                        "Large pool, spa (select), and gym",
                        "Convention‑scale banquets and lawns"
                    ],
                    "brief": "A resort‑style hotel with big lawns, a large pool, and sizeable banquet spaces—well‑suited to events and group stays.",
                    "highlights": [
                        "Event‑friendly infrastructure",
                        "Comfortable for long stays",
                        "Good road connectivity",
                        "Value‑forward for groups"
                    ]
                },
                {
                    "name": "Amar Mahal, Orchha",
                    "address": "Near St. Anthony School, Orachha, Madhya Pradesh 472246",
                    "website": "https://www.amarmahal.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1300, "max": 3000 } },
                    "facilities": [
                        "Traditional rooms around courtyards",
                        "Restaurant and terrace sit‑outs",
                        "Pool and gardens",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A heritage‑style property with classic architecture, green lawns, and a photo‑friendly pool court.",
                    "highlights": [
                        "Close to river and temples",
                        "Romantic heritage vibe",
                        "Popular for social events",
                        "Good for couples and families"
                    ]
                },
                {
                    "name": "Raj Vilas (The Palace) Orchha",
                    "address": "Near Lakshmi Mandir Road, Orchha, Madhya Pradesh 472246",
                    "website": "https://www.rajvillasorchha.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Elegant rooms with heritage accents",
                        "Restaurant and lounge",
                        "Pool and gardens",
                        "Event/meeting space"
                    ],
                    "brief": "A palace‑style hotel with tasteful rooms, landscaped grounds, and dependable dining near key sights.",
                    "highlights": [
                        "Convenient for temple/fort circuit",
                        "Wedding‑friendly ambience",
                        "Balanced price‑to‑amenities",
                        "Comfortable for multi‑night stays"
                    ]
                },
                {
                    "name": "The Orchha Resort (By River Side)",
                    "address": "Kanchan Ghat, Orchha, Madhya Pradesh 472246",
                    "website": "https://theorchharesort.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "River‑adjacent rooms/cottages",
                        "Restaurant and outdoor dining",
                        "Pool and spa (select)",
                        "Banquet lawns and hall"
                    ],
                    "brief": "A long‑running riverside resort with peaceful grounds, comfortable rooms, and easy access to heritage spots.",
                    "highlights": [
                        "Near cenotaphs and ghats",
                        "Family‑friendly leisure",
                        "Good for small events",
                        "Consistent housekeeping"
                    ]
                },
                {
                    "name": "MPT Betwa Retreat, Orchha",
                    "address": "Near Betwa River, Orchha, Madhya Pradesh 472246",
                    "website": "https://mpstdc.com/",
                    "averageCost": { "stay": 8000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Cottages/rooms in a green campus",
                        "Restaurant and sit‑outs",
                        "Pool (property‑specific)",
                        "Event lawn/room"
                    ],
                    "brief": "A government‑run retreat with leafy grounds, simple rooms, and straightforward dining close to the river and monuments.",
                    "highlights": [
                        "Green, open spaces",
                        "Easy sightseeing access",
                        "Value for families/groups",
                        "Ample parking and access roads"
                    ]
                }
            ]
        }
    },



    "gwalior": {
        "name": "Gwalior (Madhya Pradesh)",
        "description": "Best stays in Gwalior—heritage palaces and premium city hotels near Gwalior Fort, Lashkar/CBD, and the railway–airport corridors. Expect polished rooms, reliable dining, pools/spas (select), and event spaces.",
        "sectionOne": "Gwalior blends Scindia-era heritage, classical music legacy, and a compact, well-connected city layout. Travellers explore Gwalior Fort, Jai Vilas Palace & Museum, Tansen’s Tomb, Sun Temple, and the old city markets. Hotels focus on clean, comfortable rooms, dependable Wi‑Fi, multi‑cuisine dining, and banquet halls for weddings and conferences—ideal for family trips, heritage getaways, and corporate visits.",
        "sectionTwo": {
            "text": "Gwalior offers heritage palace stays, premium business hotels, and value options around Lashkar, Maharaj Bada, and the station/airport routes. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Taj Usha Kiran Palace, Gwalior",
                    "address": "Jayendraganj, Lashkar, Gwalior, Madhya Pradesh 474009",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2800, "max": 6500 } },
                    "facilities": [
                        "Heritage palace rooms and suites",
                        "Signature restaurants and bar",
                        "Pool, spa, and fitness centre",
                        "Lawns, courtyards, and banquet halls"
                    ],
                    "brief": "A regal heritage hotel with lush lawns, refined dining, and elegant venues—ideal for celebrations and luxury breaks.",
                    "highlights": [
                        "Palace ambience and heritage walks",
                        "Close to key sights",
                        "High‑touch hospitality",
                        "Indoor–outdoor event flexibility"
                    ]
                },
                {
                    "name": "Radisson Gwalior",
                    "address": "DB City, By Pass Road, Gwalior, Madhya Pradesh 474011",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Modern rooms and suites",
                        "All‑day dining and rooftop/lounge (property‑specific)",
                        "Pool (select) and fitness",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A contemporary business‑friendly hotel with steady dining and versatile venues for meetings and socials.",
                    "highlights": [
                        "Good road/airport connectivity",
                        "Reliable breakfast and service",
                        "Event‑friendly floors",
                        "Suitable for short and extended stays"
                    ]
                },
                {
                    "name": "Park Inn by Radisson Gwalior",
                    "address": "City Center, Gwalior, Madhya Pradesh 474011",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Smart, centrally located rooms",
                        "Restaurant and bar",
                        "Fitness corner",
                        "Meeting room"
                    ],
                    "brief": "A centrally placed hotel with clean rooms, efficient service, and practical dining—great for business travellers.",
                    "highlights": [
                        "Close to station and markets",
                        "Quick check‑in/out",
                        "Consistent housekeeping",
                        "Value‑forward premium pick"
                    ]
                },
                {
                    "name": "Neemrana’s Deo Bagh",
                    "address": "Agra‑Mumbai Highway (NH44), Gwalior, Madhya Pradesh 474002",
                    "website": "https://www.neemranahotels.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Heritage rooms set amid historic gardens",
                        "Courtyard dining and tea service",
                        "Guided walks (property‑assisted)",
                        "Intimate event space"
                    ],
                    "brief": "A serene heritage garden hotel with characterful rooms, calm courtyards, and old‑world dining.",
                    "highlights": [
                        "Historic pavilions and gardens",
                        "Quiet, contemplative ambience",
                        "Photo‑friendly settings",
                        "Great for couples and culture seekers"
                    ]
                },
                {
                    "name": "Clarks Inn Suites Gwalior",
                    "address": "Madhav Rao Scindia Marg, City Center, Gwalior, Madhya Pradesh 474011",
                    "website": "https://www.clarksinn.in/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Comfortable rooms near CBD",
                        "Restaurant and café",
                        "Pool (select) and fitness",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A dependable central hotel with tidy rooms, solid dining, and event facilities—popular with families and corporates.",
                    "highlights": [
                        "CBD convenience",
                        "Popular breakfast options",
                        "Balanced price‑to‑amenities",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "The Central Park, Gwalior",
                    "address": "City Center, Gwalior, Madhya Pradesh 474011",
                    "website": "https://www.thecentralpark.in/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "City‑view rooms and suites",
                        "Restaurant, bar, and bakery",
                        "Pool and fitness room",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A long‑trusted city hotel offering comfortable rooms, classic dining, and indoor–outdoor venues.",
                    "highlights": [
                        "Near transport hubs",
                        "Event‑friendly lawns",
                        "Family‑friendly amenities",
                        "Reliable service"
                    ]
                },
                {
                    "name": "MPT Tansen Residency, Gwalior",
                    "address": "Padav, Near Railway Station, Gwalior, Madhya Pradesh 474002",
                    "website": "https://mpstdc.com/",
                    "averageCost": { "stay": 7500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Spacious rooms in a green campus",
                        "Restaurant and room service",
                        "Lawns and sit‑outs",
                        "Event/meeting hall"
                    ],
                    "brief": "A government‑run property with simple rooms, greenery, and straightforward dining near transit and sights.",
                    "highlights": [
                        "Transit‑friendly location",
                        "Good parking and access",
                        "Value for families/groups",
                        "Calm campus feel"
                    ]
                }
            ]
        }
    },





    "jaisalmer": {
        "name": "Jaisalmer (Rajasthan)",
        "description": "Best stays in Jaisalmer—heritage havelis, fort‑side boutiques, and desert camps near Sam Dunes. Enjoy terrace views, candlelit courtyards, cultural dinners, and event spaces for weddings and offsites.",
        "sectionOne": "Jaisalmer, the Golden City, blends the living Jaisalmer Fort, ornate havelis, and Thar Desert dunes. Travellers explore Sonar Quila (Jaisalmer Fort), Patwon ki Haveli, Salim Singh ki Haveli, Nathmal ki Haveli, Gadisar Lake, Bada Bagh cenotaphs, Kuldhara village, and sunset safaris at Sam/Khuri dunes. Hotels focus on characterful heritage rooms, rooftop dining with fort views, folk music evenings, dependable Wi‑Fi, and compact to grand banquets—ideal for culture trips, honeymoons, and desert celebrations.",
        "sectionTwo": {
            "text": "Jaisalmer offers fort‑view heritage hotels in the old city, premium resorts on the outskirts, and authentic desert camps at Sam/Khuri. Below are handpicked properties known for location, ambience, and consistent service.",
            "hotels": [
                {
                    "name": "Suryagarh, Jaisalmer",
                    "address": "Kahala Phata, Sam Road, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.suryagarh.com/",
                    "averageCost": { "stay": 38000, "dining": { "min": 2800, "max": 7000 } },
                    "facilities": [
                        "Palace‑style rooms and suites",
                        "Destination restaurants and bars",
                        "Courtyard pool, spa, and fitness",
                        "Grand lawns, stepwell settings, and ballrooms"
                    ],
                    "brief": "A modern‑palace desert retreat with curated trails, torchlit dinners, and cinematic wedding venues.",
                    "highlights": [
                        "Curated desert/silk route experiences",
                        "Iconic photo spots and courtyards",
                        "High‑touch hospitality",
                        "Large‑format event capability"
                    ]
                },
                {
                    "name": "The Serai, Jaisalmer (SUJÁN)",
                    "address": "Bherwa, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.thesujanlife.com/serai",
                    "averageCost": { "stay": 65000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "Luxury tented suites (select with pools)",
                        "Destination dining and bar",
                        "Spa, pool, and curated experiences",
                        "Event lawns and desert setups"
                    ],
                    "brief": "A luxury desert camp with lavish tents, private‑pool suites, and bespoke dune experiences.",
                    "highlights": [
                        "Ultra‑luxury tented living",
                        "Private desert dinners",
                        "Wellness‑led downtime",
                        "Exclusive celebration backdrops"
                    ]
                },
                {
                    "name": "Jaisalmer Marriott Resort & Spa",
                    "address": "Dhanana Road, Police Line, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Modern rooms and suites (select fort views)",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A premium city resort pairing fort‑view rooms with dependable dining and event‑ready venues.",
                    "highlights": [
                        "Easy access to old city and fort",
                        "Popular breakfast and brunches",
                        "Family‑friendly leisure",
                        "Conference‑ready infrastructure"
                    ]
                },
                {
                    "name": "Fort Rajwada, Jaisalmer",
                    "address": "Jodhpur Barmer Link Road, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.fortrajwada.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Palatial rooms and suites",
                        "Restaurants and bar",
                        "Pool and spa services",
                        "Banquet halls and courtyards"
                    ],
                    "brief": "A classic, palace‑style hotel with expansive courtyards, traditional décor, and wedding‑friendly spaces.",
                    "highlights": [
                        "Photo‑friendly architecture",
                        "Good for big socials",
                        "Comfortable for longer stays",
                        "Balanced value and scale"
                    ]
                },
                {
                    "name": "WelcomHeritage Mandir Palace",
                    "address": "Gandhi Chowk, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.welcomheritagehotels.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Heritage rooms and suites",
                        "Rooftop/restaurant dining",
                        "Courtyard sit‑outs",
                        "Boutique event spaces"
                    ],
                    "brief": "A living heritage palace with intricate stonework, cosy rooms, and fort‑side ambience near the old city.",
                    "highlights": [
                        "Close to Patwon/fort circuit",
                        "Vintage charm and terraces",
                        "Great for couples",
                        "Intimate celebrations"
                    ]
                },
                {
                    "name": "The Gulaal, Jaisalmer",
                    "address": "Bera Road, Jaisalmer, Rajasthan 345001",
                    "website": "https://www.thegulaal.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Boutique haveli‑style rooms",
                        "Restaurant and rooftop with fort views",
                        "Plunge pool (property‑specific)",
                        "Small event room"
                    ],
                    "brief": "A boutique haveli‑inspired stay with tasteful rooms, rooftop views, and warm, personalised service.",
                    "highlights": [
                        "Fort‑view rooftop dining",
                        "Characterful interiors",
                        "Quiet yet accessible location",
                        "Good value premium pick"
                    ]
                },
                {
                    "name": "Desert Camps (Sam Sand Dunes) – Premium Category",
                    "address": "Sam Village, Jaisalmer, Rajasthan 345001",
                    "website": "#",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Swiss/luxury tents with ensuite",
                        "Evening cultural shows and dinner",
                        "Camel/jeep safari arrangements",
                        "Bonfire and stargazing"
                    ],
                    "brief": "Premium desert camps offering cultural evenings, dune safaris, and starry‑night stays in Sam.",
                    "highlights": [
                        "Sunset/sunrise dune access",
                        "Folk dance and music nights",
                        "Great for groups and families",
                        "Unique Thar experience"
                    ]
                },
                {
                    "name": "Desert Camps (Khuri Dunes) – Boutique Category",
                    "address": "Khuri Village, Jaisalmer, Rajasthan 345001",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Cozy tents/cottages with ensuite",
                        "Local cuisine dinners",
                        "Camel rides and village walks",
                        "Bonfire circles"
                    ],
                    "brief": "Boutique camps near quieter Khuri dunes for intimate dune sunsets and village‑side experiences.",
                    "highlights": [
                        "Less crowded than Sam (generally)",
                        "Authentic rural vibe",
                        "Couple‑friendly quiet ambience",
                        "Great for photography"
                    ]
                }
            ]
        }
    },



    "mount_abu": {
        "name": "Mount Abu (Rajasthan)",
        "description": "Best stays in Mount Abu—hill retreats and heritage hotels near Nakki Lake, Dilwara Temples, and Guru Shikhar road. Expect clean rooms, gardens/pools (select), scenic dining, and compact event spaces.",
        "sectionOne": "Mount Abu, Rajasthan’s only hill station, pairs cool climate and Aravalli views with temples, lakes, and forest trails. Travellers explore Dilwara Jain Temples, Nakki Lake, Sunset Point, Guru Shikhar, Achalgarh Fort, Trevor’s Tank, and Brahma Kumaris campus. Hotels emphasize airy rooms, hearty dining, gardens, and indoor leisure—ideal for family trips, couples’ getaways, and small corporate offsites.",
        "sectionTwo": {
            "text": "Mount Abu features garden resorts, heritage bungalows, and practical town‑centre hotels around Nakki Lake, Delwara/Dilwara, and the ring‑road approaches. Below are handpicked options known for location, ambience, and consistent service.",
            "hotels": [
                {
                    "name": "Palace Hotel – Bikaner House",
                    "address": "Delwara Road, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Heritage palace rooms and suites",
                        "Restaurant, bar, and lawn dining",
                        "Garden sit‑outs",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A heritage palace with sprawling lawns, vintage interiors, and tranquil ambience—great for relaxed, classic stays.",
                    "highlights": [
                        "Leafy, quiet setting",
                        "Photo‑friendly architecture",
                        "Intimate social events",
                        "Comfortable for longer stays"
                    ]
                },
                {
                    "name": "WelcomHeritage Connaught House",
                    "address": "Near Rajendra Marg, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Colonial‑style rooms and cottages",
                        "Dining room and lawns",
                        "Garden sit‑outs",
                        "Small event room"
                    ],
                    "brief": "A charming heritage bungalow with cottage rooms, leafy gardens, and warm service close to town sights.",
                    "highlights": [
                        "Heritage, home‑like feel",
                        "Walk/short drive to lake",
                        "Quiet courtyards",
                        "Good for couples and families"
                    ]
                },
                {
                    "name": "Hotel Hilltone",
                    "address": "Main Road, Near Bus Stand, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Modern rooms and suites",
                        "Restaurant, bar, and café",
                        "Pool (seasonal/select) and spa",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A popular town‑centre hotel with steady dining, leisure facilities, and event‑friendly spaces.",
                    "highlights": [
                        "Near Nakki Lake approach",
                        "Family‑friendly amenities",
                        "Good breakfast options",
                        "Value‑forward premium pick"
                    ]
                },
                {
                    "name": "Hotel Hillock",
                    "address": "Main Road, Near Nakki Lake, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 11000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Comfortable, garden‑view rooms",
                        "All‑day dining and lounge",
                        "Pool (property‑specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A centrally located hotel known for tidy rooms, garden spaces, and reliable dining close to key attractions.",
                    "highlights": [
                        "Walkable access to markets",
                        "Consistent housekeeping",
                        "Suitable for short and long stays",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Ratan Villas Resort, Mount Abu",
                    "address": "3 Km from Dilwara Temples road, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 13000, "dining": { "min": 1300, "max": 3000 } },
                    "facilities": [
                        "Villa/cottage‑style rooms amid greenery",
                        "Restaurant and outdoor seating",
                        "Activities/bonfire (seasonal)",
                        "Event lawn (property‑specific)"
                    ],
                    "brief": "A nature‑framed resort with cottage layouts, relaxed dining, and outdoor leisure near the Dilwara belt.",
                    "highlights": [
                        "Green, quiet setting",
                        "Family and group‑friendly",
                        "Photo‑ready corners",
                        "Good for weekend stays"
                    ]
                },
                {
                    "name": "Sterling Mount Abu",
                    "address": "Neelkanth Road, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Rooms with hill/valley glimpses",
                        "Restaurant and lounge",
                        "Activity zone (select)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A resort‑style stay with scenic surroundings, family‑friendly amenities, and practical event spaces.",
                    "highlights": [
                        "Calm hillside ambience",
                        "Good for families",
                        "Reliable breakfast",
                        "Easy access to key points"
                    ]
                },
                {
                    "name": "RTDC Hotel Shikhar (Tourism Dept.)",
                    "address": "Near Bus Stand, Mount Abu, Rajasthan 307501",
                    "website": "#",
                    "averageCost": { "stay": 6500, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Basic, spacious rooms and cottages",
                        "Restaurant and bar (property‑specific)",
                        "Tour assistance (on request)",
                        "Parking and front‑desk"
                    ],
                    "brief": "A government‑run, centrally placed hotel offering simple rooms, straightforward dining, and easy sightseeing access.",
                    "highlights": [
                        "Budget‑friendly city base",
                        "Near transport hubs",
                        "Good for short stopovers",
                        "Practical, no‑frills choice"
                    ]
                }
            ]
        }
    },



    "ajmer": {
        "name": "Ajmer (Rajasthan)",
        "description": "Best stays in Ajmer—premium and midscale hotels near Ajmer Sharif Dargah, Ana Sagar Lake, and the Jaipur–Udaipur highway corridor. Expect clean rooms, reliable dining, event halls, and easy access to Pushkar.",
        "sectionOne": "Ajmer blends Mughal-era heritage and Sufi culture with lakeside promenades and a vibrant bazaar scene. Travellers visit Ajmer Sharif Dargah, Adhai Din Ka Jhopra, Ana Sagar and Foy Sagar Lakes, Taragarh Fort, Nasiyan (Red) Jain Temple, and nearby Pushkar for ghats and the Brahma Temple. City hotels focus on tidy rooms, dependable Wi‑Fi, multi-cuisine dining, and banquet spaces for weddings and conferences—ideal for pilgrimages, family trips, and short corporate visits.",
        "sectionTwo": {
            "text": "Ajmer offers central-city business hotels around Dargah/Station Road, lakeside and Civil Lines addresses, and highway-access properties convenient for Pushkar day trips.",
            "hotels": [
                {
                    "name": "Pratap Mahal, Ajmer – IHCL SeleQtions (Kishangarh corridor)",
                    "address": "Pushkar Bypass, Ajmer, Rajasthan 305022",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Palace-style rooms and suites with balconies (select)",
                        "Multiple restaurants and bar",
                        "Pool, spa services, and fitness",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A resort-style, palace-inspired hotel on the Ajmer–Pushkar corridor with spacious rooms, leisure, and event capacity.",
                    "highlights": [
                        "Quick access to Pushkar",
                        "Family-friendly lawns and pool",
                        "Event-ready venues",
                        "Calm outskirts ambience"
                    ]
                },
                {
                    "name": "The Royal Melange Beacon, Ajmer",
                    "address": "Opp. City Power House, Jaipur Road, Ajmer, Rajasthan 305001",
                    "website": "https://www.beaconhotels.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Modern, centrally located rooms",
                        "Restaurant and room service",
                        "Meeting room",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A practical central-city stay with tidy rooms, easy bazaar access, and compact event space.",
                    "highlights": [
                        "Convenient for Dargah and markets",
                        "Good value for families",
                        "Efficient check‑in/out",
                        "Suitable for short stays"
                    ]
                },
                {
                    "name": "The Fern Residency, Ajmer",
                    "address": "Hathi Kheda, Near IOC Petrol Pump, Jaipur Road, Ajmer 305001",
                    "website": "https://www.fernhotels.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Contemporary rooms with business amenities",
                        "Restaurant and café",
                        "Fitness corner (property-specific)",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "A business-friendly hotel on Jaipur Road with reliable dining and event facilities.",
                    "highlights": [
                        "Highway connectivity",
                        "Steady breakfast options",
                        "Good for corporate trips",
                        "Value-forward pricing"
                    ]
                },
                {
                    "name": "Xenia Palace, Ajmer (Premium Boutique)",
                    "address": "Civil Lines, Near Ana Sagar Lake, Ajmer 305001",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Boutique rooms and suites",
                        "Restaurant and rooftop (property-specific)",
                        "Lawn/courtyard sit-outs",
                        "Small banquet hall"
                    ],
                    "brief": "A boutique, lakeside-access hotel with cosy rooms, scenic dining, and intimate event spaces.",
                    "highlights": [
                        "Near Ana Sagar promenade",
                        "Couple- and family-friendly",
                        "Photo-friendly interiors",
                        "Calm Civil Lines setting"
                    ]
                },
                {
                    "name": "Hotel Merwara Estate (Heritage-Style)",
                    "address": "Near Ana Sagar Lake, Daulat Bagh Road, Ajmer 305001",
                    "website": "#",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Heritage-style rooms and suites",
                        "Restaurant and terrace seating",
                        "Event lawns (property-specific)",
                        "Meeting/banquet rooms"
                    ],
                    "brief": "A grand, heritage-inspired estate near the lake with lawns, classic dining, and event capacity.",
                    "highlights": [
                        "Proximity to lakeside gardens",
                        "Good for socials and weddings",
                        "Spacious, characterful rooms",
                        "Balanced price-to-amenities"
                    ]
                },
                {
                    "name": "Regenta Inn Embassy, Ajmer",
                    "address": "Opp. City Power House, Jaipur Road, Ajmer 305001",
                    "website": "https://www.royalorchidhotels.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Comfortable rooms with essentials",
                        "Restaurant and room service",
                        "Small banquet/meeting hall",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A value business hotel with clean rooms, convenient dining, and compact event space in the city core.",
                    "highlights": [
                        "Easy bazaar/Dargah reach",
                        "Good for short corporate stays",
                        "Budget-friendly categories",
                        "Consistent housekeeping"
                    ]
                },
                {
                    "name": "Pushkar Resorts/Hotels (Ajmer Day-trip Pairing)",
                    "address": "Pushkar, Ajmer District 305022",
                    "website": "#",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Garden/courtyard rooms",
                        "Vegetarian-friendly dining",
                        "Pool/spa (property-specific)",
                        "Event lawns and halls"
                    ],
                    "brief": "Popular Ajmer–Pushkar pairing for pilgrims and families seeking resort ambience near ghats and markets.",
                    "highlights": [
                        "Quick link to Brahma Temple/Ghats",
                        "Great for weekend trips",
                        "Family- and group-friendly",
                        "Indoor–outdoor venues"
                    ]
                }
            ]
        }
    },



    "ranthambore": {
        "name": "Ranthambore (Rajasthan)",
        "description": "Best stays in Ranthambore—jungle lodges, boutique resorts, and luxury retreats near Sawai Madhopur and the park gates (Zones 1–10). Expect safari-friendly services, hearty dining, pools/spas (select), and lawns for bonfires and events.",
        "sectionOne": "Ranthambore, among India’s most renowned tiger reserves, blends a dramatic dry-deciduous landscape with lakes, the 10th‑century Ranthambore Fort, and abundant wildlife. Travellers base themselves in Sawai Madhopur for guided jeep/canter safaris, fort visits, and photo sessions around Padam/Rajbagh/Malik Talabs. Good lodges focus on early-bird breakfasts, reliable Wi‑Fi, naturalist-led experiences, and flexible dining around safari timings—ideal for family holidays, wildlife photography, and small corporate offsites.",
        "sectionTwo": {
            "text": "Ranthambore offers high-end nature retreats, comfortable jungle lodges, and value safari stays around Ranthambore Road and village belts like Khilchipur and Sherpur. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Aman‑i‑Khas, Ranthambore",
                    "address": "Near Ranthambore National Park, Sherpur–Khilchipur belt, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.aman.com/",
                    "averageCost": { "stay": 95000, "dining": { "min": 6000, "max": 15000 } },
                    "facilities": [
                        "Ultra‑luxury tented suites",
                        "Destination dining and campfire evenings",
                        "Spa therapies and private experiences",
                        "Personalised safaris with naturalists"
                    ],
                    "brief": "A secluded, ultra‑luxury camp offering tented grandeur, bespoke dining, and highly curated safari experiences.",
                    "highlights": [
                        "White‑canvas tented suites",
                        "Butler‑style, personalised service",
                        "Private dining under the stars",
                        "Top‑tier naturalist guidance"
                    ]
                },
                {
                    "name": "Suján Sher Bagh, Ranthambore",
                    "address": "Khilchipur, Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.thesujanlife.com/",
                    "averageCost": { "stay": 65000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "Luxury tents and suites",
                        "Farm‑to‑table dining and bar",
                        "Pool and spa",
                        "Curated safaris and craft experiences"
                    ],
                    "brief": "A classic luxury tented camp blending old‑world safari charm with refined dining and conservation‑led experiences.",
                    "highlights": [
                        "Stylish tents with heritage touches",
                        "Signature bush dinners",
                        "Community and conservation ethos",
                        "Excellent guide network"
                    ]
                },
                {
                    "name": "The Oberoi Vanyavilas Wildlife Resort",
                    "address": "Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.oberoihotels.com/",
                    "averageCost": { "stay": 60000, "dining": { "min": 3000, "max": 8000 } },
                    "facilities": [
                        "Luxury tented accommodations",
                        "Fine dining and bar",
                        "Spa, pool, and fitness",
                        "Nature walks and experiences"
                    ],
                    "brief": "A luxury tented resort with elegant dining, serene lawns, and seamless safari coordination near the park.",
                    "highlights": [
                        "Grand tents with plush baths",
                        "Signature Oberoi service",
                        "Beautiful gardens and pool",
                        "Effortless safari logistics"
                    ]
                },
                {
                    "name": "Taj Sawai, Ranthambore (IHCL)",
                    "address": "Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2200, "max": 6000 } },
                    "facilities": [
                        "Rooms/suites with jungle aesthetics",
                        "Multiple dining options and bar",
                        "Pool, spa services, and fitness",
                        "Curated safaris and kids’ activities"
                    ],
                    "brief": "A polished, family‑friendly luxury hotel combining stylish rooms, destination dining, and well‑organized safaris.",
                    "highlights": [
                        "Kid‑friendly programming",
                        "Reliable early‑breakfast setups",
                        "Event‑friendly lawns",
                        "Trusted hospitality brand"
                    ]
                },
                {
                    "name": "Six Senses Fort Barwara (near Ranthambore)",
                    "address": "Chauth Ka Barwara, Sawai Madhopur, Rajasthan 322702",
                    "website": "https://www.sixsenses.com/",
                    "averageCost": { "stay": 55000, "dining": { "min": 3000, "max": 8000 } },
                    "facilities": [
                        "Restored fort suites",
                        "Holistic spa and wellness",
                        "Multiple restaurants and bars",
                        "Excursions and curated day trips"
                    ],
                    "brief": "A beautifully restored fort retreat offering elevated wellness and dining; pairs well with Ranthambore safaris.",
                    "highlights": [
                        "Statement heritage architecture",
                        "Deep wellness programmes",
                        "Stylish pools and terraces",
                        "Premium add‑on to safari trips"
                    ]
                },
                {
                    "name": "The Tigress, Ranthambore",
                    "address": "Near Ranthambore National Park, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.thetigress.co.in/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Spacious rooms and suites",
                        "Restaurants and bar",
                        "Pool, spa, and fitness",
                        "Banquet lawns and hall"
                    ],
                    "brief": "A resort‑style property with roomy suites, good leisure facilities, and event‑ready spaces close to safari zones.",
                    "highlights": [
                        "Family‑friendly leisure",
                        "Reliable breakfast and service",
                        "Event‑friendly layouts",
                        "Good price‑to‑amenities"
                    ]
                },
                {
                    "name": "The Baagh Ananta Elite, Ranthambore",
                    "address": "Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.anantahotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Modern rooms and cottages",
                        "Restaurant and bar",
                        "Pool and spa (select)",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A contemporary jungle‑adjacent resort balancing comfortable rooms, steady dining, and practical event spaces.",
                    "highlights": [
                        "Quick access to park gates",
                        "Consistent housekeeping",
                        "Value‑friendly premium choice",
                        "Good for groups and families"
                    ]
                },
                {
                    "name": "Abhyaran Resort & Spa (WelcomHeritage)",
                    "address": "Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.welcomheritagehotels.in/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Rooms/suites with garden views",
                        "Restaurant and lounge",
                        "Pool and spa (select)",
                        "Banquet lawn/hall"
                    ],
                    "brief": "A comfortable resort with garden‑view rooms, poolside downtime, and compact event options near safari pick‑ups.",
                    "highlights": [
                        "Calm green campus",
                        "Family‑friendly setups",
                        "Popular breakfast options",
                        "Balanced pricing"
                    ]
                },
                {
                    "name": "Jungle Vilas Ranthambore",
                    "address": "Village Khilchipur, Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.junglevilas.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Cottages/rooms with sit‑outs",
                        "Restaurant and café",
                        "Pool and bonfire area",
                        "Small banquet/meeting room"
                    ],
                    "brief": "A value‑forward safari base with clean, spacious cottages, a pool, and easy access to multiple zones.",
                    "highlights": [
                        "Early breakfast for safaris",
                        "Tour desk and logistics help",
                        "Good for groups",
                        "Reliable essentials"
                    ]
                },
                {
                    "name": "Regenta Resort Vanya Mahal, Ranthambore",
                    "address": "Ranthambore Road, Sawai Madhopur, Rajasthan 322001",
                    "website": "https://www.royalorchidhotels.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Palace‑style rooms",
                        "Restaurant and bar",
                        "Pool and lawns",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A palace‑inspired resort with comfortable rooms, lawns, and reliable dining suited to family and corporate stays.",
                    "highlights": [
                        "Good road connectivity",
                        "Event‑friendly spaces",
                        "Consistent service",
                        "Budget‑friendly premium bracket"
                    ]
                }
            ]
        }
    },



    "kaziranga": {
        "name": "Kaziranga (Assam)",
        "description": "Best stays near Kaziranga—jungle lodges, boutique resorts, and comfortable camps around Kohora (Central), Bagori (Western), Agoratoli (Eastern), and Burapahar ranges. Expect safari‑friendly services, hearty dining, pools/spa (select), and lawns for bonfires.",
        "sectionOne": "Kaziranga National Park, a UNESCO World Heritage Site, is famed for the one‑horned rhinoceros, rich birdlife, and floodplain landscapes shaped by the Brahmaputra. Travellers base themselves around Kohora/Bagori for jeep/elephant safaris, birding at beels, and visits to nearby tea estates and ethnic villages. Good lodges prioritize early breakfasts, naturalist‑led activities, reliable Wi‑Fi, and flexible dining around safari timings—ideal for families, wildlife photographers, and small groups.",
        "sectionTwo": {
            "text": "Kaziranga offers nature‑forward lodges and resorts in and around Kohora (NH‑37), Bagori, Agoratoli, and Burapahar. Below are handpicked properties known for location, safari logistics, and steady hospitality.",
            "hotels": [
                {
                    "name": "IORA – The Retreat, Kaziranga",
                    "address": "Kohora, NH‑37, Kaziranga, Assam 785609",
                    "website": "https://www.ioraretreat.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Spacious rooms and suites with garden views",
                        "Multiple restaurants and bar",
                        "Pool, spa services, and fitness (select)",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A popular full‑service resort in Kohora with roomy stays, reliable dining, and event‑ready spaces—great for families and groups.",
                    "highlights": [
                        "Central (Kohora) range access",
                        "Consistent breakfast and service",
                        "Good for multi‑night stays",
                        "Value‑forward premium option"
                    ]
                },
                {
                    "name": "Diphlu River Lodge",
                    "address": "Kuthori (near Central/Bagori belt), Kaziranga, Assam 782136",
                    "website": "https://www.diphluriverlodge.com/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Cottage‑style rooms on the riverside (select)",
                        "Restaurant and lounge deck",
                        "Curated safaris with naturalists",
                        "Boutique event and screening spaces"
                    ],
                    "brief": "A highly regarded boutique lodge with riverfront ambience, thoughtful dining, and expert safari logistics.",
                    "highlights": [
                        "Close to park gates",
                        "Nature‑immersive setting",
                        "Attentive, guided experiences",
                        "Great for couples and photographers"
                    ]
                },
                {
                    "name": "Infinity Resorts Kaziranga",
                    "address": "Bocha Gaon, Kohora, Kaziranga, Assam 785609",
                    "website": "https://www.infinityresorts.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Rooms and cottages amid greenery",
                        "Restaurant and bar",
                        "Pool and spa (select)",
                        "Banquet lawn and meeting room"
                    ],
                    "brief": "A green, resort‑style property with comfortable rooms, steady dining, and easy access to Kohora/Burapahar belts.",
                    "highlights": [
                        "Leafy campus and water features",
                        "Family‑friendly facilities",
                        "Popular breakfast spreads",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Borgos Resort, Kaziranga",
                    "address": "Bagori Gate Road, Kaziranga, Assam 785609",
                    "website": "https://www.borgoskaziranga.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Large rooms near Bagori gate",
                        "Restaurant, bar, and café",
                        "Pool, spa services, and gym",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A sizable resort close to Bagori gate with strong leisure and event capabilities—ideal for groups and families.",
                    "highlights": [
                        "Convenient for Western range",
                        "High‑capacity venues",
                        "Reliable housekeeping",
                        "Good for multi‑night safaris"
                    ]
                },
                {
                    "name": "Wild Mahseer (Balipara, add‑on to Kaziranga circuit)",
                    "address": "Addabarie Tea Estate, Balipara, Sonitpur, Assam 784101",
                    "website": "https://www.wildmahseer.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Heritage plantation bungalows",
                        "Estate dining and tea experiences",
                        "Guided nature and culture trails",
                        "Intimate event lawns"
                    ],
                    "brief": "A tea‑estate heritage retreat often paired with Kaziranga trips, offering slow travel, birding, and plantation life.",
                    "highlights": [
                        "Immersive tea‑country setting",
                        "Culture and birding experiences",
                        "Romantic heritage ambience",
                        "Great post‑safari unwind"
                    ]
                },
                {
                    "name": "Resort Borgos Annex: Budget/Value Wing (Example Category)",
                    "address": "Bagori belt, Kaziranga, Assam 785609",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Clean, functional rooms",
                        "Restaurant access",
                        "Travel/safari assistance",
                        "Meeting room (compact)"
                    ],
                    "brief": "A value‑forward wing for budget‑sensitive travellers who want Bagori proximity and dependable basics.",
                    "highlights": [
                        "Quick access to park gates",
                        "Early‑breakfast support",
                        "Good for short stays",
                        "Reliable essentials"
                    ]
                },
                {
                    "name": "Paltan Bazar/Guwahati Airport Hotels (Transit Pairing)",
                    "address": "Guwahati city and airport corridor, Assam",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Transit‑friendly rooms",
                        "Restaurant and café",
                        "Airport transfers (on request)",
                        "Meeting room"
                    ],
                    "brief": "Useful transit stops before/after Kaziranga; practical for odd‑hour flights and quick city errands.",
                    "highlights": [
                        "Airport/rail connectivity",
                        "Efficient check‑in/out",
                        "Budget‑friendly options",
                        "Good for one‑night stays"
                    ]
                }
            ]
        }
    },


    "shillong": {
        "name": "Shillong (Meghalaya)",
        "description": "Best stays in Shillong—lakeside retreats and premium city hotels around Police Bazar, Laitumkhrah, and Umiam Lake. Expect scenic rooms, cosy lounges, reliable dining, and intimate event spaces.",
        "sectionOne": "Shillong, the Scotland of the East, blends pine‑clad hills, waterfalls, cafés, and music culture. Travellers explore Umiam Lake, Ward’s Lake, Elephant Falls, Shillong Peak, Don Bosco Museum, Cathedral, Police Bazar, and day trips to Cherrapunji/Sohra and Mawlynnong. Hotels emphasize warm rooms, dependable Wi‑Fi, hearty dining, and compact banquets—ideal for family trips, honeymoons, road journeys, and small corporate meets.",
        "sectionTwo": {
            "text": "Shillong features lakeside resorts near Umiam, premium CBD hotels around Police Bazar/Laitumkhrah, and boutique hillside stays on the city fringes.",
            "hotels": [
                {
                    "name": "Ri Kynjai – Serenity by the Lake",
                    "address": "Umiam Lake, Shillong, Meghalaya 793103",
                    "website": "https://www.rikynjai.com/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2200, "max": 6000 } },
                    "facilities": [
                        "Traditional Khasi‑inspired lake‑view rooms",
                        "Destination restaurant and bar",
                        "Spa and wellness",
                        "Lawns and intimate event spaces"
                    ],
                    "brief": "An iconic lakeside resort with serene views, refined dining, and calm, nature‑led ambience.",
                    "highlights": [
                        "Panoramic Umiam vistas",
                        "Khasi architecture accents",
                        "Great for romantic stays",
                        "Boutique weddings/retreats"
                    ]
                },
                {
                    "name": "Courtyard by Marriott Shillong",
                    "address": "Police Bazar/Central Shillong belt, Meghalaya 793001",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4500 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All‑day dining, lounge, and bakery",
                        "Spa, pool (select), and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A premium city hotel with modern rooms, strong dining, and versatile venues near the shopping core.",
                    "highlights": [
                        "Central access to cafés/markets",
                        "Event‑ready floors with AV",
                        "Family‑friendly leisure",
                        "Consistent brand standards"
                    ]
                },
                {
                    "name": "Vivanta Meghalaya, Shillong",
                    "address": "Near Police Bazar, Shillong, Meghalaya 793001",
                    "website": "https://www.vivantahotels.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1700, "max": 4200 } },
                    "facilities": [
                        "Stylish rooms in city centre",
                        "Multiple restaurants and bar",
                        "Fitness centre",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A chic, centrally placed hotel with lively dining, polished service, and practical event spaces.",
                    "highlights": [
                        "Walkable to shops and sights",
                        "Efficient check‑in/out",
                        "Good breakfast options",
                        "Ideal for business and families"
                    ]
                },
                {
                    "name": "Hotel Polo Towers Shillong",
                    "address": "Oakland Road, Near Polo Grounds, Shillong, Meghalaya 793001",
                    "website": "https://www.hotelpolotowers.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1300, "max": 3200 } },
                    "facilities": [
                        "Comfortable rooms near city attractions",
                        "Restaurants, bakery, and bar",
                        "Rooftop/terrace dining (property‑specific)",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A long‑trusted city hotel with dependable rooms, diverse dining, and compact event facilities.",
                    "highlights": [
                        "Easy reach to Police Bazar",
                        "Popular breakfast and bakery",
                        "Good for group stays",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "The Heritage Club – Tripura Castle",
                    "address": "Tripura Castle Road, Cleve Colony, Shillong, Meghalaya 793003",
                    "website": "https://www.tripuracastle.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Heritage rooms and suites",
                        "Restaurants, bar, and lawns",
                        "Bonfire corners (seasonal)",
                        "Intimate event halls"
                    ],
                    "brief": "A heritage‑style hillside stay with vintage charm, leafy lawns, and cosy dining spaces.",
                    "highlights": [
                        "Characterful interiors",
                        "Calm, green surroundings",
                        "Photo‑friendly corners",
                        "Great for relaxed breaks"
                    ]
                },
                {
                    "name": "La Nicholas – Lake View (by Summit Hotels)",
                    "address": "Near Umiam Lake approach, Shillong, Meghalaya 793103",
                    "website": "https://www.summithotels.in/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Rooms with lake/hill glimpses (select)",
                        "Restaurant and café",
                        "Activity corner (property‑specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A value‑forward lakeside‑approach hotel with scenic rooms and straightforward dining.",
                    "highlights": [
                        "Access to Umiam viewpoints",
                        "Family‑friendly categories",
                        "Reliable housekeeping",
                        "Good base for day trips"
                    ]
                },
                {
                    "name": "Windermere Resorts (Shillong/Cherrapunji belt)",
                    "address": "Shillong–Sohra corridor, Meghalaya 793108",
                    "website": "#",
                    "averageCost": { "stay": 10000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Hillside rooms and cottages",
                        "Restaurant and lounge",
                        "Bonfire/activities (seasonal)",
                        "Event room (property‑specific)"
                    ],
                    "brief": "A hillside resort option across the Shillong–Sohra belt with cosy rooms and nature‑rich surroundings.",
                    "highlights": [
                        "Good access to waterfalls/valleys",
                        "Kid‑friendly leisure",
                        "Value pricing",
                        "Suitable for groups"
                    ]
                }
            ]
        }
    },



    "cherrapunji-mawsynram": {
        "name": "Cherrapunji (Sohra) & Mawsynram (Meghalaya)",
        "description": "Best stays around Cherrapunji and Mawsynram—hillside resorts, eco‑retreats, and boutique cottages near living root bridges, waterfalls, and caves. Expect rainforest views, cosy rooms, hearty dining, and spaces for retreats and small events.",
        "sectionOne": "Cherrapunji and Mawsynram, among the wettest places on earth, offer cloud forests, living root bridges, dramatic waterfalls, limestone caves, and sweeping valley views. Travellers explore Double‑Decker Living Root Bridge (Nongriat), Nohkalikai Falls, Seven Sisters (Nohsngithiang) Falls, Mawsmai/Arwah caves, Mawkdok–Dympep Valley, and Mawsynram’s Mawjymbuin Cave and sacred groves. Stays prioritize warm rooms, dehumidified indoor spaces, homely and local cuisine, guided treks, and flexible dining around hiking schedules—ideal for nature lovers, families, and wellness/yoga retreats.",
        "sectionTwo": {
            "text": "The belt features cosy hill resorts near Sohra market, quiet cottages around Tyrna/Laitkynsew trailheads, and simple scenic stays towards Mawsynram’s caves and viewpoints.",
            "hotels": [
                {
                    "name": "Polo Orchid Resort, Cherrapunji",
                    "address": "Nohsngithiang (Seven Sisters) Falls View, Sohra (Cherrapunji), Meghalaya 793108",
                    "website": "https://www.hotelpolotowers.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2000, "max": 5200 } },
                    "facilities": [
                        "Valley/waterfall‑view rooms and cottages",
                        "Restaurant, bar, and bonfire deck",
                        "Infinity pool (seasonal/select)",
                        "Banquet lawn and meeting room"
                    ],
                    "brief": "A view‑led resort overlooking the canyons and falls, with cosy rooms, scenic decks, and event‑friendly lawns.",
                    "highlights": [
                        "Seven Sisters Falls vistas (seasonal)",
                        "Great for couples and families",
                        "Sunset decks and bonfires",
                        "Good base for Sohra sights"
                    ]
                },
                {
                    "name": "Cherrapunjee Holiday Resort",
                    "address": "Laitkynsew Village (near Nongriat trail), Sohra, Meghalaya 793108",
                    "website": "https://www.cherrapunjee.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Simple, tidy rooms with valley views (select)",
                        "Home‑style restaurant",
                        "Trek assistance to root bridges",
                        "Guided local experiences"
                    ],
                    "brief": "A friendly trekker‑hub with homely meals and easy access to the Double‑Decker Living Root Bridge trail.",
                    "highlights": [
                        "Trailhead convenience",
                        "Local guides and tips",
                        "Ideal for nature walks",
                        "Value‑forward simplicity"
                    ]
                },
                {
                    "name": "Jiva Resort, Cherrapunji",
                    "address": "Sohra–Shella Road belt, Cherrapunji, Meghalaya 793108",
                    "website": "https://jivaresorts.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Modern rooms with valley glimpses",
                        "Restaurant and café",
                        "Bonfire area (seasonal)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A contemporary hillside stay with bright rooms, steady dining, and easy access to caves and viewpoints.",
                    "highlights": [
                        "Convenient Sohra access",
                        "Family‑friendly setups",
                        "Popular breakfast",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Saimika Park & Resort",
                    "address": "Sohra (Cherrapunji) town approach, Meghalaya 793108",
                    "website": "https://saimikaresort.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Cottages and rooms in green campus",
                        "Restaurant and picnic lawns",
                        "Children’s play zone",
                        "Event lawn (property‑specific)"
                    ],
                    "brief": "A relaxed, green‑campus resort with family‑friendly lawns and simple, hearty meals near town.",
                    "highlights": [
                        "Open grounds for kids",
                        "Good base for day trips",
                        "Easy parking and access",
                        "Value‑friendly choice"
                    ]
                },
                {
                    "name": "Roinam Retreat (Boutique)",
                    "address": "Tyrna/Laitkynsew trail belt, Cherrapunji 793108",
                    "website": "#",
                    "averageCost": { "stay": 11000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Boutique rooms with balconies (select)",
                        "Café with local/satvik options",
                        "Trek/guide coordination",
                        "Small event room"
                    ],
                    "brief": "A boutique hideaway for hikers with balcony rooms, simple wholesome food, and quick trail access.",
                    "highlights": [
                        "Close to root‑bridge treks",
                        "Quiet, nature‑rich setting",
                        "Great for couples and friends",
                        "Good price‑to‑comfort"
                    ]
                },
                {
                    "name": "Lawbah Homestays (Mawsynram Belt – Example Category)",
                    "address": "Mawsynram village belt, East Khasi Hills, Meghalaya 793113",
                    "website": "#",
                    "averageCost": { "stay": 6000, "dining": { "min": 700, "max": 1800 } },
                    "facilities": [
                        "Clean rooms with village/valley views",
                        "Home‑cooked Khasi meals",
                        "Local guide connect",
                        "Parking and assistance"
                    ],
                    "brief": "Simple, welcoming village homestays for authentic Mawsynram experiences close to caves and viewpoints.",
                    "highlights": [
                        "Great for slow travel",
                        "Cultural immersion",
                        "Budget‑friendly comfort",
                        "Ideal for small groups"
                    ]
                },
                {
                    "name": "Mawjymbuin Cave Cottages (Example Category)",
                    "address": "Near Mawjymbuin Cave, Mawsynram, Meghalaya 793113",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Rustic cottages close to cave",
                        "Simple dining arrangements",
                        "Guided cave and forest walks",
                        "Bonfire (seasonal)"
                    ],
                    "brief": "Rustic, cave‑side cottages that put Mawsynram’s karst formations and sacred forest walks within easy reach.",
                    "highlights": [
                        "Nature‑immersive setting",
                        "Great for explorers",
                        "Quiet, offbeat ambience",
                        "Good for overnights on circuit"
                    ]
                }
            ]
        }
    },




    "cherrapunji_mawsynram": {
        "name": "Cherrapunji (Sohra) & Mawsynram (Meghalaya)",
        "description": "Best stays around Cherrapunji and Mawsynram—hillside resorts, eco‑retreats, and boutique cottages near living root bridges, waterfalls, and caves. Expect rainforest views, cosy rooms, hearty dining, and spaces for retreats and small events.",
        "sectionOne": "Cherrapunji and Mawsynram, among the wettest places on earth, offer cloud forests, living root bridges, dramatic waterfalls, limestone caves, and sweeping valley views. Travellers explore Double‑Decker Living Root Bridge (Nongriat), Nohkalikai Falls, Seven Sisters (Nohsngithiang) Falls, Mawsmai/Arwah caves, Mawkdok–Dympep Valley, and Mawsynram’s Mawjymbuin Cave and sacred groves. Stays prioritize warm rooms, dehumidified indoor spaces, homely and local cuisine, guided treks, and flexible dining around hiking schedules—ideal for nature lovers, families, and wellness/yoga retreats.",
        "sectionTwo": {
            "text": "The belt features cosy hill resorts near Sohra market, quiet cottages around Tyrna/Laitkynsew trailheads, and simple scenic stays towards Mawsynram’s caves and viewpoints.",
            "hotels": [
                {
                    "name": "Polo Orchid Resort, Cherrapunji",
                    "address": "Nohsngithiang (Seven Sisters) Falls View, Sohra (Cherrapunji), Meghalaya 793108",
                    "website": "https://www.hotelpolotowers.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2000, "max": 5200 } },
                    "facilities": [
                        "Valley/waterfall‑view rooms and cottages",
                        "Restaurant, bar, and bonfire deck",
                        "Infinity pool (seasonal/select)",
                        "Banquet lawn and meeting room"
                    ],
                    "brief": "A view‑led resort overlooking the canyons and falls, with cosy rooms, scenic decks, and event‑friendly lawns.",
                    "highlights": [
                        "Seven Sisters Falls vistas (seasonal)",
                        "Great for couples and families",
                        "Sunset decks and bonfires",
                        "Good base for Sohra sights"
                    ]
                },
                {
                    "name": "Cherrapunjee Holiday Resort",
                    "address": "Laitkynsew Village (near Nongriat trail), Sohra, Meghalaya 793108",
                    "website": "https://www.cherrapunjee.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Simple, tidy rooms with valley views (select)",
                        "Home‑style restaurant",
                        "Trek assistance to root bridges",
                        "Guided local experiences"
                    ],
                    "brief": "A friendly trekker‑hub with homely meals and easy access to the Double‑Decker Living Root Bridge trail.",
                    "highlights": [
                        "Trailhead convenience",
                        "Local guides and tips",
                        "Ideal for nature walks",
                        "Value‑forward simplicity"
                    ]
                },
                {
                    "name": "Jiva Resort, Cherrapunji",
                    "address": "Sohra–Shella Road belt, Cherrapunji, Meghalaya 793108",
                    "website": "https://jivaresorts.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Modern rooms with valley glimpses",
                        "Restaurant and café",
                        "Bonfire area (seasonal)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A contemporary hillside stay with bright rooms, steady dining, and easy access to caves and viewpoints.",
                    "highlights": [
                        "Convenient Sohra access",
                        "Family‑friendly setups",
                        "Popular breakfast",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Saimika Park & Resort",
                    "address": "Sohra (Cherrapunji) town approach, Meghalaya 793108",
                    "website": "https://saimikaresort.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Cottages and rooms in green campus",
                        "Restaurant and picnic lawns",
                        "Children’s play zone",
                        "Event lawn (property‑specific)"
                    ],
                    "brief": "A relaxed, green‑campus resort with family‑friendly lawns and simple, hearty meals near town.",
                    "highlights": [
                        "Open grounds for kids",
                        "Good base for day trips",
                        "Easy parking and access",
                        "Value‑friendly choice"
                    ]
                },
                {
                    "name": "Roinam Retreat (Boutique)",
                    "address": "Tyrna/Laitkynsew trail belt, Cherrapunji 793108",
                    "website": "#",
                    "averageCost": { "stay": 11000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Boutique rooms with balconies (select)",
                        "Café with local/satvik options",
                        "Trek/guide coordination",
                        "Small event room"
                    ],
                    "brief": "A boutique hideaway for hikers with balcony rooms, simple wholesome food, and quick trail access.",
                    "highlights": [
                        "Close to root‑bridge treks",
                        "Quiet, nature‑rich setting",
                        "Great for couples and friends",
                        "Good price‑to‑comfort"
                    ]
                },
                {
                    "name": "Lawbah Homestays (Mawsynram Belt – Example Category)",
                    "address": "Mawsynram village belt, East Khasi Hills, Meghalaya 793113",
                    "website": "#",
                    "averageCost": { "stay": 6000, "dining": { "min": 700, "max": 1800 } },
                    "facilities": [
                        "Clean rooms with village/valley views",
                        "Home‑cooked Khasi meals",
                        "Local guide connect",
                        "Parking and assistance"
                    ],
                    "brief": "Simple, welcoming village homestays for authentic Mawsynram experiences close to caves and viewpoints.",
                    "highlights": [
                        "Great for slow travel",
                        "Cultural immersion",
                        "Budget‑friendly comfort",
                        "Ideal for small groups"
                    ]
                },
                {
                    "name": "Mawjymbuin Cave Cottages (Example Category)",
                    "address": "Near Mawjymbuin Cave, Mawsynram, Meghalaya 793113",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Rustic cottages close to cave",
                        "Simple dining arrangements",
                        "Guided cave and forest walks",
                        "Bonfire (seasonal)"
                    ],
                    "brief": "Rustic, cave‑side cottages that put Mawsynram’s karst formations and sacred forest walks within easy reach.",
                    "highlights": [
                        "Nature‑immersive setting",
                        "Great for explorers",
                        "Quiet, offbeat ambience",
                        "Good for overnights on circuit"
                    ]
                }
            ]
        }
    },




    "majuli": {
        "name": "Majuli (Assam)",
        "description": "Best stays in Majuli—eco-homestays, bamboo cottages, and boutique retreats near satras (Vaishnavite monasteries) and riverside villages. Expect simple, clean rooms, local cuisine, cultural walks, and guided boat/ferry logistics.",
        "sectionOne": "Majuli, one of the world’s largest river islands on the Brahmaputra, is known for its satra culture, mask-making traditions, migratory birds, and quiet village life. Travellers visit Kamalabari, Auniati, Dakhinpat, and Samaguri (mask-makers) satras; explore wetlands for birding; and experience pottery, weaving, and Mishing tribal hamlets. Stays focus on warmth and authenticity—clean rooms, homely Assamese meals, bicycle/boat arrangements, and village guides—ideal for slow travel, families, backpackers, and culture enthusiasts.",
        "sectionTwo": {
            "text": "Majuli primarily offers homestays and small, eco-forward lodges around Garamur, Kamalabari, and near key satras, plus a handful of cottage resorts on quiet village roads.",
            "hotels": [
                {
                    "name": "Okegiga Homes (Eco Homestay)",
                    "address": "Near Garamur/Kamalabari belt, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 2200, "dining": { "min": 300, "max": 800 } },
                    "facilities": [
                        "Simple bamboo/wood cottages",
                        "Home-cooked Assamese meals",
                        "Bicycle rentals and tour help",
                        "Village/river walks"
                    ],
                    "brief": "A beloved eco-homestay offering clean cottages, friendly hosts, and easy access to satras and village life.",
                    "highlights": [
                        "Authentic local hospitality",
                        "Good base for culture trails",
                        "Budget-friendly comfort",
                        "Great for backpackers/slow travel"
                    ]
                },
                {
                    "name": "La Maison de Ananda",
                    "address": "Kamalabari–Garamur corridor, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 2500, "dining": { "min": 400, "max": 900 } },
                    "facilities": [
                        "Traditional bamboo cottages",
                        "Community-style dining",
                        "Cultural and craft link-ups",
                        "Bicycle/boat assistance"
                    ],
                    "brief": "A long-standing traveler favorite with rustic cottages, communal dining, and strong community connections.",
                    "highlights": [
                        "Cultural immersion focus",
                        "Close to satra circuits",
                        "Warm hosts and guidance",
                        "Good for small groups"
                    ]
                },
                {
                    "name": "Eco-Camp Me:Po Okum (Happy House)",
                    "address": "Village belt near satras, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 2200, "dining": { "min": 350, "max": 800 } },
                    "facilities": [
                        "Bamboo huts and simple rooms",
                        "Homely local meals",
                        "Folk craft/music connects",
                        "Birding and village walks"
                    ],
                    "brief": "A nature-led campstay with airy bamboo huts, homestyle food, and easy access to crafts and birding spots.",
                    "highlights": [
                        "Quiet, green setting",
                        "Friendly owners",
                        "Good for budget travelers",
                        "Ideal for nature lovers"
                    ]
                },
                {
                    "name": "Ygdrasill Bamboo Cottage",
                    "address": "Garamur side villages, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 2500, "dining": { "min": 400, "max": 900 } },
                    "facilities": [
                        "Bamboo cottages with sit-outs",
                        "Assamese/tribal cuisine",
                        "Cycle hire and local tours",
                        "Campfire (seasonal)"
                    ],
                    "brief": "Cosy bamboo cottages with simple comforts, hearty meals, and helpful hosts—great for relaxed stays.",
                    "highlights": [
                        "Village ambience",
                        "Handy for satra visits",
                        "Good value",
                        "Suitable for friends/families"
                    ]
                },
                {
                    "name": "Ayang Okum Riverbank Bamboo Cottages",
                    "address": "Riverside hamlet, near Garamur, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 3200, "dining": { "min": 500, "max": 1000 } },
                    "facilities": [
                        "Riverbank bamboo cottages",
                        "Farm-to-table meals (simple)",
                        "Fishing/boat experiences",
                        "Village crafts and weaving"
                    ],
                    "brief": "Riverside bamboo cottages emphasizing sustainability, local food, and hands-on village experiences.",
                    "highlights": [
                        "Peaceful river setting",
                        "Craft and culture workshops",
                        "Great for photographers",
                        "Authentic rural vibe"
                    ]
                },
                {
                    "name": "Maheswar Land (Eco Cottages)",
                    "address": "Garamur area, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 1800, "dining": { "min": 350, "max": 800 } },
                    "facilities": [
                        "Bamboo/cane cottages in greenery",
                        "Local meals on request",
                        "Pond and nature walks",
                        "Guide/transport assistance"
                    ],
                    "brief": "Green, peaceful cottages with friendly hosts, homely food, and easy access to satras and birding sites.",
                    "highlights": [
                        "Budget-friendly, calm",
                        "Family-run hospitality",
                        "Good for multi-night stays",
                        "Simple and clean"
                    ]
                },
                {
                    "name": "Borluit Bamboo Cottage",
                    "address": "Village belt, Majuli, Assam 785104",
                    "website": "#",
                    "averageCost": { "stay": 2200, "dining": { "min": 350, "max": 900 } },
                    "facilities": [
                        "Basic bamboo cottages",
                        "Home-style Assamese meals",
                        "Local guide access",
                        "Bicycle rentals"
                    ],
                    "brief": "Straightforward bamboo stays with warm hosts and handy links to satra and craft circuits.",
                    "highlights": [
                        "Good for backpackers",
                        "Close to key villages",
                        "Clean, no-frills",
                        "Great value"
                    ]
                }
            ]
        }
    },



    "pondicherry": {
        "name": "Pondicherry (Puducherry)",
        "description": "Best stays in Pondicherry—heritage boutiques in White Town, beach/lagoon resorts on ECR, and premium city hotels near MG Road. Enjoy French‑quarter charm, refined dining, pools/spas (select), and event spaces.",
        "sectionOne": "Pondicherry blends French‑colonial architecture, seaside promenades, cafés, and Tamil‑Creole culture. Travellers explore White Town (Promenade, Notre Dame des Anges), Aurobindo Ashram, Auroville, Serenity/Paradise Beaches, Goubert Avenue, and Bharathi Park. Hotels focus on clean, design‑forward rooms, dependable Wi‑Fi, destination dining, and compact to large banquets—ideal for romantic getaways, family holidays, and chic city breaks.",
        "sectionTwo": {
            "text": "Pondicherry features heritage hotels in White Town, premium beach and backwater resorts along the ECR/Cuddalore corridor, and reliable business hotels around MG Road/mission street. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Radisson Resort Pondicherry Bay",
                    "address": "Arikamedu, Chinna Veerampattinam, Puducherry 605007",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5500 } },
                    "facilities": [
                        "Villa‑style rooms near the backwaters/beach belt",
                        "Multiple restaurants and bar",
                        "Pool, spa, and fitness",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A resort‑style property on the lagoon/beach belt with roomy villas, lively dining, and event‑ready venues.",
                    "highlights": [
                        "Quick reach to beaches and White Town",
                        "Family‑friendly leisure",
                        "Popular brunches",
                        "Good for weddings and offsites"
                    ]
                },
                {
                    "name": "Le Pondy – Beach & Lake Resort",
                    "address": "No. 3, Lake View Road, Nallvadu, Puducherry 605007",
                    "website": "https://www.lepondy.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Rooms and villas facing sea/backwaters",
                        "Restaurant and bar",
                        "Pool and spa",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A beachfront‑and‑backwater resort offering scenic villas, relaxed dining, and photo‑friendly common spaces.",
                    "highlights": [
                        "Dual waterbody setting",
                        "Great for couples and families",
                        "Resort ambience",
                        "Event‑friendly lawns"
                    ]
                },
                {
                    "name": "Ocean Spray, Pondicherry",
                    "address": "7, 8th Cross, ECR, Manjakuppam, Puducherry 605007",
                    "website": "https://www.oceanspray.in/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Lagoon‑side rooms and villas (select with plunge pool)",
                        "Multiple restaurants and bar",
                        "Large pool and spa",
                        "Ballrooms and lawns"
                    ],
                    "brief": "A lagoon‑centric resort on the ECR with villa categories, big pool, and sizable event infrastructure.",
                    "highlights": [
                        "ECR connectivity",
                        "Good for destination weddings",
                        "Family‑friendly",
                        "Popular F&B"
                    ]
                },
                {
                    "name": "Accord Puducherry",
                    "address": "No. 1, Thilagar Nagar, Ellaipillaichavady, Puducherry 605009",
                    "website": "https://www.theaccordhotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Contemporary city rooms and suites",
                        "All‑day dining and bar",
                        "Pool, spa, and fitness",
                        "Banquet halls and meeting rooms"
                    ],
                    "brief": "A polished city hotel with dependable rooms, strong dining, and event‑friendly spaces near the central belt.",
                    "highlights": [
                        "Easy access to White Town",
                        "Reliable breakfast",
                        "Good for business and families",
                        "Value‑forward premium pick"
                    ]
                },
                {
                    "name": "Palais de Mahe – CGH Earth",
                    "address": "4/8, Rue Bussy, White Town, Puducherry 605001",
                    "website": "https://www.cghearth.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Heritage‑style rooms around courtyard",
                        "Restaurant, café, and bar",
                        "Courtyard pool",
                        "Small event/meeting room"
                    ],
                    "brief": "An elegant White Town heritage‑style hotel with courtyard pool, classic dining, and walkable sightseeing.",
                    "highlights": [
                        "Steps to Promenade and cafés",
                        "Colonial character",
                        "Intimate events",
                        "Great for romantic breaks"
                    ]
                },
                {
                    "name": "Maison Perumal – CGH Earth",
                    "address": "New 44, Old 58, Perumal Koil Street, Puducherry 605001",
                    "website": "https://www.cghearth.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Chettiar townhouse‑style heritage rooms",
                        "Restaurant and lounge",
                        "Courtyard sit‑outs",
                        "Boutique event room"
                    ],
                    "brief": "A restored heritage residence blending Tamil and French influences with intimate dining and calm courtyards.",
                    "highlights": [
                        "Immersive heritage vibe",
                        "Walkable to sights",
                        "Curated local cuisine",
                        "Ideal for couples"
                    ]
                },
                {
                    "name": "The Promenade, Pondicherry",
                    "address": "23, Goubert Ave, White Town, Puducherry 605001",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Sea‑facing rooms (select)",
                        "Rooftop/sea‑view dining and bar",
                        "Small pool (property‑specific)",
                        "Event/meeting room"
                    ],
                    "brief": "A seafront city hotel with promenade access, buzzy dining, and compact leisure facilities.",
                    "highlights": [
                        "On the seaside boulevard",
                        "Great sunset dining",
                        "Walkable to White Town lanes",
                        "Good for short city stays"
                    ]
                },
                {
                    "name": "Club Mahindra Puducherry",
                    "address": "No. 200, Valluvar Medu, Manapattu, Puducherry 607402",
                    "website": "https://www.clubmahindra.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Beach‑side resort rooms and villas",
                        "Restaurants and bar",
                        "Large pool, spa, and activities",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A spacious beach resort outside the city core with family‑friendly leisure and event capacity.",
                    "highlights": [
                        "Quiet beachfront setting",
                        "Activities for kids",
                        "Good for longer stays",
                        "Resort‑style amenities"
                    ]
                },
                {
                    "name": "Lagoon Sarovar Premiere Resort, Pondicherry",
                    "address": "R.S. No. 203/4A, 203/4B, Chinna Kudi Road, Puducherry 605007",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Lagoon‑side rooms and suites",
                        "Restaurants and bar",
                        "Pool, spa, and fitness",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A contemporary lagoon‑side resort offering polished rooms, robust dining, and event‑ready venues.",
                    "highlights": [
                        "Waterside ambience",
                        "Family‑friendly",
                        "Event‑friendly infrastructure",
                        "Convenient ECR access"
                    ]
                }
            ]
        }
    },



    "kanyakumari": {
        "name": "Kanyakumari (Tamil Nadu)",
        "description": "Best stays in Kanyakumari—sea‑facing hotels and practical city stays near the beach promenade, Vivekananda Rock jetty, and Suchindram corridor. Expect clean rooms, reliable dining, rooftop/terrace views, and compact event spaces.",
        "sectionOne": "Kanyakumari, India’s southern tip at the confluence of the Arabian Sea, Bay of Bengal, and Indian Ocean, blends coastal panoramas with spiritual and cultural landmarks. Travellers visit Vivekananda Rock Memorial, Thiruvalluvar Statue, Kumari Amman Temple, Mahatma Gandhi Mandapam, Vattakottai Fort, and nearby waterfalls/bridges like Thirparappu and Mathoor Aqueduct. Hotels focus on sea‑view rooms, walkable access to the jetty/promenade, dependable Wi‑Fi, multi‑cuisine dining, and compact banquets—ideal for pilgrimages, family trips, and sunrise/sunset seekers.",
        "sectionTwo": {
            "text": "Kanyakumari offers promenade‑side sea‑view hotels, central town stays near the temple and market lanes, and highway‑access properties convenient for day trips to Suchindram, Padmanabhapuram, and nearby beaches.",
            "hotels": [
                {
                    "name": "Sparsa Resort Kanyakumari",
                    "address": "Near Sunset Point, Beach Road, Kanyakumari, Tamil Nadu 629702",
                    "website": "#",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Sea‑facing rooms (select)",
                        "Restaurant and café",
                        "Pool and fitness room",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A sea‑view resort‑style hotel near the promenade with comfortable rooms, steady dining, and leisure facilities.",
                    "highlights": [
                        "Walkable to viewpoints",
                        "Family‑friendly amenities",
                        "Popular breakfast spreads",
                        "Good for weekend stays"
                    ]
                },
                {
                    "name": "Hotel Sea View",
                    "address": "East Car Street, Near Beach, Kanyakumari, Tamil Nadu 629702",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Rooms with sea/temple glimpses (select)",
                        "Restaurant and room service",
                        "Rooftop/terrace sit‑outs (property‑specific)",
                        "Small banquet room"
                    ],
                    "brief": "A practical sea‑adjacent hotel offering tidy rooms, easy jetty access, and rooftop viewpoints.",
                    "highlights": [
                        "Close to jetty and temple",
                        "Good value for families",
                        "Efficient check‑in/out",
                        "Great for sunrise/sunset runs"
                    ]
                },
                {
                    "name": "Sangam Hotel Kanyakumari",
                    "address": "5/22, Main Road, Kanyakumari, Tamil Nadu 629702",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Clean, central rooms",
                        "Vegetarian/non‑veg restaurant",
                        "Parking and travel desk",
                        "Meeting room"
                    ],
                    "brief": "A centrally located value hotel with straightforward rooms, dependable dining, and easy market access.",
                    "highlights": [
                        "Close to bazaar/promenade",
                        "Budget‑friendly",
                        "Family‑oriented service",
                        "Handy for short stays"
                    ]
                },
                {
                    "name": "Annai Resorts & Spa (Seaside Belt)",
                    "address": "Beach/Poompuhar Road belt, Kanyakumari, Tamil Nadu 629702",
                    "website": "#",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Sea‑proximate rooms (select views)",
                        "Restaurant and lounge",
                        "Spa services (property‑specific)",
                        "Banquet/meeting space"
                    ],
                    "brief": "A seaside‑belt hotel balancing scenic proximity with comfy rooms, spa options, and event‑friendly spaces.",
                    "highlights": [
                        "Promenade access",
                        "Relaxed leisure vibe",
                        "Couple‑ and family‑friendly",
                        "Good price‑to‑amenities"
                    ]
                },
                {
                    "name": "Hotel Seashore",
                    "address": "East Car Street, Near Sunrise Viewpoint, Kanyakumari 629702",
                    "website": "#",
                    "averageCost": { "stay": 10000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Sea‑view rooms (select balconies)",
                        "Restaurant and café",
                        "Rooftop viewing deck (select)",
                        "Small banquet room"
                    ],
                    "brief": "A sea‑facing, promenade‑side hotel with rooftop views, tidy rooms, and reliable dining near major sights.",
                    "highlights": [
                        "Great sunrise/sunset angles",
                        "Easy jetty/temple reach",
                        "Consistent housekeeping",
                        "Good for short city breaks"
                    ]
                },
                {
                    "name": "The Gopinivas Grand",
                    "address": "East Car Street, Kanyakumari, Tamil Nadu 629702",
                    "website": "#",
                    "averageCost": { "stay": 8000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Comfortable central rooms",
                        "Multi‑cuisine restaurant",
                        "Travel desk",
                        "Meeting room"
                    ],
                    "brief": "A well‑located town hotel with clean rooms, steady dining, and quick access to the promenade and markets.",
                    "highlights": [
                        "Walkable to key points",
                        "Budget‑friendly premium",
                        "Popular set breakfasts",
                        "Transit‑friendly"
                    ]
                },
                {
                    "name": "Anantya by the Lake (Day‑trip pairing)",
                    "address": "Chittar Lake, Kaliel Village, Kanyakumari District 629153",
                    "website": "#",
                    "averageCost": { "stay": 16000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Lake‑view villas/rooms",
                        "Restaurant and bar",
                        "Spa and pool",
                        "Lawns and intimate event spaces"
                    ],
                    "brief": "A tranquil lakeside retreat in the district—popular pairing with Kanyakumari for nature‑rich downtime.",
                    "highlights": [
                        "Serene lake setting",
                        "Wellness‑friendly",
                        "Romantic ambience",
                        "Great for weekenders"
                    ]
                }
            ]
        }
    },




    "mahabalipuram": {
        "name": "Mahabalipuram (Mamallapuram), Tamil Nadu",
        "description": "Best stays in Mahabalipuram—beachfront resorts and premium hotels near Shore Temple, Pancha Rathas, and ECR. Expect sea‑view rooms (select), refined dining, pools/spas, and event spaces for weddings and offsites.",
        "sectionOne": "Mahabalipuram, a UNESCO World Heritage town on the Coromandel Coast, is famed for 7th–8th century Pallava rock‑cut temples and bas‑reliefs, sandy beaches, and seafood cafés. Travellers explore Shore Temple, Pancha Rathas, Arjuna’s Penance (Descent of the Ganges), Varaha/ Mahishasuramardini cave temples, Lighthouse, Tiger Cave, and Crocodile Bank on the ECR. Hotels focus on comfortable rooms, dependable Wi‑Fi, destination dining, and indoor‑outdoor banquets—ideal for family trips, cultural getaways, beach weddings, and corporate retreats.",
        "sectionTwo": {
            "text": "Mahabalipuram features luxury beach resorts, family‑friendly coastal hotels, and practical ECR properties with quick access to monuments and the seaside.",
            "hotels": [
                {
                    "name": "Radisson Blu Resort Temple Bay Mamallapuram",
                    "address": "57, Kovalam Road, Mahabalipuram, Tamil Nadu 603104",
                    "website": "https://www.radissonhotels.com/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2500, "max": 6500 } },
                    "facilities": [
                        "Sea‑facing/ garden villas and rooms",
                        "Multiple restaurants and bars",
                        "Large pools, spa, and fitness",
                        "Expansive lawns and ballrooms"
                    ],
                    "brief": "A flagship beachfront resort with sprawling pools, varied dining, and grand wedding/event venues near Shore Temple.",
                    "highlights": [
                        "Direct beach access",
                        "Family‑friendly leisure",
                        "Convention‑scale spaces",
                        "Quick reach to monuments"
                    ]
                },
                {
                    "name": "Chariot Beach Resort Mahabalipuram",
                    "address": "Five Rathas Road, Mahabalipuram, Tamil Nadu 603104",
                    "website": "https://www.chariotbeachresorts.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Rooms/cottages near private beach strip",
                        "Restaurant, bar, and café",
                        "Pool, spa, and fitness",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A beach‑side resort close to Pancha Rathas offering roomy stays, steady dining, and big lawns for celebrations.",
                    "highlights": [
                        "Easy access to Five Rathas",
                        "Sunrise beach walks",
                        "Wedding‑friendly grounds",
                        "Good for family stays"
                    ]
                },
                {
                    "name": "Welcomhotel by ITC Hotels, Kences Palm Beach",
                    "address": "No. 530, SH 49 (ECR), Mahabalipuram, Tamil Nadu 603104",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Sea‑facing rooms and suites",
                        "Signature restaurants and bar",
                        "Pool, spa services, and gym",
                        "Event lawns and banquet halls"
                    ],
                    "brief": "A refined beachfront hotel with sea‑view rooms, signature dining, and polished event operations on the ECR.",
                    "highlights": [
                        "On the beach belt",
                        "Responsible Luxury ethos (brand)",
                        "Great for weddings/retreats",
                        "Convenient ECR connectivity"
                    ]
                },
                {
                    "name": "InterContinental Chennai Mahabalipuram Resort",
                    "address": "No. 212, East Coast Road, Nemelli, Chennai 603104",
                    "website": "https://www.ihg.com/",
                    "averageCost": { "stay": 28000, "dining": { "min": 2500, "max": 6500 } },
                    "facilities": [
                        "Courtyard/sea‑proximate rooms and suites",
                        "Destination restaurants and bar",
                        "Pool, spa, and fitness studio",
                        "Ballrooms, lawns, and courtyards"
                    ],
                    "brief": "A serene, design‑driven coastal resort on ECR offering elegant rooms, acclaimed dining, and upscale event spaces.",
                    "highlights": [
                        "Quiet coastal stretch",
                        "Popular Sunday brunches",
                        "Wedding‑ready venues",
                        "Easy drive to monuments"
                    ]
                },
                {
                    "name": "Four Points by Sheraton Mahabalipuram Resort & Convention Center",
                    "address": "ECR‑OMR Junction, ECR, Poonjeri, Mahabalipuram 603104",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Modern rooms and family suites",
                        "All‑day dining and bar",
                        "Pool and fitness",
                        "Convention centre and halls"
                    ],
                    "brief": "A convenient resort‑convention combo for families and corporates, with quick access to the heritage zone.",
                    "highlights": [
                        "Convention‑scale MICE",
                        "Family‑friendly amenities",
                        "Good value for brand",
                        "Proximity to ECR‑OMR junction"
                    ]
                },
                {
                    "name": "Ideal Beach Resort",
                    "address": "Devaneri Village, ECR, Mahabalipuram 603104",
                    "website": "https://idealresort.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Beach‑access rooms and cottages",
                        "Restaurant and bar",
                        "Pool and spa",
                        "Banquet lawn and hall"
                    ],
                    "brief": "A classic beach resort with direct shore access, relaxed dining, and event‑friendly spaces close to town.",
                    "highlights": [
                        "Direct sandy beach",
                        "Laid‑back ambience",
                        "Good for families/groups",
                        "Walk/short drive to sights"
                    ]
                },
                {
                    "name": "Grande Bay Resort and Spa Mamallapuram",
                    "address": "ECR, Kovalam Road, Mahabalipuram 603104",
                    "website": "https://grandebayresort.in/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Stylish rooms and chalets",
                        "Restaurant and poolside bar",
                        "Pool and spa",
                        "Small banquet/meeting room"
                    ],
                    "brief": "A chic coastal resort with stylish rooms, cosy dining, and quick access to Shore Temple and the beach.",
                    "highlights": [
                        "Near monument zone",
                        "Boutique vibe",
                        "Couple‑friendly",
                        "Great for short escapes"
                    ]
                }
            ]
        }
    },



    "madurai": {
        "name": "Madurai (Tamil Nadu)",
        "description": "Best stays in Madurai—heritage and premium city hotels near Meenakshi Amman Temple, Thirumalai Nayak Palace belt, and the ring‑road/airport corridor. Expect clean rooms, reliable dining, pools/spas (select), and event spaces.",
        "sectionOne": "Madurai, the cultural capital of Tamil Nadu, is famed for the Meenakshi Amman Temple, Thirumalai Nayak Palace, vibrant markets, and classic South Indian cuisine. Travellers explore the temple’s gopurams and 1000‑pillar hall, Thiruparankundram Murugan Temple, Gandhi Memorial Museum, Koodal Azhagar Temple, and day trips to Alagar Kovil/Teppakulam. City hotels emphasize comfortable rooms, dependable Wi‑Fi, multi‑cuisine dining, and banquet halls—ideal for pilgrimages, family trips, and corporate visits.",
        "sectionTwo": {
            "text": "Madurai offers central‑city business hotels around the temple/CBD, premium properties near race course/Collectorate belts, and highway/airport‑access stays for transits and events.",
            "hotels": [
                {
                    "name": "Courtyard by Marriott Madurai",
                    "address": "No. 168, Alagarkoil Road, Next to Circuit House, Madurai, Tamil Nadu 625002",
                    "website": "https://www.marriott.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All‑day dining, specialty restaurant, and bar",
                        "Pool and fitness centre",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A polished, centrally‑placed premium hotel with strong dining and event‑ready spaces—ideal for business and families.",
                    "highlights": [
                        "Quick drive to Meenakshi Temple",
                        "Reliable breakfast and service",
                        "Conference‑friendly floors",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "Heritage Madurai",
                    "address": "11, Melakkal Main Road, Kochadai, Madurai, Tamil Nadu 625016",
                    "website": "https://www.heritagemadurai.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 2000, "max": 4800 } },
                    "facilities": [
                        "Heritage rooms and villa‑style suites (select plunge pools)",
                        "Restaurants and bar",
                        "Large pool and spa",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A heritage‑style resort with leafy grounds, serene villas, and refined dining—great for relaxed family stays and weddings.",
                    "highlights": [
                        "Resort ambience within city",
                        "Photo‑friendly heritage touches",
                        "Event‑friendly lawns",
                        "Calm, spacious layout"
                    ]
                },
                {
                    "name": "The Gateway Hotel Pasumalai (by Taj), Madurai",
                    "address": "40, TPK Road, Pasumalai, Madurai, Tamil Nadu 625004",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Hilltop rooms with city/temple views (select)",
                        "Restaurants, bar, and tea terraces",
                        "Pool and fitness centre",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A classic hilltop retreat overlooking Madurai with vintage charm, scenic decks, and polished service.",
                    "highlights": [
                        "Panoramic city views",
                        "Green, quiet surroundings",
                        "Great for intimate weddings",
                        "Trusted luxury brand"
                    ]
                },
                {
                    "name": "Fortune Pandiyan Hotel, Madurai",
                    "address": "Race Course, Madurai, Tamil Nadu 625002",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "All‑day dining and bar",
                        "Pool and fitness centre",
                        "Banquet/meeting spaces"
                    ],
                    "brief": "A dependable premium hotel popular with families and corporates for its steady dining and event facilities.",
                    "highlights": [
                        "Easy access to sights",
                        "Consistent housekeeping",
                        "Good value in premium bracket",
                        "Event‑friendly floors"
                    ]
                },
                {
                    "name": "The Residency Towers, Madurai",
                    "address": "No. 43, TPK Road, Madurai, Tamil Nadu 625004",
                    "website": "https://www.theresidency.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1500, "max": 3400 } },
                    "facilities": [
                        "Modern rooms in city core",
                        "Multiple restaurants and bar",
                        "Pool and fitness",
                        "Ballrooms and meeting rooms"
                    ],
                    "brief": "A centrally located premium stay with lively dining and versatile banquets—good for business and family trips.",
                    "highlights": [
                        "Proximity to temple/CBD",
                        "Popular breakfast",
                        "Smooth check‑in/out",
                        "Good for groups"
                    ]
                },
                {
                    "name": "Poppys Hotel Madurai",
                    "address": "122, 124, 126, Madurai–Dindigul Main Road, Paravai, Madurai 625402",
                    "website": "https://www.poppyshotels.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Spacious rooms with modern comforts",
                        "Restaurant and lounge",
                        "Pool and lawns",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A value‑forward, event‑friendly hotel on the highway approach with roomy stays and practical amenities.",
                    "highlights": [
                        "Good for road travellers",
                        "Event‑ready spaces",
                        "Family‑friendly",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "JC Residency Madurai",
                    "address": "14, Lady Doak College Road, Chinna Chokkikulam, Madurai 625002",
                    "website": "https://www.jcresidency.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Traditional‑style rooms",
                        "Restaurant and café",
                        "Pool (property‑specific) and fitness corner",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A centrally placed, heritage‑flavoured hotel with cosy rooms, steady dining, and compact event facilities.",
                    "highlights": [
                        "Close to markets and sights",
                        "Popular set breakfasts",
                        "Good for short stays",
                        "Value‑friendly"
                    ]
                }
            ]
        }
    },


    "hampi": {
        "name": "Hampi (Karnataka)",
        "description": "Best stays in Hampi—heritage‑style retreats and boutique resorts near the Sacred Centre (Virupaksha–Hampi Bazaar), Royal Enclosure/Kamalapur, and river‑side Anegundi. Expect character rooms, hearty dining, gardens/pools (select), and compact event spaces.",
        "sectionOne": "Hampi, a UNESCO World Heritage site on the Tungabhadra, showcases Vijayanagara‑era temples, bazaars, and boulder‑strewn landscapes. Travellers explore Virupaksha Temple, Vittala Temple (Stone Chariot, musical pillars), Hemakuta/Matanga sunset points, Lotus Mahal, Elephant Stables, Hampi Bazaar, Anegundi and coracle rides. Hotels emphasize calm rooms, reliable Wi‑Fi, homely and regional dining, guided tours, and flexible timings for sunrise/sunset excursions—ideal for culture getaways, backpacking circuits, and family trips.",
        "sectionTwo": {
            "text": "Hampi offers heritage/boutique stays around the temple belt, full‑service resorts near Kamalapur/Royal Enclosure, and scenic retreats across the river around Anegundi and Sanapur.",
            "hotels": [
                {
                    "name": "Evolve Back Kamalapura Palace, Hampi",
                    "address": "Kamalapur, Near Hampi, Ballari District, Karnataka 583221",
                    "website": "https://www.evolveback.com/",
                    "averageCost": { "stay": 42000, "dining": { "min": 3000, "max": 8000 } },
                    "facilities": [
                        "Palace‑inspired suites (select with private pool)",
                        "Destination restaurants and lounge",
                        "Large pool, spa, and fitness",
                        "Courtyards, lawns, and event halls"
                    ],
                    "brief": "A luxury, palace‑style resort close to the Royal Enclosure with refined suites, curated dining, and serene courtyards.",
                    "highlights": [
                        "Quick access to Royal Centre",
                        "Signature spa and pools",
                        "Elegant indoor–outdoor venues",
                        "High‑touch hospitality"
                    ]
                },
                {
                    "name": "Hotel Malligi (Hospet)",
                    "address": "10/90, J.N. Road, Hospet, Karnataka 583201",
                    "website": "https://www.malligihotels.com/",
                    "averageCost": { "stay": 6000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Comfortable rooms in city hub",
                        "Multiple restaurants and café",
                        "Pool and spa (select)",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "A value‑forward base in Hospet with steady dining, a pool, and event spaces—popular with families and groups.",
                    "highlights": [
                        "Transit‑friendly city location",
                        "Good price‑to‑amenities",
                        "Consistent housekeeping",
                        "Reliable breakfast options"
                    ]
                },
                {
                    "name": "Clarks Inn Hampi (Kamalapur)",
                    "address": "Kamalapur, Near ASI Museum, Hampi, Karnataka 583221",
                    "website": "https://www.clarksinn.in/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Modern rooms near Royal Enclosure",
                        "Restaurant and café",
                        "Travel desk",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A convenient stay next to Kamalapur’s museum and monuments with tidy rooms and practical dining.",
                    "highlights": [
                        "Walk/short drive to Royal Centre",
                        "Efficient check‑in/out",
                        "Good for short cultural trips",
                        "Balanced value"
                    ]
                },
                {
                    "name": "Heritage Resort Hampi",
                    "address": "SH 49, 6 Km from Kamalapur, Hampi, Karnataka 583221",
                    "website": "https://www.heritageresorthampi.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Villa‑style rooms amid greenery",
                        "Restaurant and bar",
                        "Pool and spa",
                        "Lawn and small event hall"
                    ],
                    "brief": "A green, resort‑style retreat with spacious rooms, a good pool, and easy access to main sights.",
                    "highlights": [
                        "Calm, nature‑rich campus",
                        "Family‑friendly",
                        "Popular breakfast",
                        "Good for longer stays"
                    ]
                },
                {
                    "name": "Hampi’s Boulders (Anegundi belt)",
                    "address": "Narayanpet, Near Anegundi, Hampi Region, Karnataka 583234",
                    "website": "https://www.hampisboulders.com/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Rustic cottages with boulder/river views",
                        "Restaurant and lounge decks",
                        "Nature walks and birding",
                        "Boutique event spaces"
                    ],
                    "brief": "A characterful riverside‑and‑boulders hideaway with nature trails, scenic sit‑outs, and relaxed dining.",
                    "highlights": [
                        "Unique boulder landscape",
                        "Great for photography",
                        "Couple‑friendly ambience",
                        "Close to coracle points"
                    ]
                },
                {
                    "name": "Kishkinda Heritage Resort (Anegundi/Sanapur)",
                    "address": "Anegundi–Sanapur belt, Hampi Region, Karnataka 583234",
                    "website": "https://www.kishkindaheritage.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Cottages and family rooms",
                        "Restaurant and café",
                        "Pool (property‑specific) and lawns",
                        "Event/meeting room"
                    ],
                    "brief": "A family‑friendly retreat across the river with spacious rooms, lawns, and easy access to Sanapur lake.",
                    "highlights": [
                        "Good for groups and kids",
                        "Budget‑friendly premium",
                        "Proximity to Anegundi",
                        "Nature‑ringed setting"
                    ]
                },
                {
                    "name": "Rocky’s Homestay (Boutique)",
                    "address": "Near Hampi Bazaar, Hampi, Karnataka 583239",
                    "website": "#",
                    "averageCost": { "stay": 4500, "dining": { "min": 600, "max": 1600 } },
                    "facilities": [
                        "Simple, clean AC rooms",
                        "Home‑style café",
                        "Local guide assistance",
                        "Bicycle rental"
                    ],
                    "brief": "A tidy boutique homestay near the Bazaar with friendly hosts, homely meals, and quick monument access.",
                    "highlights": [
                        "Walkable to Virupaksha area",
                        "Backpacker‑friendly",
                        "Great value",
                        "Handy for sunrise treks"
                    ]
                },
                {
                    "name": "Evolve Back Itineraries (Add‑on)",
                    "address": "Kamalapur, Hampi Region, Karnataka 583221",
                    "website": "https://www.evolveback.com/",
                    "averageCost": { "stay": 0, "dining": { "min": 0, "max": 0 } },
                    "facilities": [
                        "Curated guides and trails",
                        "Sunrise/sunset points",
                        "Cultural performances",
                        "Private dining setups"
                    ],
                    "brief": "Curated experiences pairing monument trails, viewpoints, and private dining—ideal for milestone trips.",
                    "highlights": [
                        "Tailored heritage walks",
                        "Great for couples",
                        "Photography‑friendly timing",
                        "Seamless logistics"
                    ]
                }
            ]
        }
    },



    "badami-pattadakal-aihole": {
        "name": "Badami, Pattadakal & Aihole (Karnataka)",
        "description": "Best stays around Badami–Pattadakal–Aihole—heritage‑style retreats, boutique resorts, and practical town hotels near cave temples, UNESCO complexes, and Agastya Lake. Expect clean rooms, hearty dining, gardens/pools (select), and compact event spaces.",
        "sectionOne": "North Karnataka’s Chalukyan heritage circuit spans Badami’s sandstone cave temples and Agastya Lake, Pattadakal’s UNESCO‑listed coronation temples, and Aihole’s early temple experiments. Travellers explore Badami Cave Temples, Bhutanatha Temple, Agastya Lake, Badami Fort/Shivalaya, Pattadakal’s Virupaksha/Mallikarjuna/Papanatha complexes, and Aihole’s Durga Temple, Lad Khan, and Ravana Phadi. Stays emphasize calm rooms, reliable Wi‑Fi, homely multi‑cuisine dining, and guided tours—ideal for heritage trips, family getaways, and photo walks.",
        "sectionTwo": {
            "text": "Base in Badami/Hospet or stay near Pattadakal/Aihole for early starts. Below are handpicked options noted for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Clarks Inn Badami",
                    "address": "Opp. KSRTC Depot, Station Road, Badami, Karnataka 587201",
                    "website": "https://www.clarksinn.in/",
                    "averageCost": { "stay": 7500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Modern, centrally located rooms",
                        "Restaurant and café",
                        "Travel desk",
                        "Banquet/meeting room"
                    ],
                    "brief": "A convenient Badami base with tidy rooms, steady dining, and quick access to cave temples and Agastya Lake.",
                    "highlights": [
                        "Walk/short drive to sights",
                        "Consistent housekeeping",
                        "Good value",
                        "Transit‑friendly"
                    ]
                },
                {
                    "name": "Hotel Badami Court",
                    "address": "Station Road, Badami, Karnataka 587201",
                    "website": "#",
                    "averageCost": { "stay": 6800, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Comfortable rooms near town centre",
                        "Restaurant and room service",
                        "Garden sit‑outs",
                        "Small event space"
                    ],
                    "brief": "A long‑running, practical hotel close to the heritage core—simple comforts and handy sightseeing access.",
                    "highlights": [
                        "Near bus/rail links",
                        "Family‑friendly",
                        "Good breakfast options",
                        "Budget‑friendly"
                    ]
                },
                {
                    "name": "KSTDC Hotel Mayura Chalukya, Badami",
                    "address": "Ramankoppa, Near Badami Caves, Karnataka 587201",
                    "website": "https://www.kstdc.co/",
                    "averageCost": { "stay": 5500, "dining": { "min": 600, "max": 1600 } },
                    "facilities": [
                        "Basic AC rooms/cottages",
                        "Restaurant",
                        "Parking and travel help",
                        "Compact meeting room"
                    ],
                    "brief": "A government‑run option with straightforward rooms and reliable meals, very convenient for early sightseeing.",
                    "highlights": [
                        "Close to cave temples",
                        "Value pricing",
                        "Easy parking",
                        "Good for short stays"
                    ]
                },
                {
                    "name": "The Heritage Resort Badami",
                    "address": "SH‑57, Badami–Pattadakal Road, Badami, Karnataka 587201",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Cottage‑style rooms amid greenery",
                        "Restaurant and lawns",
                        "Pool (property‑specific)",
                        "Banquet hall"
                    ],
                    "brief": "A green, resort‑like base between monuments with airy rooms, lawns, and family‑friendly amenities.",
                    "highlights": [
                        "Easy access to all three sites",
                        "Good for families/groups",
                        "Relaxed ambience",
                        "Event‑friendly"
                    ]
                },
                {
                    "name": "Anand Homestay & Café (Badami Bazaar belt)",
                    "address": "Near Agastya Lake approach, Badami, Karnataka 587201",
                    "website": "#",
                    "averageCost": { "stay": 3500, "dining": { "min": 500, "max": 1200 } },
                    "facilities": [
                        "Simple, clean rooms",
                        "Home‑style café",
                        "Local guide assistance",
                        "Bicycle/scooter hire"
                    ],
                    "brief": "A backpacker‑friendly pick with homely meals and quick walks to the lake, caves, and bazaar lanes.",
                    "highlights": [
                        "Great value",
                        "Walkable location",
                        "Helpful hosts",
                        "Good for sunrise/sunset runs"
                    ]
                },
                {
                    "name": "Hotel Mookambika (Pattadakal access)",
                    "address": "Pattadakal Road corridor, Badami Taluk, Karnataka 587201",
                    "website": "#",
                    "averageCost": { "stay": 4800, "dining": { "min": 600, "max": 1600 } },
                    "facilities": [
                        "Basic, neat rooms for quick overnights",
                        "Veg restaurant",
                        "Parking",
                        "Front‑desk assistance"
                    ],
                    "brief": "A simple stopover convenient for early Pattadakal/Aihole starts—clean rooms and straightforward dining.",
                    "highlights": [
                        "Early access to UNESCO complex",
                        "Budget‑friendly",
                        "Transit convenience",
                        "Good for one‑night stays"
                    ]
                },
                {
                    "name": "Aihole Village Homestays (Example Category)",
                    "address": "Near Durga Temple complex, Aihole, Karnataka 587124",
                    "website": "#",
                    "averageCost": { "stay": 2800, "dining": { "min": 400, "max": 900 } },
                    "facilities": [
                        "Clean rooms with village ambience",
                        "Home‑cooked meals",
                        "Local guide/auto connect",
                        "Bicycle rentals"
                    ],
                    "brief": "Welcoming village homestays that put Aihole’s early temples and cave shrines right at the doorstep.",
                    "highlights": [
                        "Walkable to monuments",
                        "Authentic local food",
                        "Budget comfort",
                        "Great for photographers"
                    ]
                },
                {
                    "name": "Hospet Add‑on: Hotel Malligi",
                    "address": "10/90, J.N. Road, Hospet, Karnataka 583201",
                    "website": "https://www.malligihotels.com/",
                    "averageCost": { "stay": 6000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "City‑hub rooms and suites",
                        "Multiple dining outlets",
                        "Pool/spa (select)",
                        "Banquet spaces"
                    ],
                    "brief": "A popular, value‑forward hub hotel if pairing this circuit with Hampi, offering steady dining and facilities.",
                    "highlights": [
                        "Reliable city base",
                        "Good for groups",
                        "Event‑friendly",
                        "Balanced price‑to‑amenities"
                    ]
                }
            ]
        }
    },


    "ooty": {
        "name": "Ooty (Udhagamandalam), Tamil Nadu",
        "description": "Best stays in Ooty—tea‑estate resorts and heritage hill hotels around Doddabetta, Fern Hill, Charing Cross, and Ooty Lake. Expect mountain‑view rooms (select), fireplaces/heaters, cosy lounges, spas, and compact to large event spaces.",
        "sectionOne": "Ooty, the ‘Queen of the Nilgiris’, blends rolling tea gardens, colonial‑era charm, and cool weather. Travellers enjoy Doddabetta Peak, Ooty Lake/Boathouse, Rose Garden, Botanical Gardens, scenic toy‑train rides to Coonoor, and tea factory tours. Hill hotels focus on warm rooms, reliable Wi‑Fi, hearty multi‑cuisine dining, bonfire evenings, and indoor leisure—ideal for family holidays, honeymoons, and relaxed long weekends.",
        "sectionTwo": {
            "text": "Ooty features heritage bungalows, premium hillside resorts, and practical town‑centre stays near the lake and Charing Cross. Below are handpicked properties known for views, ambience, and consistent service.",
            "hotels": [
                {
                    "name": "Savoy, Ooty – IHCL SeleQtions",
                    "address": "77, Sylks Road, Ooty, Tamil Nadu 643001",
                    "website": "https://www.seleqtionshotels.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2500, "max": 6000 } },
                    "facilities": [
                        "Heritage cottages and rooms",
                        "Restaurants, tea lounge, and bar",
                        "Lawn sit‑outs, spa, and activities",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A storied heritage hotel with cottage rooms, classic high‑tea, and serene lawns near the town core.",
                    "highlights": [
                        "Colonial charm and gardens",
                        "Family‑friendly leisure",
                        "Polished service",
                        "Great for intimate weddings"
                    ]
                },
                {
                    "name": "Fortune Resort Sullivan Court, Ooty (ITC Group)",
                    "address": "123, Selbourne Road, Ooty, Tamil Nadu 643001",
                    "website": "https://www.itchotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Contemporary rooms and suites",
                        "All‑day dining and bar",
                        "Fitness, games, and lawns",
                        "Banquet and meeting rooms"
                    ],
                    "brief": "A dependable, family‑friendly resort in town with steady dining, indoor leisure, and event spaces.",
                    "highlights": [
                        "Central access to sights",
                        "Popular breakfast",
                        "Good for groups",
                        "Value‑forward premium"
                    ]
                },
                {
                    "name": "Accord Highland Hotel Ooty",
                    "address": "4/278, Shimla‑Hatty Road, Doddabetta Junction, Ooty 643001",
                    "website": "https://www.theaccordhotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Hill‑view rooms and suites",
                        "Restaurant, café, and bar",
                        "Games room and bonfire (seasonal)",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A hill‑crest hotel near Doddabetta with sweeping vistas, lively dining, and family‑friendly activities.",
                    "highlights": [
                        "Great viewpoints",
                        "Kid‑friendly amenities",
                        "Reliable service",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "Gem Park Ooty",
                    "address": "Sheddon Road, Pudumund, Ooty, Tamil Nadu 643001",
                    "website": "https://www.gemhotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Rooms with valley/city views (select)",
                        "Multiple restaurants and bar",
                        "Heated pool (select) and spa",
                        "Banquet halls"
                    ],
                    "brief": "A well‑known town hotel with view‑facing rooms, varied dining, and compact leisure facilities.",
                    "highlights": [
                        "Easy town connectivity",
                        "Popular buffets",
                        "Event‑friendly",
                        "Consistent housekeeping"
                    ]
                },
                {
                    "name": "Sinclairs Retreat Ooty",
                    "address": "Gorishola Road, Ooty, Tamil Nadu 643001",
                    "website": "https://www.sinclairshotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Rooms/suites with hillside views",
                        "Restaurant, bar, and lounges",
                        "Bonfire and activities (seasonal)",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "A hillside retreat with scenic sit‑outs, cosy lounges, and reliable dining away from the town bustle.",
                    "highlights": [
                        "Quiet, scenic ambience",
                        "Family‑friendly",
                        "Good breakfast",
                        "Suited to relaxed stays"
                    ]
                },
                {
                    "name": "Kings Cliff by Littlearth",
                    "address": "Havelock Road, Ooty, Tamil Nadu 643001",
                    "website": "https://www.littlearth.in/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Vintage rooms with fireplaces (select)",
                        "Popular restaurant (Earl’s Secret)",
                        "Garden sit‑outs",
                        "Boutique event room"
                    ],
                    "brief": "A characterful heritage bungalow with fireplace rooms, leafy lawns, and a favorite on‑site restaurant.",
                    "highlights": [
                        "Colonial vibe",
                        "Romantic ambience",
                        "Great for food lovers",
                        "Photo‑friendly corners"
                    ]
                },
                {
                    "name": "Sterling Ooty – Fern Hill / Elk Hill",
                    "address": "Fern Hill/Elk Hill belts, Ooty, Tamil Nadu 643001",
                    "website": "https://www.sterlingholidays.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Family rooms and suites",
                        "All‑day dining and café",
                        "Kids’ zone and activities",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "Two popular family‑friendly resorts offering roomy stays, kids’ activities, and reliable dining.",
                    "highlights": [
                        "Good for families/groups",
                        "Activity‑rich",
                        "Consistent service",
                        "Value‑forward"
                    ]
                },
                {
                    "name": "Destiny – The Farm Resort (near Ooty belt)",
                    "address": "Avalanche Road region, Ooty outskirts 643001",
                    "website": "https://www.natureresorts.in/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Lake‑and‑meadow‑view rooms",
                        "Farm‑to‑table restaurant",
                        "Outdoor activities and bonfires",
                        "Event lawn"
                    ],
                    "brief": "A nature‑immersive farm resort with lake views, outdoor activities, and serene rooms on Ooty’s outskirts.",
                    "highlights": [
                        "Scenic, off‑city setting",
                        "Great for kids and couples",
                        "Photo‑worthy landscapes",
                        "Relaxed, slow‑travel vibe"
                    ]
                }
            ]
        }
    },


    "kodaikanal": {
        "name": "Kodaikanal (Tamil Nadu)",
        "description": "Best stays in Kodaikanal—valley‑view resorts and heritage hill hotels near Coaker’s Walk, Bryant Park, and Kodaikanal Lake/Upper Lake Road. Expect cosy rooms, fireplaces/heaters (select), hearty dining, spas, and event spaces.",
        "sectionOne": "Kodaikanal, the Princess of Hill Stations, blends misty valleys, shola forests, and lakefront promenades. Travellers explore Kodaikanal Lake boating circuit, Coaker’s Walk, Bryant Park, Pine Forest, Pillar Rocks, Guna Caves, Silver Cascade, and Mannavanur meadows. Hotels focus on warm rooms with views, dependable Wi‑Fi, multi‑cuisine dining, bonfire evenings, and kids’ activities—ideal for family holidays, honeymoons, and relaxed long weekends.",
        "sectionTwo": {
            "text": "Kodaikanal features premium valley‑view resorts, family‑friendly lake belt hotels, and heritage/boutique stays near Coaker’s Walk and the town core.",
            "hotels": [
                {
                    "name": "The Tamara Kodai",
                    "address": "St. Mary’s Road, La Providence, Kodaikanal, Tamil Nadu 624101",
                    "website": "https://www.thetamara.com/kodaikanal-resort/",
                    "averageCost": { "stay": 26000, "dining": { "min": 2500, "max": 6500 } },
                    "facilities": [
                        "Colonial‑inspired luxury suites",
                        "Signature restaurants and bar",
                        "Heated pool (temperature‑controlled), spa, and fitness",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A hill‑top luxury retreat with colonial charm, refined dining, and upscale leisure—great for couples and families.",
                    "highlights": [
                        "Serene hillside setting",
                        "Curated dining and high‑tea",
                        "Event‑ready infrastructure",
                        "Polished hospitality"
                    ]
                },
                {
                    "name": "Great Trails Kodaikanal by GRT Hotels",
                    "address": "Bharathi Nagar, Vilpatti Road, Kodaikanal, Tamil Nadu 624101",
                    "website": "https://www.grthotels.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Chalet‑style rooms with valley views",
                        "Restaurant and lounge",
                        "Bonfire/activities (seasonal)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A scenic, activity‑rich hillside resort with wood‑accented rooms and lively dining—popular for family getaways.",
                    "highlights": [
                        "Panoramic valley vistas",
                        "Kid‑friendly leisure",
                        "Reliable breakfast",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "Kodai Resort Hotel",
                    "address": "Near Coaker’s Walk & Bryant Park, Kodaikanal 624101",
                    "website": "https://kodairesorthotel.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Cottage‑style rooms with private decks",
                        "Restaurant and café",
                        "Lawn sit‑outs and activities",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A centrally located resort with cottage layouts, easy access to top sights, and family‑friendly lawns.",
                    "highlights": [
                        "Walkable to lake and parks",
                        "Great for families",
                        "Value‑forward premium pick",
                        "Consistent housekeeping"
                    ]
                },
                {
                    "name": "The Carlton, Kodaikanal",
                    "address": "Lake Road, Kodaikanal, Tamil Nadu 624101",
                    "website": "https://www.carlton-kodaikanal.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Lake‑facing rooms and suites",
                        "Restaurants and bar",
                        "Spa, gym, and kid’s activities",
                        "Banquet halls and lawns"
                    ],
                    "brief": "A classic lakefront hotel with polished rooms, robust dining, and event‑ready spaces in the heart of town.",
                    "highlights": [
                        "Prime lakefront location",
                        "Family‑friendly amenities",
                        "Popular breakfast and teas",
                        "Convenient for sightseeing"
                    ]
                },
                {
                    "name": "Sterling Kodai Lake / Sterling Kodai Valley",
                    "address": "Lake Road / Pallangi Road belts, Kodaikanal 624101",
                    "website": "https://www.sterlingholidays.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Rooms and family suites",
                        "All‑day dining and café",
                        "Activities and kids’ zone",
                        "Banquet/meeting room"
                    ],
                    "brief": "Two popular family‑friendly resorts offering roomy stays, kids’ activities, and consistent dining.",
                    "highlights": [
                        "Good for families/groups",
                        "Activity‑rich stays",
                        "Reliable service",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "JC Residency, Kodaikanal",
                    "address": "Convent Road, Naidupuram, Kodaikanal 624101",
                    "website": "https://www.jcresidency.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2600 } },
                    "facilities": [
                        "Traditional‑style rooms",
                        "Restaurant and café",
                        "Indoor games/bonfire (seasonal)",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A centrally placed, heritage‑flavoured hotel with cosy rooms, steady dining, and compact event facilities.",
                    "highlights": [
                        "Close to markets and sights",
                        "Popular breakfast spreads",
                        "Good for short stays",
                        "Value‑friendly"
                    ]
                },
                {
                    "name": "Green Pastures – A Hill Country Resort",
                    "address": "Attuvampatti, Kodaikanal, Tamil Nadu 624101",
                    "website": "https://hillcountryresorts.in/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Cottage‑style rooms with lawns",
                        "Restaurant and lounge",
                        "Play area and activities",
                        "Banquet/meeting room"
                    ],
                    "brief": "A tranquil, family‑friendly resort with lawns, activities, and comfortable rooms in a quiet belt.",
                    "highlights": [
                        "Nature‑rich ambience",
                        "Kid‑friendly",
                        "Reliable housekeeping",
                        "Good for longer stays"
                    ]
                },
                {
                    "name": "Lilly’s Valley Resort",
                    "address": "Sivanadi Road, Kodaikanal 624101",
                    "website": "https://www.lillysvalley.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Stone cottages and rooms",
                        "Restaurant and campfire area",
                        "Garden sit‑outs",
                        "Small event room"
                    ],
                    "brief": "A rustic, garden‑style resort with stone cottages, campfire evenings, and warm service.",
                    "highlights": [
                        "Cosy, old‑world vibe",
                        "Great for families and couples",
                        "Value pricing",
                        "Helpful staff"
                    ]
                }
            ]
        }
    },



    "andaman-nicobar": {
        "name": "Andaman & Nicobar Islands",
        "description": "Best stays across Andamans—beachfront resorts, boutique island retreats, and practical city hotels around Port Blair, Havelock (Swaraj Dweep), and Neil (Shaheed Dweep). Expect sea‑view rooms (select), water‑activity desks, pools/spas (select), and event lawns.",
        "sectionOne": "Andaman & Nicobar blends pristine beaches, coral reefs, and layered history. Travellers explore Port Blair’s Cellular Jail and museums, Havelock’s Radhanagar/Elephant/Kalapathar beaches, Neil’s Bharatpur/Laxmanpur/Sitapur beaches, Ross Island (Netaji Subhash Chandra Bose Dweep), Baratang’s mangroves and limestone caves, and North Bay/Jolly Buoy for snorkeling. Stays prioritize island connectivity, activity concierge (diving/snorkeling/sea walks), flexible dining around ferry schedules, and family‑friendly leisure—ideal for honeymoons, families, and small groups.",
        "sectionTwo": {
            "text": "Stay at Port Blair for arrival/departure and split nights between Havelock and Neil for beaches and water activities. Below are handpicked properties noted for location, amenities, and service consistency.",
            "hotels": [
                {
                    "name": "Taj Exotica Resort & Spa, Andamans",
                    "address": "Radhanagar Beach, Havelock Island (Swaraj Dweep) 744211",
                    "website": "https://www.tajhotels.com/",
                    "averageCost": { "stay": 55000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "Luxury villa‑style rooms within tropical groves",
                        "Destination restaurants and bar",
                        "Pool, J Wellness Spa, and fitness",
                        "Curated experiences and event lawns"
                    ],
                    "brief": "An ultra‑premium Havelock resort with serene villas, refined dining, and signature wellness near Radhanagar.",
                    "highlights": [
                        "Close to one of Asia’s top beaches",
                        "High‑touch service",
                        "Honeymoon and family friendly",
                        "Elegant indoor–outdoor venues"
                    ]
                },
                {
                    "name": "Barefoot at Havelock",
                    "address": "Radhanagar Beach belt, Havelock Island 744211",
                    "website": "https://www.barefoot-andaman.com/",
                    "averageCost": { "stay": 24000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Eco‑chic cottages and villas",
                        "Restaurant and bar",
                        "Activity/experience desk",
                        "Yoga/wellness (property‑specific)"
                    ],
                    "brief": "An eco‑focused hideaway near Radhanagar with rustic‑lux cottages, thoughtful dining, and nature‑led vibes.",
                    "highlights": [
                        "Nature‑immersive setting",
                        "Great for slow travel",
                        "Couple‑friendly ambience",
                        "Easy beach access"
                    ]
                },
                {
                    "name": "SeaShell Havelock",
                    "address": "Govind Nagar Beach belt, Havelock Island 744211",
                    "website": "https://www.seashellhotels.net/",
                    "averageCost": { "stay": 18000, "dining": { "min": 1600, "max": 3800 } },
                    "facilities": [
                        "Beach‑side rooms/cottages",
                        "Restaurant and bar",
                        "Activity desk (diving/snorkel tie‑ups)",
                        "Event lawn (property‑specific)"
                    ],
                    "brief": "A popular beachfront stay with comfy rooms, steady dining, and easy access to water activities.",
                    "highlights": [
                        "Good family layouts",
                        "House reef/snorkel access (area dependent)",
                        "Reliable housekeeping",
                        "Balanced price–amenities"
                    ]
                },
                {
                    "name": "Symphony Palms Beach Resort & Spa",
                    "address": "Govind Nagar, Havelock Island 744211",
                    "website": "https://www.symphonyresorts.com/",
                    "averageCost": { "stay": 17000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Cottages/villas near the beach",
                        "Restaurants and lounge",
                        "Spa services",
                        "Activity desk and lawns"
                    ],
                    "brief": "A resort‑style property with cottage categories, spa options, and quick access to Havelock beaches.",
                    "highlights": [
                        "Beach‑belt location",
                        "Family‑friendly",
                        "Event‑friendly grounds",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "Seashell Neil",
                    "address": "Neil Kendra/Bharatpur belt, Neil Island (Shaheed Dweep) 744104",
                    "website": "https://www.seashellhotels.net/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Rooms/cottages near beaches",
                        "Restaurant and bar",
                        "Activity desk",
                        "Small event space"
                    ],
                    "brief": "A relaxed Neil Island stay close to Bharatpur/Laxmanpur beaches with straightforward dining and activities.",
                    "highlights": [
                        "Laid‑back island vibe",
                        "Snorkel/glass‑bottom tie‑ups",
                        "Family‑friendly",
                        "Value‑forward premium"
                    ]
                },
                {
                    "name": "SeaShell Coral Cove, Port Blair",
                    "address": "Atlanta Point, Port Blair 744101",
                    "website": "https://www.seashellhotels.net/",
                    "averageCost": { "stay": 9000, "dining": { "min": 900, "max": 2400 } },
                    "facilities": [
                        "Modern city rooms",
                        "Restaurant and café",
                        "Rooftop (property‑specific)",
                        "Meeting room"
                    ],
                    "brief": "A convenient Port Blair base with tidy rooms, steady dining, and quick links to jetties and sights.",
                    "highlights": [
                        "Airport/ferry access",
                        "Good for short stays",
                        "Consistent breakfast",
                        "Transit‑friendly"
                    ]
                },
                {
                    "name": "Sinclairs Bayview Port Blair",
                    "address": "South Point, Port Blair 744106",
                    "website": "https://www.sinclairshotels.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Sea‑view rooms (select)",
                        "Restaurant and bar",
                        "Pool (property‑specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A sea‑facing city hotel with scenic rooms, reliable dining, and compact event facilities.",
                    "highlights": [
                        "Waterfront outlook",
                        "Close to key museums",
                        "Good for families",
                        "Balanced price–amenities"
                    ]
                },
                {
                    "name": "Havelock Island Beach Resort (HIBR)",
                    "address": "Govind Nagar Beach (No. 2), Havelock Island 744211",
                    "website": "https://www.havelockislandbeachresort.com/",
                    "averageCost": { "stay": 15000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Beachfront rooms (select)",
                        "Restaurant and bar",
                        "Activity/boat assistance",
                        "Event lawns"
                    ],
                    "brief": "A beachfront resort known for easy sea access, steady dining, and helpful activity coordination.",
                    "highlights": [
                        "Great for beach time",
                        "Snorkel/diving tie‑ups",
                        "Family‑friendly",
                        "Event‑ready lawns"
                    ]
                },
                {
                    "name": "TSG Blue Resort (Havelock) / TSG Emerald View (Port Blair)",
                    "address": "Havelock & Port Blair, Andaman Islands",
                    "website": "https://www.tsgHotelsAndResorts.com/",
                    "averageCost": { "stay": 10000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Comfortable rooms in key locations",
                        "Restaurants and cafés",
                        "Activity desks",
                        "Meeting room (property‑specific)"
                    ],
                    "brief": "Reliable mid‑premium options in both hubs for easy splits across Port Blair and Havelock.",
                    "highlights": [
                        "Transit + beach pairing",
                        "Good breakfast options",
                        "Budget‑sensitive premium",
                        "Consistent housekeeping"
                    ]
                }
            ]
        }
    },



    "lakshadweep": {
        "name": "Lakshadweep Islands",
        "description": "Best stays across Lakshadweep—beachfront resorts, eco‑stays, and homestays on Agatti, Bangaram, Kadmat, Kavaratti, and Minicoy. Expect lagoon‑view rooms (select), dive/snorkel desks, boat transfers, and simple to premium dining.",
        "sectionOne": "Lakshadweep is a turquoise atoll archipelago known for coral reefs, glassy lagoons, and powder‑soft beaches. Travellers typically fly into Agatti, then connect by boat to Bangaram/Kadmat/Minicoy/Kavaratti. Expect snorkeling and scuba, glass‑bottom boats, kayaking, and sandbank picnics. Properties prioritize island logistics, water‑activity tie‑ups, and flexible meals around ferry/boat timings—ideal for honeymoons, families, and underwater lovers.",
        "sectionTwo": {
            "text": "Stay first night at Agatti for arrivals, then split nights between Bangaram (luxury/island retreat) and Kadmat/Minicoy (water sports). Below are handpicked options known for location, activities, and consistent service.",
            "hotels": [
                {
                    "name": "Praveg Atoll’s – Bangaram Island (Managed with IHCL SeleQtions)",
                    "address": "Bangaram Island, Lakshadweep 682551",
                    "website": "https://www.dizcoverpraveg.com/bangaram",
                    "averageCost": { "stay": 48000, "dining": { "min": 3500, "max": 9000 } },
                    "facilities": [
                        "Cocoon/Shell‑style cottages on the beach",
                        "Restaurant and bar",
                        "Diving/snorkel/watersports desk",
                        "Yoga on beach and curated island activities"
                    ],
                    "brief": "A statement island retreat on Bangaram with designer cottages, refined vegetarian dining, and premium experiences.",
                    "highlights": [
                        "Bioluminescence nights (seasonal/natural)",
                        "Direct lagoon access",
                        "Honeymoon‑friendly serenity",
                        "Upscale service and amenities"
                    ]
                },
                {
                    "name": "Bangaram Island Resort",
                    "address": "Bangaram Island, Lakshadweep 682551",
                    "website": "#",
                    "averageCost": { "stay": 28000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Beachfront cottages",
                        "Restaurant and beach bar",
                        "Diving/snorkel operations",
                        "Boat excursions and sandbank picnics"
                    ],
                    "brief": "A classic Bangaram stay with direct lagoon access, relaxed cottages, and easy dives/snorkels right off the beach.",
                    "highlights": [
                        "Iconic turquoise lagoon",
                        "Uncluttered, barefoot vibe",
                        "Great for photographers",
                        "Laid‑back island life"
                    ]
                },
                {
                    "name": "Agatti Island – White Pearl/Sea Shells/Coral Burst (Representative Picks)",
                    "address": "Agatti Island, Lakshadweep 682553",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Beachfront/beltd‑side rooms",
                        "Restaurant or homely dining",
                        "Water‑activity tie‑ups",
                        "Airport/jetty transfers"
                    ],
                    "brief": "Convenient Agatti stays for first/last nights with beach access, island tours, and snorkel/boat arrangements.",
                    "highlights": [
                        "Gateway island convenience",
                        "Great for short stays",
                        "Budget to mid‑premium choices",
                        "Sunset walks and shore snorkels"
                    ]
                },
                {
                    "name": "Kadmat Island Beach Resort (Govt./Eco Category)",
                    "address": "Kadmat Island, Lakshadweep 682556",
                    "website": "#",
                    "averageCost": { "stay": 11000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Simple beachfront rooms",
                        "Café/restaurant",
                        "Diving, snorkeling, kayaking",
                        "Excursions and boat support"
                    ],
                    "brief": "A water‑sports‑forward island base with long beaches, clear lagoons, and straightforward, clean rooms.",
                    "highlights": [
                        "Great house‑reef access (area‑dependent)",
                        "Activity‑rich days",
                        "Good for families",
                        "Value‑friendly"
                    ]
                },
                {
                    "name": "Minicoy Island Beach Resort",
                    "address": "Minicoy (Maliku), Lakshadweep 682559",
                    "website": "#",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Beachside cottages",
                        "Restaurant",
                        "Lagoon activities and boat trips",
                        "Cultural village experiences"
                    ],
                    "brief": "A scenic southern atoll stay with signature blue lagoons, lighthouse views, and easy lagoon adventures.",
                    "highlights": [
                        "Idyllic lagoon colors",
                        "Calm, couple‑friendly vibe",
                        "Great for long swims",
                        "Photo‑ready settings"
                    ]
                },
                {
                    "name": "Kavaratti – Government Guest House / Homestay Options",
                    "address": "Kavaratti Island, Lakshadweep 682555",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Clean, basic rooms",
                        "Canteen/restaurant access",
                        "Local sightseeing and water activities",
                        "Ferry/boat coordination"
                    ],
                    "brief": "The administrative hub offers practical stays with cultural stops and calm‑lagoon activities.",
                    "highlights": [
                        "Good for short stopovers",
                        "Budget‑friendly",
                        "Local food experiences",
                        "Easy logistics"
                    ]
                }
            ]
        }
    },



    "sundarbans": {
        "name": "Sundarbans (West Bengal)",
        "description": "Best stays in the Sundarbans—riverside jungle resorts, eco‑lodges, and homestays near Sajnekhali, Pakhiralay, and Dayapur belts. Expect boat logistics, fixed‑menu hearty dining, guided creek safaris, and lawns for cultural evenings.",
        "sectionOne": "The Sundarbans, the world’s largest mangrove forest and a UNESCO World Heritage Site, is famed for tidal creeks, rich birdlife, saltwater crocodiles, and the elusive Royal Bengal Tiger. Travellers base themselves around Gosaba–Pakhiralay–Dayapur for boat safaris to Sajnekhali, Sudhanyakhali, Dobanki, and Jharkhali. Lodges prioritize early breakfasts, buffet meals, naturalist‑guided boat trips, and flexible schedules around tides—ideal for families, birders, wildlife enthusiasts, and small groups.",
        "sectionTwo": {
            "text": "Most properties cluster near boat jetties for early departures. Below are handpicked options known for location, hospitality, and safari logistics.",
            "hotels": [
                {
                    "name": "Sunderban Tiger Camp",
                    "address": "Dayapur Island (near Sajnekhali belt), Sundarbans 743370",
                    "website": "https://www.sunderbantigercamp.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Cottage‑style rooms",
                        "Restaurant and bar",
                        "Guided boat safaris",
                        "Small conference room"
                    ],
                    "brief": "A long‑trusted jungle lodge with comfortable cottages, steady dining, and well‑organized safari logistics.",
                    "highlights": [
                        "Close to Sajnekhali hub",
                        "Experienced naturalists",
                        "Family‑friendly",
                        "Reliable housekeeping"
                    ]
                },
                {
                    "name": "Royal Sundarban Wild Resort",
                    "address": "Pakhiralay belt, Sundarbans 743370",
                    "website": "https://www.royalsundarbanwildresort.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2500 } },
                    "facilities": [
                        "Rooms/cottages in green campus",
                        "Restaurant",
                        "Boat safari assistance",
                        "Lawn for cultural shows"
                    ],
                    "brief": "A friendly, value‑forward resort with tidy rooms, homely food, and easy access to boat jetties.",
                    "highlights": [
                        "Good for groups",
                        "Popular buffet meals",
                        "Quick jetty reach",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Hotel Sonar Bangla Sundarban",
                    "address": "Dulki, near Gosaba–Sajnekhali corridor, Sundarbans 743370",
                    "website": "https://www.hotelsonarbangla.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Riverside rooms (select)",
                        "Restaurant and lawns",
                        "Sunset cruises (property‑assisted)",
                        "Banquet/event spaces"
                    ],
                    "brief": "A riverside resort with modern comforts, lawns, and convenient access to core sightseeing circuits.",
                    "highlights": [
                        "River‑facing ambience",
                        "Family‑friendly",
                        "Event‑ready spaces",
                        "Good for weekend getaways"
                    ]
                },
                {
                    "name": "Sundarban Tiger Roar Resort",
                    "address": "Jamespur/Pakhiralay belt, Sundarbans 743370",
                    "website": "https://www.sundarbantigerroarresort.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Cottages and rooms",
                        "Restaurant",
                        "Boat safari desk",
                        "Cultural evenings (seasonal)"
                    ],
                    "brief": "A straightforward resort with clean rooms, helpful staff, and dependable safari coordination.",
                    "highlights": [
                        "Easy jetty access",
                        "Value pricing",
                        "Good for families",
                        "Consistent service"
                    ]
                },
                {
                    "name": "Sunderban Mangrove Retreat",
                    "address": "Gosaba/Sajnekhali approach belt, Sundarbans 743370",
                    "website": "https://www.sundarbanmangroveretreat.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Ethnic‑style cottages",
                        "Buffet dining",
                        "Guided boat safaris",
                        "Village walk experiences"
                    ],
                    "brief": "An ethnic‑inspired retreat offering simple comforts, hearty local fare, and nature‑led excursions.",
                    "highlights": [
                        "Close to safari routes",
                        "Homely hospitality",
                        "Birding‑friendly",
                        "Budget‑friendly"
                    ]
                },
                {
                    "name": "Solitary Nook (Eco‑Lodge)",
                    "address": "Dayapur/Pakhiralay region, Sundarbans 743370",
                    "website": "https://www.solitarynook.com/",
                    "averageCost": { "stay": 7000, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Basic clean rooms",
                        "Set‑menu dining",
                        "Boat tours (on request)",
                        "Lawn sit‑outs"
                    ],
                    "brief": "A simple eco‑lodge with clean rooms, set menus, and helpful local arrangements near the creeks.",
                    "highlights": [
                        "Quiet, green ambience",
                        "Good host support",
                        "Ideal for budget travelers",
                        "Close to jetty"
                    ]
                },
                {
                    "name": "Sundarban Riverside Holiday Resort",
                    "address": "Gosaba belt, Sundarbans 743370",
                    "website": "https://www.sundarbanriversideholidayresort.com/",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Riverside rooms/cottages",
                        "Restaurant",
                        "Safari/village tour desk",
                        "Event lawn (compact)"
                    ],
                    "brief": "A riverside resort offering comfy rooms, simple dining, and tour coordination for families and small groups.",
                    "highlights": [
                        "Peaceful river views",
                        "Family‑friendly",
                        "Good housekeeping",
                        "Balanced value"
                    ]
                }
            ]
        }
    },



    "bodh-gaya": {
        "name": "Bodh Gaya (Bihar)",
        "description": "Best stays in Bodh Gaya—premium and midscale hotels near Mahabodhi Temple, Kalachakra Maidan, and the airport/railway corridors. Expect clean rooms, reliable dining, prayer-friendly schedules, and event spaces.",
        "sectionOne": "Bodh Gaya, a UNESCO World Heritage site, is the place where the Buddha attained enlightenment under the Bodhi Tree. Travellers visit the Mahabodhi Temple Complex, Bodhi Tree, Great Buddha Statue, various international monasteries (Thai, Japanese, Tibetan, Bhutanese), Sujata Stupa and village, and nearby Gaya’s Vishnupad Temple. Hotels emphasize peaceful rooms, dependable Wi‑Fi, vegetarian-friendly dining, and flexible timings to suit puja/meditation—ideal for pilgrimages, cultural trips, and small conferences.",
        "sectionTwo": {
            "text": "Bodh Gaya features premium city hotels, peaceful retreat-style resorts, and practical midscale stays close to the temple belt and airport road. Below are handpicked options known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Marasa Sarovar Premiere, Bodhgaya",
                    "address": "Domuhan–Bodhgaya Road, Bodh Gaya, Bihar 824231",
                    "website": "https://www.sarovarhotels.com/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1600, "max": 3600 } },
                    "facilities": [
                        "Modern rooms and suites",
                        "All‑day dining and café",
                        "Pool/spa (property‑specific) and fitness",
                        "Banquet/meeting rooms"
                    ],
                    "brief": "A polished, peaceful hotel with roomy stays, steady dining, and event‑ready spaces near the temple circuit.",
                    "highlights": [
                        "Short drive to Mahabodhi Temple",
                        "Vegetarian‑friendly menus",
                        "Popular breakfast",
                        "Good for groups and families"
                    ]
                },
                {
                    "name": "Hyatt Place Bodh Gaya",
                    "address": "Newataur, Near Mahabodhi Temple approach, Bodh Gaya 824231",
                    "website": "https://www.hyatt.com/",
                    "averageCost": { "stay": 16000, "dining": { "min": 1800, "max": 4200 } },
                    "facilities": [
                        "Contemporary rooms and family setups",
                        "Gallery Kitchen dining and lounge",
                        "Fitness centre",
                        "Event/meeting rooms"
                    ],
                    "brief": "A contemporary, well‑located hotel with comfortable rooms, reliable dining, and compact event facilities.",
                    "highlights": [
                        "Temple and monastery access",
                        "Efficient services",
                        "Consistent housekeeping",
                        "Good for business and pilgrims"
                    ]
                },
                {
                    "name": "Maha Bodhi Hotel, Resort & Convention Centre",
                    "address": "Hariharpur, Bodh Gaya, Bihar 824231",
                    "website": "https://www.mahabodhihotels.com/",
                    "averageCost": { "stay": 13000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Resort‑style rooms and suites",
                        "Restaurants and café",
                        "Pool, spa (select), and lawn",
                        "Convention halls and meeting rooms"
                    ],
                    "brief": "A convention‑ready resort with spacious grounds, comfortable rooms, and versatile event venues.",
                    "highlights": [
                        "Event‑friendly infrastructure",
                        "Family‑friendly ambience",
                        "Popular buffets",
                        "Good for multi‑night stays"
                    ]
                },
                {
                    "name": "The Bodhi Palace Resort",
                    "address": "Bodh Gaya–Gaya Road, Bodh Gaya 824231",
                    "website": "https://www.thebodhipalaceresort.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "Restaurant and lounge",
                        "Pool (property‑specific) and lawns",
                        "Banquet/meeting hall"
                    ],
                    "brief": "A value‑forward resort‑style stay with poolside downtime, lawns, and easy access to key sights.",
                    "highlights": [
                        "Good for families and groups",
                        "Steady dining",
                        "Calm, spacious campus",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Oaks Bodhgaya",
                    "address": "Airport Road, Bodh Gaya 824231",
                    "website": "https://www.oakshotels.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Smart, airy rooms",
                        "Restaurant and café",
                        "Fitness corner",
                        "Meeting room"
                    ],
                    "brief": "A practical, airport‑corridor hotel with clean rooms, dependable dining, and quick temple/airport connectivity.",
                    "highlights": [
                        "Transit‑friendly",
                        "Good breakfast options",
                        "Efficient check‑in/out",
                        "Value‑friendly"
                    ]
                },
                {
                    "name": "Bodhgaya Regency Hotel",
                    "address": "Near Mahabodhi Temple belt, Bodh Gaya 824231",
                    "website": "https://www.bodhgayaregency.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Neat rooms close to temple zone",
                        "Vegetarian‑friendly restaurant",
                        "Prayer/meeting hall (property‑specific)",
                        "Travel desk"
                    ],
                    "brief": "A temple‑belt hotel offering simple comforts, veg‑friendly menus, and quick access for early darshan.",
                    "highlights": [
                        "Walk/short drive to Mahabodhi",
                        "Pilgrim‑friendly schedules",
                        "Consistent housekeeping",
                        "Budget‑sensitive pick"
                    ]
                }
            ]
        }
    },


    "nalanda": {
        "name": "Nalanda (Bihar)",
        "description": "Best stays for the Nalanda–Rajgir circuit—peaceful resorts and practical town hotels near Nalanda University ruins, Rajgir ropeway/Vishwa Shanti Stupa, and Pawapuri’s Jal Mandir. Expect clean rooms, vegetarian-friendly dining, and compact event spaces.",
        "sectionOne": "Nalanda, home to the ancient Nalanda Mahavihara ruins, pairs Buddhist heritage with the nearby Rajgir hills, hot springs, and Pawapuri’s serene Jain temple on a lake. Travellers visit Nalanda University ruins and museum, Rajgir ropeway to Vishwa Shanti Stupa at Ratnagiri, Cyclopean Wall, hot springs, Glass Bridge (Ghora Katora belt), and Pawapuri Jal Mandir. Hotels focus on calm rooms, reliable Wi‑Fi, hearty local/veg dining, and easy road access—ideal for pilgrimages, student/heritage tours, and family trips.",
        "sectionTwo": {
            "text": "Most comfortable bases are in Rajgir (10–15 km from Nalanda ruins) with some options in Bihar Sharif and Pawapuri. Below are handpicked properties known for location, amenities, and consistent service.",
            "hotels": [
                {
                    "name": "Indo Hokke Hotel, Rajgir",
                    "address": "Near Venu Van/Rajgir core, Rajgir, Bihar 803116",
                    "website": "https://www.indohokke.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Quiet, garden‑view rooms",
                        "Vegetarian‑friendly restaurant",
                        "Prayer/meditation space (property‑specific)",
                        "Small banquet/meeting room"
                    ],
                    "brief": "A peaceful, Buddhist‑traveller‑friendly hotel with calm rooms, veg dining, and easy access to Rajgir sights.",
                    "highlights": [
                        "Good base for Nalanda ruins",
                        "Pilgrim‑friendly ambience",
                        "Consistent housekeeping",
                        "Suited to families/groups"
                    ]
                },
                {
                    "name": "The Rajgir Residency",
                    "address": "Virayatan Road belt, Rajgir, Bihar 803116",
                    "website": "https://www.rajgirresidency.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Modern rooms and suites",
                        "Restaurant and café",
                        "Pool (property‑specific)",
                        "Banquet/meeting halls"
                    ],
                    "brief": "A dependable Rajgir hotel with tidy rooms, steady dining, and event‑friendly spaces close to main attractions.",
                    "highlights": [
                        "Family‑friendly amenities",
                        "Good for school/heritage tours",
                        "Popular breakfast",
                        "Value‑forward premium pick"
                    ]
                },
                {
                    "name": "Kripanidhi Retreat, Rajgir (within Jain complex)",
                    "address": "Rajgir hills belt, Rajgir, Bihar 803116",
                    "website": "https://www.kripanidhiretreat.com/",
                    "averageCost": { "stay": 11000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Rooms with hill views",
                        "Pure‑veg dining",
                        "Lawns and sit‑outs",
                        "Small event hall"
                    ],
                    "brief": "A serene, vegetarian retreat amid greenery with hill views and calm, family‑friendly spaces.",
                    "highlights": [
                        "Quiet, devotional ambience",
                        "Close to ropeway access",
                        "Great for seniors/families",
                        "Balanced price‑to‑comfort"
                    ]
                },
                {
                    "name": "Gargee Gautam Vihar Resort, Rajgir",
                    "address": "Near Rajgir Nature Safari belt, Rajgir, Bihar 803116",
                    "website": "https://www.gargeehotels.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 3000 } },
                    "facilities": [
                        "Resort‑style rooms and cottages",
                        "Restaurant and café",
                        "Pool and kids’ play areas",
                        "Banquet lawns and halls"
                    ],
                    "brief": "A family‑friendly resort with lawns, pool, and practical event spaces—handy for Rajgir safaris and Nalanda.",
                    "highlights": [
                        "Good for longer stays",
                        "Child‑friendly facilities",
                        "Event‑ready",
                        "Reliable housekeeping"
                    ]
                },
                {
                    "name": "Hotel Nalanda Regency (Rajgir)",
                    "address": "Station Road belt, Rajgir, Bihar 803116",
                    "website": "https://www.hotelnalandaregency.com/",
                    "averageCost": { "stay": 6500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Neat, central rooms",
                        "Restaurant and room service",
                        "Travel assistance",
                        "Meeting room"
                    ],
                    "brief": "A straightforward town‑centre hotel with tidy rooms and convenient access to ropeway and heritage sites.",
                    "highlights": [
                        "Budget‑friendly comfort",
                        "Transit‑friendly location",
                        "Popular set breakfasts",
                        "Good for short stays"
                    ]
                },
                {
                    "name": "Pandu Pokhar Eco Adventure Resort (Rajgir)",
                    "address": "Pandu Pokhar belt, Rajgir, Bihar 803116",
                    "website": "https://www.pandupokhar.com/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Cottage/tent‑style accommodations",
                        "Restaurant",
                        "Adventure zone and gardens",
                        "Event lawn"
                    ],
                    "brief": "An eco‑adventure stay with cottages, gardens, and activities—great for families and student groups.",
                    "highlights": [
                        "Green, spacious grounds",
                        "Kid‑friendly activities",
                        "Good for groups",
                        "Photo‑friendly setting"
                    ]
                },
                {
                    "name": "Hotel Abhilasha (Pawapuri/Jal Mandir access)",
                    "address": "Near Jal Mandir, Pawapuri, Bihar 805124",
                    "website": "#",
                    "averageCost": { "stay": 5000, "dining": { "min": 700, "max": 1800 } },
                    "facilities": [
                        "Simple, clean rooms",
                        "Veg dining",
                        "Parking and assistance",
                        "Prayer‑friendly schedules"
                    ],
                    "brief": "A practical stop for Jal Mandir darshan with clean rooms, homely veg meals, and easy temple access.",
                    "highlights": [
                        "Pilgrim‑friendly",
                        "Budget‑sensitive",
                        "Calm surroundings",
                        "Good for one‑night stays"
                    ]
                },
                {
                    "name": "Nalanda Area Homestays (Example Category)",
                    "address": "Villages around Nalanda ruins, Bihar 803111",
                    "website": "#",
                    "averageCost": { "stay": 2500, "dining": { "min": 400, "max": 900 } },
                    "facilities": [
                        "Clean, basic rooms",
                        "Home‑style vegetarian meals",
                        "Cycle/local guide links",
                        "Flexible check‑in/out"
                    ],
                    "brief": "Welcoming homestays offering simple comforts, local food, and close proximity to the archaeological zone.",
                    "highlights": [
                        "Great value",
                        "Cultural immersion",
                        "Walk/short drive to ruins",
                        "Ideal for students/backpackers"
                    ]
                }
            ]
        }
    },



    "pelling": {
        "name": "Pelling (Sikkim)",
        "description": "Best stays in Pelling—Kanchenjunga‑view resorts and boutique hill hotels around Upper/Lower Pelling, Pelling‑Rimbi Road, and Pemayangtse belt. Expect view‑led rooms (select), cosy lounges, hearty dining, and compact event spaces.",
        "sectionOne": "Pelling pairs monasteries and palace ruins with sweeping Kanchenjunga vistas. Travellers explore Pemayangtse Monastery, Rabdentse Ruins, Sky Walk at Sanga Choeling ridge, Khecheopalri Lake, Rimbi/Khangchendzonga waterfalls, and helipad viewpoints. Hill hotels focus on warm rooms, reliable Wi‑Fi, bonfire evenings, and easy taxi access—ideal for family trips, honeymoons, and relaxed hill breaks.",
        "sectionTwo": {
            "text": "Pelling offers view‑centric premium resorts in Upper Pelling, convenient midscale hotels in Lower Pelling, and heritage/boutique stays near Pemayangtse.",
            "hotels": [
                {
                    "name": "The Elgin Mount Pandim – A Heritage Resort & Spa",
                    "address": "Pemayangtse, Pelling, West Sikkim 737113",
                    "website": "https://www.elginhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Heritage rooms with mountain views (select)",
                        "Restaurant, tea lounge, and bar",
                        "Spa services",
                        "Banquet/meeting room"
                    ],
                    "brief": "A heritage‑style retreat beside Pemayangtse Monastery with classic interiors, high‑tea, and serene lawns.",
                    "highlights": [
                        "Proximity to monastery/ruins",
                        "Kanchenjunga glimpses (select)",
                        "Romantic, old‑world vibe",
                        "Great for slow travel"
                    ]
                },
                {
                    "name": "Chumbi Mountain Retreat & Spa",
                    "address": "Naku‑Chumbong, Pelling, West Sikkim 737113",
                    "website": "https://www.chumbiresort.com/",
                    "averageCost": { "stay": 22000, "dining": { "min": 2200, "max": 5400 } },
                    "facilities": [
                        "Mountain‑view rooms and suites",
                        "Restaurants and lounge",
                        "Spa and wellness",
                        "Lawns and small banquets"
                    ],
                    "brief": "A view‑rich hillside resort with tasteful rooms, spa‑led downtime, and curated local cuisine.",
                    "highlights": [
                        "Kanchenjunga viewpoints",
                        "Peaceful green setting",
                        "Family‑friendly",
                        "Photo‑friendly terraces"
                    ]
                },
                {
                    "name": "Summit Newa Regency & Spa, Pelling",
                    "address": "Pelling‑Rimbi Road, Lower Pelling 737113",
                    "website": "https://www.summithotels.in/",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Comfortable rooms and family suites",
                        "Restaurant and bar",
                        "Spa (property‑specific)",
                        "Banquet/meeting room"
                    ],
                    "brief": "A convenient, value‑forward hotel with cosy rooms, spa options, and easy taxi links for sightseeing.",
                    "highlights": [
                        "Close to markets and cafés",
                        "Good for families",
                        "Reliable breakfast",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Udaan Olive Hotel & Spa, Pelling",
                    "address": "Pachu, Pelling, West Sikkim 737113",
                    "website": "https://www.udaanhotels.com/",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Rooms with valley/forest views (select)",
                        "Restaurant and café",
                        "Travel desk",
                        "Small event room"
                    ],
                    "brief": "A calm hotel ringed by pines offering comfortable rooms, warm dining, and practical access to main sights.",
                    "highlights": [
                        "Quiet yet accessible",
                        "Couple‑ and family‑friendly",
                        "Helpful staff",
                        "Great value in town"
                    ]
                },
                {
                    "name": "Norbu Ghang Resort",
                    "address": "Upper Pelling, West Sikkim 737113",
                    "website": "https://www.norbughang.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1200, "max": 2800 } },
                    "facilities": [
                        "Cottage‑style rooms with sit‑outs (select)",
                        "Restaurant and lounge",
                        "Garden terraces",
                        "Small banquet hall"
                    ],
                    "brief": "A classic Pelling resort with gardens, hill views, and homely service near the helipad viewpoint zone.",
                    "highlights": [
                        "Upper Pelling views",
                        "Green sit‑outs",
                        "Good for groups",
                        "Consistent housekeeping"
                    ]
                }
            ]
        }
    },
    "ravangla": {
        "name": "Ravangla (South Sikkim)",
        "description": "Best stays in Ravangla—tranquil mountain resorts and monasteries‑belt stays near Buddha Park (Tathagata Tsal), Ralong, and Bon monasteries. Expect view‑led rooms, cosy dining, and lawns for small gatherings.",
        "sectionOne": "Ravangla sits on a high ridge with superb Kanchenjunga angles and easy monastery circuits. Travellers explore Buddha Park, Ralong Monastery, Bon Monastery, Rayong Sunrise Viewpoint, Temi Tea Garden (via Damthang), and Maenam Wildlife Sanctuary trails (from adjacent Borong/NGO tracks). Hotels prioritize quiet rooms, panoramic decks, local cuisine, and taxi links—ideal for spiritual breaks, families, and soft‑trek escapes.",
        "sectionTwo": {
            "text": "Ravangla features hillside resorts near Buddha Park, tea‑view retreats on the Temi approach, and boutique cottage stays in Borong.",
            "hotels": [
                {
                    "name": "The Elgin Mount Simsbang (Ravangla) – Boutique",
                    "address": "Near Buddha Park belt, Ravangla, South Sikkim 737139",
                    "website": "https://www.elginhotels.com/",
                    "averageCost": { "stay": 20000, "dining": { "min": 2200, "max": 5200 } },
                    "facilities": [
                        "Boutique rooms with mountain views (select)",
                        "Restaurant and lounge",
                        "Garden sit‑outs",
                        "Intimate event room"
                    ],
                    "brief": "A boutique hill hotel with heritage accents, cosy dining, and easy access to Buddha Park and monasteries.",
                    "highlights": [
                        "Quiet, scenic setting",
                        "Kanchenjunga angles (clear days)",
                        "Great for couples",
                        "Walk/short drive to sights"
                    ]
                },
                {
                    "name": "Summit Sobralia Resort & Spa, Namchi (Ravangla circuit pairing)",
                    "address": "Chardham Road, Namchi, South Sikkim 737126",
                    "website": "https://www.summithotels.in/",
                    "averageCost": { "stay": 14000, "dining": { "min": 1400, "max": 3200 } },
                    "facilities": [
                        "Rooms/suites with valley views (select)",
                        "Restaurants and bar",
                        "Spa and pool (select)",
                        "Banquet halls"
                    ],
                    "brief": "A full‑service resort often paired with Ravangla trips, offering bigger leisure and event facilities.",
                    "highlights": [
                        "Good for families",
                        "Event‑ready spaces",
                        "Namchi/Ravangla connectivity",
                        "Value‑forward premium"
                    ]
                },
                {
                    "name": "Cherry Resort (Temi Tea Garden belt)",
                    "address": "Temi Tea Garden approach, South Sikkim 737139",
                    "website": "https://www.temicherryresort.com/",
                    "averageCost": { "stay": 12000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Tea‑view rooms and balconies (select)",
                        "Restaurant and café",
                        "Lawn sit‑outs",
                        "Small event space"
                    ],
                    "brief": "A tea‑estate‑facing resort with breezy rooms, scenic sit‑outs, and relaxed dining near Ravangla/Temi circuits.",
                    "highlights": [
                        "Tea garden panoramas",
                        "Calm ambience",
                        "Great for photo walks",
                        "Good access to viewpoints"
                    ]
                },
                {
                    "name": "Barfung Retreat (Borong/Ravangla outskirts)",
                    "address": "Borong village belt, near Ravangla, South Sikkim 737139",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Cottage rooms with valley glimpses",
                        "Restaurant",
                        "Bonfire (seasonal)",
                        "Small event room"
                    ],
                    "brief": "A quiet countryside stay with simple cottages, warm meals, and trail access towards Maenam/Borong.",
                    "highlights": [
                        "Nature‑rich setting",
                        "Great for families/couples",
                        "Value pricing",
                        "Relaxed pace"
                    ]
                }
            ]
        }
    },
    "yuksom": {
        "name": "Yuksom (West Sikkim)",
        "description": "Best stays in Yuksom—trailhead lodges and heritage cottages near Norbugang Coronation Throne, Dubdi Monastery, and Khangchendzonga NP entry. Expect trek‑friendly services, homely dining, and serene village views.",
        "sectionOne": "Yuksom, the historic first capital of Sikkim, is the gateway to Dzongri/Goecha La treks. Travellers visit the Norbugang Chorten & Coronation Throne, Dubdi Monastery, Kathok Wodsallin Gompa, Khecheopalri Lake (via road), and waterfalls/bridges en route. Stays emphasize early breakfasts, packed lunches for hikes, local cuisine, and guide/porter links—ideal for trekkers, nature lovers, and culture seekers.",
        "sectionTwo": {
            "text": "Yuksom offers trek‑focused lodges near the trailhead, vintage cottages in quiet lanes, and simple village homestays.",
            "hotels": [
                {
                    "name": "The Tashigang Resort, Yuksom",
                    "address": "Yuksom village approach, West Sikkim 737113",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Wood‑accented rooms with balconies (select)",
                        "Restaurant and lounge",
                        "Bonfire (seasonal)",
                        "Small meeting room"
                    ],
                    "brief": "A peaceful hillside resort with cosy rooms, mountain glimpses, and warm dining close to monastery circuits.",
                    "highlights": [
                        "Quiet, green ambience",
                        "Good for couples/families",
                        "Helpful trek logistics",
                        "Great value"
                    ]
                },
                {
                    "name": "Hotel Red Palace, Yuksom",
                    "address": "Near Yuksom market, West Sikkim 737113",
                    "website": "#",
                    "averageCost": { "stay": 6500, "dining": { "min": 800, "max": 2000 } },
                    "facilities": [
                        "Simple, tidy rooms",
                        "Restaurant and café",
                        "Guide/porter assistance",
                        "Packed lunches (on request)"
                    ],
                    "brief": "A practical trailhead hotel offering clean rooms, homely food, and trek‑friendly services in the village core.",
                    "highlights": [
                        "Walkable to trail start",
                        "Budget‑friendly",
                        "Good breakfasts",
                        "Great for short stays"
                    ]
                },
                {
                    "name": "Ejam Residency / Homestay Belt (Representative)",
                    "address": "Yuksom village lanes, West Sikkim 737113",
                    "website": "#",
                    "averageCost": { "stay": 3500, "dining": { "min": 500, "max": 1200 } },
                    "facilities": [
                        "Basic rooms with mountain/village views (select)",
                        "Home‑style kitchens",
                        "Guide/porter connect",
                        "Flexible check‑in/out"
                    ],
                    "brief": "Welcoming homestays with simple comforts, local food, and easy access to treks and monasteries.",
                    "highlights": [
                        "Cultural immersion",
                        "Great for trek prep",
                        "Budget comfort",
                        "Quiet surroundings"
                    ]
                },
                {
                    "name": "Limboo Homestay (Heritage‑style)",
                    "address": "Near Kathok Lake belt, Yuksom 737113",
                    "website": "#",
                    "averageCost": { "stay": 4200, "dining": { "min": 600, "max": 1400 } },
                    "facilities": [
                        "Traditional rooms in a family home",
                        "Home‑cooked Sikkimese meals",
                        "Garden sit‑outs",
                        "Trek lunch packs (on request)"
                    ],
                    "brief": "A beloved family homestay offering authentic meals, quiet rooms, and hosts who help with trek planning.",
                    "highlights": [
                        "Authentic local hospitality",
                        "Great value",
                        "Ideal for trekkers",
                        "Close to village sights"
                    ]
                }
            ]
        }
    },


    "tawang": {
        "name": "Tawang (Arunachal Pradesh)",
        "description": "Best stays in Tawang—mountain‑view hotels and cosy boutique lodges near Tawang Monastery, Old Market/City Centre, and the Bumla/PT Tso access road. Expect heated rooms (select), hearty dining, hot water support, and compact event spaces.",
        "sectionOne": "Tawang pairs dramatic Himalayan scenery with deep Buddhist heritage. Travellers visit Tawang Monastery (Gaden Namgyal Lhatse), War Memorial, Nuranang (Jang) Falls, Sela Pass, PT Tso (Pankang Teng Tso) Lake, Bumla Pass (permit required), Urgelling Gompa, and local markets. Given high‑altitude weather, hotels focus on warm rooms, dependable hot water, robust meals, oxygen/first‑aid readiness (select), and transport/permit guidance—ideal for family trips, culture seekers, and road‑trip itineraries.",
        "sectionTwo": {
            "text": "Tawang features view‑rich hillside hotels, central market‑area stays for easy dining/shopping, and boutique lodges on quieter ridges toward PT Tso/Bumla approach.",
            "hotels": [
                {
                    "name": "Dondrub Homestay & Cottages (Boutique)",
                    "address": "Near Tawang Monastery approach, Tawang, Arunachal Pradesh 790104",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Wood‑accented rooms with heaters (select)",
                        "Home‑style kitchen and breakfast",
                        "Permit/transport guidance (on request)",
                        "Small lounge with views"
                    ],
                    "brief": "A cosy, family‑run stay close to the monastery with warm rooms, homely food, and helpful local guidance.",
                    "highlights": [
                        "Quiet monastery‑side lane",
                        "Great for couples/families",
                        "Local cultural tips",
                        "Good value boutique pick"
                    ]
                },
                {
                    "name": "Hotel Mon Paradise",
                    "address": "Old Market/City Centre belt, Tawang 790104",
                    "website": "#",
                    "averageCost": { "stay": 8500, "dining": { "min": 900, "max": 2200 } },
                    "facilities": [
                        "Comfortable heated rooms (select)",
                        "Restaurant and room service",
                        "Travel/permit assistance",
                        "Meeting room (compact)"
                    ],
                    "brief": "A central, practical hotel with tidy, heated rooms and quick access to eateries, shops, and taxi stands.",
                    "highlights": [
                        "Walkable city conveniences",
                        "Consistent housekeeping",
                        "Efficient check‑in/out",
                        "Budget‑friendly premium"
                    ]
                },
                {
                    "name": "Yangzom Hotel & Restaurant",
                    "address": "Near Tawang Monastery road, Tawang 790104",
                    "website": "#",
                    "averageCost": { "stay": 7800, "dining": { "min": 900, "max": 2000 } },
                    "facilities": [
                        "Neat, warm rooms",
                        "Local Tibetan/Indian kitchen",
                        "Taxi/permit connect",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A neat monastery‑side pick known for hearty local food, clean rooms, and easy sightseeing access.",
                    "highlights": [
                        "Close to monastery",
                        "Popular momos/thukpa",
                        "Family‑run hospitality",
                        "Great for short stays"
                    ]
                },
                {
                    "name": "The Oak Hotel Tawang",
                    "address": "Market approach road, Tawang 790104",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Modern rooms (select views)",
                        "Restaurant and café",
                        "Heaters on request",
                        "Small banquet room"
                    ],
                    "brief": "A centrally placed, modern hotel with comfortable rooms, reliable dining, and easy access to daily essentials.",
                    "highlights": [
                        "City‑centre convenience",
                        "Family‑friendly layouts",
                        "Reliable breakfast",
                        "Balanced price‑to‑amenities"
                    ]
                },
                {
                    "name": "Snowland Residency (View‑side)",
                    "address": "View ridge toward PT Tso approach, Tawang 790104",
                    "website": "#",
                    "averageCost": { "stay": 10000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Rooms with mountain glimpses (select)",
                        "Restaurant with hot meals",
                        "Permit/vehicle guidance",
                        "Lounge and bonfire corner (seasonal)"
                    ],
                    "brief": "A view‑leaning lodge with warm interiors, hearty dining, and helpful logistics for PT Tso/Bumla excursions.",
                    "highlights": [
                        "Scenic ridge setting",
                        "Good for sunrise angles",
                        "Trip planning support",
                        "Calm, off‑market ambience"
                    ]
                },
                {
                    "name": "Hotel Zambala",
                    "address": "Old Market, Tawang 790104",
                    "website": "#",
                    "averageCost": { "stay": 6500, "dining": { "min": 800, "max": 1800 } },
                    "facilities": [
                        "Basic heated rooms (select)",
                        "In‑house dining",
                        "Permit/driver contacts",
                        "Wi‑Fi and parking"
                    ],
                    "brief": "A simple, value stay in the market belt with clean rooms, straightforward meals, and easy taxi access.",
                    "highlights": [
                        "Budget‑friendly",
                        "Near shops/eateries",
                        "Good for short stopovers",
                        "Reliable essentials"
                    ]
                }
            ]
        }
    },


    "ziro-valley": {
        "name": "Ziro Valley (Arunachal Pradesh)",
        "description": "Best stays in Ziro—eco-homestays, cottage resorts, and practical town hotels around Hapoli (Old/New Ziro), Siiro, and Biiri. Expect simple, clean rooms, hot meals, local culture walks, and trek/transport assistance.",
        "sectionOne": "Ziro Valley, home of the Apatani tribe, is known for emerald paddy fields, pine-clad ridges, and living village culture. Travellers explore Hong/Hari/Bulou villages, Siikhe Lake, Talley Valley Wildlife Sanctuary (via permits/treks), craft hubs, and the famed Ziro Music Festival (seasonal). Properties focus on warm hospitality, homely cuisine, basic heating (select), guide link-ups, and flexible meals around field trips—ideal for slow travel, families, backpackers, and culture enthusiasts.",
        "sectionTwo": {
            "text": "Most stays cluster near Hapoli for connectivity, with scenic cottage/homestay options in Siiro and Biiri hamlets.",
            "hotels": [
                {
                    "name": "Siiro Resort",
                    "address": "Siiro Village, Ziro, Arunachal Pradesh 791120",
                    "website": "#",
                    "averageCost": { "stay": 4500, "dining": { "min": 700, "max": 1800 } },
                    "facilities": [
                        "Cottage-style rooms with valley glimpses",
                        "Restaurant with local cuisine",
                        "Bonfire (seasonal)",
                        "Parking and travel desk"
                    ],
                    "brief": "A quiet, greenery-wrapped resort in Siiro offering cottage rooms, homely fare, and easy village access.",
                    "highlights": [
                        "Village-side calm",
                        "Good for families",
                        "Local food focus",
                        "Value-friendly"
                    ]
                },
                {
                    "name": "Ziro Valley Resort (Biiri)",
                    "address": "Biiri Village, near Hapoli, Ziro 791120",
                    "website": "#",
                    "averageCost": { "stay": 3800, "dining": { "min": 600, "max": 1600 } },
                    "facilities": [
                        "Rooms and simple cottages",
                        "Restaurant and lawn sit-outs",
                        "Local guide assistance",
                        "Event lawn (compact)"
                    ],
                    "brief": "A budget-to-midstay resort near paddy fields with simple rooms, lawns, and helpful staff.",
                    "highlights": [
                        "Near village walks",
                        "Great for groups",
                        "Straightforward dining",
                        "Good access roads"
                    ]
                },
                {
                    "name": "Suchusi/Local Homestay Belt (Representative)",
                    "address": "Hapoli & nearby villages, Ziro 791120",
                    "website": "#",
                    "averageCost": { "stay": 2500, "dining": { "min": 400, "max": 900 } },
                    "facilities": [
                        "Clean rooms in family homes",
                        "Home-cooked Apatani meals",
                        "Guide/porter and taxi links",
                        "Flexible check-in/out"
                    ],
                    "brief": "Welcoming homestays focused on culture immersion, local food, and easy access to village circuits.",
                    "highlights": [
                        "Authentic hospitality",
                        "Budget comfort",
                        "Great for long stays",
                        "Good for solo travellers"
                    ]
                },
                {
                    "name": "Blue Pine / Valley View (Town Hotels)",
                    "address": "Hapoli (Old/New Ziro) core, Ziro 791120",
                    "website": "#",
                    "averageCost": { "stay": 2800, "dining": { "min": 500, "max": 1200 } },
                    "facilities": [
                        "Neat, central rooms",
                        "In-house dining",
                        "Wi‑Fi and parking",
                        "Travel assistance"
                    ],
                    "brief": "Practical town hotels offering simple rooms, steady meals, and walkable market access.",
                    "highlights": [
                        "Market/transport convenience",
                        "Good for short stays",
                        "Reliable essentials",
                        "Budget-friendly"
                    ]
                },
                {
                    "name": "Kasa / Passa Lath (Representative Resorts)",
                    "address": "Hapoli approach belts, Ziro 791120",
                    "website": "#",
                    "averageCost": { "stay": 4200, "dining": { "min": 700, "max": 1600 } },
                    "facilities": [
                        "Rooms/cottages amid greenery",
                        "Restaurant",
                        "Bonfire (seasonal)",
                        "Parking and lawn"
                    ],
                    "brief": "Green-campus resorts balancing simple comforts, warm meals, and easy access to main sights.",
                    "highlights": [
                        "Family-friendly",
                        "Calm ambience",
                        "Good road connectivity",
                        "Balanced value"
                    ]
                },
                {
                    "name": "Festival Camps (Ziro Music Fest Season) – Example Category",
                    "address": "Festival grounds vicinity (seasonal), Ziro 791120",
                    "website": "#",
                    "averageCost": { "stay": 3500, "dining": { "min": 500, "max": 1200 } },
                    "facilities": [
                        "Tented camps with common facilities",
                        "Set meals and café zones",
                        "Shuttle/logistics (seasonal)",
                        "Bonfire/music areas (as permitted)"
                    ],
                    "brief": "Seasonal camp setups near Ziro Music Festival with basic tents, common areas, and lively evenings.",
                    "highlights": [
                        "Walk/short shuttle to venue",
                        "Community vibe",
                        "Budget-friendly",
                        "Great for friends/groups"
                    ]
                }
            ]
        }
    },

    "aizawl": {
        "name": "Aizawl (Mizoram)",
        "description": "Best stays in Aizawl—city‑view hotels, boutique stays, and practical midscale options around Zarkawt/Chaltlang, Old Secretariat, and Millennium Centre/Bara Bazar belt. Expect clean rooms, hearty dining, reliable hot water, and compact event spaces.",
        "sectionOne": "Aizawl, Mizoram’s hilltop capital, blends sweeping ridge‑line views, vibrant church culture, and lively markets. Travellers explore Solomon’s Temple, Durtlang Hills viewpoints, Reiek Heritage Village (day trip), Mizoram State Museum, Bara (Burrra) Bazar, KV Paradise, Hmuifang, and Tamdil Lake (day trip). Hotels emphasize warm rooms, dependable Wi‑Fi, robust breakfasts, airport transfer coordination, and taxi links—ideal for family trips, culture seekers, and workations.",
        "sectionTwo": {
            "text": "Aizawl features central hotels near markets for easy dining/shopping, scenic ridge‑side boutiques with city views, and practical stays on airport approach roads.",
            "hotels": [
                {
                    "name": "The Grand Aizawl",
                    "address": "Zarkawt/City Centre belt, Aizawl, Mizoram 796001",
                    "website": "#",
                    "averageCost": { "stay": 9000, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Modern rooms (select city views)",
                        "Restaurant and café",
                        "Airport transfer assistance",
                        "Banquet/meeting room"
                    ],
                    "brief": "A polished city‑centre hotel with comfortable rooms, reliable dining, and easy access to shops and cafés.",
                    "highlights": [
                        "Walkable to markets",
                        "Consistent housekeeping",
                        "Good breakfast spread",
                        "Convenient for short stays"
                    ]
                },
                {
                    "name": "Hotel Regency (Aizawl)",
                    "address": "Near Millennium Centre, Dawrpui, Aizawl 796001",
                    "website": "#",
                    "averageCost": { "stay": 8500, "dining": { "min": 1000, "max": 2400 } },
                    "facilities": [
                        "Comfortable rooms and suites",
                        "Restaurant and room service",
                        "Travel/permit assistance",
                        "Meeting room"
                    ],
                    "brief": "A dependable central stay with tidy rooms, steady dining, and quick links to shopping and sightseeing.",
                    "highlights": [
                        "City‑core convenience",
                        "Family‑friendly",
                        "Efficient check‑in/out",
                        "Value‑forward premium"
                    ]
                },
                {
                    "name": "The 1998 – Boutique Stay",
                    "address": "Chaltlang ridge belt, Aizawl 796012",
                    "website": "#",
                    "averageCost": { "stay": 9500, "dining": { "min": 1100, "max": 2600 } },
                    "facilities": [
                        "Boutique rooms with city/ridge views (select)",
                        "Coffee shop and kitchen",
                        "Airport/taxi coordination",
                        "Small event lounge"
                    ],
                    "brief": "A view‑side boutique with chic rooms, artisanal café fare, and calm ambience away from market bustle.",
                    "highlights": [
                        "City‑light vistas",
                        "Couple‑friendly",
                        "Quiet surroundings",
                        "Photo‑friendly interiors"
                    ]
                },
                {
                    "name": "Hotel AR – Aizawl Residency",
                    "address": "Luangmual/Durtlang approach belt, Aizawl 796009",
                    "website": "#",
                    "averageCost": { "stay": 7000, "dining": { "min": 900, "max": 2000 } },
                    "facilities": [
                        "Neat rooms with essentials",
                        "Restaurant (local and Indian menu)",
                        "Parking and travel desk",
                        "Meeting room (compact)"
                    ],
                    "brief": "A practical hillside hotel with clean rooms, straightforward dining, and handy access to viewpoints.",
                    "highlights": [
                        "Near Durtlang viewpoints",
                        "Good road connectivity",
                        "Budget‑friendly comfort",
                        "Great for short stays"
                    ]
                },
                {
                    "name": "Chaltlang Cliff Edge (Boutique Homestay)",
                    "address": "Chaltlang South, Aizawl 796012",
                    "website": "#",
                    "averageCost": { "stay": 6500, "dining": { "min": 800, "max": 1800 } },
                    "facilities": [
                        "Cosy rooms/apartments (select balconies)",
                        "Home‑style kitchen",
                        "Laundry and taxi links",
                        "Lounge/sit‑out"
                    ],
                    "brief": "A homely boutique perch overlooking the valley with simple rooms, warm hosts, and hearty breakfasts.",
                    "highlights": [
                        "City‑and‑valley views",
                        "Great host support",
                        "Workation‑friendly",
                        "Calm residential lane"
                    ]
                },
                {
                    "name": "The Hillside Studio",
                    "address": "Laipuitlang/High Ridge belt, Aizawl 796012",
                    "website": "#",
                    "averageCost": { "stay": 6000, "dining": { "min": 700, "max": 1600 } },
                    "facilities": [
                        "Studio/room formats with kitchenette (select)",
                        "Breakfast service",
                        "Airport transfer (on request)",
                        "Parking"
                    ],
                    "brief": "A simple, view‑facing studio stay offering self‑sufficiency for longer trips and quick access to city sights.",
                    "highlights": [
                        "Good for longer stays",
                        "Quiet, airy rooms",
                        "Budget‑sensitive",
                        "Near ridge viewpoints"
                    ]
                },
                {
                    "name": "Airport Corridor Inns (Representative Category)",
                    "address": "Lengpui Airport approach, Aizawl district 796410",
                    "website": "#",
                    "averageCost": { "stay": 5000, "dining": { "min": 700, "max": 1500 } },
                    "facilities": [
                        "Clean transit rooms",
                        "On‑call meals/packed breakfast",
                        "Shuttle/transfer setup",
                        "Parking"
                    ],
                    "brief": "Transit‑friendly inns useful for early flights and late arrivals, with basic comforts and meal support.",
                    "highlights": [
                        "Flight‑timing convenience",
                        "Good for one‑night halts",
                        "Reliable essentials",
                        "Budget‑friendly"
                    ]
                }
            ]
        }
    },

};

export default HotelintentData;
